webpackJsonptesseract([0],Array(309).concat([
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnalystsPanel", function() { return AnalystsPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Currencies", function() { return Currencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CurrencyIndicator", function() { return CurrencyIndicator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CurrencyMatrix", function() { return CurrencyMatrix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DynamicStockChart", function() { return DynamicStockChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Earnings", function() { return Earnings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FinancialDetailsPanel", function() { return FinancialDetailsPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FundsPanel", function() { return FundsPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HistoricalDataPanel", function() { return HistoricalDataPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HoldingsPanel", function() { return HoldingsPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IncomeStatement", function() { return IncomeStatement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarketIndicators", function() { return MarketIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarketsPanel", function() { return MarketsPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PressWidget", function() { return PressWidget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Profile", function() { return Profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProfilePhone", function() { return ProfilePhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecentlyViewed", function() { return RecentlyViewed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SectorPerformance", function() { return SectorPerformance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SectorsPanel", function() { return SectorsPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Statistics", function() { return Statistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockChartDetails", function() { return StockChartDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockDetailsPage", function() { return StockDetailsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockList", function() { return StockList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockOpenAnalysis", function() { return StockOpenAnalysis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockPerformanceByDay", function() { return StockPerformanceByDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockPerformanceByMonth", function() { return StockPerformanceByMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockPriceBar", function() { return StockPriceBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockQuotePanel", function() { return StockQuotePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StocksPanel", function() { return StocksPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StocksWidget", function() { return StocksWidget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockSymbolTable", function() { return StockSymbolTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockTickerBar", function() { return StockTickerBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WorldMarkets", function() { return WorldMarkets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolLookupWidget", function() { return SymbolLookupWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intl_json__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__intl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_analysts_panel__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_currencies__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_currency_indicator__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_currency_matrix__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dynamic_stock_chart__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_statistics_panel_earnings__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_financial_details_panel__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_funds_panel__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_historical_data_panel__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_holdings_panel__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_stock_data_table_income_statement__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_indicators__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_markets_panel__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_press_widget__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_company_profile__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_stock_recently_viewed__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_sector_performance__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_sectors_panel__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_statistics_panel__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_stock_chart_details__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_stock_details_page__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_stock_list__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_stock_open_analysis__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_stock_performance__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_stock_price_bar__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_stock_quote_panel__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_stocks_panel__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_stocks_widget__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_stock_symbol_table__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_stock_ticker_bar__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_world_markets__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_symbol_lookup_widget__ = __webpack_require__(1085);



function intlWrap(c) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact_i18n__["e" /* default */])(c, { scope: 'finance-components', definition: __WEBPACK_IMPORTED_MODULE_1__intl_json___default.a });
}

//it's necessary to do explicit named import/export so that webpack can do proper static analysis


var AnalystsPanel = intlWrap(__WEBPACK_IMPORTED_MODULE_2__components_analysts_panel__["a" /* default */]);


var Currencies = intlWrap(__WEBPACK_IMPORTED_MODULE_3__components_currencies__["a" /* default */]);


var CurrencyIndicator = intlWrap(__WEBPACK_IMPORTED_MODULE_4__components_currency_indicator__["a" /* CurrencyIndicator */]);


var CurrencyMatrix = intlWrap(__WEBPACK_IMPORTED_MODULE_5__components_currency_matrix__["a" /* default */]);


var DynamicStockChart = intlWrap(__WEBPACK_IMPORTED_MODULE_6__components_dynamic_stock_chart__["a" /* default */]);


var Earnings = intlWrap(__WEBPACK_IMPORTED_MODULE_7__components_statistics_panel_earnings__["a" /* default */]);


var FinancialDetailsPanel = intlWrap(__WEBPACK_IMPORTED_MODULE_8__components_financial_details_panel__["a" /* default */]);


var FundsPanel = intlWrap(__WEBPACK_IMPORTED_MODULE_9__components_funds_panel__["a" /* default */]);


var HistoricalDataPanel = intlWrap(__WEBPACK_IMPORTED_MODULE_10__components_historical_data_panel__["a" /* default */]);


var HoldingsPanel = intlWrap(__WEBPACK_IMPORTED_MODULE_11__components_holdings_panel__["a" /* default */]);


var IncomeStatement = intlWrap(__WEBPACK_IMPORTED_MODULE_12__components_stock_data_table_income_statement__["a" /* default */]);


var MarketIndicators = intlWrap(__WEBPACK_IMPORTED_MODULE_13__components_market_indicators__["a" /* default */]);


var MarketsPanel = intlWrap(__WEBPACK_IMPORTED_MODULE_14__components_markets_panel__["a" /* default */]);


var PressWidget = intlWrap(__WEBPACK_IMPORTED_MODULE_15__components_press_widget__["a" /* default */]);


var Profile = intlWrap(__WEBPACK_IMPORTED_MODULE_16__components_company_profile__["b" /* default */]);
var ProfilePhone = intlWrap(__WEBPACK_IMPORTED_MODULE_16__components_company_profile__["a" /* ProfilePhone */]);


var RecentlyViewed = intlWrap(__WEBPACK_IMPORTED_MODULE_17__components_stock_recently_viewed__["b" /* default */]);


var SectorPerformance = intlWrap(__WEBPACK_IMPORTED_MODULE_18__components_sector_performance__["a" /* default */]);


var SectorsPanel = intlWrap(__WEBPACK_IMPORTED_MODULE_19__components_sectors_panel__["a" /* default */]);


var Statistics = intlWrap(__WEBPACK_IMPORTED_MODULE_20__components_statistics_panel__["a" /* default */]);


var StockChartDetails = intlWrap(__WEBPACK_IMPORTED_MODULE_21__components_stock_chart_details__["a" /* default */]);


var StockDetailsPage = intlWrap(__WEBPACK_IMPORTED_MODULE_22__components_stock_details_page__["a" /* default */]);


var StockList = intlWrap(__WEBPACK_IMPORTED_MODULE_23__components_stock_list__["a" /* default */]);


var StockOpenAnalysis = intlWrap(__WEBPACK_IMPORTED_MODULE_24__components_stock_open_analysis__["a" /* default */]);


var StockPerformanceByDay = intlWrap(__WEBPACK_IMPORTED_MODULE_25__components_stock_performance__["a" /* StockPerformanceByDay */]);
var StockPerformanceByMonth = intlWrap(__WEBPACK_IMPORTED_MODULE_25__components_stock_performance__["b" /* StockPerformanceByMonth */]);


var StockPriceBar = intlWrap(__WEBPACK_IMPORTED_MODULE_26__components_stock_price_bar__["b" /* default */]);


var StockQuotePanel = intlWrap(__WEBPACK_IMPORTED_MODULE_27__components_stock_quote_panel__["a" /* default */]);


var StocksPanel = intlWrap(__WEBPACK_IMPORTED_MODULE_28__components_stocks_panel__["a" /* default */]);


var StocksWidget = intlWrap(__WEBPACK_IMPORTED_MODULE_29__components_stocks_widget__["a" /* default */]);


var StockSymbolTable = intlWrap(__WEBPACK_IMPORTED_MODULE_30__components_stock_symbol_table__["a" /* default */]);


var StockTickerBar = intlWrap(__WEBPACK_IMPORTED_MODULE_31__components_stock_ticker_bar__["a" /* default */]);


var WorldMarkets = intlWrap(__WEBPACK_IMPORTED_MODULE_32__components_world_markets__["a" /* default */]);


var SymbolLookupWidget = intlWrap(__WEBPACK_IMPORTED_MODULE_33__components_symbol_lookup_widget__["a" /* default */]);

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAnnual; });
/* harmony export (immutable) */ __webpack_exports__["p"] = shallowEqual;
/* harmony export (immutable) */ __webpack_exports__["o"] = shallowDiffers;
/* harmony export (immutable) */ __webpack_exports__["k"] = gle;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = calcChange;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["l"] = intlDateNode;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatLastTradeTime;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAverage;
/* harmony export (immutable) */ __webpack_exports__["n"] = percentFormatter;
/* unused harmony export getDefaultPrecision */
/* harmony export (immutable) */ __webpack_exports__["f"] = generatePriceFormatter;
/* harmony export (immutable) */ __webpack_exports__["i"] = getBaseCurrencyCode;
/* harmony export (immutable) */ __webpack_exports__["m"] = isCurrency;
/* harmony export (immutable) */ __webpack_exports__["b"] = camel;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDaysInMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



var HOP = Object.prototype.hasOwnProperty;

var getAnnual = function getAnnual(rows) {
	var annual = function annual(q4, q3, q2, q1) {
		return q4.map(function (q, i) {
			return i > 5 ? q + q3[i] + q2[i] + q1[i] : q;
		});
	};

	for (var i = 0; i < rows.length; i++) {
		if (rows[i][0] === 'Q4') {
			rows = rows.slice(i, i + 12);
			rows = [annual(rows[0], rows[1], rows[2], rows[3]), annual(rows[4], rows[5], rows[6], rows[7]), annual(rows[8], rows[9], rows[10], rows[11])];
			break;
		}
	}
	return rows;
};

/* Check if two objects have equal keys & values. */
function shallowEqual(a, b) {
	if (a === b) return true;

	if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' || !a || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object' || !b) return false;

	for (var key in a) {
		if (!HOP.call(b, key) || a[key] !== b[key]) return false;
	}

	for (var _key in b) {
		if (!HOP.call(a, _key)) return false;
	}

	return true;
}

/**
 * Performs a shallow compare between `a` and `b`
 */
function shallowDiffers(a, b) {
	for (var key in a) {
		if (a[key] !== b[key]) return true;
	}for (var _key2 in b) {
		if (!(_key2 in a)) return true;
	}return false;
}

/** Compare a <=> b, return greater, lessthan or equal value
 *	@TODO only used in one place, could just be inlined as a nested ternary
 */
function gle(a, b, greater, lessthan, equal) {
	if (a > b) return greater;
	if (a < b) return lessthan;
	return equal;
}

/** Format a number based on a configuration object.
 *	@TODO option keys should be pascalCase, not CamelCase.
 *	@param {Number}		value
 *	@param {Object}		format
 *	@param {Number}		[format.Decimals=0]        Number of decimal places
 *	@param {Number}		[format.Default]           Default number to return when value is falsey
 *	@param {Boolean}	[format.Comma=false]       Add a comma thousands separator
 *	@param {Boolean}	[format.Compact=false]     Use compact magnitudes (K/M/B)
 *	@param {Boolean}	[format.Plus=false]        Display a plus sign in front of positive numbers
 *	@param {Boolean}	[format.inThousands=false] Display number in thousands
 *	@param {String}		[format.Prefix='']         Characters to prepend
 *	@param {String}		[format.Suffix='']         Characters to append
 */
function formatNumber(v, f) {
	v = v || 0;
	if (!(f.Decimals >= 0)) f.Decimals = 0;
	if (v && v !== 0 && f.inThousands) v = Math.floor(v / 1e3);
	if (v === 0 || isNaN(v)) return f.Default;
	var o = []; //output
	if (v < 0) {
		o.push('-');
		v = Math.abs(v);
	} else if (v > 0 && f.Plus) {
		o.push('+');
	}

	if (f.Prefix !== null) {
		o.push(f.Prefix);
	}

	var ex = ''; // Extension: K/M/B
	if (f.Compact) {
		if (v >= 1000000000) {
			v /= 1000000000;
			ex = 'B';
			f.Decimals = 2;
		} else if (v >= 1000000) {
			v /= 1000000;
			ex = 'M';
			f.Decimals = 2;
		} else if (v >= 1000) {
			v /= 1000;
			ex = 'K';
			f.Decimals = 2;
		}
	}

	v = parseFloat(v).toFixed(f.Decimals);

	if (f.Comma) {
		var end = v.indexOf('.');
		if (end === -1) {
			end = v.length;
		}
		if (end > 3) {
			var parts = [];
			var fraction = v.substr(end, v.length);

			var i = end - 3;
			for (; i > 0; i -= 3) {
				parts.push(v.substr(i, 3));
			}
			parts.push(v.substr(0, i + 3));
			v = parts.reverse().join(',') + fraction;
		}
	}

	o.push(v);
	o.push(ex);
	if (f.Suffix !== null) {
		o.push(f.Suffix);
	}
	return o.join('');
}

/** Compare a current and previous value, and return a description of the change.
 *	@param {Number} current
 *	@param {Number} previous
 *	@returns {Object} `{ price, percent, class }`
 */
function calcChange(now, prev) {
	var ret = { price: 0, percent: 0, class: 'unchanged' };
	if (now > 0 && prev > 0) {
		ret.price = now - prev;
		ret.percent = ret.price * 100 / prev;
		if (now > prev) {
			ret.class = 'positive';
		} else if (now < prev) {
			ret.class = 'negative';
		}
	}
	return ret;
}

function formatDate(date) {
	if (!(date instanceof Date)) {
		date = new Date(date);
	}
	var d = !isNaN(date.getTime()) && date.toISOString().slice(0, 'YYYY-MM-DD'.length).split('-');
	return d ? d[1] + '/' + d[2] + '/' + d[0] : '--/--/----';
}

function intlDateNode(date) {
	var _formatDate$split = formatDate(date).split('/'),
	    month = _formatDate$split[0],
	    day = _formatDate$split[1],
	    year = _formatDate$split[2];

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'format.date.numberDate', fields: { month: month, day: day, year: year } });
}

/** Format a timestamp based on age.
 *	@param {Date|String|Number} date	A Date instance or any variant thereof. Timestamps less than 2147483647 are treated as being in seconds.
 *	@TODO this is quite similar to how momentjs or http://npm.im/neatime work, might be better as a dependency.
 */
function formatLastTradeTime(d) {
	if (!(d instanceof Date)) {
		if (d > 0 && d < 2147483647) {
			d = new Date(d * 1000); // Epoch Seconds
		} else {
			d = new Date(d); //Everything else - Epoch Milliseconds, time string, etc.
		}
	}
	if (d.getTimezoneOffset() <= 0) {
		//We are not in 'murica, so defer to broswer
		return d.toLocaleString();
	}
	//We are in 'murica, so we force all times to EST/EDT and then incorrectly label them EST
	var month = d.getMonth();
	var dst = 0;
	if (month > 2 && month < 10) {
		dst = 1;
	} else if (month === 2 || month === 10) {
		// Mar or Nov
		var dstBegin = new Date(d.getFullYear(), 2, 7, 6, 0, 0, 0); // 7AM GMT == DST switchover time, Mar 7 == earliest possible DST day
		var dow = dstBegin.getDay();
		if (dow > 0) {
			dstBegin.setDate(dstBegin.getDate() + (7 - dow)); // Adjust to 2nd sunday if the 7th isn't a sunday
		}

		var dstEnd = new Date(d.getFullYear(), 10, 1, 6, 0, 0, 0); // 7AM GMT == DST switchover time, Mar 7 == earliest possible DST day
		dow = dstEnd.getDay();
		if (dow > 0) {
			dstEnd.setDate(dstEnd.getDate() + (7 - dow)); // Adjust to 1st sunday if the 1st isn't a sunday
		}
		dst = d >= dstBegin && d < dstEnd;
	}

	var tzOffset = dst ? -4 : -5;

	d = new Date(d.getTime() + tzOffset * 3600000);

	var hour = d.getUTCHours();
	var pm = 0;
	if (hour >= 12) {
		hour -= 12;
		pm = 1;
	}
	if (hour === 0) {
		hour = 12;
	}

	var mins = d.getUTCMinutes();
	if (mins < 10) {
		mins = '0' + mins;
	}
	var secs = d.getUTCSeconds();
	if (secs < 10) {
		secs = '0' + secs;
	}

	var monthAbbr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()];

	var AMorPM = pm ? ' PM ' : ' AM ';
	if (d.getTime() < new Date().getTime() - 16 * 60 * 60 * 1000) {
		//More than 16 hours old, show date
		return monthAbbr + ' ' + d.getDate() + ', ' + d.getFullYear() + ' - ' + hour + ':' + mins + ' ' + AMorPM + ' EST';
	}
	return hour + ':' + mins + ':' + secs + AMorPM + 'EST';
}

/** Return an average of number array.
 *	@param [Number, ...] values	An array of numbers.  Removes any undefined or null values before calculating average
 *	@returns {Number} returns number if has correct values.  If empty or full of null/undefined then returns undefined
 */
function getAverage(values) {
	var count = 0,
	    sum = 0;
	for (var _iterator = values, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var value = _ref;

		if (value !== undefined && value !== null) {
			count++;
			sum += value;
		}
	}
	return count > 0 ? sum / count : undefined;
}

/** Return a formatted percentage string
 *	@param {percentage}
 * 	@returns {String} returns a string that looks like a percentage with '%' concatenated and correct number of decimal places
 */
function percentFormatter(percent) {
	return formatNumber(percent, { Decimals: 2, Comma: true, Suffix: '%', Plus: true, Default: '0.00%' });
}

var HIGH_PRECISION_TYPE_CODES = ['CURRENCY', 'INTEREST'];

function getDefaultPrecision() {
	var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	return HIGH_PRECISION_TYPE_CODES.indexOf(item.SecurityTypeCode) > -1 ? 4 : 2;
}

/** Return a function that is bound to a default (overridable) precision and output value
 *	@param {stockInfo}
 *	@param {maxPrecision} number of digits after decimal point
 *	@returns {Function} returns a function that will generate a formatted string
 */
function generatePriceFormatter(stockInfo) {
	var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var Default = _ref2.Default,
	    _ref2$maxPrecision = _ref2.maxPrecision,
	    maxPrecision = _ref2$maxPrecision === undefined ? Infinity : _ref2$maxPrecision,
	    restFirstLevel = _objectWithoutProperties(_ref2, ['Default', 'maxPrecision']);

	var defaultPrecision = Math.min(maxPrecision, getDefaultPrecision(stockInfo));
	var defaultText = Default || '0.' + Array(defaultPrecision + 1).join('0');
	return function (value) {
		var restSecondLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		return formatNumber(value, _extends({ Decimals: defaultPrecision, Default: defaultText, Comma: true }, restFirstLevel, restSecondLevel));
	};
}

/** Return the base currency for a given quote
 *	@param {quot}
 *	@param {maxPrecision} number of digits after decimal point
 *	@returns {String} returns a string that is the base currency of a quote
 */
function getBaseCurrencyCode() {
	var quote = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	return quote.ExchangeDefaultCurrency || (isCurrency(quote) ? quote.Symbol.substr(-3) : null);
}

/**
 *
 *	@param {quote}
 *	@returns {Boolean} Whether the quote represents a currency or not
 */
function isCurrency(quote) {
	return quote && quote.SecurityTypeCode && quote.SecurityTypeCode.toUpperCase() === 'CURRENCY';
}

/**
 * Get the camel-cased version of a string
 *
 * @param {String} words - The sentence/words to camel case
 * @return {string}
 */
function camel(words) {
	return words.split(' ').map(function (w, i) {
		return i ? '' + w.slice(0, 1).toUpperCase() + w.slice(1, w.length).toLowerCase() : w.toLowerCase();
	}).join('');
}

function getDaysInMonth(m, y) {
	var d = new Date(y, m, 0);
	return d.getDate();
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getCurrencyMatrix"] = getCurrencyMatrix;
/* harmony export (immutable) */ __webpack_exports__["getCurrencyPrice"] = getCurrencyPrice;
/* harmony export (immutable) */ __webpack_exports__["findStock"] = findStock;
/* harmony export (immutable) */ __webpack_exports__["getStockPrice"] = getStockPrice;
/* harmony export (immutable) */ __webpack_exports__["getStockPriceHistory"] = getStockPriceHistory;
/* harmony export (immutable) */ __webpack_exports__["getStockTickHistory"] = getStockTickHistory;
/* harmony export (immutable) */ __webpack_exports__["sortedSecurityList"] = sortedSecurityList;
/* harmony export (immutable) */ __webpack_exports__["getLeaders"] = getLeaders;
/* harmony export (immutable) */ __webpack_exports__["getSecurityStats"] = getSecurityStats;
/* harmony export (immutable) */ __webpack_exports__["getSplitsBySecurity"] = getSplitsBySecurity;
/* harmony export (immutable) */ __webpack_exports__["getProfile"] = getProfile;
/* harmony export (immutable) */ __webpack_exports__["getEquityOptions"] = getEquityOptions;
/* harmony export (immutable) */ __webpack_exports__["getEarningsEstimates"] = getEarningsEstimates;
/* harmony export (immutable) */ __webpack_exports__["getEarningsEstimatesBySecurity"] = getEarningsEstimatesBySecurity;
/* harmony export (immutable) */ __webpack_exports__["getCorporateActions"] = getCorporateActions;
/* harmony export (immutable) */ __webpack_exports__["getCompetitors"] = getCompetitors;
/* harmony export (immutable) */ __webpack_exports__["getCompanyProfile"] = getCompanyProfile;
/* harmony export (immutable) */ __webpack_exports__["getCompanyLogoURL"] = getCompanyLogoURL;
/* harmony export (immutable) */ __webpack_exports__["getSVGPriceChartURL"] = getSVGPriceChartURL;
/* harmony export (immutable) */ __webpack_exports__["getPNGPriceChartURL"] = getPNGPriceChartURL;
/* harmony export (immutable) */ __webpack_exports__["getIncomeStatement"] = getIncomeStatement;
/* harmony export (immutable) */ __webpack_exports__["getCashFlow"] = getCashFlow;
/* harmony export (immutable) */ __webpack_exports__["getBalanceSheet"] = getBalanceSheet;
/* harmony export (immutable) */ __webpack_exports__["getInsiderActions"] = getInsiderActions;
/* harmony export (immutable) */ __webpack_exports__["getInstitutionalHoldings"] = getInstitutionalHoldings;
/* harmony export (immutable) */ __webpack_exports__["getRatingsByDate"] = getRatingsByDate;
/* harmony export (immutable) */ __webpack_exports__["getRatingsBySecurity"] = getRatingsBySecurity;
/* harmony export (immutable) */ __webpack_exports__["getNewsHeadlines"] = getNewsHeadlines;
/* harmony export (immutable) */ __webpack_exports__["renderNews"] = renderNews;
/* harmony export (immutable) */ __webpack_exports__["stockAPIStreamer"] = stockAPIStreamer;
/* harmony export (immutable) */ __webpack_exports__["newStockAPIStreamer"] = newStockAPIStreamer;
/* harmony export (immutable) */ __webpack_exports__["getDataTable"] = getDataTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_apiCall__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_storage__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util_js__ = __webpack_require__(654);




/**
 * <h1>Synacor CloudQuote API SDK</h1>
 * The public API for interfacing with CloudQuote
 * <p>Two layers of caching:</p>
 *   <p>1. Cache requests by URL to fetchCache<p>
 *   <p>2. Cache symbols found in response to symbolCache<p>
 * @module CloudQuote
 */

/**
 * Returns a matrix of currencies
 * @function getCurrencyMatrix
 * @param {String} currencies  a list of currencies
 * @returns {Promise}          a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getCurrencyMatrix(currencies) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getCurrencyMatrix.json', { currencies: currencies });
}

/**
 * Get a list of currency prices
 * @function getCurrencyPrice
 * @param {String|String[]} symbol     a symbol or array of symbols
 * @returns {Promise}         a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getCurrencyPrice(symbol) {
  symbol = Object(__WEBPACK_IMPORTED_MODULE_2__util_util_js__["d" /* toCsv */])(symbol);
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getCurrencyPrice.json', { symbol: symbol }).then(__WEBPACK_IMPORTED_MODULE_1__util_storage__["c" /* symbolCacheStoreResult */]);
}

/**
 * Run a query and get back a list of quotes
 * @function findStock
 * @param {String} search     A CloudQuote API query string
 * @memberof CloudQuote
 */
function findStock(search) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/findStock.json', { sort: 'Popularity', search: search }).then(__WEBPACK_IMPORTED_MODULE_1__util_storage__["c" /* symbolCacheStoreResult */]);
}

/**
 * Get a list of stock quotes
 * @function getStockPrice
 * @param {String|String[]} symbol    a symbol or array of symbols
 * @returns {Promise}                 a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getStockPrice(symbol) {
  var _getQuotesFromSymbolC = Object(__WEBPACK_IMPORTED_MODULE_1__util_storage__["b" /* getQuotesFromSymbolCache */])(symbol),
      results = _getQuotesFromSymbolC.results,
      miss = _getQuotesFromSymbolC.miss;

  if (!miss.length) {
    // if all symbols are cached we can avoid a network request entirely
    return Promise.resolve(results);
  }

  symbol = Object(__WEBPACK_IMPORTED_MODULE_2__util_util_js__["d" /* toCsv */])(miss);

  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getStockPrice.json', { symbol: symbol }).then(__WEBPACK_IMPORTED_MODULE_1__util_storage__["c" /* symbolCacheStoreResult */]).then(function (data) {
    return results && results.rows.length ? { rows: Object(__WEBPACK_IMPORTED_MODULE_2__util_util_js__["b" /* mergeIntoUndefinedSlots */])(results.rows, data.rows) } : data;
  });
}

/**
 * Get the history of prices on a stock symbol
 * @function getStockPriceHistory
 * @param {Object|String} params      an object with parameters to be passed to the CloudQuote API. if passed a string, the string will be used as the only parameter "symbol"
 * @param {String} [params.symbol]    a symbol
 * @param {String} [params.from]      a date string for when historical data should begin, format 'YYYY-MM-DD'
 * @param {String} [params.to]        a date string for when historical data should end, format 'YYYY-MM-DD'
 * @returns {Promise}                 a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getStockPriceHistory(params) {
  if (typeof params === 'string') {
    // passing in a string will treat that string as a symbol
    params = { symbol: params };
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getStockPriceHistory.json', params);
}

/**
 * Get minute-by-minute stock data
 * @function getStockTickHistory
 * @param {Object} params                      an object with parameters to be passed to the CloudQuote API
 * @param {String|String[]} [params.symbol]    a symbol or array of symbols
 * @param {String} [params.from]               a ISOString date to begin requesting data on
 * @param {String} [params.to]                 the end date to request data from, in ISOString format
 * @returns {Promise}                          a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getStockTickHistory(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getStockTickHistory.json', params);
}

/**
 * Get a list of sorted securities
 * @function sortedSecurityList
 * @param {Object} params     an object with parameters to be passed to the CloudQuote API
 * @returns {Promise}         a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function sortedSecurityList(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/sortedSecurityList.json', params).then(__WEBPACK_IMPORTED_MODULE_1__util_storage__["c" /* symbolCacheStoreResult */]);
}

/**
 * Get a list of leading securities with pricing for the current trading session
 * @function getLeaders
 * @param {Object} params     an object with parameters to be passed to the CloudQuote API
 * @param {String} [params.list]    The list of securities to search (MOSTACTIVE, PERCENTGAINERS, PERCENTLOSERS, POPULAR)
 * @param {String} [params.type]    The type of security (STOCK,FUND,etc.)
 * @param {Integer} [params.limit]   The number of securities to return
 * @param {Bool} [params.calcChange]   The number of securities to return
 * @param {Number} [params.minPrice]   Minimum price of securities to include
 * @returns {Promise}         a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getLeaders(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getLeaders.json', params).then(__WEBPACK_IMPORTED_MODULE_1__util_storage__["c" /* symbolCacheStoreResult */]);
}

/**
 * Returns calculated statistics about a security
 * @function getSecurityStats
 * @param {String} symbol    a symbol
 * @returns {Promise}        a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getSecurityStats(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getSecurityStats.json', { symbol: symbol });
}

/**
 * Retrieve all the stock splits for a security
 * @function getSplitsBySecurity
 * @param {String} symbol    a symbol
 * @returns {Promise}        a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getSplitsBySecurity(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getSplitsBySecurity.json', { symbol: symbol });
}

/**
 * Get financial data profiles of multiple companies (business summary, location, industry name, sicSector etc)
 * @function getProfile
 * @param {String|String[]} symbols    a symbol or array of symbols
 * @returns {Promise}                  a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getProfile(symbols) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/barchart/getProfile.json', { symbols: symbols });
}

/**
 * Retreive the option chain for a security
 * @function getEquityOptions
 * @param {String|String[]} symbols    a symbol or array of symbols
 * @returns {Promise}                  a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getEquityOptions(symbols) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/barchart/getEquityOptions.json', { underlying_symbols: symbols });
}

/**
 * Retreive the earnings estimates for a security
 * @function getEarningsEstimates
 * @param {String|String[]} symbols    a symbol or array of symbols
 * @returns {Promise}                  a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getEarningsEstimates(symbols) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/barchart/getEarningsEstimates.json', { symbols: symbols });
}

/**
 * Retreive detailed earnings estimates for a security
 * @function getEarningsEstimatesBySecurity
 * @param {Object|String} params       an object with parameters to be passed to the CloudQuote API. if passed a string, the string will be used as the only parameter "symbol"
 * @param {String} [params.symbol]     a symbol
 * @returns {Promise}                  a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getEarningsEstimatesBySecurity(params) {
  if (typeof params === 'string') {
    params = { symbol: params };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/barchart/getEarningsEstimatesBySecurity.json', params);
}

/**
 * Retreive the corporate actions for a security
 * @function getCorporateActions
 * @param {Object} params                         an object with parameters to be passed to the CloudQuote API
 * @param {String|String[]} [params.symbols]      a symbol or array of symbols
 * @param {String} [params.eventType]             the event type to get, one of [ dividend, split, earnings ]
 * @returns {Promise}                             a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getCorporateActions(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/barchart/getCorporateActions.json', params);
}

/**
 * Retreive the competitors for a security.
 * @function getCompetitors
 * @param {String} symbol    a symbol
 * @returns {Promise}        a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getCompetitors(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/barchart/getCompetitors.json', { symbol: symbol });
}

/**
 * Get information and useful links about a company (name, website, logo, social media etc)
 * @function getCompanyProfile
 * @param {String} symbol    a symbol
 * @returns {Promise}        a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getCompanyProfile(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/fcon/getCompanyProfile.json', { symbol: symbol });
}

/**
 * Get a URL to a company logo from a symbol
 * @function getCompanyLogoURL
 * @param {String} symbol   a symbol
 * @returns {String}        A URL pointing to the company logo
 * @memberof CloudQuote
 */
function getCompanyLogoURL(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["c" /* getApiUrl */])('/fcon/getCompanyLogo.png', { symbol: symbol });
}

/**
 * Get a price chart in SVG format
 * @function getSVGPriceChartURL
 * @param {Object} params    an object with parameters to be passed to the CloudQuote API
 * @returns {String}         a URL to an SVG price chart
 * @memberof CloudQuote
 */
function getSVGPriceChartURL(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["c" /* getApiUrl */])('/fcon/getPriceChart.svg', params);
}

/**
 * Get a price chart in PNG format
 * @function getPNGPriceChartURL
 * @param {Object} params    an object with parameters to be passed to the CloudQuote API
 * @returns {String}         a URL to a PNG price chart
 * @memberof CloudQuote
 */
function getPNGPriceChartURL() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (window.devicePixelRatio > 2) {
    params.hidpi = 3;
  } else if (window.devicePixelRatio > 1) {
    params.hidpi = 2;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["c" /* getApiUrl */])('/fcon/getPriceChart.png', params);
}

/**
 * Retrieve a list of income statements for a chosen security
 * @function getIncomeStatement
 * @param {String} symbol    a symbol
 * @returns {Promise}        a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getIncomeStatement(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/sage/getIncomeStatement.json', { symbol: symbol });
}

/**
 * Retreive a list of cash flow statements for a chosen security
 * @function getCashFlow
 * @param {String} symbol    a symbol
 * @returns {Promise}        a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getCashFlow(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/sage/getCashFlow.json', { symbol: symbol });
}

/**
 * Retrieve a list of balance sheets for a chosen security
 * @function getBalanceSheet
 * @param {String} symbol    a symbol
 * @returns {Promise}        a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getBalanceSheet(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/sage/getBalanceSheet.json', { symbol: symbol });
}

/**
 * Retrieve a list of insider activity for a chosen security
 * @function getInsiderActions
 * @param {Object} params                an object with parameters to be passed to the CloudQuote API
 * @param {String} [params.symbol]       symbol to get insider actions for
 * @param {Number} [params.count=5000]   number of actions to retrieve
 * @param {Number} [params.start=0]      the number of actions to skip before retrieving
 * @returns {Promise}                    a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getInsiderActions(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/sage/getInsiderActions.json', params);
}

/**
 * Retrieve a list of institutions holding a chosen security
 * @function getInstitutionalHoldings
 * @param {Object} params                  an object with parameters to be passed to the CloudQuote API
 * @param {String} [params.symbol]         symbol to get institutional holdings for
 * @param {Number} [params.count=5000]     number of holdings to retrieve
 * @param {Number} [params.start=0]        the number of holdings to skip before retrieving
 * @returns {Promise}                      a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getInstitutionalHoldings(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/sage/getInstitutionalHoldings.json', params);
}

/**
 * Returns all the rating events for all securities for a particular date range
 * @function getRatingsByDate
 * @param {Object} params                  an object with parameters to be passed to the CloudQuote API
 * @param {String} [params.startDate]      the start range to get dates, format YYYY-MM-DD
 * @param {String} [params.endDate]        the end range to get dates, format YYYY-MM-DD
 * @returns {Promise}                      a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getRatingsByDate(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/streetinsider/getRatingsByDate.json', params);
}

/**
 * Returns all the rating events for a particular security
 * @function getRatingsBySecurity
 * @param {String} symbol    a symbol
 * @returns {Promise}        a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getRatingsBySecurity(symbol) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/streetinsider/getRatingsBySecurity.json', { symbol: symbol });
}

/**
 * Request the most recent headlines from a content provider. Retrieves a list of articles and indexed metadata associated with those articles
 * @function getNewsHeadlines
 * @param {Object} params                  an object with parameters to be passed to the CloudQuote API
 * @param {Number} [params.provider.id]    The numeric ID of the provider you wish to retrieve news releases form (required)
 * @param {String} [params.startDate]      start date to get headlines from, ISO8601 date string
 * @param {String} [params.endDate]        end date to get headlines from, ISO8601 date string
 * @returns {Promise}                      a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getNewsHeadlines(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/prconnect/getNewsHeadlines.json', params);
}

/**
 * Returns the unindexed metadata for an article, and renders the article from the content provider native format into a generic HTML format
 * @function renderNews
 * @param {Object} params         an object with parameters to be passed to the CloudQuote API
 * @param {Number} [params.id]    The numeric ID of the article you wish to render (required) (as found in getNewsHeadlines response)
 * @returns {Promise}             a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function renderNews(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["a" /* apiCall */])('/prconnect/renderNews.json', params);
}

/**
 * A function which can be streamed by the stockAPIStreamer
 * @property {Function} getCurrencyPrice
 * @property {Function} getStockPrice
 * @property {Function} getStockPriceHistory
 * @property {Function} getStockTickHistory
 */
var streamable = {
  getCurrencyPrice: getCurrencyPrice,
  getStockPrice: getStockPrice,
  getStockPriceHistory: getStockPriceHistory,
  getStockTickHistory: getStockTickHistory
};

/**
 * Returns an object that will continously emit new data for given stock symbols
 * @function stockAPIStreamer
 * @param {String|String[]} symbols    a symbol or list of symbols to continously fetch data for
 * @param {streamable} pollingFn       the name of a function to poll the API with, must be a key in {@link streamable}
 * @param {int} timeout                the interval timeout between successive calls to the API
 * @returns {streamer}                 returns a streamer object
 * @memberof CloudQuote
 * @example <caption>A streamer for Stock Prices of the GOOG symbol</caption>
 * let streamer = stockAPIStreamer('GOOG', 'getStockPrice').on('data', (data) => console.log('Got:', data));
 *
 */
function stockAPIStreamer(symbols, pollingFn) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60000;

  return newStockAPIStreamer({ symbols: symbols, pollingFn: pollingFn, timeout: timeout });
}

/**
 * Returns an object that will continously emit new data for given stock symbols
 * @function newStockAPIStreamer
 * @param {String|String[]} symbols    a symbol or list of symbols to continously fetch data for
 * @param {streamable} pollingFn       the name of a function to poll the API with, must be a key in {@link streamable}
 * @param {int} timeout                the interval timeout between successive calls to the API
 * @param {function} shouldUpdate      a function that can be evaluated each interval to determine whether or not to allow the api call to proceed
 * @returns {streamer}                 returns a streamer object
 * @memberof CloudQuote
 * @example <caption>A streamer for Stock Prices of the GOOG symbol</caption>
 * let streamer = stockAPIStreamer('GOOG', 'getStockPrice').on('data', (data) => console.log('Got:', data));
 *
 */
function newStockAPIStreamer(_ref) {
  var symbols = _ref.symbols,
      pollingFn = _ref.pollingFn,
      timeout = _ref.timeout,
      shouldUpdate = _ref.shouldUpdate;


  /**
   * An object to stream API data for a list of symbols. Use {@link #CloudQuotestockAPIStreamer|CloudQuote.stockAPIStreamer} to create a streamer.
   * @namespace streamer
   */
  pollingFn = streamable[pollingFn];
  timeout = timeout || 60000;
  shouldUpdate = typeof shouldUpdate === 'function' ? shouldUpdate : function () {
    return true;
  };
  var streamer = {};
  var callbacks = { then: function then() {}, catch: function _catch() {} };
  var timer = void 0;

  /**
   * Set an event handler for the streamer
   * @function streamer.on
   * @param {String} event         the event to listen for, valid events include [ 'data', 'error' ]
   * @param {Function} callback    the callback to fire for the event
   * @returns {streamer}           returns itself for chaining methods together
   */
  streamer.on = function (event, callback) {
    if (event === 'data') callbacks.then = callback;
    if (event === 'error') callbacks.catch = callback;

    streamer.stream();
    return streamer;
  };

  /**
   * Start/restart the streamer with a list of symbols
   * @function streamer.stream
   * @param {String|String[]} newSymbols    a list of symbols to continously get data for. if not passed any symbols, use the current symbols
   * @returns {streamer}                    returns itself for chaining methods together
   */
  streamer.stream = function (newSymbols) {
    streamer.end();
    symbols = newSymbols || symbols;
    if (symbols && symbols.length > 0) {
      pollingFn(symbols).then(callbacks.then).catch(callbacks.catch);

      timer = setInterval(function () {
        if (!shouldUpdate()) return;
        if (!timer) return;
        pollingFn(symbols).then(callbacks.then).catch(callbacks.catch);
      }, timeout);
    }
    return streamer;
  };

  /**
   * Stop the streamer from fetching data
   * @function streamer.end
   * @returns {streamer}           returns itself for chaining methods together
   */
  streamer.end = function () {
    clearInterval(timer);
    timer = null;
    return streamer;
  };

  /**
   * Set the timeout between requests for the streamer
   * @function streamer.setTimeout
   * @param {Number} n             the timeout between polling the API in milliseconds
   * @returns {streamer}           returns itself for chaining methods together
   */
  streamer.setTimeout = function (n) {
    timeout = n;
    return streamer;
  };

  return streamer;
}

/**
 * Fields which can be provided to getDataTable
 * @constant DATA_TABLE_FIELDS
 * @param {Number} ANNUALDIVIDEND             dividend, in reporting currency
 * @param {Number} ASK                        ask price, in trading currency
 * @param {Number} ASKSIZE                    ask size, in shares
 * @param {Number} AVGVOLUME3M                3-month average daily volume, in shares
 * @param {Number} BID                        bid price, in trading currency
 * @param {Number} BIDSIZE                    bid size, in shares
 * @param {Number} BOOKVALUE                  book value, in reporting currency
 * @param {Number} CHANGEPCTVSHIGH52          percentage change vs. 52-week high
 * @param {Number} CHANGEPCTVSLOW52           percentage change vs. 52-week low
 * @param {Number} CHANGEPERCENT              share price percentage change vs. previous trading session, in trading currency
 * @param {Number} CHANGEPRICE                share price change vs. previous trading session, in trading currency
 * @param {Number} CHANGEVSHIGH52             change vs. 52-week high, in trading currency
 * @param {Number} CHANGEVSLOW52              change vs. 52-week low, in trading currency
 * @param {Number} CHGPCTVS200MA              percentage change vs. 200-day moving average price
 * @param {Number} CHGPCTVS50MA               percentage change vs. 50-day moving average price
 * @param {Number} CHGVS200MA                 change vs. 200-day moving average price, in trading currency
 * @param {Number} CHGVS50MA                  change vs. 50-day moving average price, in trading currency
 * @param {String} CURRENCY                   currency
 * @param {Number} EBITDA                     earnings before interest, taxes, depreciation & amortization, (trailing 12-month period?), in reporting currency
 * @param {Number} EPS                        earnings-per-share (trailing 12-month period?), in reporting currency
 * @param {Number} EPSESTCURYEAR              earnings-per-share estimate for the current fiscal year, in reporting currency
 * @param {Number} EPSESTNEXTQTR              earnings-per-share estimate for the current fiscal quarter, in reporting currency
 * @param {Number} EPSESTNEXTYEAR             earnings-per-share estimate for the next fiscal year, in reporting currency
 * @param {String} EXCHANGE                   exchange on which the security is traded
 * @param {Number} EXCHANGEDEFAULTCURRENCY    trading currency of the exchange on which the security is traded
 * @param {Number} EXCHANGESHORTNAME          short name of the exchange on which the security is traded
 * @param {Number} HIGH                       intra-day high, in trading currency
 * @param {Number} HIGH52                     52-week high, in trading currency
 * @param {Number} LASTDIVDATE                timestamp
 * @param {Number} LASTTRADETIME              timestamp in seconds
 * @param {Number} LOW                        intra-day low, in trading currency
 * @param {Number} LOW52                      52-week low, in trading currency
 * @param {Number} MARKETCAP                  market capitalization, in trading currency
 * @param {Number} MOVINGAVG200               200-day moving average, in trading currency
 * @param {Number} MOVINGAVG50                50-day moving average, in trading currency
 * @param {String} NAME                       company name
 * @param {Number} NOMINALCURRENCYCODE        code name of nomincal currency (e.g. 'USD')
 * @param {Number} OPEN                       opening price of the current or most recent trading session, in trading currency
 * @param {Number} PEESTCURYEAR               price-to-earnings ratio estimate for the current fiscal year
 * @param {Number} PEESTNEXTYR                price-to-earnings ratio estimate for the next fiscal year
 * @param {Number} PEG                        price-to-earnings-to-growth ratio
 * @param {Number} PREVCLOSE                  close price of the most recently-closed trading session, in trading currency
 * @param {Number} PRICE                      most recent trading price, in trading currency
 * @param {Number} PRICEBOOK                  price-to-book ratio
 * @param {Number} PRICESALES                 price-to-sales ratio (trailing 12-month period?)
 * @param {Number} SECURITYTYPECODE           code name of the security type (e.g. 'STOCK', 'FUND', etc.)
 * @param {Number} SHARESOUTSTANDING          number of shares outstanding
 * @param {String} SYMBOL                     security ticker or security ID
 * @param {Number} TRAILINGPE                 trailing price-to-earnings ratio
 * @param {Number} VOLUME                     cumulative trading volume for the current (or most recently closed?) session
 * @param {Number} YIELD                      trailing yield prercentage
 */
var DATA_TABLE_FIELDS = ['ANNUALDIVIDEND', 'ASK', 'ASKSIZE', 'AVGVOLUME3M', 'BID', 'BIDSIZE', 'BOOKVALUE', 'CHANGEPCTVSHIGH52', 'CHANGEPCTVSLOW52', 'CHANGEPERCENT', 'CHANGEPRICE', 'CHANGEVSHIGH52', 'CHANGEVSLOW52', 'CHGPCTVS200MA', 'CHGPCTVS50MA', 'CHGVS200MA', 'CHGVS50MA', 'CURRENCY', 'EBITDA', 'EPS', 'EPSESTCURYEAR', 'EPSESTNEXTQTR', 'EPSESTNEXTYEAR', 'EXCHANGE', 'EXCHANGEDEFAULTCURRENCY', 'EXCHANGESHORTNAME', 'HIGH', 'HIGH52', 'LASTDIVDATE', 'LASTTRADETIME', 'LOW', 'LOW52', 'MARKETCAP', 'MOVINGAVG200', 'MOVINGAVG50', 'NAME', 'NOMINALCURRENCYCODE', 'OPEN', 'PEESTCURYEAR', 'PEESTNEXTYR', 'PEG', 'PREVCLOSE', 'PRICE', 'PRICEBOOK', 'PRICESALES', 'SECURITYTYPECODE', 'SHARESOUTSTANDING', 'SYMBOL', 'TRAILINGPE', 'VOLUME', 'YIELD'];

/**
 * Get values for a provided set of data fields for a provided list of securities
 * @function getDataTable
 * @param {Object} opts                                        options for the request
 * @param {String|String[]} opts.symbols                       a symbol or array of symbols
 * @param {String|String[]} [opts.fields=DATA_TABLE_FIELDS]    a field or array of fields
 * @param {Boolean} [opts.keyResponseDataBySymbol=false]       indicates whether the response should be mutated to be keyed by security
 * @returns {Promise}                                          a Promise resolving with JSON or rejecting with error
 * @memberof CloudQuote
 */
function getDataTable() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var symbols = opts.symbols,
      _opts$fields = opts.fields,
      fields = _opts$fields === undefined ? DATA_TABLE_FIELDS : _opts$fields;


  if (!symbols || !symbols.length) {
    return Promise.reject('No symbols provided.');
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_apiCall__["b" /* apiCallWithManySymbols */])('/cloudquote/getDataTable.json', symbols, { fields: Object(__WEBPACK_IMPORTED_MODULE_2__util_util_js__["d" /* toCsv */])(fields) }).then(function (response) {
    return opts.keyResponseDataBySymbol ? Object(__WEBPACK_IMPORTED_MODULE_2__util_util_js__["a" /* keyResponseDataBySymbol */])(symbols, response) : response;
  });
}

/***/ }),
/* 336 */,
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FinanceSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Pill; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__os_debounce__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__os_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__os_debounce__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var THIRTY_FPS = 33.33;

var FinanceSpinner = function FinanceSpinner(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.loading, props.class), style: props.style },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["r" /* Spinner */], { showError: true, 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.spinner })
		)
	);
};

function safeGetBBox(element) {
	try {
		return element.getBBox();
	}
	//firefox throws exception if you try to getBBox() of a hidden element
	//silently ignore it
	catch (e) {}
}

/**
 * An SVG pill that auto-sizes/centers based on the text in the label
 */
var Pill = (_temp2 = _class = function (_Component) {
	_inherits(Pill, _Component);

	function Pill() {
		var _temp, _this, _ret;

		_classCallCheck(this, Pill);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { width: 1, height: 1

			/**
    * Update the width state with the new width of the pill
    */
		}, _this.updateWidth = __WEBPACK_IMPORTED_MODULE_4__os_debounce___default()(function () {
			var _this$props$maxWidth = _this.props.maxWidth,
			    maxWidth = _this$props$maxWidth === undefined ? 99999 : _this$props$maxWidth;

			var dims = safeGetBBox(_this.base && _this.base.lastChild);

			// failed to find dimensions
			if (!dims) return;
			var width = dims.width,
			    height = dims.height;

			//pad the width for the rounded corners but don't exceed the maxWidth

			width = Math.min(width + height, maxWidth);
			_this.setState({ width: width, height: height });
		}, THIRTY_FPS), _temp), _possibleConstructorReturn(_this, _ret);
	}

	//update the width based on the size of the newly created text svg node
	Pill.prototype.componentDidMount = function componentDidMount() {
		this.updateWidth();
	};

	//update the width only if the label property or maxWidth has changed


	Pill.prototype.componentDidUpdate = function componentDidUpdate(_ref) {
		var label = _ref.label,
		    maxWidth = _ref.maxWidth;

		if (label !== this.props.label || maxWidth !== this.props.maxWidth) {
			this.updateWidth();
		}
	};

	/**
  * @param x The upper-left x dimension of where to position the pill (see center* params below for more positioning)
  * @param y The upper-left y dimension of where to position the pill (see center* params below for more positioning)
  * @param {Object} padding object witih top/bottom/left/right keys for the amount of padding to add around the text
  * @param maxWidth The maximum width in pixels of the pill
  * @param label The label/text to be shown in the pill
  * @param centerX True/False whether to center the pill horizontally along the x-axis.  Default: False.
  * @param centerY True/False whether to center the pill vertically along the y-axis.  Default: False.
  * @param mixX If specified, the minimum x-value that the pill should be drawn at
  * @param maxX If specified, the maximum x-value that the pill should be drawn at
  * @param class The class attribute to be applied to the surrounding <g> element for the pill
  * @param pillShape allows for different shaped pills. Defult: rounded
  *
  */


	Pill.prototype.render = function render(_ref2, _ref3) {
		var width = _ref3.width,
		    height = _ref3.height;

		var x = _ref2.x,
		    y = _ref2.y,
		    padding = _ref2.padding,
		    maxWidth = _ref2.maxWidth,
		    label = _ref2.label,
		    centerX = _ref2.centerX,
		    centerY = _ref2.centerY,
		    minX = _ref2.minX,
		    maxX = _ref2.maxX,
		    pillShape = _ref2.pillShape,
		    restProps = _objectWithoutProperties(_ref2, ['x', 'y', 'padding', 'maxWidth', 'label', 'centerX', 'centerY', 'minX', 'maxX', 'pillShape']);

		var _padding$top = padding.top,
		    top = _padding$top === undefined ? 0 : _padding$top,
		    _padding$bottom = padding.bottom,
		    bottom = _padding$bottom === undefined ? 0 : _padding$bottom,
		    _padding$left = padding.left,
		    left = _padding$left === undefined ? 0 : _padding$left,
		    _padding$right = padding.right,
		    right = _padding$right === undefined ? 0 : _padding$right;

		//Make sure we still render something valid even if we don't get valid x,y
		//so that preact will re-render the SVG component when we do get valid props

		var shouldHide = typeof x === 'undefined' || typeof y === 'undefined';
		if (shouldHide) {
			x = 0;
			y = 0;
		}

		height = height + top + bottom;
		width = width + left + right;
		var halfHeight = height / 2;
		var halfWidth = width / 2;
		var pointyPillWidth = Math.max(width - 7, 0);
		if (centerX) x -= halfWidth;
		var rectX = Math.min(maxX - width, Math.max(minX, x));
		if (centerY) y -= halfHeight;

		//creates a polygon for the pointy pill pointer
		var polyPoints = String('8,0 ' + halfWidth + ',0 ' + halfWidth + ',' + height + ' 8,' + height + ' 0,' + halfHeight);

		if (pillShape === 'rounded' || !pillShape) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				_extends({ style: shouldHide ? 'display:none' : false }, restProps),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { x: rectX, y: y, width: width, height: height, rx: halfHeight, ry: halfHeight }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'text',
					{ x: rectX + halfWidth + left, y: y + halfHeight + top / 2, dy: '0.38em', 'text-anchor': 'middle' },
					label
				)
			);
		}

		if (pillShape === 'pointy') {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				_extends({ style: shouldHide ? 'display:none' : false }, restProps),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'svg',
					{ x: rectX - 1, y: y, height: height + 2, width: halfWidth },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('polygon', { points: polyPoints })
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { x: rectX + 6, y: y, width: pointyPillWidth, height: height, rx: halfHeight, ry: halfHeight }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'text',
					{ x: rectX + halfWidth + left + 1, y: y + halfHeight + top / 2, dy: '0.38em', 'text-anchor': 'middle' },
					label
				)
			);
		}
	};

	return Pill;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	padding: { top: 0, bottom: 0, left: 0, right: 0 },
	minX: -1,
	maxX: 999999,
	pillShape: 'rounded' }, _temp2);

/***/ }),
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Container;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function Container(_ref) {
	var parent = _ref.parent,
	    props = _objectWithoutProperties(_ref, ['parent']);

	return parent ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["d" /* ContainerSize */],
		{ height: false },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Cont, _extends({ parent: 'parent' }, props))
	) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Cont, props);
}

var Cont = function Cont(_ref2) {
	var title = _ref2.title,
	    _ref2$transform = _ref2.transform,
	    transform = _ref2$transform === undefined ? 'capitalize' : _ref2$transform,
	    children = _ref2.children,
	    width = _ref2.width,
	    theme = _ref2.theme,
	    props = _objectWithoutProperties(_ref2, ['title', 'transform', 'children', 'width', 'theme']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style___default.a.container, __WEBPACK_IMPORTED_MODULE_1__style___default.a[props.parent], props.class, width > 630 && __WEBPACK_IMPORTED_MODULE_1__style___default.a.wide, __WEBPACK_IMPORTED_MODULE_1__style___default.a[theme]) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.shiftedContainer },
			title && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["h" /* HeaderV2 */], { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.head, title: title }),
			children
		)
	);
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__(862);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__(863);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__(668);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__(670);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__(864);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__(867);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__(868);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__(674);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__(869);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__(870);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__(871);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__(872);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__(675);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__(667);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__(873);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__(514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__(672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_19__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__(874);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__(875);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__(876);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__(673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__(676);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__(669);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__(877);
/* unused harmony reexport zip */




























/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__value_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array_js__ = __webpack_require__(682);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis_js__ = __webpack_require__(519);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed_js__ = __webpack_require__(680);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_js__ = __webpack_require__(683);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete_js__ = __webpack_require__(887);
/* unused harmony reexport interpolateDiscrete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue_js__ = __webpack_require__(888);
/* unused harmony reexport interpolateHue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number_js__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__number_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(520);
/* unused harmony reexport interpolateNumberArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__object_js__ = __webpack_require__(684);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__round_js__ = __webpack_require__(889);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__round_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__string_js__ = __webpack_require__(685);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__string_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transform_index_js__ = __webpack_require__(890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__transform_index_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_12__transform_index_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zoom_js__ = __webpack_require__(893);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_13__zoom_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rgb_js__ = __webpack_require__(679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__rgb_js__["a"]; });
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hsl_js__ = __webpack_require__(894);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lab_js__ = __webpack_require__(895);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hcl_js__ = __webpack_require__(896);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cubehelix_js__ = __webpack_require__(897);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_18__cubehelix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__piecewise_js__ = __webpack_require__(898);
/* unused harmony reexport piecewise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__quantize_js__ = __webpack_require__(899);
/* unused harmony reexport quantize */






















/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = scaleFinanceTime;
/* harmony export (immutable) */ __webpack_exports__["a"] = financeScale;
/* harmony export (immutable) */ __webpack_exports__["b"] = financeScaleInvert;
/* unused harmony export financeSecondsOfDay */
/* unused harmony export weekdaysInYear */
/* unused harmony export weekdayOfYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_localtime__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__finance_constants__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__ = __webpack_require__(925);







/**
 * Meant to be a drop-in replacement for d3-scale/scaleTime, but uses the financial calendar instead of a regular
 * calendar. i.e. Only M-F, 9:00am-5:00pm are used in the scale.  The difference is that it expects
 * the domain to be from the financeScale function in this file instead of straight date/epoch values
 *
 * @see https://github.com/d3/d3-scale#time-scales for provided functions
 */
function scaleFinanceTime() {
	var scale = Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleLinear */])();

	scale.ticks = function (count) {
		var d = this.domain();
		return getTickGenerator(d)(d[0], d[1], count);
	};

	scale.tickFormat = function (count, specifier) {
		return specifier ? function (tick) {
			return __WEBPACK_IMPORTED_MODULE_3__os_localtime__["a" /* default */].format(specifier)(Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(financeScaleInvert(tick)));
		} : formatTick;
	};

	return scale;
}

/**
 * Return an appropriate interval generator for the span of the domain
 * e.g. if the domain spans 2 years or more, it will return a yearlyInterval function,
 * if the domain spans 7 months-2 years, it will return a quarterlyInterval function, etc.
 *
 * @param {Array} domain The domain array from a scale with 2 values, domain[0] is the
 *		beginning of the domain and domain[1] is the end of the domain as ticks from fiannceScale
 * @returns {Function} an interval function like yearlyInterval that given a domain will return appropriate ticks for an axis of that domain
 */
function getTickGenerator(domain) {
	var tickSpan = domain[1] - domain[0] + 1;

	/* eslint-disable no-magic-numbers */
	/* eslint-disable indent */
	return tickSpan < 6 ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["k" /* secondlyInterval */] : tickSpan < 3 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["v" /* SECONDS_PER_MINUTE */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["e" /* halfMinutelyInterval */] : tickSpan < 6 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["v" /* SECONDS_PER_MINUTE */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["g" /* minutelyInterval */] : tickSpan < 30 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["v" /* SECONDS_PER_MINUTE */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["d" /* fiveMinutelyInterval */] : tickSpan < 90 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["v" /* SECONDS_PER_MINUTE */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["i" /* quarterHourlyInterval */] : tickSpan < 6 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["u" /* SECONDS_PER_HOUR */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["f" /* hourlyInterval */] : tickSpan < 12 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["u" /* SECONDS_PER_HOUR */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["a" /* bihourlyInterval */] : tickSpan < 6 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["b" /* dailyInterval */] : tickSpan < 6 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["q" /* SECONDS_PER_FINANCE_WEEK */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["l" /* weeklyInterval */] : tickSpan < 7 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["p" /* SECONDS_PER_FINANCE_MONTH */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["h" /* monthlyInterval */] : tickSpan < 2 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["r" /* SECONDS_PER_FINANCE_YEAR */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["j" /* quarterlyInterval */] : tickSpan < 11 * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["r" /* SECONDS_PER_FINANCE_YEAR */] ? __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["m" /* yearlyInterval */] : __WEBPACK_IMPORTED_MODULE_5__finance_time_intervals__["c" /* decadelyInterval */];

	/* eslint-enable indent */
	/* eslint-enable no-magic-numbers */
}

// Format definitions used in formatTick
var formatSecond = __WEBPACK_IMPORTED_MODULE_3__os_localtime__["a" /* default */].format(':%S'),
    // :05
formatMinute = __WEBPACK_IMPORTED_MODULE_3__os_localtime__["a" /* default */].format('%I:%M'),
    // 04:05 (12-hour clock)
formatHour = __WEBPACK_IMPORTED_MODULE_3__os_localtime__["a" /* default */].format('%I %p'),
    // 04 PM
formatDay = __WEBPACK_IMPORTED_MODULE_3__os_localtime__["a" /* default */].format('%a %d'),
    // Fri 23
formatWeek = __WEBPACK_IMPORTED_MODULE_3__os_localtime__["a" /* default */].format('%b %d'),
    // Jan 23
formatMonth = __WEBPACK_IMPORTED_MODULE_3__os_localtime__["a" /* default */].format('%B'),
    // January
formatYear = __WEBPACK_IMPORTED_MODULE_3__os_localtime__["a" /* default */].format('%Y'); // 2016

/**
 * Given a tick value, format the tick in a "smart" way such that as you zoom in and out
 * on a scale you see years when zoomed out far and seconds when zoomed way in
 * It does this by formatting the tick based on whether it falls on a given fidelity
 * boundary.
 * The first tick of a year will be formatted as yearly - 2016
 * The first tick of the month that isn't the first tick of the year will be formatted as monthly - February
 * The first tick of the week that isn't the first tick of the month or year will be formatted as weekly - Jan 23
 * ...etc. all the way down through daily, hourly, minutely, and secondly
 *
 * @param {Integer} tick from financeScale
 * @returns {String} The tick formatted as a date string according to the rules above
 */
function formatTick(tick) {
	var tickDate = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(financeScaleInvert(tick));
	var d = new Date(tickDate);

	//get the first
	var firstTickOfYear = financeScale(Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(new Date(d.getFullYear(), 0))) + 1;
	if (tick === firstTickOfYear) return formatYear(tickDate);

	/* Steadily decrease the fidelity of the tick date.  If a particular decrease
 	in fidelity yields a lower date, that is your fidelity for formatting. */
	d.setMilliseconds(0);
	d.setSeconds(0);
	if (d < tickDate) return formatSecond(tickDate);

	d.setMinutes(0);
	if (d < tickDate) return formatMinute(tickDate);

	d.setHours(__WEBPACK_IMPORTED_MODULE_4__finance_constants__["d" /* FIRST_HOUR */]);
	if (d < tickDate) return formatHour(tickDate);

	/* Weekly format check.  If day is a Monday, it is first of week,
  	but could also be first of month.  If first of month, format as monthly
 	otherwise format as weekly */
	if (d <= tickDate && d.getDay() === __WEBPACK_IMPORTED_MODULE_4__finance_constants__["k" /* MONDAY */]) {
		d.setDate(1);
		var dayOfWeek = (d.getDay() + __WEBPACK_IMPORTED_MODULE_4__finance_constants__["A" /* SHIFT_MONDAY_TO_DAY_0 */]) % __WEBPACK_IMPORTED_MODULE_4__finance_constants__["b" /* DAYS_PER_WEEK */];
		//if on a Weekend, set date to the first following Monday
		if (dayOfWeek > __WEBPACK_IMPORTED_MODULE_4__finance_constants__["x" /* SHIFTED_FRIDAY */]) d.setDate(Math.abs(dayOfWeek - __WEBPACK_IMPORTED_MODULE_4__finance_constants__["b" /* DAYS_PER_WEEK */] - 1));
		return d < tickDate ? formatWeek(tickDate) : formatMonth(tickDate);
	}

	d.setDate(1);
	if (d < tickDate) return formatDay(tickDate);

	d.setMonth(0);
	if (d < tickDate) return formatMonth(tickDate);

	return formatYear(tickDate);
}

/**
 * A linear scale where 1 tick is equal to 1 second.  It only includes Monday-Friday,
 * 9:00am - 5:00 pm Eastern time (inclusive) as "tickable" times.  Any days/times outside of that range
 * map to the previous valid tick value (i.e. a floor function).
 * @param {Date} date A date object or an epoch time number representing a date.
 * @returns {Integer} scaleValue An integer value representing the date's place in the linear scale
 */
function financeScale(date) {
	if (!date) return undefined;
	var dateInEasternTZ = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(date);

	var dayInYear = weekdayOfYear(dateInEasternTZ),
	    year = dateInEasternTZ.getFullYear(),
	    weekdays = dayInYear + weekdaysBeforeYear(year),
	    secondsInDay = financeSecondsOfDay(dateInEasternTZ),
	    isWeekDay = dateInEasternTZ.getDay() > __WEBPACK_IMPORTED_MODULE_4__finance_constants__["C" /* SUNDAY */] && dateInEasternTZ.getDay() < __WEBPACK_IMPORTED_MODULE_4__finance_constants__["m" /* SATURDAY */];
	if (isWeekDay && secondsInDay === null || !isWeekDay && dayInYear === 0) {
		//don't count the current weekday if we haven't reached the first valid second of the day or year
		weekdays--;
		secondsInDay = __WEBPACK_IMPORTED_MODULE_4__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */] - 1;
	} else if (!isWeekDay) {
		//treat weekend day like end of Friday
		secondsInDay = __WEBPACK_IMPORTED_MODULE_4__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */] - 1;
	}

	return weekdays * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */] + secondsInDay;
}

// The inverse of financeScale.  Given a scale value, returns a date;
function financeScaleInvert(seconds) {
	if (typeof seconds === 'undefined') return undefined;

	var year = __WEBPACK_IMPORTED_MODULE_4__finance_constants__["a" /* BASE_YEAR */],
	    yearWeekdays = void 0;

	var weekdays = seconds / __WEBPACK_IMPORTED_MODULE_4__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */] | 0;
	var secondsInDay = seconds - weekdays * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */];

	// Compute the year and the remaining weekdays in the last year
	while ((yearWeekdays = weekdaysInYear(year)) <= weekdays) {
		++year;
		weekdays -= yearWeekdays;
	}

	// Compute the date from the remaining weekdays.
	var days = weekdays % __WEBPACK_IMPORTED_MODULE_4__finance_constants__["D" /* WEEKDAYS_PER_WEEK */],
	    day0 = (new Date(year, 0, 1).getDay() + __WEBPACK_IMPORTED_MODULE_4__finance_constants__["A" /* SHIFT_MONDAY_TO_DAY_0 */]) % __WEBPACK_IMPORTED_MODULE_4__finance_constants__["b" /* DAYS_PER_WEEK */];
	if (day0 + days > __WEBPACK_IMPORTED_MODULE_4__finance_constants__["x" /* SHIFTED_FRIDAY */]) days += __WEBPACK_IMPORTED_MODULE_4__finance_constants__["B" /* SHIFT_WEEKEND_TO_WEEKDAY */];
	//fix for years that start on Sunday
	if (day0 === __WEBPACK_IMPORTED_MODULE_4__finance_constants__["z" /* SHIFTED_SUNDAY */]) days -= 1;
	return Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["b" /* getLocalTimeFromEasternDate */])(new Date(year, 0, (weekdays / __WEBPACK_IMPORTED_MODULE_4__finance_constants__["D" /* WEEKDAYS_PER_WEEK */] | 0) * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["b" /* DAYS_PER_WEEK */] + days + 1, 0, 0, __WEBPACK_IMPORTED_MODULE_4__finance_constants__["g" /* FIRST_SECOND_OF_FINANCE_DAY */] + secondsInDay));
}

/**
 * Return 0-based seconds in the finance day.  0 starts at the first second of the finance day (e.g. 9:00:00 am)
 * and counts up 1 each seconds until the the end of the finance day e.g. 5:00:00 pm Eastern (inclusive).
 *
 * @param {Date} date The date to analyze the time portion of to get the finance seconds in its day
 * @returns {Integer} The number of 0 based seconds.  If the time is before the start of the finance day on a given day, return null.
 * If time is after end of finance day, return the same value as end of finance day
 */
function financeSecondsOfDay(date) {
	var seconds = date.getHours() * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["u" /* SECONDS_PER_HOUR */] + date.getMinutes() * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["v" /* SECONDS_PER_MINUTE */] + date.getSeconds();
	if (seconds < __WEBPACK_IMPORTED_MODULE_4__finance_constants__["g" /* FIRST_SECOND_OF_FINANCE_DAY */]) return null;
	return Math.min(__WEBPACK_IMPORTED_MODULE_4__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */] - 1, seconds - __WEBPACK_IMPORTED_MODULE_4__finance_constants__["g" /* FIRST_SECOND_OF_FINANCE_DAY */]);
}

/**
 * Returns the number of weekdays in the specified year.  Similar to Array.length,
 * it is the true length, even though weekdayOfYear is 0 based
 *
 * @param {Integer} year The full year (e.g. 2016) to get get the number of weekdays for
 * @returns {Integer} Number of weekdays in year
 */
function weekdaysInYear(year) {
	var LAST_DAY = 31;
	return weekdayOfYear(new Date(year, __WEBPACK_IMPORTED_MODULE_4__finance_constants__["c" /* DECEMBER */], LAST_DAY)) + 1;
}

var weekdaysBeforeYearCache = {};

/**
 * Given a year return how many weekdays were in all of the years
 * from 1970 up to that year exclusive
 * @example weekdaysBeforeYear(2000) would return the sum of weekdays in the years 1970-1999
 *
 * @param {Integer} year
 * @returns {Integer} weekdays Number of weekdays in all of the years between 1970 and this year
 */
function weekdaysBeforeYear(year) {
	if (weekdaysBeforeYearCache.hasOwnProperty(year)) return weekdaysBeforeYearCache[year];
	return year <= __WEBPACK_IMPORTED_MODULE_4__finance_constants__["a" /* BASE_YEAR */] ? 0 : weekdaysBeforeYearCache[year] = weekdaysInYear(year - 1) + weekdaysBeforeYear(year - 1);
}

/**
 * Get the 0-based weekday number for the given date relative to the start of the year. i.e. First weekday of year is 0
 * seconds weekday of year is 1, etc.  Saturday and Sunday report the value for the prior Friday.
 * @param {Date} date
 * @returns {Integer} 0-based weekday number for the date
 */
function weekdayOfYear(date) {
	var year = date.getFullYear();
	var daysEllapsedInYear = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(date), date),
	    weeks = daysEllapsedInYear / __WEBPACK_IMPORTED_MODULE_4__finance_constants__["b" /* DAYS_PER_WEEK */] | 0,
	    // bitwise or is same as floor to int value
	//Day of week (Monday=0, Sunday=6) for 1st day of year
	day0 = (new Date(year, 0, 1).getDay() + __WEBPACK_IMPORTED_MODULE_4__finance_constants__["A" /* SHIFT_MONDAY_TO_DAY_0 */]) % __WEBPACK_IMPORTED_MODULE_4__finance_constants__["b" /* DAYS_PER_WEEK */],

	//Day of week (Monday=0, Sunday=6) for date argument
	dayDate = (new Date(year, 0, daysEllapsedInYear + 1).getDay() + __WEBPACK_IMPORTED_MODULE_4__finance_constants__["A" /* SHIFT_MONDAY_TO_DAY_0 */]) % __WEBPACK_IMPORTED_MODULE_4__finance_constants__["b" /* DAYS_PER_WEEK */],
	    cumulativeWeekendDays = weeks * __WEBPACK_IMPORTED_MODULE_4__finance_constants__["E" /* WEEKEND_DAYS_PER_WEEK */];

	if (day0 === __WEBPACK_IMPORTED_MODULE_4__finance_constants__["y" /* SHIFTED_SATURDAY */]) {
		//If Year started on a Saturday, add two weekend days, except if date is Saturday, where we only add 1
		cumulativeWeekendDays += dayDate === __WEBPACK_IMPORTED_MODULE_4__finance_constants__["y" /* SHIFTED_SATURDAY */] ? 1 : __WEBPACK_IMPORTED_MODULE_4__finance_constants__["E" /* WEEKEND_DAYS_PER_WEEK */];
	} else if (day0 === __WEBPACK_IMPORTED_MODULE_4__finance_constants__["z" /* SHIFTED_SUNDAY */]) {
		//If Year started on a Sunday, add 1 weekend day, except Saturday, where add 2
		cumulativeWeekendDays += dayDate === __WEBPACK_IMPORTED_MODULE_4__finance_constants__["y" /* SHIFTED_SATURDAY */] ? __WEBPACK_IMPORTED_MODULE_4__finance_constants__["E" /* WEEKEND_DAYS_PER_WEEK */] : 1;
	} else {
		//year started on a weekday
		//add 1 for Saturday and 2 for Sunday or if we don't have a full week if year started on a weekday
		cumulativeWeekendDays += dayDate < day0 || dayDate === __WEBPACK_IMPORTED_MODULE_4__finance_constants__["z" /* SHIFTED_SUNDAY */] ? __WEBPACK_IMPORTED_MODULE_4__finance_constants__["E" /* WEEKEND_DAYS_PER_WEEK */] : dayDate === __WEBPACK_IMPORTED_MODULE_4__finance_constants__["y" /* SHIFTED_SATURDAY */] ? 1 : 0;
	}

	//Remove the number of weekend days so far in this year from the ellapsed day total
	//Adjust for years that start on Saturday or Sunday
	return Math.max(0, daysEllapsedInYear - cumulativeWeekendDays);
}

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab_js__ = __webpack_require__(885);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["b"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__ = __webpack_require__(886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__["a"]; });




/***/ }),
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StockDetailsPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stock_price_bar__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stock_details_nav__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaults__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cube_store_connect__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var StockDetailsPage = function (_Component) {
	_inherits(StockDetailsPage, _Component);

	function StockDetailsPage() {
		_classCallCheck(this, StockDetailsPage);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	// Get the stock type for a symbol, e.g. "stock" or "index"
	StockDetailsPage.prototype.getStockType = function getStockType(symbol) {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_4__os_cloudquote__["getStockPrice"])(symbol).then(function (_ref) {
			var rows = _ref.rows;

			if (rows && rows[0]) {
				_this2.setState({
					done: true,
					securityTypeCode: rows[0].SecurityTypeCode,
					uniqueSymbol: rows[0].UniqueSymbol
				});
			} else {
				_this2.setState({ done: true, notFound: true });
			}
		});
	};

	StockDetailsPage.prototype.componentWillMount = function componentWillMount() {
		this.getStockType(this.props.symbol);
	};

	StockDetailsPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
		var symbol = _ref2.symbol;

		if (this.props.symbol !== symbol) {
			this.getStockType(symbol);
		}
	};

	StockDetailsPage.prototype.render = function render(_ref3, _ref4) {
		var done = _ref4.done,
		    notFound = _ref4.notFound,
		    _ref4$securityTypeCod = _ref4.securityTypeCode,
		    securityTypeCode = _ref4$securityTypeCod === undefined ? 'STOCK' : _ref4$securityTypeCod,
		    uniqueSymbol = _ref4.uniqueSymbol,
		    _ref4$hasCompanyData = _ref4.hasCompanyData,
		    hasCompanyData = _ref4$hasCompanyData === undefined ? false : _ref4$hasCompanyData,
		    companyProfileData = _ref4.companyProfileData;

		var children = _ref3.children,
		    showCurrencyIndicator = _ref3.showCurrencyIndicator,
		    locale = _ref3.locale,
		    className = _ref3.class,
		    props = _objectWithoutProperties(_ref3, ['children', 'showCurrencyIndicator', 'locale', 'class']);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': className },
			!done && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__glyphs__["a" /* FinanceSpinner */], { showError: true }),
			done && notFound && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_price_bar__["b" /* default */], _extends({ invalidSymbol: true }, props)),
			done && !notFound && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_price_bar__["b" /* default */], props),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["f" /* DeviceVariance */], {
					adaptive: true,
					phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__stock_details_nav__["a" /* default */], _extends({
						menus: __WEBPACK_IMPORTED_MODULE_6__defaults__["a" /* default */].tertiaryNavigation.phone,
						type: securityTypeCode,
						uniqueSymbol: uniqueSymbol,
						showCurrencyIndicator: showCurrencyIndicator,
						locale: locale,
						showProfileInfo: hasCompanyData
					}, props)),
					other: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__stock_details_nav__["a" /* default */], _extends({
						menus: __WEBPACK_IMPORTED_MODULE_6__defaults__["a" /* default */].tertiaryNavigation.desktop,
						type: securityTypeCode,
						uniqueSymbol: uniqueSymbol,
						showCurrencyIndicator: showCurrencyIndicator,
						locale: locale,
						device: 'other',
						showProfileInfo: hasCompanyData
					}, props))
				}),
				children.map(function (child) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(child, { showProfileInfo: hasCompanyData });
				})
			)
		);
	};

	return StockDetailsPage;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var ConnectedStockDetailsPage = Object(__WEBPACK_IMPORTED_MODULE_7__cube_store_connect__["a" /* default */])(function (_ref5) {
	var locale = _ref5.locale;
	return { locale: locale };
})(StockDetailsPage);

/* harmony default export */ __webpack_exports__["a"] = (ConnectedStockDetailsPage);

/***/ }),
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getGoodPrevClose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(334);


/**
 * This function is to switch between using either the MostRecentClose, or the LessRecentClose.
 * During the trading day, the MostRecentClose is typically from the day before and will work fine.
 * However, after the trading closes sometimes certain stocks such as the S&P500 and the NASDAQ will zero out.
 * This is because the MostRecentClose will be updated to the close that day and not the day before.
 * To counter this we check if the MostRecentCloseDate is the same day as the closing date,
 * and if it is we will use LessRecentClose which by this time will be updated to the day before.
 * All of this is to replace the previously unreliable PrevClose which would without notice switch
 * between the two closing prices.
 * In addition, there is a fun twist for Mutual Funds in which they are calculated on the same
 * day as the closing day, after the close of the day, so we always want to use the PrevClose
 * Price as provided by CloudQuote.
 */
function getGoodPrevClose(quoteObj) {
  var mostRecentCloseDateCheck = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* formatDate */])(quoteObj.MostRecentCloseDate).split('/');
  var chartEndTimeCheck = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* formatDate */])(quoteObj.ChartEndTime * 1000).split('/');

  if (quoteObj.ExchangePrefixCode && quoteObj.ExchangePrefixCode.toUpperCase() === 'MF') {
    return quoteObj.PrevClose;
  }

  if (mostRecentCloseDateCheck[1] === chartEndTimeCheck[1]) {
    return quoteObj.LessRecentClose;
  }
  return quoteObj.MostRecentClose;
}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = indexOrKey;
/* harmony export (immutable) */ __webpack_exports__["a"] = createDataTable;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tableUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footnotes__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_i18n__ = __webpack_require__(9);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * Get the index or key to access data in a "row".
 * @param {undefined|String[]} columns    the columns of data as returned by CloudQuote API, or undefined if CloudQuote did not return columns
 * @param {String} key                    a property in the response data, from either columns or rows.
 * @returns {Number|String}               returns an index in the columns array if columns is not empty, otherwise returns the key itself
 * @example
 * Access the key "Date" in `row` when there are columns
 *   let columns = [ 0: 'Date', 1: 'Price' ];
 *   let row = [ 0: 999, 1: 50 ];
 *   assert(row[indexOrKey(columns, 'Date')] === 999);
 * Accessing the key "Date" in `row` when there are not columns
 *   let columns = undefined;
 *   let row = { Date: 999, Price: 50 };
 *   assert(row[indexOrKey(columns, 'Date')] === 999);
 */
function indexOrKey(columns, key) {
	return columns && columns.length ? columns.indexOf(key) : key;
}

/**
 * Create a table which fetchs data from CloudQuote and displays it in an easy to format data table.
 * @param {Object} options                           The options for displaying the DataTable.
 * @param {(String|Function)[]} [options.headers]    the labels for all columns headers.
 * @param {(String|Function)[]} [options.cells]      the data to display in each cell for all rows.
 * @param {Function} [options.apiMethod]             the CloudQuote API method from @os/cloudquote that the table will get data from. this function will be called with DataTable.props.params
 * @param {Function} [options.sort]                  a function for sorting data. this function is called with data and returns sorted data. eg. (data) => data.
 * @param {Number} [options.maxRows]                 the data will be truncated to contain only maxRows rows.
 */
function createDataTable(_ref) {
	var _class, _temp2;

	var headers = _ref.headers,
	    cells = _ref.cells,
	    apiMethod = _ref.apiMethod,
	    sort = _ref.sort,
	    maxRows = _ref.maxRows,
	    footnotes = _ref.footnotes;

	return _temp2 = _class = function (_Component) {
		_inherits(DataTable, _Component);

		function DataTable() {
			var _temp, _this, _ret;

			_classCallCheck(this, DataTable);

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { data: undefined }, _temp), _possibleConstructorReturn(_this, _ret);
		}

		DataTable.prototype.getParams = function getParams(_ref2) {
			var symbol = _ref2.symbol,
			    params = _ref2.params;

			if (symbol) {
				if (!params) {
					params = { symbol: symbol };
				} else {
					params.symbol = symbol;
				}
			}

			return params;
		};

		DataTable.prototype.fetchData = function fetchData(props) {
			var _this2 = this;

			var sort = props.sort,
			    apiMethod = props.apiMethod,
			    maxRows = props.maxRows;

			var params = this.getParams(props);
			return apiMethod(params).then(function (data) {
				return typeof sort === 'function' ? sort(data) : data;
			}).then(function (_ref3) {
				var rows = _ref3.rows,
				    columns = _ref3.columns;
				return { columns: columns, rows: rows && rows.slice(0, maxRows) };
			}).then(function (data) {
				return _this2.setState({ data: data });
			});
		};

		DataTable.prototype.componentWillMount = function componentWillMount() {
			if (!this.props.data && this.props.apiMethod) {
				this.fetchData(this.props);
			}
		};

		DataTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			var _this3 = this;

			if (!nextProps.data && !Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["p" /* shallowEqual */])(this.getParams(this.props), this.getParams(nextProps))) {
				this.setState({ data: {} }, function () {
					_this3.fetchData(nextProps);
				});
			}
		};

		DataTable.prototype.render = function render(_ref4, _ref5) {
			var data = _ref5.data;

			var headers = _ref4.headers,
			    cells = _ref4.cells,
			    footnotes = _ref4.footnotes,
			    props = _objectWithoutProperties(_ref4, ['headers', 'cells', 'footnotes']);

			data = props.data || data;
			var isLoading = !data && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__glyphs__["a" /* FinanceSpinner */], null)
			);

			var hasNoData = data && (!data.rows || !data.rows.length) && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(NoResultsTable, {
				data: data,
				headers: headers
			});

			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': props.class, style: props.style },
				hasNoData || isLoading || Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Table, {
					data: data,
					headers: headers,
					cells: cells,
					footnotes: footnotes
				}),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__footnotes__["b" /* default */], { notes: footnotes })
			);
		};

		return DataTable;
	}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = { headers: headers, cells: cells, apiMethod: apiMethod, sort: sort, maxRows: maxRows, footnotes: footnotes }, _temp2;
}

var NoResultsTable = function NoResultsTable(_ref6) {
	var data = _ref6.data,
	    headers = _ref6.headers,
	    messageId = _ref6.messageId;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'table',
		{ 'class': [__WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style___default.a.financeTable), __WEBPACK_IMPORTED_MODULE_4__style___default.a.noResults].join(' ') },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Thead, { data: data, headers: headers }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(TbodyNoResults, { colspan: headers.length })
	);
};

var Table = function Table(_ref7) {
	var data = _ref7.data,
	    headers = _ref7.headers,
	    cells = _ref7.cells,
	    footnotes = _ref7.footnotes;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'table',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style___default.a.financeTable) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Thead, { data: data, headers: headers, footnotes: footnotes }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Tbody, { data: data, cells: cells })
	);
};

var TableHeading = function TableHeading(_ref8) {
	var header = _ref8.header,
	    footnotes = _ref8.footnotes,
	    data = _ref8.data;

	var headerText = void 0;
	if (typeof header === 'function') {
		headerText = header(data);
	}
	// If a vNode, don't try to make a FootnoteReference component out of it
	else if ((typeof header === 'undefined' ? 'undefined' : _typeof(header)) === 'object' && !header.nodeName) {
			headerText = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				null,
				header.name,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__footnotes__["a" /* FootnoteReference */], { id: header.id, footnotes: footnotes })
			);
		} else {
			headerText = header;
		}
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'th',
		null,
		headerText
	);
};

var Thead = function Thead(_ref9) {
	var data = _ref9.data,
	    headers = _ref9.headers,
	    footnotes = _ref9.footnotes;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'thead',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			headers.map(function (header) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(TableHeading, { header: header, footnotes: footnotes, data: data });
			})
		)
	);
};

/**
 * Body of a data table.
 * @param {Object} props                          preact props
 * @param {Object} [props.data]                   data from a cloudquote API response, shaped as { rows, columns }
 * @param {(String|Function)[]} [props.cells]     how to display the cells in each row. the number of columns in a table is equal to the length of props.cells. if given a string, will display row[columns.indexOf(cell)]. if given a function, will call that function with all columns and the current row, allowing you to use functions to format cells with a callback.
 * @example
 * To create a table with two rows, and two cells in each row, formatted to two decimal places.
 *   <Tbody
			data={{
				columns: [ 0: 'High', 1: 'Low' ],
				rows: [
					[ 0: 24, 1: 12 ],
					[ 0: 20, 1: 10 ]
				]
			}}
			cells={[
				({ columns, row }) => return parseFloat(row[columns.indexOf('High')]).toFixed(2),
				({ columns, row }) => return parseFloat(row[columns.indexOf('Low')]).toFixed(2)
			]}
		/>
 */
var Tbody = function Tbody(_ref10) {
	var data = _ref10.data,
	    cells = _ref10.cells;
	var rows = data.rows,
	    columns = data.columns;

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'tbody',
		null,
		rows.map(function (row) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'tr',
				null,
				cells.map(function (cell) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						typeof cell === 'function' ? cell({ columns: columns, row: row }) : row[indexOrKey(columns, cell)] || ''
					);
				})
			);
		})
	);
};

var TbodyNoResults = function TbodyNoResults(_ref11) {
	var colspan = _ref11.colspan;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'tbody',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{ colspan: colspan },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */],
					{ id: 'dataUnavailable' },
					'Data Unavailable'
				)
			)
		)
	);
};

/**
 * Handy functions for using with the cloudquote DataTable
 * @property {Function} formatField    pass in a field and a callback to call when printing that field
 * @property {Object} sort             a few examples of different sorting functions
 */
var tableUtils = {
	formatField: function formatField(field, fn) {
		return function (_ref12) {
			var columns = _ref12.columns,
			    row = _ref12.row;
			return fn(row[indexOrKey(columns, field)]);
		};
	},
	sort: {
		descending: {
			dateByKey: function descendingDateByKey(key) {
				return function (_ref13) {
					var columns = _ref13.columns,
					    rows = _ref13.rows;

					rows = rows && rows.slice().sort(function (a, b) {
						return new Date(b[indexOrKey(columns, key)]) - new Date(a[indexOrKey(columns, key)]);
					});
					return { columns: columns, rows: rows };
				};
			},
			byKey: function descendingByKey(key) {
				return function (_ref14) {
					var columns = _ref14.columns,
					    rows = _ref14.rows;

					rows = rows && rows.slice().sort(function (a, b) {
						return b[indexOrKey(columns, key)] - a[indexOrKey(columns, key)];
					});
					return { columns: columns, rows: rows };
				};
			}
		}
	}
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;

/***/ }),
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(681);


function linear(a, d) {
  return function (t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function (a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}

/***/ }),
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SymbolLookup; });
/* unused harmony export StockTableWrapper */
/* unused harmony export StockWidgetTable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LastUpdated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intl_json__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__intl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_symbol_lookup__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_stock_table_wrapper__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_stock_widget_table__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_last_updated__ = __webpack_require__(795);








function intlWrap(Child) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact_i18n__["e" /* default */])(Child, { scope: 'finance-blocks', definition: __WEBPACK_IMPORTED_MODULE_1__intl_json___default.a });
}

var SymbolLookup = intlWrap(__WEBPACK_IMPORTED_MODULE_2__components_symbol_lookup__["a" /* default */]);
var StockTableWrapper = intlWrap(__WEBPACK_IMPORTED_MODULE_3__components_stock_table_wrapper__["a" /* default */]);
var StockWidgetTable = intlWrap(__WEBPACK_IMPORTED_MODULE_4__components_stock_widget_table__["a" /* default */]);
var LastUpdated = intlWrap(__WEBPACK_IMPORTED_MODULE_5__components_last_updated__["a" /* default */]);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrencyIndicator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var CurrencyIndicator = function (_Component) {
	_inherits(CurrencyIndicator, _Component);

	function CurrencyIndicator() {
		_classCallCheck(this, CurrencyIndicator);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	CurrencyIndicator.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		// Fetch the price data for the symbol
		Object(__WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getStockPrice"])(this.props.symbol).then(function (data) {
			_this2.setState({ data: data });
		});
	};

	CurrencyIndicator.prototype.render = function render(_ref, _ref2) {
		var symbol = _ref.symbol;
		var data = _ref2.data;

		var priceData = data && data.rows && data.rows[0] || undefined,
		    code = 'USD';
		// Default to USD if no data available, otherwise use the provided code
		if (priceData && priceData.NominalCurrencyCode) {
			code = priceData.NominalCurrencyCode;
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a['currency-indicator'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'currency-indicator', fields: { code: code } })
		);
	};

	return CurrencyIndicator;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EST_OFFSET */
/* unused harmony export EDT_OFFSET */
/* harmony export (immutable) */ __webpack_exports__["a"] = getEasternTimeFromDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLocalTimeFromEasternDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameDateEST;
/* unused harmony export DST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__finance_constants__ = __webpack_require__(421);


/* eslint-disable no-magic-numbers */
var EST_OFFSET = 300;
var EDT_OFFSET = 240;
var MS_IN_MIN = 60000;

/**
 * Given a date in the host systems arbitrary timezone, returns a date object
 * that behaves like it is in the eastern timezone (e.g. will shift the date object
 * forward three hours to go from Pacific to Eastern time)
 * @param {Date}{Number} date The "accurate" date in the user's arbitrary timezone, or epoch time if a number
 * @returns {Date} the date moved to eastern time.  If before 1970, just returns the date unchanged
 *
 */
function getEasternTimeFromDate(date) {
	if (!date) return undefined;
	var realDate = new Date(date); //ensure we have a date object and not just a number
	var offset = getTimezoneDiffFromEastern(realDate);
	if (!offset) return realDate;
	return new Date(realDate.getTime() + offset * MS_IN_MIN);
}

/**
 * Given a date that has been converted to eastern time from the hosts timezone, convert it back
 * to the host systems arbitrary timezone (i.e. the inverse of getEasternTimeFromDate()
 * @param {Date}{Number} date The pretending to be Eastern Time date based on the user's arbitrary timezone
 * @returns {Date} the date moved to the users local time.  If before 1970, just returns the date unchanged
 *
 */
function getLocalTimeFromEasternDate(date) {
	if (!date) return undefined;
	var realDate = new Date(date); //ensure we have a date object and not just a number
	var offset = getTimezoneDiffFromEastern(realDate);
	if (!offset) return realDate;
	return new Date(realDate.getTime() - offset * MS_IN_MIN);
}

/**
 * Given a date in local time, determine wat the timezone offset difference is for that date
 * to eastern time
 */
function getTimezoneDiffFromEastern(date) {
	var time = date.getTime();
	var year = date.getFullYear();
	//around Jan 1st, year might not match the equivalent year for Eastern time
	//but we default to EST, so it's OK.

	//if we don't have DST data for the year in question, just base it off of EST as a fallback
	if (year < __WEBPACK_IMPORTED_MODULE_0__finance_constants__["a" /* BASE_YEAR */]) return date.getTimezoneOffset() - EST_OFFSET;
	var easternOffset = time > DST[year][0] && time <= DST[year][1] ? EDT_OFFSET : EST_OFFSET;
	return date.getTimezoneOffset() - easternOffset;
}

function isSameDateEST(date, prevDate) {
	var dateEST = getEasternTimeFromDate(new Date(date));
	var prevDateEST = getEasternTimeFromDate(new Date(prevDate));
	var isSameDateEST = dateEST.getDate() !== prevDateEST.getDate();

	return isSameDateEST;
}

/* You can generate the following array in a browser/node environment running in Eastern Time with the following code:
	for(let i = 1962; i<=2030; i++) {
		let time = new Date(i, 0, 1).getTime();
		while (new Date(time).getTimezoneOffset() !== 240) { time += 1000; };
		startDst = time;
		while (new Date(time).getTimezoneOffset() !== 300) { time += 1000; }
		endDst = time;
		console.log(`[${i}, ${startDst/100000}, ${endDst/100000}],`);
	}
*/

//to save bites, remove the trailing 00000 from each millisecond timestamp
var DST = [[1962, -2464740, -2259144], [1963, -2150244, -1944648], [1964, -1835748, -1630152], [1965, -1515204, -1309608], [1966, -1200708, -995112], [1967, -886212, -680616], [1968, -571716, -366120], [1969, -257220, -51624], [1970, 99612, 256824], [1971, 414108, 577368], [1972, 734652, 891864], [1973, 1049148, 1206360], [1974, 1266876, 1520856], [1975, 1623708, 1835352], [1976, 1992636, 2155896], [1977, 2307132, 2470392], [1978, 2627676, 2784888], [1979, 2942172, 3099384], [1980, 3256668, 3413880], [1981, 3571164, 3728376], [1982, 3885660, 4048920], [1983, 4200156, 4363416], [1984, 4520700, 4677912], [1985, 4835196, 4992408], [1986, 5149692, 5306904], [1987, 5446044, 5621400], [1988, 5760540, 5941944], [1989, 6075036, 6256440], [1990, 6389532, 6570936], [1991, 6710076, 6885432], [1992, 7024572, 7199928], [1993, 7339068, 7520472], [1994, 7653564, 7834968], [1995, 7968060, 8149464], [1996, 8288604, 8463960], [1997, 8603100, 8778456], [1998, 8917596, 9092952], [1999, 9232092, 9413496], [2000, 9546588, 9727992], [2001, 9861084, 10042488], [2002, 10181628, 10356984], [2003, 10496124, 10671480], [2004, 10810620, 10992024], [2005, 11125116, 11306520], [2006, 11439612, 11621016], [2007, 11735964, 11941560], [2008, 12050460, 12256056], [2009, 12364956, 12570552], [2010, 12685500, 12891096], [2011, 12999996, 13205592], [2012, 13314492, 13520088], [2013, 13628988, 13834584], [2014, 13943484, 14149080], [2015, 14257980, 14463576], [2016, 14578524, 14784120], [2017, 14893020, 15098616], [2018, 15207516, 15413112], [2019, 15522012, 15727608], [2020, 15836508, 16042104], [2021, 16157052, 16362648], [2022, 16471548, 16677144], [2023, 16786044, 16991640], [2024, 17100540, 17306136], [2025, 17415036, 17620632], [2026, 17729532, 17935128], [2027, 18050076, 18255672], [2028, 18364572, 18570168], [2029, 18679068, 18884664], [2030, 18993564, 19199160]].reduce(function (acc, _ref) {
	var year = _ref[0],
	    times = _ref.slice(1);

	acc[year] = times.map(function (v) {
		return v * 100000;
	});return acc;
}, {});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return WEEKDAYS_PER_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return WEEKEND_DAYS_PER_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DAYS_PER_WEEK; });
/* unused harmony export WEEKDAYS_PER_MONTH */
/* unused harmony export WEEKS_PER_YEAR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MONTHS_PER_QUARTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SHIFT_MONDAY_TO_DAY_0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SHIFTED_FRIDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SHIFTED_SATURDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SHIFTED_SUNDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SHIFT_WEEKEND_TO_WEEKDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DECEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SECONDS_PER_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SECONDS_PER_BI_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SECONDS_PER_MINUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SECONDS_PER_QUARTER_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SECONDS_PER_FIVE_MINUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SECONDS_PER_HALF_MINUTE; });
/* unused harmony export MILLISECONDS_PER_WEEK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return YEARS_PER_DECADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIRST_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIRST_MINUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIRST_SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LAST_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LAST_MINUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LAST_SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIRST_SECOND_OF_FINANCE_DAY; });
/* unused harmony export LAST_SECOND_OF_FINANCE_DAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SECONDS_PER_FINANCE_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SECONDS_PER_FINANCE_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SECONDS_PER_FINANCE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SECONDS_PER_FINANCE_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SUNDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MONDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SATURDAY; });
//Constants used by finance-time-scale and other related classes

/* eslint-disable no-magic-numbers */
var BASE_YEAR = 1962,
    WEEKDAYS_PER_WEEK = 5,
    WEEKEND_DAYS_PER_WEEK = 2,
    DAYS_PER_WEEK = 7,
    WEEKDAYS_PER_MONTH = 22,
    WEEKS_PER_YEAR = 52,
    MONTHS_PER_QUARTER = 3,
    SUNDAY = 0,
    MONDAY = 1,
    SATURDAY = 6,
    SHIFT_MONDAY_TO_DAY_0 = 6,
    SHIFTED_FRIDAY = 4,
    SHIFTED_SATURDAY = 5,
    SHIFTED_SUNDAY = 6,
    SHIFT_WEEKEND_TO_WEEKDAY = 2,
    DECEMBER = 11,
    SECONDS_PER_HOUR = 3600,
    SECONDS_PER_BI_HOUR = 2 * SECONDS_PER_HOUR,
    SECONDS_PER_MINUTE = 60,
    SECONDS_PER_QUARTER_HOUR = 15 * SECONDS_PER_MINUTE,
    SECONDS_PER_FIVE_MINUTES = 5 * SECONDS_PER_MINUTE,
    SECONDS_PER_HALF_MINUTE = 30,
    MILLISECONDS_PER_WEEK = 6.048e8,
    YEARS_PER_DECADE = 10,
    FIRST_HOUR = 9,
    FIRST_MINUTE = 0,
    FIRST_SECOND = 0,
    LAST_HOUR = 16,
    LAST_MINUTE = 59,
    LAST_SECOND = 59,
    FIRST_SECOND_OF_FINANCE_DAY = FIRST_HOUR * SECONDS_PER_HOUR + FIRST_MINUTE * SECONDS_PER_MINUTE + FIRST_SECOND,
    LAST_SECOND_OF_FINANCE_DAY = LAST_HOUR * SECONDS_PER_HOUR + LAST_MINUTE * SECONDS_PER_MINUTE + LAST_SECOND,
    SECONDS_PER_FINANCE_DAY = LAST_SECOND_OF_FINANCE_DAY - FIRST_SECOND_OF_FINANCE_DAY + 1,
    SECONDS_PER_FINANCE_WEEK = SECONDS_PER_FINANCE_DAY * WEEKDAYS_PER_WEEK,
    SECONDS_PER_FINANCE_MONTH = SECONDS_PER_FINANCE_DAY * WEEKDAYS_PER_MONTH,
    SECONDS_PER_FINANCE_YEAR = SECONDS_PER_FINANCE_WEEK * WEEKS_PER_YEAR;

/* eslint-enable no-magic-numbers */



/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return x === null ? NaN : +x;
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(900);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function (count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function (count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function (count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]);

  scale.copy = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (s) {
  return s.match(/.{6}/g).map(function (x) {
    return "#" + x;
  });
});

/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockInfoTable; });
/* unused harmony export StockInfoHeaders */
/* unused harmony export StockInfoRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stock_chart__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_util_stock_price__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flags__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaults__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_linkstate__ = __webpack_require__(727);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Lots of micro-components in this file.  May want to give them display names via named functions in the future, but disable errors for now
/* eslint-disable react/display-name */














var INTL_NS = 'stock-info-table';

var FIELD_HEADERS = {
	price: INTL_NS + '.price',
	marketCap: INTL_NS + '.marketCap',
	symbol: INTL_NS + '.symbol',
	symbolWithName: INTL_NS + '.symbol',
	name: INTL_NS + '.name',
	changeCompound: INTL_NS + '.changeCompound',
	changePrice: INTL_NS + '.changePrice',
	changePercent: INTL_NS + '.changePct',
	oneMonthChangePercent: INTL_NS + '.oneMonthPct',
	threeMonthChangePercent: INTL_NS + '.threeMonthPct',
	'52WeekChangePercent': INTL_NS + '.fiftyTwoWeekPct',
	YTDChangePercent: INTL_NS + '.ytdChangePct',
	trash: INTL_NS + '.trash',
	volume: INTL_NS + '.volume',
	dollarVolume: INTL_NS + '.dollarVolume',
	dollarVolumeChange: INTL_NS + '.dollarVolumeChange',
	competitors: INTL_NS + '.competitors',
	eventDate: INTL_NS + '.eventDate',
	split: INTL_NS + '.split',
	dividend: INTL_NS + '.dividend'
};

var StockInfoTable = function (_Component) {
	_inherits(StockInfoTable, _Component);

	function StockInfoTable() {
		_classCallCheck(this, StockInfoTable);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	StockInfoTable.prototype.toSymbols = function toSymbols(data) {
		return data && data.rows && data.rows.map(function (r) {
			return r && r.SymbolID;
		}).join();
	};

	StockInfoTable.prototype.componentWillMount = function componentWillMount() {
		this.setState({ cursor: this.props.cursor || 0 });
	};

	StockInfoTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
		var data = _ref.data,
		    cursor = _ref.cursor;

		if (!this.state.cursor || this.toSymbols(data) !== this.toSymbols(this.props.data)) {
			this.setState({ cursor: cursor });
		}
	};

	StockInfoTable.prototype.render = function render(_ref2, _ref3) {
		var _this2 = this;

		var cursor = _ref3.cursor;

		var data = _ref2.data,
		    columns = _ref2.columns,
		    noData = _ref2.noData,
		    onDelete = _ref2.onDelete,
		    showHeaders = _ref2.showHeaders,
		    showChart = _ref2.showChart,
		    theme = _ref2.theme,
		    props = _objectWithoutProperties(_ref2, ['data', 'columns', 'noData', 'onDelete', 'showHeaders', 'showChart', 'theme']);

		var rows = data && data.rows;
		// If we know that there isn't any data, don't render the spinner and resulting 'Data Not Available'
		if (!noData && (!rows || !rows.length)) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__glyphs__["a" /* FinanceSpinner */], null);
		var symbolWithName = columns.indexOf('symbolWithName') === 0;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.stockInfoTable, props.dataTable && __WEBPACK_IMPORTED_MODULE_9__style___default.a.dataTable, __WEBPACK_IMPORTED_MODULE_9__style___default.a[theme]) },
			showChart && rows[cursor] && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_chart__["a" /* StockChartBare */], _extends({
				symbol: rows[cursor].SymbolID,
				width: '375',
				height: '150'
			}, __WEBPACK_IMPORTED_MODULE_8__defaults__["a" /* default */].chart)),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'table',
				{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.financeTable },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockInfoHeaders, { columns: columns, showHeaders: showHeaders }),
				!noData && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tbody',
					{ 'class': __WEBPACK_IMPORTED_MODULE_10_classnames___default()(symbolWithName ? __WEBPACK_IMPORTED_MODULE_9__style___default.a.alternate2 : __WEBPACK_IMPORTED_MODULE_9__style___default.a.alternate1) },
					rows.reduce(function (allRows, row, i) {
						if (row) {
							allRows.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockInfoRow, _extends({
								showChart: showChart,
								pos: i,
								selected: cursor === i,
								symbol: row.SymbolID
							}, props, { columns: columns, row: row, onDelete: onDelete }, {
								onMouseOver: Object(__WEBPACK_IMPORTED_MODULE_11_linkstate__["a" /* default */])(_this2, 'cursor', 'pos')
							})));
						}
						if (row && row.Name && symbolWithName) {
							allRows.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'tr',
								{ 'class': __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.symbolWithName) },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'td',
									{ colspan: columns.length },
									row.Name || '-'
								)
							));
						}
						return allRows;
					}, [])
				)
			)
		);
	};

	return StockInfoTable;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);




var StockInfoHeaders = function StockInfoHeaders(_ref4) {
	var columns = _ref4.columns,
	    showHeaders = _ref4.showHeaders;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'thead',
		null,
		showHeaders && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			columns.map(function (field, i) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'th',
					null,
					Array.isArray(showHeaders) ? showHeaders[i] : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: FIELD_HEADERS[field] })
				);
			})
		)
	);
};

var StockInfoRow = function (_Component2) {
	_inherits(StockInfoRow, _Component2);

	function StockInfoRow() {
		var _temp, _this3, _ret;

		_classCallCheck(this, StockInfoRow);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this3), _this3.handleMouseOver = function () {
			_this3.props.onMouseOver(_this3.props);
		}, _this3.handleClick = function (ev) {
			ev.stopPropagation();
		}, _temp), _possibleConstructorReturn(_this3, _ret);
	}

	// Workaround for the fact that preact-router wraps every <a> tag everywhere without notice / choice,
	// and we do not want that behavior for this component.


	StockInfoRow.prototype.render = function render(_ref5) {
		var _this4 = this;

		var columns = _ref5.columns,
		    row = _ref5.row,
		    onmouseover = _ref5.onmouseover,
		    selected = _ref5.selected,
		    showChart = _ref5.showChart,
		    props = _objectWithoutProperties(_ref5, ['columns', 'row', 'onmouseover', 'selected', 'showChart']);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{
				'class': __WEBPACK_IMPORTED_MODULE_10_classnames___default()(selected && __WEBPACK_IMPORTED_MODULE_9__style___default.a.selected, showChart && __WEBPACK_IMPORTED_MODULE_9__style___default.a.image),
				onMouseOver: this.handleMouseOver
			},
			row && columns.map(function (col) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(NamedField, _extends({ name: col === 'symbolWithName' ? 'symbol' : col, row: row }, props, { onClick: _this4.handleClick }));
			})
		);
	};

	return StockInfoRow;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/** Renders a named component from FIELD_COMPONENTS */
var NamedField = function NamedField(_ref6) {
	var name = _ref6.name,
	    props = _objectWithoutProperties(_ref6, ['name']);

	var goodPrevClose = Object(__WEBPACK_IMPORTED_MODULE_6__lib_util_stock_price__["a" /* getGoodPrevClose */])(props.row);
	props.change = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(props.row.Price, goodPrevClose);
	var Comp = FIELD_COMPONENTS[name];
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Comp, props);
};

var createChangePercentComponent = function createChangePercentComponent(className, prevField) {
	return function (_ref7) {
		var onClick = _ref7.onClick,
		    row = _ref7.row;

		var cl = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.change, __WEBPACK_IMPORTED_MODULE_9__style___default.a[className]),
		    inner = '-';

		if (row.Price > 0 && row[prevField] > 0) {
			var change = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(row.Price, row[prevField]);
			cl = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(cl, __WEBPACK_IMPORTED_MODULE_9__style___default.a[change.class]);
			inner = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(change.percent, { Plus: true, Decimals: 2, Default: '0.00%', Suffix: '%' });
		}
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': cl, onClick: onClick },
			inner
		);
	};
};

var maxDecimals = 2;
var minDecimals = 2;

var FIELD_COMPONENTS = {
	flag: function flag(_ref8) {
		var row = _ref8.row,
		    flags = _ref8.flags,
		    pos = _ref8.pos,
		    change = _ref8.change,
		    props = _objectWithoutProperties(_ref8, ['row', 'flags', 'pos', 'change']);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			_extends({ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.flag }, props),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__flags__["a" /* default */], { country: flags && flags[pos] })
		);
	},

	eventDate: function eventDate(_ref9) {
		var row = _ref9.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.price },
			row.eventDate
		);
	},

	split: function split(_ref10) {
		var row = _ref10.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.price },
			row.split
		);
	},

	dividend: function dividend(_ref11) {
		var row = _ref11.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.price },
			row.dividend
		);
	},

	price: function price(_ref12) {
		var onClick = _ref12.onClick,
		    row = _ref12.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.price, onClick: onClick },
			Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(row.Price, {
				Comma: true,
				Decimals: row.Price < 10 ? maxDecimals : minDecimals,
				Default: '0.00'
			})
		);
	},

	marketCap: function marketCap(_ref13) {
		var row = _ref13.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.cap },
			Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(row.MarketCap, { Comma: true, Compact: true, Default: '0' })
		);
	},

	symbol: function symbol(_ref14) {
		var onClick = _ref14.onClick,
		    row = _ref14.row,
		    change = _ref14.change,
		    props = _objectWithoutProperties(_ref14, ['onClick', 'row', 'change']);

		var name = props.abbrv ? row.Symbol : row.ShortName || row.Name || row.Symbol,
		    trackingId = props.trackingSource ? props.trackingSource : 'stock-info-table';

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ onClick: onClick, 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.symbol },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: '/finance/category/stockdetail/symbol/' + row.UniqueSymbol,
					'data-tracking-id': trackingId,
					'data-tracking-type': 'trackgif',
					'data-tracking-zone': 'finance-components',
					'data-tracking-symbol': row.UniqueSymbol
				},
				name || 'Unknown'
			)
		);
	},

	name: function name(_ref15) {
		var onClick = _ref15.onClick,
		    row = _ref15.row,
		    props = _objectWithoutProperties(_ref15, ['onClick', 'row']);

		var trackingId = props.trackingSource ? props.trackingSource : 'stock-info-table';

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ onClick: onClick, 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.name },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: '/finance/category/stockdetail/symbol/' + row.UniqueSymbol,
					'data-tracking-id': trackingId,
					'data-tracking-type': 'trackgif',
					'data-tracking-zone': 'finance-components',
					'data-tracking-symbol': row.UniqueSymbol
				},
				row.Name || row.ShortName || row.Symbol || ''
			)
		);
	},

	competitors: function competitors(_ref16) {
		var onClick = _ref16.onClick,
		    row = _ref16.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ onClick: onClick, 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.name },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{
					href: '/finance/category/stockdetail/symbol/' + row.UniqueSymbol
				},
				row.Name + ' (' + row.Symbol + ')'
			)
		);
	},

	changeCompoundIcon: function changeCompoundIcon(_ref17) {
		var onClick = _ref17.onClick,
		    row = _ref17.row,
		    change = _ref17.change;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('td', { 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.iconArrow + (' ' + __WEBPACK_IMPORTED_MODULE_9__style___default.a[change.class]) });
	},

	changeCompound: function changeCompound(_ref18) {
		var onClick = _ref18.onClick,
		    row = _ref18.row,
		    change = _ref18.change;
		return change.price ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{
				'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.change + ' ' + __WEBPACK_IMPORTED_MODULE_9__style___default.a.changeCompound + ' ' + __WEBPACK_IMPORTED_MODULE_9__style___default.a[change.class],
				onClick: onClick
			},
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.price },
				Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(change.price, {
					Plus: true,
					Decimals: row.Price < 10 ? maxDecimals : minDecimals,
					Default: '0.00'
				})
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.percent },
				Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(change.percent, {
					Plus: true,
					Decimals: 2,
					Default: '0.00%',
					Suffix: '%'
				})
			)
		) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': '' + __WEBPACK_IMPORTED_MODULE_9__style___default.a.change, onClick: onClick },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.unchanged' })
		);
	},

	changePrice: function changePrice(_ref19) {
		var onClick = _ref19.onClick,
		    row = _ref19.row,
		    change = _ref19.change;

		var inner = '-';
		if (row.Price > 0) {
			inner = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(change.price, {
				Plus: true,
				Decimals: row.Price < 10 ? maxDecimals : minDecimals,
				Default: '0.00'
			});
		}
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.change, __WEBPACK_IMPORTED_MODULE_9__style___default.a[change.class]), onClick: onClick },
			inner
		);
	},

	changePercent: createChangePercentComponent('changePercent', 'PrevClose'),

	oneMonthChangePercent: createChangePercentComponent('oneMonthChangePercent', 'StartingPrice1M'),

	threeMonthChangePercent: createChangePercentComponent('threeMonthChangePercent', 'StartingPrice3M'),

	'52WeekChangePercent': createChangePercentComponent('52WeekChangePercent', 'StartingPrice52'),

	YTDChangePercent: createChangePercentComponent('YTDChangePercent', 'StartingPriceYTD'),

	trash: function trash(_ref20) {
		var onDelete = _ref20.onDelete,
		    pos = _ref20.pos;

		var trash = function trash() {
			onDelete(pos);
		};
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.trash, onClick: trash },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["i" /* Icon */], { name: 'trash' })
		);
	},

	volume: function volume(_ref21) {
		var onClick = _ref21.onClick,
		    row = _ref21.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.volume), onClick: onClick },
			Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(row.Volume, { Comma: true, Compact: true, Default: '0' })
		);
	},

	dollarVolume: function dollarVolume(_ref22) {
		var onClick = _ref22.onClick,
		    row = _ref22.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.dollarVolume), onClick: onClick },
			Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(row.Price * row.Volume, {
				Decimals: 2,
				Compact: true,
				Default: '$0.00',
				Prefix: '$'
			})
		);
	},

	dollarVolumeChange: function dollarVolumeChange(_ref23) {
		var onClick = _ref23.onClick,
		    row = _ref23.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.change, __WEBPACK_IMPORTED_MODULE_9__style___default.a.dollarVolume), onClick: onClick },
			Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(row.Price * row.Volume, {
				Decimals: 2,
				Compact: true,
				Default: '$0.00',
				Prefix: '$'
			})
		);
	}
};

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"profile":"finance_company-profile_profile","narrow":"finance_company-profile_narrow","left":"finance_company-profile_left","description":"finance_company-profile_description","phone":"finance_company-profile_phone","phoneHeader":"finance_company-profile_phoneHeader","bold":"finance_company-profile_bold","dataUnavailable":"finance_company-profile_dataUnavailable","container":"finance_company-profile_container","competitors":"finance_company-profile_competitors","right":"finance_company-profile_right"};

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var defaults = {

	defaultSymbols: ['DJI', 'SPX', 'COMP', 'CY:OIL', 'CY:GOLD', 'USAYIELD10YR', 'USD-EUR', '^FTSE', '^N225'],

	chart: {
		// 0= filled area chart
		type: 2,

		/**	Do/don't show supplementary volume graph [2]
   *	0 = don't show volume graph
   *	1 = show monochrome volume graph
   *	2 = show volume graph colored by price increase vs. decrease
   */
		volume: 0,

		// Chart and footer box bg shadow/extrusion thickness in px
		shwidth: 0,

		// Filled area chart translucency in percent
		fillalpha: 60,

		// Canvas background color
		ibcolor: 'null',

		// Price region background color
		bgcolor: 'FFFFFF',

		// Volume region background color
		// bvcolor: '',

		// Filled area chart color, ignored if a gradient is used [4]
		arcolor: '009fdb',

		// Comma-delimited list of value line colors, corresponding to tickers
		lncolor: 'FFFFFF',

		// Volume bar color if volume=1
		// vocolor: '',

		// Price & volume graph border & tick color
		brcolor: '009fdb',

		// Price & volume graph shadow/extrude color
		// shcolor: '',

		// Price & volume graph grid line color (major)
		grcolor: 'DDDDDD',

		// Price & volume graph grid line color (minor)
		gmcolor: 'DDDDDD',

		// Intraday chart previous close line color
		mkcolor: '',

		// Text color for axis labels, attribution, etc., and tickers if legend is outside chart [5]
		txcolor: '444444',

		// Ticker symbol legend text color if legend is inside chart [5]
		itcolor: '000000'

		// Filled area chart gradient color (top/left)
		// gtcolor: '',

		// Filled area chart gradient color (bottom/right)
		// gbcolor: ''
	},
	tertiaryNavigation: {
		desktop: {
			stock: [{
				url: '/finance/category/stockdetail/symbol/{symbol}',
				label: 'Overview',
				lite: true
			}, {
				url: '/finance/category/stockdetail/section/profile/symbol/{symbol}',
				label: 'Profile'
			}, {
				url: '/finance/category/stockdetail/section/key-statistics/symbol/{symbol}/',
				label: 'Statistics'
			}, {
				url: '/finance/category/stockdetail/section/historical-data/symbol/{symbol}',
				label: 'Historical Data',
				lite: true
			}, {
				url: '/finance/category/stockdetail/section/analysts/symbol/{symbol}',
				label: 'Analysts'
			}, {
				url: '/finance/category/stockdetail/section/financials/symbol/{symbol}',
				label: 'Financials'
			}, {
				url: '/finance/category/stockdetail/section/holdings/symbol/{symbol}',
				label: 'Holdings'
			}],
			default: [{
				url: '/finance/category/stockdetail/symbol/{symbol}',
				label: 'Overview',
				lite: true
			}, {
				url: '/finance/category/stockdetail/section/historical-data/symbol/{symbol}',
				label: 'Historical Data',
				lite: true
			}]
		},
		phone: {
			stock: [{
				url: '/finance/category/stockdetail/symbol/{symbol}',
				label: 'Overview',
				lite: true
			}, {
				url: '/finance/category/stockdetail/section/key-statistics/symbol/{symbol}/',
				label: 'Statistics'
			}, {
				url: '/finance/category/stockdetail/section/news/symbol/{symbol}',
				label: 'News',
				limitedLocales: ['es'],
				lite: true
			}],
			default: [{
				url: '/finance/category/stockdetail/symbol/{symbol}',
				label: 'Overview',
				lite: true
			}]
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (defaults);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FootnoteContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FootnoteReference; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Footnotes = function Footnotes(_ref) {
	var notes = _ref.notes,
	    props = _objectWithoutProperties(_ref, ['notes']);

	if (!notes || notes.length === 0) {
		return;
	}
	var footnotes = notes.reduce(function (acc, note, index) {
		var footnote = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.footnote },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'sup',
				null,
				index + 1
			),
			' ',
			note.text
		);
		if (acc.length === 0) {
			acc.push([footnote]);
			return acc;
		}

		if (note.break) {
			acc.push([footnote]);
			return acc;
		}

		var last = acc.pop();
		last.push(footnote);
		acc.push(last);
		return acc;
	}, []);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["d" /* ContainerSize */],
		{ height: false, 'class': __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style___default.a.footnoteContainer, props.class) },
		footnotes.map(function (footnoteSet) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(FootnoteContainer, { noteSet: footnoteSet });
		})
	);
};

/* harmony default export */ __webpack_exports__["b"] = (Footnotes);

var FootnoteContainer = function FootnoteContainer(_ref2) {
	var noteSet = _ref2.noteSet,
	    width = _ref2.width;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style___default.a.footnoteChildContainer, width > 600 && __WEBPACK_IMPORTED_MODULE_3__style___default.a.split) },
		noteSet
	);
};

var FootnoteReference = function FootnoteReference(_ref3) {
	var id = _ref3.id,
	    footnotes = _ref3.footnotes;

	if (!footnotes) return;
	var note = void 0,
	    index = false;

	if (footnotes) {
		for (var i = 0; i < footnotes.length; i++) {
			note = footnotes[i];
			if (note.name === id) {
				index = i + 1;
				break;
			}
		}
	}

	return index && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'sup',
		null,
		index
	);
};

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  return a = +a, b = +b, function (t) {
    return a * (1 - t) + b * t;
  };
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(686);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= a = +a) ? function (x) {
    return (x - a) / b;
  } : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function (a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function (x) {
      return x <= a ? 0 : x >= b ? 1 : d(x);
    };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function (a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function (t) {
      return t <= 0 ? a : t >= 1 ? b : r(t);
    };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0],
      d1 = domain[1],
      r0 = range[0],
      r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function (x) {
    return r0(d0(x));
  };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function (x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function (y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function (_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function (_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["e" /* interpolateRound */], rescale();
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function (_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(463);


/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* formatDecimalParts */])(Math.abs(x)), x ? x[1] : NaN;
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDecimalParts;
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
});

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i,
      coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intervalHelpers; });
/* unused harmony export intervals */
/* harmony export (immutable) */ __webpack_exports__["b"] = labelToScaledTimeInterval;
/* harmony export (immutable) */ __webpack_exports__["c"] = labelToTimeInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__finance_time_scale__ = __webpack_require__(361);




var intervalHelpers = {

	/**
  * Returns a function which takes a date and returns
  * the scaled date at the beginning of the financial day n days before that
  */
	startOfFinanceDayDaysAgo: function startOfFinanceDayDaysAgo(n) {
		return function (from) {
			//get the most recent valid date from the financial calendar
			var d = Object(__WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["b" /* financeScaleInvert */])(from));
			d = new Date(d.getFullYear(), d.getMonth(), d.getDate(), __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["d" /* FIRST_HOUR */], __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["e" /* FIRST_MINUTE */], __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["f" /* FIRST_SECOND */]);
			d = Object(__WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__["b" /* getLocalTimeFromEasternDate */])(d);
			return Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["a" /* financeScale */])(d) - n * __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["o" /* SECONDS_PER_FINANCE_DAY */];
		};
	},


	/**
  * Returns a function which takes a date and returns
  * a date at the beginning of the financial day n days before that
  */
	endOfFinanceDayDaysAgo: function endOfFinanceDayDaysAgo(n) {
		return function (from) {
			//get the most recent valid date from the financial calendar
			var d = Object(__WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["b" /* financeScaleInvert */])(from));
			d = new Date(d.getFullYear(), d.getMonth(), d.getDate(), __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["h" /* LAST_HOUR */], __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["i" /* LAST_MINUTE */], __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["j" /* LAST_SECOND */]);
			d = Object(__WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__["b" /* getLocalTimeFromEasternDate */])(d);
			return Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["a" /* financeScale */])(d) - n * __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["o" /* SECONDS_PER_FINANCE_DAY */];
		};
	},


	/**
  * Returns a function which takes a date and
  * returns a scaled date n months before that.
  */
	monthsAgo: function monthsAgo(n) {
		return function (from) {
			//get the most recent valid date from the financial calendar
			var d = Object(__WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["b" /* financeScaleInvert */])(from));
			d = new Date(d.getFullYear(), d.getMonth() - n, d.getDate(), __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["d" /* FIRST_HOUR */], __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["e" /* FIRST_MINUTE */], __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["f" /* FIRST_SECOND */]);
			d = Object(__WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__["b" /* getLocalTimeFromEasternDate */])(d);
			return Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["a" /* financeScale */])(d);
		};
	},


	/**
  * Returns a function which takes a date and
  * returns a scaled date n years before that.
  */
	yearsAgo: function yearsAgo(n) {
		return function (from) {
			//get the most recent valid date from the financial calendar
			var d = Object(__WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["b" /* financeScaleInvert */])(from));
			d = new Date(d.getFullYear() - n, d.getMonth(), d.getDate(), __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["d" /* FIRST_HOUR */], __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["e" /* FIRST_MINUTE */], __WEBPACK_IMPORTED_MODULE_1__finance_constants_js__["f" /* FIRST_SECOND */]);
			d = Object(__WEBPACK_IMPORTED_MODULE_0__daylight_savings_time__["b" /* getLocalTimeFromEasternDate */])(d);
			return Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["a" /* financeScale */])(d);
		};
	},


	/**
  * Returns a function which takes a date and
  * returns a scaled date "infinitely" before that.
  */
	foreverAgo: function foreverAgo() {
		return function () {
			return -Infinity;
		};
	}
};

/* eslint-disable no-magic-numbers */ // the are all pretty self explanatory
var intervals = {
	'1d': intervalHelpers.startOfFinanceDayDaysAgo(0),
	'1w': intervalHelpers.startOfFinanceDayDaysAgo(5),
	'1m': intervalHelpers.monthsAgo(1),
	'3m': intervalHelpers.monthsAgo(3),
	'6m': intervalHelpers.monthsAgo(6),
	'1y': intervalHelpers.yearsAgo(1),
	'5y': intervalHelpers.yearsAgo(5),
	'10y': intervalHelpers.yearsAgo(10),
	max: intervalHelpers.foreverAgo()
};

/**
 * Get a financeScale scaled interval based on a string description such as "1m", which would return an interval
 * from financeScale of 1 month ago up to "to" param (defaults to financeScale of now).
 *
 * @param {String} label The label that corresponds to the key in the map of interval functions
 * @param {Integer} to [optional - defaults to now] financeScale'd time of when the interval should be based off of
 * @return {Array} Two element array.  First element is the adjusted start of the interval, second element is the to param
 */
function labelToScaledTimeInterval(label, to) {
	if (!to) to = Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["a" /* financeScale */])(Date.now());
	return [intervals[label.toLowerCase()](to), to];
}

/**
 * Get a regular date (not financeScaled) interval based on a string description such as "1m", which would return an interval
 * from 1 month ago up to "to" param (defaults to now).
 *
 * @param {String} label The label that corresponds to the key in the map of interval functions
 * @param {Integer} to [optional - defaults to now] financeScale'd time of when the interval should be based off of
 * @return {Array} Two element array.  First element is the adjusted start of the interval, second element is the to param
 */
function labelToTimeInterval(label, to) {
	if (!to) to = Date.now();

	var _labelToScaledTimeInt = labelToScaledTimeInterval(label, Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["a" /* financeScale */])(to)),
	    scaledBottom = _labelToScaledTimeInt[0];

	if (scaledBottom !== -Infinity) scaledBottom = Object(__WEBPACK_IMPORTED_MODULE_2__finance_time_scale__["b" /* financeScaleInvert */])(scaledBottom);
	return [scaledBottom, to];
}

/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = StockDataTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__os_localtime__ = __webpack_require__(82);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function StockDataTable(_ref) {
	var data = _ref.data,
	    cols = _ref.cols,
	    _ref$compact = _ref.compact,
	    compact = _ref$compact === undefined ? false : _ref$compact,
	    showDates = _ref.showDates,
	    _ref$timespan = _ref.timespan,
	    timespan = _ref$timespan === undefined ? 'quarterly' : _ref$timespan,
	    props = _objectWithoutProperties(_ref, ['data', 'cols', 'compact', 'showDates', 'timespan']);

	var dates = [],
	    rows = data && data.rows;

	if (timespan === 'quarterly') {
		rows = rows.slice(0, 4);
	} else {
		rows = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["g" /* getAnnual */])(rows);
	}

	if (showDates) {
		var rd = data.columns.indexOf('Reported Date');

		dates = rows.map(function (row, i) {
			if (timespan === 'quarterly') {
				var cq = data.columns.indexOf('Calendar Quarter');
				var yearSuffix = __WEBPACK_IMPORTED_MODULE_5__os_localtime__["a" /* default */].format('%y')(new Date(row[rd]));
				var quarter = row[cq] && row[cq][1] || '';
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: 'format.date.quarterDate', fields: { yearSuffix: yearSuffix, quarter: quarter } });
			}

			var _row$rd$split = row[rd].split('-'),
			    year = _row$rd$split[0],
			    month = _row$rd$split[1],
			    day = _row$rd$split[2];

			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: 'format.date.numberDate', fields: { month: month, day: day, year: year } });
		});
	} else {
		dates = rows.map(function (row) {
			return '\xA0';
		});
	}

	props.title = showDates && !props.title ? '\xA0' : props.title;

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'table',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.financeTable, __WEBPACK_IMPORTED_MODULE_2__style___default.a[timespan]) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'thead',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'tr',
				null,
				props.title && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'th',
					null,
					props.title
				),
				dates.map(function (date, i) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'th',
						null,
						date
					);
				})
			)
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tbody',
			null,
			cols.map(function (obj) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(obj.bold && __WEBPACK_IMPORTED_MODULE_2__style___default.a.bold) },
						obj.nameIntl || obj.name,
						obj.sup && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'sup',
							null,
							obj.sup
						)
					),
					rows.map(function (row) {
						var val = row[data.columns.indexOf(obj.name)];
						return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'td',
							{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(obj.bold && __WEBPACK_IMPORTED_MODULE_2__style___default.a.bold, val < 0 && __WEBPACK_IMPORTED_MODULE_2__style___default.a.negative) },
							Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(val, { Compact: compact, inThousands: true, Comma: true, Default: '-' })
						);
					})
				);
			})
		)
	);
}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"financeTable":"finance_stock-data-table_financeTable","annual":"finance_stock-data-table_annual","noResults":"finance_stock-data-table_noResults","bold":"finance_stock-data-table_bold","dataHeader":"finance_stock-data-table_dataHeader","negative":"finance_stock-data-table_negative"};

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stock_info_table__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var StockList = function (_Component) {
	_inherits(StockList, _Component);

	function StockList() {
		var _temp, _this, _ret;

		_classCallCheck(this, StockList);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.fetchSortedSecurityList = function (query) {
			Object(__WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["sortedSecurityList"])(query).then(function (data) {
				_this.setState({ data: data });
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	StockList.prototype.componentWillMount = function componentWillMount() {
		this.fetchSortedSecurityList(this.props.query);
	};

	StockList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (!Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["p" /* shallowEqual */])(nextProps.query, this.props.query)) {
			this.fetchSortedSecurityList(nextProps.query);
		}
	};

	StockList.prototype.render = function render(_ref, _ref2) {
		var data = _ref2.data;

		var query = _ref.query,
		    props = _objectWithoutProperties(_ref, ['query']);

		if (!data) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', null);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a['stock-list'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__stock_info_table__["a" /* default */], _extends({ data: data, abbrv: true }, props))
		);
	};

	return StockList;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockSymbolTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stock_info_table__ = __webpack_require__(430);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/*
 * A table of stocks, data is passed in by symbol
 * wraps a StockInfoTable component and handles subscribing
 * to streaming data;
 */

var StockSymbolTable = function (_Component) {
	_inherits(StockSymbolTable, _Component);

	function StockSymbolTable() {
		var _temp, _this, _ret;

		_classCallCheck(this, StockSymbolTable);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onData = function (data) {
			data && _this.setState({ data: data });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	StockSymbolTable.prototype.componentWillMount = function componentWillMount() {
		// Setup the streaming data
		var symbols = this.props.symbols;

		this.streamer = Object(__WEBPACK_IMPORTED_MODULE_2__os_cloudquote__["stockAPIStreamer"])(symbols, 'getStockPrice').on('data', this.onData);
	};

	StockSymbolTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		// Update the streamer if the symbols changed
		if (!Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["p" /* shallowEqual */])(this.props.symbols, nextProps.symbols)) {
			this.streamer.stream(nextProps.symbols);
		}
	};

	StockSymbolTable.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.streamer) this.streamer.end();
	};

	StockSymbolTable.prototype.render = function render(props, _ref) {
		var data = _ref.data;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__stock_info_table__["a" /* default */], _extends({}, props, { data: data }));
	};

	return StockSymbolTable;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTL_NS */
/* unused harmony export FieldComponents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footnotes__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_util_stock_price__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Lots of micro-components in this file.  May want to give them display names via named functions in the future, but disable errors for now
/* eslint-disable react/display-name */









var INTL_NS = 'stock-details';

var StockDetails = function StockDetails(_ref) {
	var fields = _ref.fields,
	    quote = _ref.quote,
	    props = _objectWithoutProperties(_ref, ['fields', 'quote']);

	if (!quote || (typeof quote === 'undefined' ? 'undefined' : _typeof(quote)) === 'object' && !Object.keys(quote).length) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__glyphs__["a" /* FinanceSpinner */], null)
		);
	}
	quote.formatter = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["f" /* generatePriceFormatter */])(quote, { Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' }) });

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'table',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] },
			props.header && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockDetailHeader, { title: props.header }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'tbody',
				null,
				fields.map(function (field) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(FieldComponents[field], _extends({ field: field, fields: fields, quote: quote }, props));
				})
			)
		)
	);
};
/* harmony default export */ __webpack_exports__["a"] = (StockDetails);

var StockDetailHeader = function StockDetailHeader(_ref2) {
	var title = _ref2.title;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'thead',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'th',
			{ colspan: '2' },
			title
		)
	);
};

var FieldComponents = {
	volume: function volume(_ref3) {
		var quote = _ref3.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.volume' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.Volume, { Decimals: 0, Comma: true, Default: '0' })
			)
		);
	},

	averageVolume: function averageVolume(_ref4) {
		var quote = _ref4.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.averageVolume' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.AvgVolume3M, { Decimals: 0, Comma: true, Default: '0' })
			)
		);
	},

	open: function open(_ref5) {
		var quote = _ref5.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.open' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				quote.formatter(quote.Open)
			)
		);
	},

	profitOverEarnings: function profitOverEarnings(_ref6) {
		var quote = _ref6.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.profitOverEarnings' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.Price / quote.EPS, {
					Comma: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	marketCap: function marketCap(_ref7) {
		var quote = _ref7.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.marketCap' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.SharesOutstanding * quote.Price, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				}),
				' '
			)
		);
	},

	marketCapSecurityStats: function marketCapSecurityStats(_ref8) {
		var quote = _ref8.quote,
		    field = _ref8.field,
		    footnotes = _ref8.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.marketCapSecurityStats' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.MarketCap, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				}),
				' '
			)
		);
	},

	enterpriseValue: function enterpriseValue(_ref9) {
		var quote = _ref9.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.enterpriseValue' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.EnterpriseValue, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	trailingPe: function trailingPe(_ref10) {
		var quote = _ref10.quote,
		    field = _ref10.field,
		    footnotes = _ref10.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.trailingPe' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.TrailingPE, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	priceToSale: function priceToSale(_ref11) {
		var quote = _ref11.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.priceToSale' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.PriceToSales, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	priceToBook: function priceToBook(_ref12) {
		var quote = _ref12.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.priceToBook' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.PriceToBook, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	enterpriseValueRevenue: function enterpriseValueRevenue(_ref13) {
		var quote = _ref13.quote,
		    field = _ref13.field,
		    footnotes = _ref13.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.enterpriseValueRevenue' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.EnterpriseValueToRevenue, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	enterpriseValueEbitda: function enterpriseValueEbitda(_ref14) {
		var quote = _ref14.quote,
		    field = _ref14.field,
		    footnotes = _ref14.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.enterpriseValueEbitda' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.EnterpriseValueToEBITDA, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	fiscalYearEnds: function fiscalYearEnds(_ref15) {
		var quote = _ref15.quote,
		    field = _ref15.field,
		    footnotes = _ref15.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.fiscalYearEnds' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["l" /* intlDateNode */])(quote.FiscalYearEnd)
			)
		);
	},

	mostRecentQuarter: function mostRecentQuarter(_ref16) {
		var quote = _ref16.quote,
		    field = _ref16.field,
		    footnotes = _ref16.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.mostRecentQuarter' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["l" /* intlDateNode */])(quote.MostRecentQuarter)
			)
		);
	},

	profitMargin: function profitMargin(_ref17) {
		var quote = _ref17.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.profitMargin' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.ProfitMargin, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	operatingMargin: function operatingMargin(_ref18) {
		var quote = _ref18.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.operatingMargin' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.OperatingMargin, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	returnOnAssets: function returnOnAssets(_ref19) {
		var quote = _ref19.quote,
		    field = _ref19.field,
		    footnotes = _ref19.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.returnOnAssets' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.ReturnOnAssets, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	returnOnEquity: function returnOnEquity(_ref20) {
		var quote = _ref20.quote,
		    field = _ref20.field,
		    footnotes = _ref20.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.returnOnEquity' }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.ReturnOnEquity, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	revenue: function revenue(_ref21) {
		var quote = _ref21.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.revenue' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.Revenue, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	revenuePerShare: function revenuePerShare(_ref22) {
		var quote = _ref22.quote,
		    field = _ref22.field,
		    footnotes = _ref22.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.revenuePerShare' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.RevenuePerShare, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	quarterlyRevenueGrowth: function quarterlyRevenueGrowth(_ref23) {
		var quote = _ref23.quote,
		    field = _ref23.field,
		    footnotes = _ref23.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.quarterlyRevenueGrowth' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{
					'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["k" /* gle */])(quote.QuarterlyRevenueGrowth, 0, __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive, __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative, '')
				},
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.QuarterlyRevenueGrowth, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	grossProfit: function grossProfit(_ref24) {
		var quote = _ref24.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.grossProfit' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.GrossProfit, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	ebitda: function ebitda(_ref25) {
		var quote = _ref25.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.ebitda' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.EBITDA, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	dilutedEps: function dilutedEps(_ref26) {
		var quote = _ref26.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dilutedEps' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.DilutedEPS, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	quarterlyEarningsGross: function quarterlyEarningsGross(_ref27) {
		var quote = _ref27.quote,
		    field = _ref27.field,
		    footnotes = _ref27.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.quarterlyEarningsGross' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{
					'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["k" /* gle */])(quote.QuarterlyEarningsGrowth, 0, __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive, __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative, '')
				},
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.QuarterlyEarningsGrowth, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	totalCash: function totalCash(_ref28) {
		var quote = _ref28.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.totalCash' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.TotalCash, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	totalCashPerShare: function totalCashPerShare(_ref29) {
		var quote = _ref29.quote,
		    field = _ref29.field,
		    footnotes = _ref29.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.totalCashPerShare' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.TotalCashPerShare, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	totalDebt: function totalDebt(_ref30) {
		var quote = _ref30.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.totalDebt' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.TotalDebt, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	totalDebtEquity: function totalDebtEquity(_ref31) {
		var quote = _ref31.quote,
		    field = _ref31.field,
		    footnotes = _ref31.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.totalDebtEquity' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.TotalDebtToEquity, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	currentRatio: function currentRatio(_ref32) {
		var quote = _ref32.quote,
		    field = _ref32.field,
		    footnotes = _ref32.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.currentRatio' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.CurrentRatio, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	bookValuePerShare: function bookValuePerShare(_ref33) {
		var quote = _ref33.quote,
		    field = _ref33.field,
		    footnotes = _ref33.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.bookValuePerShare' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.BookValuePerShare, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	operatingCashFlow: function operatingCashFlow(_ref34) {
		var quote = _ref34.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.operatingCashFlow' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.OperatingCashFlow, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	leveredFreeCashFlow: function leveredFreeCashFlow(_ref35) {
		var quote = _ref35.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.leveredFreeCashFlow' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.FreeCashFlow, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	oneYearHigh: function oneYearHigh(_ref36) {
		var quote = _ref36.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.oneYearHigh' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1YearHigh'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	oneYearChange: function oneYearChange(_ref37) {
		var quote = _ref37.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.oneYearChange' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1YearChange'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	oneYearLow: function oneYearLow(_ref38) {
		var quote = _ref38.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.oneYearLow' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1YearLow'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	oneWeekAvgVolume: function oneWeekAvgVolume(_ref39) {
		var quote = _ref39.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.oneWeekAvgVolume' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.AverageVolume1Week, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	threeMonthAvgVolume: function threeMonthAvgVolume(_ref40) {
		var quote = _ref40.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.threeMonthAvgVolume' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.AverageVolume3Month, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	sharesOutstanding: function sharesOutstanding(_ref41) {
		var quote = _ref41.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.sharesOutstanding' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.SharesOutstanding, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	vsDowWeek: function vsDowWeek(_ref42) {
		var quote = _ref42.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.vsDowWeek' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{
					'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["k" /* gle */])(quote['1WeekPerformanceVsDow'], 0, __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive, __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative, '')
				},
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1WeekPerformanceVsDow'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	vsSPWeek: function vsSPWeek(_ref43) {
		var quote = _ref43.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.vsSPWeek' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{
					'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["k" /* gle */])(quote['1WeekPerformanceVsSP500'], 0, __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive, __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative, '')
				},
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1WeekPerformanceVsSP500'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	vsNasdaqWeek: function vsNasdaqWeek(_ref44) {
		var quote = _ref44.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.vsNasdaqWeek' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{
					'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["k" /* gle */])(quote['1WeekPerformanceVsNasdaqComposite'], 0, __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive, __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative, '')
				},
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1WeekPerformanceVsNasdaqComposite'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	vsDowYear: function vsDowYear(_ref45) {
		var quote = _ref45.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.vsDowYear' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{
					'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["k" /* gle */])(quote['1YearPerformanceVsDow'], 0, __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive, __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative, '')
				},
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1YearPerformanceVsDow'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	vsSPYear: function vsSPYear(_ref46) {
		var quote = _ref46.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.vsSPYear' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{
					'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["k" /* gle */])(quote['1YearPerformanceVsSP500'], 0, __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive, __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative, '')
				},
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1YearPerformanceVsSP500'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	vsNasdaqYear: function vsNasdaqYear(_ref47) {
		var quote = _ref47.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.vsNasdaqYear' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{
					'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-details-table'] + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["k" /* gle */])(quote['1YearPerformanceVsNasdaqComposite'], 0, __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive, __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative, '')
				},
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote['1YearPerformanceVsNasdaqComposite'], {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	bid: function bid(_ref48) {
		var quote = _ref48.quote;
		return quote.Bid > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.bid' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				quote.formatter(quote.Bid),
				' ',
				!Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["m" /* isCurrency */])(quote) && ['* ', quote.formatter(quote.BidSize, { Decimals: 0 })]
			)
		) : null;
	},

	trailingDividendRate: function trailingDividendRate(_ref49) {
		var quote = _ref49.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.trailingDividendRate' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.TrailingAnnualDividendRate, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	trailingDividendYield: function trailingDividendYield(_ref50) {
		var quote = _ref50.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.trailingDividendYield' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.TrailingAnnualDividendYield, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	payoutRatio: function payoutRatio(_ref51) {
		var quote = _ref51.quote,
		    field = _ref51.field,
		    footnotes = _ref51.footnotes;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.payoutRatio' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["a" /* FootnoteReference */], { id: field, footnotes: footnotes })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.PayoutRatio, {
					Comma: true,
					Compact: true,
					Decimals: 2,
					Suffix: '%',
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		);
	},

	ask: function ask(_ref52) {
		var quote = _ref52.quote;
		return quote.Ask > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.ask' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				quote.formatter(quote.Ask),
				' ',
				!Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["m" /* isCurrency */])(quote) && ['* ', quote.formatter(quote.AskSize, { Decimals: 0 })]
			)
		) : null;
	},

	prevClose: function prevClose(_ref53) {
		var quote = _ref53.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.prevClose' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				quote.formatter(Object(__WEBPACK_IMPORTED_MODULE_5__lib_util_stock_price__["a" /* getGoodPrevClose */])(quote))
			)
		);
	},

	dayRange: function dayRange(_ref54) {
		var quote = _ref54.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.index },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dayRange' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				quote.formatter(quote.Low),
				' - ',
				quote.formatter(quote.High)
			)
		);
	},

	'52WeekRange': function WeekRange(_ref55) {
		var quote = _ref55.quote;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['52Range'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.52WeekRange' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				quote.formatter(quote.Low52),
				' - ',
				quote.formatter(quote.High52)
			)
		);
	},

	dividend: function dividend(_ref56) {
		var quote = _ref56.quote;
		return quote.AnnualDividend > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.dividend },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dividend' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.AnnualDividend, {
					Comma: true,
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' })
				})
			)
		) : null;
	},

	yield: function _yield(_ref57) {
		var quote = _ref57.quote;
		return quote.AnnualDividend > 0 && quote.Price > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.yield },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'th',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.yield' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.AnnualDividend * 100 / quote.Price, {
					Decimals: 2,
					Default: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.na' }),
					Suffix: '%'
				})
			)
		) : null;
	}
};

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DeviceWrappedStockPriceBar */
/* unused harmony export StockPriceBar */
/* unused harmony export Stock */
/* unused harmony export StockSymbol */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LastUpdated; });
/* unused harmony export LiteDisclaimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_util_stock_price__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cube_finance_blocks__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_preact_i18n__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }












function DeviceWrappedStockPriceBar(_ref) {
	var props = _objectWithoutProperties(_ref, []);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["f" /* DeviceVariance */], {
		phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockPriceBar, _extends({}, props, { layout: 'phone' })),
		tablet: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockPriceBar, _extends({}, props, { layout: 'tablet' })),
		desktop: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockPriceBar, _extends({}, props, { layout: 'desktop' })),
		desktopLarge: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockPriceBar, _extends({}, props, { layout: 'desktop' }))
	});
}

function routeToSymbol(quote) {
	window.location = '/finance/category/stockdetail/symbol/' + quote.UniqueSymbol;
}

var StockPriceBar = function (_Component) {
	_inherits(StockPriceBar, _Component);

	function StockPriceBar() {
		var _temp, _this, _ret;

		_classCallCheck(this, StockPriceBar);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { quote: {} }, _this.onData = function (data) {
			if (data && data.rows && data.rows.length) {
				_this.setState({ quote: data.rows[0] });
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	StockPriceBar.prototype.componentWillMount = function componentWillMount() {
		var invalidSymbol = this.props.invalidSymbol;


		if (!invalidSymbol) {
			this.streamer = Object(__WEBPACK_IMPORTED_MODULE_4__os_cloudquote__["stockAPIStreamer"])(this.props.symbol, 'getStockPrice').on('data', this.onData);
		} else {
			this.setState({ quote: { Name: 'Invalid Symbol', Price: '404' } });
		}
	};

	StockPriceBar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.symbol !== this.props.symbol) {
			this.streamer.stream(nextProps.symbol);
		}
	};

	StockPriceBar.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.stream) this.streamer.end();
	};

	StockPriceBar.prototype.render = function render(_ref2, _ref3) {
		var quote = _ref3.quote;

		var width = _ref2.width,
		    layout = _ref2.layout,
		    props = _objectWithoutProperties(_ref2, ['width', 'layout']);

		if (!quote || !quote.Price) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.stockPriceBar, __WEBPACK_IMPORTED_MODULE_2__style___default.a.loading) });
		}

		var goodPrevClose = Object(__WEBPACK_IMPORTED_MODULE_6__lib_util_stock_price__["a" /* getGoodPrevClose */])(quote);
		props.change = Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["a" /* calcChange */])(quote.Price, goodPrevClose);
		props.changeClass = props.change.class !== 'unchanged' ? __WEBPACK_IMPORTED_MODULE_2__style___default.a[props.change.class] : '';
		var isPhone = layout === 'phone';
		var isDesktop = layout === 'desktop';
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.stockPriceBar, props.invalidSymbol && __WEBPACK_IMPORTED_MODULE_2__style___default.a.invalidSymbol) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.stockHeaderCont, isPhone && __WEBPACK_IMPORTED_MODULE_2__style___default.a.phone, width <= 680 && __WEBPACK_IMPORTED_MODULE_2__style___default.a.phone, width > 680 && __WEBPACK_IMPORTED_MODULE_2__style___default.a.medium, isDesktop && __WEBPACK_IMPORTED_MODULE_2__style___default.a.wide)
				},
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(props.changeClass, __WEBPACK_IMPORTED_MODULE_2__style___default.a.stockHeader) },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.searchCont },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.search },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__cube_finance_blocks__["b" /* SymbolLookup */], {
								'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.symbolLookup,
								onSymbolSelect: routeToSymbol,
								trackingSource: 'stock-details-page/symbol-lookup',
								trackingZone: 'finance-components'
							})
						),
						!props.invalidSymbol && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockSymbol, _extends({ quote: quote }, props))
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Stock, _extends({ quote: quote }, props)),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LastUpdated, _extends({ quote: quote }, props)),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LiteDisclaimer, props)
				)
			)
		);
	};

	return StockPriceBar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Stock = function Stock(_ref4) {
	var quote = _ref4.quote,
	    change = _ref4.change,
	    changeClass = _ref4.changeClass,
	    invalidSymbol = _ref4.invalidSymbol,
	    symbol = _ref4.symbol;

	var priceFormatter = Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["f" /* generatePriceFormatter */])(quote);

	var quotePrice = priceFormatter(quote.Price);
	var changePrice = priceFormatter(change.price, { Plus: true });

	var changePercent = Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["n" /* percentFormatter */])(change.percent);
	var name = quote.Name;
	// If the symbol is a currency, swap out the 'to', e.g. 'EURO to Dollar'
	if (quote && quote.ExchangeShortName === 'Currency') {
		name = quote.Name.split(' to ');
		name.splice(1, 0, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */], { id: 'exchanges.exchangeTo' }));
	}
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.stock },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'h1',
			null,
			name
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.priceCont },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.price },
				invalidSymbol ? symbol : quotePrice
			),
			!invalidSymbol && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(changeClass, __WEBPACK_IMPORTED_MODULE_2__style___default.a.changePrice) },
				changePrice,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.changePercent },
					' (',
					changePercent,
					') '
				)
			)
		)
	);
};

var StockSymbol = function StockSymbol(_ref5) {
	var quote = _ref5.quote;
	var exch = quote.ExchangeShortName,
	    short = quote.ShortName,
	    sym = quote.Symbol;

	var name = short || sym;
	if (exch === 'Currency') {
		// Convert 'Currency' as it's not a proper name like the other exchanges
		exch = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */], { id: 'exchanges.exchangeLong.' + exch });
		// e.g. 'USD to EUR' -> 'USD a EUR'
		name = short.split(' to ');
		name.splice(1, 0, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */], { id: 'exchanges.exchangeTo' }));
	}
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.stockSymbol },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a['symbol-id'] },
			exch,
			': ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				null,
				name
			)
		)
	);
};

var LastUpdated = function LastUpdated(_ref6) {
	var quote = _ref6.quote,
	    invalidSymbol = _ref6.invalidSymbol,
	    props = _objectWithoutProperties(_ref6, ['quote', 'invalidSymbol']);

	var currency = Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["i" /* getBaseCurrencyCode */])(quote);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'p',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.lastUpdated, props.class) },
		invalidSymbol ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */],
			{ id: 'SYMBOL_NOT_FOUND' },
			'This symbol cannot be found. Please try another search!'
		) : currency ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */], { id: 'LAST_UPDATED_CURRENCY', fields: { time: Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["d" /* formatLastTradeTime */])(quote.LastTradeTime), currency: currency } }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: '/finance/disclaimer', target: '_blank', rel: 'noopener noreferrer' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */],
					{ id: 'DISCLAIMER' },
					'Disclaimer'
				)
			)
		) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */], { id: 'LAST_UPDATED', fields: { time: Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["d" /* formatLastTradeTime */])(quote.LastTradeTime) } }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: '/finance/disclaimer', target: '_blank', rel: 'noopener noreferrer' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */],
					{ id: 'DISCLAIMER' },
					'Disclaimer'
				)
			)
		)
	);
};


var LiteDisclaimer = function LiteDisclaimer(_ref7) {
	var _ref7$liteMenus = _ref7.liteMenus,
	    liteMenus = _ref7$liteMenus === undefined ? false : _ref7$liteMenus,
	    props = _objectWithoutProperties(_ref7, ['liteMenus']);

	if (liteMenus) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'p',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.liteDisclaimer, props.class) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9_preact_i18n__["d" /* Text */], { id: 'LITE_DISCLAIMER' })
		)
	);
};


/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["x" /* containerSize */])({ height: false }))(DeviceWrappedStockPriceBar));

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"twoColumns":"finance_analysts-panel_twoColumns","upgradesDowngrades":"finance_analysts-panel_upgradesDowngrades","upOrDown":"finance_analysts-panel_upOrDown","upgrade":"finance_analysts-panel_upgrade","downgrade":"finance_analysts-panel_downgrade","priceTargets":"finance_analysts-panel_priceTargets","header":"finance_analysts-panel_header","barChart":"finance_analysts-panel_barChart","dashedLine":"finance_analysts-panel_dashedLine","noData":"finance_analysts-panel_noData","verticalBar":"finance_analysts-panel_verticalBar"};

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Flag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_flag___ = __webpack_require__(810);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Flag = function (_Component) {
	_inherits(Flag, _Component);

	function Flag() {
		_classCallCheck(this, Flag);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Flag.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
		return false;
	};

	//TODO: Get the flag svgs to load properly in webpack setup


	Flag.prototype.render = function render(_ref) {
		var country = _ref.country;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.flag, country && __WEBPACK_IMPORTED_MODULE_2__style___default.a['flag-' + country]) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: Object(__WEBPACK_IMPORTED_MODULE_3__images_flag___["a" /* default */])('./' + country) })
		);
	};

	return Flag;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_split_point__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bundle_loader_lazy_name_dynamic_stock_chart_full_dynamic_stock_chart__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bundle_loader_lazy_name_dynamic_stock_chart_full_dynamic_stock_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bundle_loader_lazy_name_dynamic_stock_chart_full_dynamic_stock_chart__);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__os_split_point__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_bundle_loader_lazy_name_dynamic_stock_chart_full_dynamic_stock_chart___default.a));

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SplitPoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var FALLBACK = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	{ 'class': 'loading' },
	'Loading....'
);

/* harmony default export */ __webpack_exports__["a"] = (function (load, importName) {
	return function (props) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(SplitPoint, _extends({ load: load, importName: importName }, props));
	};
});

var SplitPoint = function (_Component) {
	_inherits(SplitPoint, _Component);

	function SplitPoint() {
		_classCallCheck(this, SplitPoint);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SplitPoint.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		var setChild = function setChild(child) {
			if (_this2.props.importName) {
				child = child[_this2.props.importName] || child;
			}
			if (child && (typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && child.default) {
				child = child.default;
			}
			if (child !== _this2.state.child) {
				_this2.setState({ child: child });
			}
		};

		var ret = this.props.load(setChild);
		if (ret && ret.then) ret.then(setChild);
	};

	SplitPoint.prototype.render = function render(_ref, _ref2) {
		var child = _ref2.child;

		var load = _ref.load,
		    fallbackContent = _ref.fallbackContent,
		    props = _objectWithoutProperties(_ref, ['load', 'fallbackContent']);

		return child ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(child, props) : fallbackContent || FALLBACK;
	};

	return SplitPoint;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(422);


/* harmony default export */ __webpack_exports__["a"] = (function (values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function has(key) {
    return prefix + key in this;
  },
  get: function get(key) {
    return this[prefix + key];
  },
  set: function set(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function remove(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function clear() {
    for (var property in this) {
      if (property[0] === prefix) delete this[property];
    }
  },
  keys: function keys() {
    var keys = [];
    for (var property in this) {
      if (property[0] === prefix) keys.push(property.slice(1));
    }return keys;
  },
  values: function values() {
    var values = [];
    for (var property in this) {
      if (property[0] === prefix) values.push(this[property]);
    }return values;
  },
  entries: function entries() {
    var entries = [];
    for (var property in this) {
      if (property[0] === prefix) entries.push({ key: property.slice(1), value: this[property] });
    }return entries;
  },
  size: function size() {
    var size = 0;
    for (var property in this) {
      if (property[0] === prefix) ++size;
    }return size;
  },
  empty: function empty() {
    for (var property in this) {
      if (property[0] === prefix) return false;
    }return true;
  },
  each: function each(f) {
    for (var property in this) {
      if (property[0] === prefix) f(this[property], property.slice(1), this);
    }
  }
};

function map(object, f) {
  var map = new Map();

  // Copy constructor.
  if (object instanceof Map) object.each(function (value, key) {
    map.set(key, value);
  });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
      var i = -1,
          n = object.length,
          o;

      if (f == null) while (++i < n) {
        map.set(i, object[i]);
      } else while (++i < n) {
        map.set(f(o = object[i], i, object), o);
      }
    }

    // Convert object to map.
    else if (object) for (var key in object) {
        map.set(key, object[key]);
      }return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb_js__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array_js__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_js__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object_js__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string_js__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant_js__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(520);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
    var t = typeof b === "undefined" ? "undefined" : _typeof(b),
        c;
    return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant_js__["a" /* default */])(b) : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* default */] : t === "string" ? (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb_js__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string_js__["a" /* default */] : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb_js__["a" /* default */] : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date_js__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_8__numberArray_js__["b" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_8__numberArray_js__["a" /* default */] : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array_js__["a" /* genericArray */] : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* default */])(a, b);
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(518);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Color() {}

var _darker = 0.7;

var _brighter = 1 / _darker;


var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Color, color, {
  copy: function copy(channels) {
    return _extends(new this.constructor(), this, channels);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
  : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity;a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var a = this.opacity;a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function (constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) {
    prototype[key] = definition[key];
  }return prototype;
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
      t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function (values) {
  var n = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isNumberArray;
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function (t) {
    for (i = 0; i < n; ++i) {
      c[i] = a[i] * (1 - t) + b[i] * t;
    }return c;
  };
});

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SMALL_BREAKPOINT; });
// Some stuff is not rendered below our "small" breakpoint
var SMALL_BREAKPOINT = 400;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"currencyIndicator":"finance_statistics-panel_currencyIndicator","statistics":"finance_statistics-panel_statistics","wide":"finance_statistics-panel_wide","phone":"finance_statistics-panel_phone","statisticsHeader":"finance_statistics-panel_statisticsHeader","footnotes":"finance_statistics-panel_footnotes"};

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = financeModel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__config__["a"]; });


/**
 * utility method that provides stock info for competitor stocks
 * @param symbol {String} The symbol to pass to cloudquote's getCompetitors method
 * @returns {Promise} Promise that when resolved contains an an object of the form {rows: []} where each entry in the rows array is the result of the call to getStockPrice for each of the competitor stocks
 *
 */
var getCompetitorStockData = function getCompetitorStockData(symbol) {
	return __WEBPACK_IMPORTED_MODULE_0__os_cloudquote__["getCompetitors"](symbol).then(function () {
		var competitors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		if (!competitors.rows) competitors.rows = [];
		return Promise.all(competitors.rows.map(function (competitor) {
			return __WEBPACK_IMPORTED_MODULE_0__os_cloudquote__["getStockPrice"](competitor.symbol).then(function (stock) {
				if (stock.rows[0]) {
					stock.rows[0].MarketCap = competitor.marketCap;
				}
				return stock.rows[0];
			});
		}));
	}).then(function (data) {
		return { rows: data };
	});
};

/**
 * Model factory for finance data to be used with @os/model-connect
 *
 * @returns {Object} With all @os/cloudquote methods exposed, plus getCompetitorStockData
 */
function financeModel() {
	var model = { getCompetitorStockData: getCompetitorStockData };
	Object.keys(__WEBPACK_IMPORTED_MODULE_0__os_cloudquote__).forEach(function (key) {
		return model[key] = __WEBPACK_IMPORTED_MODULE_0__os_cloudquote__[key];
	});
	return model;
}




/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony export (immutable) */ __webpack_exports__["b"] = provide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/** Adds all passed props into context, making them available to all descendants.
 *
 *	To learn about context, see the [React Docs](https://facebook.github.io/react/docs/context.html).
 *
 *	@name Provider
 *
 * @example
 * const Demo = (props, context) => {
 *   console.log(context.a);  // "b"
 * };
 * render(
 *   <Provider a="b">
 *     <Demo />
 *   </Provider>
 * )
 */

var Provider = function () {
  function Provider() {
    _classCallCheck(this, Provider);
  }

  Provider.prototype.getChildContext = function getChildContext() {
    var context = {};
    for (var i in this.props) {
      if (this.props.hasOwnProperty(i) && i !== 'children') {
        context[i] = this.props[i];
      }
    }
    return context;
  };

  Provider.prototype.render = function render(_ref) {
    var children = _ref.children;

    return children[0];
  };

  return Provider;
}();




Provider.provide = provide;

/**
 * Utility function to wrap a component in a {@link Provider} tag
 *
 * @param {Object} ctx props to be passed to the {@link Provider} component
 * @return {Function} A function that, given a Child component, wraps it in a Provider component with the applied ctx props
 *
 * @example
 * const Demo = (props, context) => {
 *   console.log(context.a);  // "b"
 * };
 * const ProvidedDemo = provide({a: "b"})(Demo);
 *
 * render( <ProvidedDemo /> );
 */
function provide(ctx) {
  return function (Child) {
    return function (props) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        Provider,
        ctx,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, props)
      );
    };
  };
}

/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */
/***/ (function(module, exports) {

module.exports = {"finance-components":{"addressUnavailable":"Address Unavailable","adjustedClose":"Close price adjusted for dividends and splits","analysts-panel":{"growthEstimates":{"currentQtr":"Current Qtr.","currentYear":"Current Year","growthEstimates":"Growth Estimates","label":"Label","nextFiveYears":"Next Five Years (Per Yr)","nextQtr":"Next Qtr.","nextYear":"Next Year","percentGrowth":"Percent Growth"},"insiderTransactions":{"averageEstimate":"Average Estimate","currentQtr":"Current Qtr.","currentYear":"Current Year","earningsEstimate":"Earnings Estimate","highEstimate":"High Estimate","label":"Label","lowEstimate":"Low Estimate","nextQtr":"Next Qtr.","nextYear":"Next Year","numberOfAnalysts":"Number of Analysts","priorYearEps":"Prior Year EPS"},"priceTargetsChart":{"analystsPriceTargets":"Analysts Price Targets","dataUnavailable":"Data Unavailable","currency":"Dollars","noData":"No Data","priceTargets":"Price Targets","US":"US"},"upgradeDowngrade":{"upgradesDowngrades":"Upgrades / Downgrades","date":"Date","upgrade":"Upgrade","downgrade":"Downgrade","maintain":"Maintain","newCoverage":"New Coverage","firmName":"","buy":"Buy","sell":"Sell","marketPerform":"Market Perform","neutral":"Neutral","underperform":"Underperform","overweight":"Overweight","outperform":"Outperform"}},"annual-quarterly-selector":{"annual":"Annual","quarterly":"Quarterly"},"bookValuePerShare":"Book Value / Shares Outstanding","company-profile":{"companyProfile":"Company Profile","dataUnavailable":"Data Unavailable","description":"Description","addressUnavailable":"Address Unavailable","phoneNumberUnavailable":"Phone Number Unavailable","ceo":"CEO","exchange":"Exchange","industry":"Industry","industries":{"dataUnavailable":"Data Unavailable","oil":"Oil","gold":"Gold","internet":"Internet","machinery":"Machinery","auto":"Auto","transportation":"Transportation","food":"Food","banks":"Banks","advertisingMarketingServices":"Advertising Marketing Services","aerospace-Defense":"Aerospace - Defense","aerospace-DefenseEquipment":"Aerospace - Defense Equipment","agricultureOperations":"Agriculture Operations","agricultureProducts":"Agriculture Products","appliances-Household":"Appliances - Household","auctionValuationServices":"Auction Valuation Services","audio&VideoProducts":"Audio & Video Products","auto-Domestic":"Auto - Domestic","auto-Foreign":"Auto - Foreign","auto-TruckOriginalParts":"Auto - Truck Original Parts","auto-TruckReplacementParts":"Auto - Truck Replacement Parts","banks-Foreign":"Banks - Foreign","banks-MajorRegional":"Banks - Major Regional","banks-Midwest":"Banks - Midwest","banks-Northeast":"Banks - Northeast","banks-Southeast":"Banks - Southeast","banks-Southwest":"Banks - Southwest","banks-West":"Banks - West","beverages-Alcohol":"Beverages - Alcohol","beverages-Soft":"Beverages - Soft","biofuels":"Biofuels","bottom100Stocks":"Bottom 100 Stocks","broadcast-Radio&Tv":"Broadcast - Radio & TV","building&Construction-Misc":"Building & Construction - Misc","building-Cmt&Cnt&Ag":"Building - CMT & CNT & AG","building-HeavyConstruction":"Building - Heavy Construction","building-Maint&Service":"Building - Maint & Service","building-MobileHomes&Rv":"Building - Mobile Homes & RV","building-Residential&Comm":"Building - Residential & Comm","buildingPrdcts-AirHeating":"Building Prdcts - Air Heating","buildingPrdsRetail-Wsale":"Building Prds Retail - Wsale","buildingProducts-LtgFx":"Building Products - Ltg FX","buildingProducts-Wood":"Building Products - Wood","businessInformation":"Business Information","businessOfficeProducts":"Business Office Products","businessServices":"Business Services","businessSoftwareServices":"Business Software Services","cableTv":"Cable TV","chemical-Diversified":"Chemical - Diversified","chemical-Plastics":"Chemical - Plastics","chemical-Specialty":"Chemical - Specialty","coal":"Coal","communicationNetworkSoftware":"Communication Network Software","communicationsComponents":"Communications Components","communicationsInfrastructure":"Communications Infrastructure","computer-IntegratedSystems":"Computer - Integrated Systems","computer-Mini":"Computer - Mini","computer-Networks":"Computer - Networks","computer-Services":"Computer - Services","computer-Software":"Computer - Software","computer-StorageDevices":"Computer - Storage Devices","computers-PeripheralEqupt":"Computers - Peripheral Equpt","conglomerates-DivOperations":"Conglomerates - Div Operations","consulting":"Consulting","consumerPrdts-MiscDiscr":"Consumer Prdts - Misc Discr","consumerPrdts-MiscStaple":"Consumer Prdts - Misc Staple","consumerServices-Misc":"Consumer Services - Misc","containers-Metal&Glass":"Containers - Metal & Glass","containers-PaperProducts":"Containers - Paper Products","cosmetics&Toiletries":"Cosmetics & Toiletries","diversifiedCommServices":"Diversified Comm Services","e&pMlp":"E&P MLP","electrical-Manufacturing":"Electrical - Manufacturing","electricalConstruction":"Electrical Construction","electricalPower":"Electrical Power","electronicManufacturing":"Electronic Manufacturing","electronicMiscServices":"Electronic Misc Services","electronicTestEquipment":"Electronic Test Equipment","electronics-MeasuringInst":"Electronics - Measuring Inst","electronics-Military":"Electronics - Military","electronics-MiscComponents":"Electronics - Misc Components","electronics-PartsDistrib":"Electronics - Parts Distrib","electronics-Semiconductors":"Electronics - Semiconductors","electronicsProducts-Misc":"Electronics Products - Misc","emergingMarketsIntegrated":"Emerging Markets Integrated","engineering&R&dServices":"Engineering & R&D Services","etfs-Agriculture":"ETFs - Agriculture","etfs-AlternativeInvestments":"ETFs - Alternative Investments","etfs-Asia":"ETFs - Asia","etfs-Biotech":"ETFs - Biotech","etfs-Bonds":"ETFs - Bonds","etfs-Commodities":"ETFs - Commodities","etfs-CommoditiesGeneral":"ETFs - Commodities General","etfs-Construction":"ETFs - Construction","etfs-ConsumerDiscretionary":"ETFs - Consumer Discretionary","etfs-ConsumerStaples":"ETFs - Consumer Staples","etfs-Currency":"ETFs - Currency","etfs-Defense":"ETFs - Defense","etfs-EmergingMarkets":"ETFs - Emerging Markets","etfs-Energy":"ETFs - Energy","etfs-Europe":"ETFs - Europe","etfs-FinancialServices":"ETFs - Financial Services","etfs-Grains":"ETFs - Grains","etfs-Healthcare":"ETFs - Healthcare","etfs-Income":"ETFs - Income","etfs-Industrials":"ETFs - Industrials","etfs-International":"ETFs - International","etfs-LargeCap":"ETFs - Large Cap","etfs-ManagedEtfs":"ETFs - Managed ETFs","etfs-Materials":"ETFs - Materials","etfs-Meats":"ETFs - Meats","etfs-Metals":"ETFs - Metals","etfs-MidCap":"ETFs - Mid Cap","etfs-MixedAsset":"ETFs - Mixed Asset","etfs-MultiCap":"ETFs - Multi Cap","etfs-NaturalResources":"ETFs - Natural Resources","etfs-Non-taxableBonds":"ETFs - Non-Taxable Bonds","etfs-Power":"ETFs - Power","etfs-PreciousMetals":"ETFs - Precious Metals","etfs-RealEstate":"ETFs - Real Estate","etfs-SmallCap":"ETFs - Small Cap","etfs-TaxableBonds":"ETFs - Taxable Bonds","etfs-Technology":"ETFs - Technology","etfs-Telecommunications":"ETFs - Telecommunications","etfs-Transportation":"ETFs - Transportation","etfs-Utilities":"ETFs - Utilities","fertilizers":"Fertilizers","fiberOptics":"Fiber Optics","finance-ConsumerLoans":"Finance - Consumer Loans","finance-InvestmentBrokers":"Finance - Investment Brokers","finance-InvestmentFunds":"Finance - Investment Funds","finance-InvestmentMgmt":"Finance - Investment Mgmt","finance-LeasingCompanies":"Finance - Leasing Companies","finance-MiscServices":"Finance - Misc Services","finance-Mortgage&RelSvs":"Finance - Mortgage & Rel Svs","finance-Savings&Loan":"Finance - Savings & Loan","finance-Sbic&Commercial":"Finance - SBIC & Commercial","financialTransactionServices":"Financial Transaction Services","food-Confectionery":"Food - Confectionery","food-DairyProducts":"Food - Dairy Products","food-MeatProducts":"Food - Meat Products","food-Misc&Diversified":"Food - Misc & Diversified","foodItems-Wholesale":"Food Items - Wholesale","funeralServices&Related":"Funeral Services & Related","furniture":"Furniture","gaming":"Gaming","governmentServices":"Government Services","hotels&Motels":"Hotels & Motels","indicesComposite":"Indices Composite","indicesIndustrials":"Indices Industrials","indicesNasdaq100":"Indices Nasdaq 100","indicesS&p100":"Indices S&P 100","indicesS&p400":"Indices S&P 400","indicesS&p500":"Indices S&P 500","indicesS&p500ConsumerDiscret":"Indices S&P 500 Consumer Discret","indicesS&p500ConsumerStaples":"Indices S&P 500 Consumer Staples","indicesS&p500Energies":"Indices S&P 500 Energies","indicesS&p500Financials":"Indices S&P 500 Financials","indicesS&p500HealthCare":"Indices S&P 500 Health Care","indicesS&p500Industrials":"Indices S&P 500 Industrials","indicesS&p500InformationTech":"Indices S&P 500 Information Tech","indicesS&p500Materials":"Indices S&P 500 Materials","indicesS&p500RealEstate":"Indices S&P 500 Real Estate","indicesS&p500Telcomm":"Indices S&P 500 Telcomm","indicesS&p500Utilities":"Indices S&P 500 Utilities","indicesS&p600":"Indices S&P 600","indicesTransportations":"Indices Transportations","indicesUtilities":"Indices Utilities","industrialControls":"Industrial Controls","industrialRobotics":"Industrial Robotics","industrialScientific":"Industrial Scientific","industrialServices":"Industrial Services","insurance-Accident&Health":"Insurance - Accident & Health","insurance-Brokers":"Insurance - Brokers","insurance-Life":"Insurance - Life","insurance-MultiLine":"Insurance - Multi Line","insurance-Proprty&Casualty":"Insurance - Proprty & Casualty","internet-Content":"Internet - Content","internet-Services":"Internet - Services","internet-Software":"Internet - Software","internetCommerce":"Internet Commerce","internetServices-Delivery":"Internet Services - Delivery","internetSoftwareServices":"Internet Software Services","itServices":"IT Services","largeCapPharma":"Large Cap Pharma","lasers-Systems&Components":"Lasers - Systems & Components","leisure&RecreationServices":"Leisure & Recreation Services","leisure&RecreationalPrdcts":"Leisure & Recreational Prdcts","machinery-Construct&Mining":"Machinery - Construct & Mining","machinery-Electrical":"Machinery - Electrical","machinery-Farm":"Machinery - Farm","machinery-GeneralIndustrial":"Machinery - General Industrial","machinery-MaterialHandling":"Machinery - Material Handling","machinery-ThermalProcessing":"Machinery - Thermal Processing","machinery-Tools&Related":"Machinery - Tools & Related","mediaConglomerates":"Media Conglomerates","medical-Biomedical":"Medical - Biomedical","medical-DentalSuppliers":"Medical - Dental Suppliers","medical-Drugs":"Medical - Drugs","medical-GenericDrugs":"Medical - Generic Drugs","medical-Hmo":"Medical - HMO","medical-Hospitals":"Medical - Hospitals","medical-NursingHomes":"Medical - Nursing Homes","medical-Outpatient&HmCare":"Medical - Outpatient & Hm Care","medicalInformationSystems":"Medical Information Systems","medicalInstruments":"Medical Instruments","medicalProducts":"Medical Products","medicalServices":"Medical Services","metalProduction&Fabrication":"Metal Production & Fabrication","metalProducts-Distribution":"Metal Products - Distribution","metalProducts-Fasteners":"Metal Products - Fasteners","mining-Gold":"Mining - Gold","mining-Iron":"Mining - Iron","mining-Misc":"Mining - Misc","mining-NonFerrous":"Mining - Non Ferrous","mining-Silver":"Mining - Silver","movie&TvProduction&Dist":"Movie & TV Production & Dist","officeSupply&Forms":"Office Supply & Forms","oil&Gas-Drilling":"Oil & Gas - Drilling","oil-C$Exploration&Product":"Oil - C$ Exploration & Product","oil-C$Integrated":"Oil - C$ Integrated","oil-FieldServices":"Oil - Field Services","oil-InternationalIntegrated":"Oil - International Integrated","oil-Production&Pipeline":"Oil - Production & Pipeline","oil-RefiningAndMarketing":"Oil - Refining and Marketing","oil-UsExploration&Product":"Oil - US Exploration & Product","oil-UsIntegrated":"Oil - US Integrated","oil-UsRoyaltyTrusts":"Oil - US Royalty Trusts","oilFieldMachinery&Equip":"Oil Field Machinery & Equip","oilGasProdPipelineMlp":"Oil Gas Prod Pipeline MLP","oilRefining&MarketingMlp":"Oil Refining & Marketing MLP","otherAltEnergy":"Other Alt Energy","outsourcing":"Outsourcing","paint&RelatedProducts":"Paint & Related Products","paper&RelatedProducts":"Paper & Related Products","pollutionControls":"Pollution Controls","printing-Commercial":"Printing - Commercial","protection-Safety":"Protection - Safety","publishing-Books":"Publishing - Books","publishing-Newspapers":"Publishing - Newspapers","publishing-Periodicals":"Publishing - Periodicals","realEstateDevelopers":"Real Estate Developers","realEstateOperations":"Real Estate Operations","reit-EquityTrustOther":"REIT - Equity Trust Other","reit-EquityTrustResident":"REIT - Equity Trust Resident","reit-EquityTrustRetail":"REIT - Equity Trust Retail","reit-MortgageTrusts":"REIT - Mortgage Trusts","retail-Apparel&Shoes":"Retail - Apparel & Shoes","retail-ConsumerElectronics":"Retail - Consumer Electronics","retail-Discount":"Retail - Discount","retail-DrugStores":"Retail - Drug Stores","retail-HomeFurniture":"Retail - Home Furniture","retail-Jewelry":"Retail - Jewelry","retail-MailOrder":"Retail - Mail Order","retail-Misc&Diversified":"Retail - Misc & Diversified","retail-RegionalDeptStores":"Retail - Regional Dept Stores","retail-Restaurants":"Retail - Restaurants","retail-Supermarket":"Retail - Supermarket","retail-WholesaleAutoParts":"Retail - Wholesale Auto Parts","retail-WsaleAuto&Trucks":"Retail - Wsale Auto & Trucks","rubber&Plastics":"Rubber & Plastics","satelliteCommunication":"Satellite Communication","schools":"Schools","securitiesExchanges":"Securities Exchanges","semiAnalog&Mixed":"Semi Analog & Mixed","semiCommunications":"Semi Communications","semiGeneral":"Semi General","semiRadioFrequency":"Semi Radio Frequency","semi-eqptWaferFabrication":"Semi-Eqpt Wafer Fabrication","shoesAndRelatedApparel":"Shoes and Related Apparel","soapAndCleaningProducts":"Soap and Cleaning Products","solar":"Solar","staffing":"Staffing","steel-Pipe&Tube":"Steel - Pipe & Tube","steel-Producers":"Steel - Producers","steel-Specialty":"Steel - Specialty","technologyServices":"Technology Services","textile-Apparel":"Textile - Apparel","textile-HomeFurnishings":"Textile - Home Furnishings","textile-Products":"Textile - Products","tobacco":"Tobacco","tools-HandHeld":"Tools - Hand Held","top100Stocks":"Top 100 Stocks","toys&Game&Hobby":"Toys & Game & Hobby","transportation-AirFreight":"Transportation - Air Freight","transportation-Airline":"Transportation - Airline","transportation-Equip&Lease":"Transportation - Equip & Lease","transportation-Rail":"Transportation - Rail","transportation-Services":"Transportation - Services","transportation-Ship":"Transportation - Ship","transportation-Truck":"Transportation - Truck","uniform&Related":"Uniform & Related","utility-ElectricPower":"Utility - Electric Power","utility-GasDistribution":"Utility - Gas Distribution","utility-WaterSupply":"Utility - Water Supply","wasteRemovalSvcs":"Waste Removal Svcs","wire&CableProducts":"Wire & Cable Products","wirelessEquipment":"Wireless Equipment","wirelessNational":"Wireless National","wirelessNon-us":"Wireless Non-US","wirelineRegional":"Wireline Regional"}},"competitorsUnavailable":"Competitors Unavailable","currentRatio":"Current Assets / Current Liabilities","currency-indicator":"Currency in {{code}}","currencies":{"currency":"Currency","currencyLong":{"Dollar":"Dollar","Euro":"Euro","Canadian":"Canadian","Peso":"Peso"}},"exchanges":{"exchangeLong":{"Currency":"Currency"},"exchangeTo":" to "},"dataUnavailable":"Data Unavailable","DISCLAIMER":"Disclaimer","dynamic-stock-chart":{"compare":"Compare","compareInputPlaceholder":"Add Symbol","compareMaxReached":"({{max}}/{{max}}) Max. reached!","intervalOptions":{"1d":"1d","1w":"1w","1m":"1m","3m":"3m","1y":"1y","5y":"5y","10y":"10y","max":"max"},"noDataAvailable":"No data available"},"enterpriseValueEbitda":"Enterprise Value / EBITDA","enterpriseValueRevenue":"Enterprise value / revenue","financial-details-tabs":{"incomeStatement":"Income Statement","balanceSheet":"Balance Sheet","cashFlow":"Cash Flow"},"fiscalYearEnds":"Last day of quarter that corresponds to last 10-K","format":{"date":{"numberDate":"{{month}}/{{day}}/{{year}}","quarterDate":"Q{{quarter}} '{{yearSuffix}}"}},"FUND_GAINERS":"Fund Gainers (% Change)","FUND_LOSERS":"Fund Losers (% Change)","FUNDS":"Funds","historical-data-panel":{"headers":{"date":"Date","open":"Open","high":"High","low":"Low","close":"Close","volume":"Volume","adjustedClose":"Adj. Close"},"filter":{"timePeriod":"Time Period","view":"View","frequency":"Frequency","downloadData":"Download Data","frequencies":{"daily":"Daily","weekly":"Weekly","monthly":"Monthly"},"views":{"his":"Historical Prices","div":"Dividends / Splits"}},"divSplit":{"dividends":"Dividends","stockSplits":"Stock Splits","dividend":"Dividend","split":"Split"}},"holdings-panel":{"institutional":"Institutional Holdings","insider":"Insider Transactions"},"interval-selector":{"1D":"1D","1W":"1W","1M":"1M","3M":"3M","6M":"6M","1Y":"1Y","5Y":"5Y","10Y":"10Y","MAX":"MAX"},"LAST_UPDATED":"Updated {{time}}. Quotes delayed at least 15min.","LAST_UPDATED_CURRENCY":"Updated {{time}}. Quotes delayed at least 15min. ({{currency}})","LITE_DISCLAIMER":"Only day-end data is available for NASDAQ, S&P, and Dow Jones indices.","marketCapSecurityStats":"Shares Outstanding * Price","MARKETS":"Markets","MOST_ACTIVE_FUNDS":"Most Active Funds","MOST_ACTIVE_STOCKS":"Most Active Stocks","mostRecentQuarter":"Last day of quarter that corresponds to last 10-Q","NO_STOCK_DATA_AVAILABLE":"No stock data available","payoutRatio":"100 * Annual Dividend * Shares Outstanding / EPS","phoneNumberUnavailable":"Phone Number Unavailable","POPULAR_FUNDS":"Popular Funds","POPULAR_STOCKS":"Popular Stocks","portfolio":{"addToPortfolio":"Add To Portfolio","inYourPortfolio":"In Your Portfolio","signIn":"Sign in to add to Portfolio","signInBody":"Please sign in to add stocks to your portfolio or to create custom portfolios."},"quarterlyEarningsGross":"25 * ( Earnings - PY Earnings ) / PY Earnings","quarterlyRevenueGrowth":"25 * ( Revenue - PY Revenue ) / PY Revenue","QUOTES_DELAYED":"Quotes delayed at least 15min.","quote-header":{"quoteLookup":"Quote Lookup"},"RECENTLY_VIEWED":"Recently Viewed","returnOnAssets":"Enterprise value / revenue","returnOnEquity":"Enterprise value / EBITDA","revenuePerShare":"Revenue / shares outstanding","sector-performance":{"materials":"Materials","conglomerates":"Conglomerates","consumer":"Consumer","financial":"Financial","healthcare":"Healthcare","industrial":"Industrial","services":"Services","technology":"Technology","utilities":"Utilities"},"SECTORS":"Sectors","statistics-panel":{"marketCap":"Market Cap (intraday)","valuationMeasures":"Valuation Measures","financialHighlights":"Financial Highlights","fiscalYear":"Fiscal Year","fiscalYearEnds":"Last day of quarter that corresponds to last 10-K","profitability":"Profitability","managementEffectiveness":"Management Effectiveness","incomeStatement":"Income Statement","balanceSheet":"Balance Sheet","cashFlowStatement":"Cash Flow Statement","tradingInformation":"Trading Information","stockPriceHistory":"Stock Price History","oneWeekPerformance":"1 Week Performance","oneYearPerformance":"1 Year Performance","dividendInformation":"Dividend Information","marketCapSecurityStats":"Shares Outstanding * Price","trailingPe":"Trailing P/E","enterpriseValueRevenue":"Enterprise value / revenue","enterpriseValueEbitda":"Enterprise Value / EBITDA","returnOnAssets":"Enterprise value / revenue","returnOnEquity":"Enterprise value / EBITDA","revenuePerShare":"Revenue / shares outstanding","quarterlyRevenueGrowth":"25 * ( Revenue - PY Revenue ) / PY Revenue","quarterlyEarningsGross":"25 * ( Earnings - PY Earnings ) / PY Earnings","payoutRatio":"100 * Annual Dividend * Shares Outstanding / EPS","mostRecentQuarter":"Last day of quarter that corresponds to last 10-Q","totalCashPerShare":"Total Cash / Shares Outstanding","totalDebtEquity":"Debt / Equity","currentRatio":"Current Assets / Current Liabilities","bookValuePerShare":"Book Value / Shares Outstanding"},"STOCK_GAINERS":"Stock Gainers (% Change)","STOCK_LOSERS":"Stock Losers (% Change)","stock-chart":{"compareTo":"Compare to","intervals":{"oneDay":"1D","oneWeek":"1W","oneMonth":"1M","threeMonth":"3M","oneYear":"1Y","fiveYear":"5Y","max":"MAX"},"comparisons":{"none":"None","dow":"Dow","nasdaq":"Nasdaq","sp500":"S&amp;P 500"}},"stock-data-table":{"incomeStatement":{"incomeStatement":"Income Statement","numInMs":"All numbers in thousands","revenue":"Revenue","totalRev":"Total Revenue","otherRev":"Other Revenue","costOfRev":"Cost of Revenue","grossProfit":"Gross Profit","opExpenses":"Operating Expenses","researchDev":"Research and Development","sGA":"Selling, General & Administrative","depAmort":"Depreciation & Amortization","otherOpExpenses":"Other Operating Expense","opIncome":"Operating Income","incContOp":"Income from Continuing Operations","otherNonOp":"Other Non-Operating Items","earningsPreTax":"Earnings Before Taxes","intExpNonOp":"Interest Expense","incPreTax":"Income Before Taxes","incTaxes":"Income Taxes","netIncContOp":"Earnings","netIncContOpLong":"Net Income from Continuing Operations","nonRecurring":"Non-recurring Events","nonContIntEtc":"Noncontrolling Interest, Extraordinary Items and Discontinued Operations","netIncome":"Net Income","totalExpenses":"Total Expenses","basicAvgShares":"Basic Average Shares Outstanding","basicEPSContOp":"Basic EPS from Continuing Operations","basicEPS":"Basic EPS","fullyDilShares":"Fully Diluted Shares Outstanding","fullyDilEPSContOp":"Fully Diluted EPS from Continuing Operations","fullyDilEPS":"Fully Diluted EPS","fiscalQ":"Fiscal Quarter","calendarQ":"Calendar Quarter","reportedDate":"Reported Date","filingDate":"Filing Date","fiscalY":"Fiscal Year"},"balanceSheet":{"balanceSheet":"Balance Sheet","numInMs":"All numbers in thousands","periodEnding":"Period Ending","currAssets":"Current Assets","cash":"Cash and Cash Equivalents","investST":"Short Term Investments","aR":"Accounts Receivable","prepaidExp":"Prepaid Expenses","inventory":"Inventory","otherCurrAssets":"Other Current Assets","investLT":"Long Term Investments","netPPE":"Net Property, Plant and Equipment","goodWill":"Goodwill and Intangibles","otherNonCurrAssets":"Other Non-Current Assets","receivablesLT":"Long Term Receivables","totalAssets":"Total Assets","currLiab":"Current Liabilities","aP":"Accounts Payable","otherCurrLiab":"Other Current Liabilities","accruedLiab":"Accrued Liabilities and Other Payables","debtST":"Short Term Debt","debtCurrentLT":"Current Portion of Long Term Debt","debtLT":"Long Term Debt","otherNonCurrLiab":"Other Non-Current Liabilities","totalLiab":"Total Liabilities","shareHoldersEquity":"Stockholders' Equity","commonStock":"Common Stock","preferredStock":"Preferred Stock","retainedEarnings":"Retained Earnings","treasuryStock":"Treasury Stock","addlPIC":"Additional Paid-In Capital","accumIncome":"Accumulated Other Comprehensive Income","otherEquity":"Other Equity","totalEquity":"Total Equity","fiscalQ":"Fiscal Quarter","calendarQ":"Calendar Quarter","reportedDate":"Reported Date","filingDate":"Filing Date","fiscalY":"Fiscal Year"},"cashFlow":{"cashFlow":"Cash Flow","numInMs":"All numbers in thousands","periodEnding":"Period Ending","netIncome":"Net Income","opActivities":"Operating Activities, Cash Flows Provided by or Used In","depAmort":"Depreciation & Amortization","otherNonCash":"Other Non-Cash Activities","deferredTax":"Deferred Taxes","changeWC":"Change in Working Capital","totalOperating":"Total Cash from Operating Activities","investActivities":"Investing Activities, Cash Flows Provided By or Used In","capEx":"Capital Expenditures","otherInvesting":"Other Investing Cash Flow","totalInvesting":"Total Cash from Investing Activities","financingActivities":"Financing Activities, Cash Flows Provided By or Used In","dividends":"Dividends and Distributions","buySellStock":"Purchase or Sale of Stock","otherFinancing":"Other Financing Cash Flow","payDebt":"Purchase and Retirement of Debt","totalFinancing":"Total Cash from Financing Activities","exRateEffects":"Effect of Exchange Rate Changes","exRate":"Exchange Rate Effects","changeCash":"Net Change in Cash","fiscalQ":"Fiscal Quarter","calendarQ":"Calendar Quarter","reportedDate":"Reported Date","filingDate":"Filing Date","fiscalY":"Fiscal Year"},"holdings":{"holder":"Holder","shares":"Shares","dateReported":"Date Reported","value":"Value","insider":"Insider","transaction":"Transaction","date":"Date","acquisition":"Acquisition at {{priceRange}}/share","disposition":"Disposition at {{priceRange}}/share","unknown":"{{priceRange}}/share"}},"stock-details":{"atTheOpen":"At the Open","na":"NA","volume":"Volume","averageVolume":"Avg Vol (3m)","open":"Open","profitOverEarnings":"P/E Ratio (ttm)","marketCap":"Market Cap","marketCapSecurityStats":"Market Cap (intraday)","enterpriseValue":"Enterprise Value","trailingPe":"Trailing P/E","priceToSale":"Price/Sale (ttm)","priceToBook":"Price/Book (mrq)","enterpriseValueRevenue":"Enterprise Value/Revenue","enterpriseValueEbitda":"Enterprise Value/EBITDA","fiscalYearEnds":"Fiscal Year Ends","mostRecentQuarter":"Most Recent Quarter (mrq)","profitMargin":"Profit Margin","operatingMargin":"Operating Margin (ttm)","returnOnAssets":"Return on Assets (ttm)","returnOnEquity":"Return on Equity (ttm)","revenue":"Revenue (ttm)","revenuePerShare":"Revenue Per Share (ttm)","quarterlyRevenueGrowth":"Quarterly Revenue Growth (yoy)","grossProfit":"Gross Profit (ttm)","ebitda":"EBITDA","dilutedEps":"Diluted EPS","quarterlyEarningsGross":"Quarterly Earnings Gross","totalCash":"Total Cash (mrq)","totalCashPerShare":"Total Cash Per Share (mrq)","totalDebt":"Total Debt","totalDebtEquity":"Total Debt/Equity (mrq)","currentRatio":"Current Ratio (mrq)","bookValuePerShare":"Book Value Per Share (mrq)","operatingCashFlow":"Operating Cash Flow (ttm)","leveredFreeCashFlow":"Levered Free Cash Flow (ttm)","oneYearHigh":"1 Year High","oneYearChange":"1 Year Change","oneYearLow":"1 Year Low","oneWeekAvgVolume":"Avg Vol (1 Week)","previousClose":"Previous Close","stockChart":"Stock Chart","threeMonthAvgVolume":"Avg Vol (3 Month)","sharesOutstanding":"Shares Outstanding","vsDowWeek":"vs Dow","vsSPWeek":"vs S&P 500","vsNasdaqWeek":"vs Nasdaq Composite","vsDowYear":"vs Dow","vsSPYear":"vs S&P 500","vsNasdaqYear":"vs Nasdaq Composite","bid":"Bid","trailingDividendRate":"Trailing Annual Dividend Per Share","trailingDividendYield":"Trailing Annual Dividend Yield","payoutRatio":"Payout Ratio","ask":"Ask","prevClose":"Prev Close","dayRange":"Day's Range","52WeekRange":"52wk Range","dividend":"Dividend","yield":"Yield"},"stock-details-nav":{"overview":"Overview","profile":"Profile","statistics":"Statistics","historicalData":"Historical Data","analysts":"Analysts","financials":"Financials","holdings":"Holdings","news":"News"},"stock-info-table":{"change":"Change","changeCompound":"Change","changePrice":"Change","changePct":"Change %","competitors":"Competitors","eventDate":"Date","dividend":"Dividend","dollarVolume":"$ Volume","dollarVolumeChange":"$ Volume","fiftyTwoWeekPct":"52 Week %","marketCap":"Market Cap","name":"Name","oneMonthPct":"1 Month %","price":"Price","split":"Split","symbol":"Symbol","threeMonthPct":"3 Month %","trash":"","volume":"Volume","ytdChangePct":"YTD %","unchanged":"Unchanged"},"stock-performance":{"daysOfWeek":{"sunday":"Sunday","monday":"Monday","tuesday":"Tuesday","wednesday":"Wednesday","thursday":"Thursday","friday":"Friday","saturday":"Saturday"},"months":{"jan":"Jan","feb":"Feb","mar":"Mar","apr":"Apr","may":"May","jun":"Jun","jul":"Jul","aug":"Aug","sep":"Sep","oct":"Oct","nov":"Nov","dec":"Dec"},"last5Days":"Last 5 Days","oneMonth":"1 Month","oneYear":"1 Year","sixMonth":"6 Month","threeMonth":"3 Month","ytd":"YTD"},"STOCKS":"Stocks","stock-open-analysis":{"gappedUp":"gapped up","overnightOpeningAt":"overnight, opening at","offOfAPreviousCloseOf":"off of a previous close of","openedAt":"opened at","todayAnIncreaseOf":"today, an increase of","fromThePreviousCloseOf":"from the previous close of","openedSlightlyUpTodayIncreasing":"opened slightly up today, increasing","sharesDroppedOvernightTo":"shares dropped overnight to","aDeclineOf":", a decline of","movedDownwardBy":"moved downward by","pointsOpeningAt":"points, opening at","todayComparedToAPreviousCloseOf":"today, compared to a previous close of","openedSlightlyDownTodayDecreasing":"opened slightly down today, decreasing","to":"to","sharesOpenedFlatTodayAt":"shares opened flat today at","sharesHaveNotTradedSince":"shares have not traded since"},"stock-recently-viewed":{"recentlyViewed":"Recently Viewed","noStockDataAvailable":"No stock data available"},"stock-ticker-bar":{"noIndexesSelected":"No indexes selected"},"SYMBOL_NOT_FOUND":"This symbol cannot be found. Please try another search!","totalCashPerShare":"Total Cash / Shares Outstanding","totalDebtEquity":"Debt / Equity","trailingPe":"Price / earnings per share","WORLD_MARKETS":"World Markets"}}

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCache; });
/* unused harmony export symbolCache */
/* unused harmony export safeSetSymbolCache */
/* unused harmony export addUniqueSymbol */
/* harmony export (immutable) */ __webpack_exports__["c"] = symbolCacheStoreResult;
/* harmony export (immutable) */ __webpack_exports__["b"] = getQuotesFromSymbolCache;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbolWithExchange__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_dbee__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_dbee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__os_dbee__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * See {@link dbee.static-app.apla.dev.opal.synacor.com|@os/dbee Documentation}
 * <p>dbee storage for caching CloudQuote API response data</p>
 * @module util/storage
 */

/**
 * dbee instance for storing responses to fetch calls
 * @memberof util/storage
 */
var fetchCache = __WEBPACK_IMPORTED_MODULE_1__os_dbee___default()('cloudquote.requests', { adapter: 'sessionStorage' });

/**
 * dbee instance for storing symbols found across all response
 * @memberof util/storage
 */
var symbolCache = __WEBPACK_IMPORTED_MODULE_1__os_dbee___default()('cloudquote.symbols', { adapter: 'memory' });

function safeSetSymbolCache(row, when) {
	try {
		symbolCache.set(row.UniqueSymbol, _extends({}, row, { cacheTime: when }));
	} catch (e) {
		console.error(e);
	}
}

var addUniqueSymbol = function addUniqueSymbol(data) {
	if (data && data.rows === undefined) {
		//Single row
		var composite = Object(__WEBPACK_IMPORTED_MODULE_0__symbolWithExchange__["a" /* getUniqueSymbol */])(data);
		data.UniqueSymbol = composite;
	} else if (data !== null) {
		//many rows
		data.rows.forEach(function (row) {
			var composite = Object(__WEBPACK_IMPORTED_MODULE_0__symbolWithExchange__["a" /* getUniqueSymbol */])(row);
			row.UniqueSymbol = composite;
		});
	}

	return data;
};

/**
 * If a response sends back Symbols, store them in a symbol cache
 * @private
 * @param {Object} data     response from CloudQuote API containing stock quotes
 * @returns {Promise}       passes through the data that was passed in
 * @memberof CloudQuote
 */
function symbolCacheStoreResult(data) {
	if (data && data.rows) {
		var now = Date.now();

		data.rows.forEach(function (row) {
			//Add UniqueSymbol to the row
			if (row) {
				row = addUniqueSymbol(row);
			}

			// TODO: How much overhead for accessing all the data on every request like this?
			// if the row contains a Symbol, add it to the cache
			if (row && row.UniqueSymbol) {
				safeSetSymbolCache(row, now);
			}
		});
	}
	return Promise.resolve(data);
}

/**
 * Get a list of symbols from the symbol cache
 * <p> TODO: Create caching accross-endpoints by always trying to grab from symbolCache first</p>
 * @function getQuotesFromSymbolCache
 * @param {String|String[]} symbols      a symbol or array of symbols
 * @returns {(Object|undefined)[]}       for each symbol in symbols, return either the symbol quote from cache or undefined if not in cache
 * @memberof CloudQuote
 */
function getQuotesFromSymbolCache(symbols) {
	var expiry = 20; // dont accept cache hits that are more than 20 seconds old
	symbols = [].concat(symbols);
	var rows = symbols.map(function () {
		var uniqueSymbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		var cached = symbolCache.get(uniqueSymbols);
		if (cached) {
			var age = (Date.now() - cached.cacheTime) / 1000;
			if (age < expiry) {
				return cached;
			}

			symbolCache.remove(uniqueSymbols);
		}
	});

	// Return result rows as they were found in the cache, and return a list of symbols not found in the cache.
	return {
		results: { rows: rows },
		miss: symbols.filter(function (_, index) {
			return !rows[index];
		})
	};
}

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeIntoUndefinedSlots;
/* harmony export (immutable) */ __webpack_exports__["a"] = keyResponseDataBySymbol;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeResponses;
/* harmony export (immutable) */ __webpack_exports__["d"] = toCsv;
/**
 * @private
 * Using two arrays, merge the second array into the slots of the first array which are undefined
 */
function mergeIntoUndefinedSlots() {
	var intoArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var fromArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	var startIndex = 0;
	if (fromArr.length === 0) {
		return intoArr.filter(function (elem) {
			return typeof elem !== 'undefined';
		});
	}
	return intoArr.map(function (elem) {
		if (typeof elem === 'undefined') {
			return fromArr[startIndex++];
		}

		return elem;
	}).filter(function (elem) {
		return typeof elem !== 'undefined';
	});
}

/**
 * @private
 * Massage response data from a request into an object with data for each symbol,
 * namespaced by the symbol requested
 */
function keyResponseDataBySymbol() {
	var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var response = arguments[1];

	return symbols.reduce(function (dataBySymbol, nextSymbol, symbolIdx) {
		dataBySymbol[nextSymbol] = response.columns.reduce(function (symbolData, fieldName, fieldIdx) {
			symbolData[fieldName] = response.rows[symbolIdx][fieldIdx];
			return symbolData;
		}, {});
		return dataBySymbol;
	}, {});
}

/**
 * @private
 * Combine data from multiple responses into one response object
 */
function mergeResponses(responses) {
	return responses.reduce(function (mergedResponse, nextRawResponse) {
		if (!mergedResponse.columns) mergedResponse.columns = nextRawResponse.columns;
		mergedResponse.rows = [].concat(mergedResponse.rows || [], nextRawResponse.rows);
		return mergedResponse;
	}, {});
}

function toCsv(value) {
	return String(value && value.join ? value.join(',') : value).toUpperCase();
}

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockWidgetTable; });
/* unused harmony export StockInfoHeaders */
/* unused harmony export StockInfoRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_util__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/*
* This component is heavily based on the stock-info-tablecomponent currently
* found in the the finance-components repo, much of it's functionality was
* removed to only be compatible with finance widgets (Recently Viewed, Most
* Active Stocks, and the My Portfolio)
*/

var StockWidgetTable = function (_Component) {
	_inherits(StockWidgetTable, _Component);

	function StockWidgetTable() {
		_classCallCheck(this, StockWidgetTable);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	StockWidgetTable.prototype.toSymbols = function toSymbols(data) {
		return data && data.rows && data.rows.map(function (r) {
			return r && r.SymbolID;
		}).join();
	};

	StockWidgetTable.prototype.render = function render(_ref) {
		var data = _ref.data,
		    columns = _ref.columns,
		    showHeaders = _ref.showHeaders,
		    noData = _ref.noData,
		    props = _objectWithoutProperties(_ref, ['data', 'columns', 'showHeaders', 'noData']);

		var rows = data && data.rows;

		if (noData) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.stockWidgetTable, props.dataTable && __WEBPACK_IMPORTED_MODULE_2__style___default.a.dataTable) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'table',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.financeTable },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockInfoHeaders, { columns: columns, showHeaders: showHeaders })
				)
			);
		}

		if (!rows || !rows.length) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.spinner },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__cube_blocks__["r" /* Spinner */], { style: 'font-size: 50px' })
			);
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.stockWidgetTable, props.dataTable && __WEBPACK_IMPORTED_MODULE_2__style___default.a.dataTable) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'table',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.financeTable },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockInfoHeaders, { columns: columns, showHeaders: showHeaders }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tbody',
					null,
					rows.map(function (row, i) {
						return row && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockInfoRow, _extends({
							pos: i,
							symbol: row.SymbolID
						}, props, { columns: columns, row: row }));
					})
				)
			)
		);
	};

	return StockWidgetTable;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);




var StockInfoHeaders = function StockInfoHeaders(_ref2) {
	var columns = _ref2.columns,
	    showHeaders = _ref2.showHeaders;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'thead',
		null,
		showHeaders && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			columns.map(function (field, i) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'th',
					null,
					showHeaders.splice ? showHeaders[i] : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: 'field-headers.' + field })
				);
			})
		)
	);
};

var StockInfoRow = function StockInfoRow(_ref3) {
	var columns = _ref3.columns,
	    row = _ref3.row,
	    props = _objectWithoutProperties(_ref3, ['columns', 'row']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'tr',
		null,
		row && columns.map(function (col) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(NamedField, _extends({ name: col, row: row }, props));
		})
	);
};

/** Renders a named component from FIELD_COMPONENTS */

var NamedField = function NamedField(_ref4) {
	var name = _ref4.name,
	    props = _objectWithoutProperties(_ref4, ['name']);

	props.change = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(props.row.Price, props.row.PrevClose);
	var Comp = FIELD_COMPONENTS[name];
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Comp, props);
};

var createChangePercentComponent = function createChangePercentComponent(className, prevField) {
	return function (_ref5) {
		var row = _ref5.row;

		var cl = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.change, __WEBPACK_IMPORTED_MODULE_2__style___default.a[className]),
		    inner = '0.00%';

		if (row.Price > 0 && row[prevField] > 0) {
			var change = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(row.Price, row[prevField]);
			cl = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(cl, __WEBPACK_IMPORTED_MODULE_2__style___default.a[change.class]);
			inner = change.price === 0 ? '0.00%' : Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["c" /* formatNumber */])(change.percent, { Plus: true, Decimals: 2, Default: '0.00%', Suffix: '%' });
		}
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': cl },
			inner
		);
	};
};

var maxDecimals = 2;
var minDecimals = 2;

var FIELD_COMPONENTS = {
	price: function price(_ref6) {
		var row = _ref6.row;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.price },
			Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["c" /* formatNumber */])(row.Price, { Comma: true, Decimals: row.Price < 10 ? maxDecimals : minDecimals, Default: '0.00' })
		);
	},

	symbol: function symbol(_ref7) {
		var row = _ref7.row,
		    change = _ref7.change,
		    props = _objectWithoutProperties(_ref7, ['row', 'change']);

		var name = props.abbrv ? row.Symbol : row.name,
		    trackingId = props.trackingSource ? props.trackingSource : 'stock-widget-table',
		    zone = props.trackingZone ? props.trackingZone : 'finance-blocks';

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.symbol },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: '/finance/category/stockdetail/symbol/' + row.UniqueSymbol,
					'data-tracking-id': trackingId,
					'data-tracking-type': 'trackgif',
					'data-tracking-zone': zone,
					'data-tracking-symbol': row.UniqueSymbol
				},
				name || 'Unknown'
			)
		);
	},

	name: function name(_ref8) {
		var row = _ref8.row,
		    props = _objectWithoutProperties(_ref8, ['row']);

		var nameToShow = row.SecurityTypeCode === 'STOCK' ? row.Symbol : row.ShortName,
		    trackingId = props.trackingSource ? props.trackingSource : 'stock-widget-table',
		    zone = props.trackingZone ? props.trackingZone : 'finance-blocks';

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.name },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: '/finance/category/stockdetail/symbol/' + row.UniqueSymbol,
					'data-tracking-id': trackingId,
					'data-tracking-type': 'trackgif',
					'data-tracking-zone': zone,
					'data-tracking-symbol': row.UniqueSymbol
				},
				nameToShow || row.Symbol || row.ShortName || row.Name || ''
			)
		);
	},

	changePrice: function changePrice(_ref9) {
		var row = _ref9.row,
		    change = _ref9.change;
		return change.price ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.change, __WEBPACK_IMPORTED_MODULE_2__style___default.a[change.class]) },
			Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["c" /* formatNumber */])(change.price, { Plus: true, Decimals: row.Price < 10 ? maxDecimals : minDecimals, Default: '0.00' })
		) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'td',
			{ 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.change, __WEBPACK_IMPORTED_MODULE_2__style___default.a[change.class]) },
			'0.00'
		);
	},

	changePercent: createChangePercentComponent('changePercent', 'PrevClose')

};

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = formatNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = calcChange;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatLastTradeTime;
/** Format a number based on a configuration object.
 *	@TODO option keys should be pascalCase, not CamelCase.
 *	@param {Number}		value
 *	@param {Object}		format
 *	@param {Number}		[format.Decimals=0]     Number of decimal places
 *	@param {Number}		[format.Default]        Default number to return when value is falsey
 *	@param {Boolean}	[format.Comma=false]    Add a comma thousands separator
 *	@param {Boolean}	[format.Compact=false]  Use compact magnitudes (K/M/B)
 *	@param {Boolean}	[format.Plus=false]     Display a plus sign in front of positive numbers
 *	@param {String}		[format.Prefix='']      Characters to prepend
 *	@param {String}		[format.Suffix='']      Characters to append
 */
function formatNumber(v, f) {
	if (!(f.Decimals >= 0)) f.Decimals = 0;
	if (v === 0 || isNaN(v)) return f.Default;
	var o = []; //output
	if (v < 0) {
		o.push('-');
		v = Math.abs(v);
	} else if (v > 0 && f.Plus) {
		o.push('+');
	}

	if (f.Prefix !== null) {
		o.push(f.Prefix);
	}

	var ex = ''; // Extension: K/M/B
	if (f.Compact) {
		if (v >= 1000000000) {
			v /= 1000000000;
			ex = 'B';
			f.Decimals = 2;
		} else if (v >= 1000000) {
			v /= 1000000;
			ex = 'M';
			f.Decimals = 2;
		}
		// else if (v >= 1000) {
		// 	v /= 1000;
		// 	ex = 'K';
		// 	f.Decimals = 2;
		// }
	}

	v = parseFloat(v).toFixed(f.Decimals);

	if (f.Comma) {
		var end = v.indexOf('.');
		if (end === -1) {
			end = v.length;
		}
		if (end > 3) {
			var parts = [];
			var fraction = v.substr(end, v.length);

			var i = end - 3;
			for (; i > 0; i -= 3) {
				parts.push(v.substr(i, 3));
			}
			parts.push(v.substr(0, i + 3));
			v = parts.reverse().join(',') + fraction;
		}
	}
	o.push(v);
	o.push(ex);
	if (f.Suffix !== null) {
		o.push(f.Suffix);
	}
	return o.join('');
}

/** Compare a current and previous value, and return a description of the change.
 *	@param {Number} current
 *	@param {Number} previous
 *	@returns {Object} `{ price, percent, class }`
 */
function calcChange(now, prev) {
	var ret = { price: 0, percent: 0, class: 'unchanged' };
	if (now > 0 && prev > 0) {
		ret.price = now - prev;
		ret.percent = ret.price * 100 / prev;
		if (now > prev) {
			ret.class = 'positive';
		} else if (now < prev) {
			ret.class = 'negative';
		}
	}
	return ret;
}

/** Format a timestamp based on age.
 *	@param {Date|String|Number} date	A Date instance or any variant thereof. Timestamps less than 2147483647 are treated as being in seconds.
 *	@TODO this is quite similar to how momentjs or http://npm.im/neatime work, might be better as a dependency.
 */
function formatLastTradeTime(d) {
	if (!(d instanceof Date)) {
		if (d > 0 && d < 2147483647) {
			d = new Date(d * 1000); // Epoch Seconds
		} else {
			d = new Date(d); //Everything else - Epoch Milliseconds, time string, etc.
		}
	}
	if (d.getTimezoneOffset() <= 0) {
		//We are not in 'murica, so defer to broswer
		return d.toLocaleString();
	}
	//We are in 'murica, so we force all times to EST/EDT and then incorrectly label them EST
	var month = d.getMonth();
	var dst = 0;
	if (month > 2 && month < 10) {
		dst = 1;
	} else if (month === 2 || month === 10) {
		// Mar or Nov
		var dstBegin = new Date(d.getYear(), 2, 7, 6, 0, 0, 0); // 7AM GMT == DST switchover time, Mar 7 == earliest possible DST day
		var dow = dstBegin.getDay();
		if (dow > 0) {
			dstBegin.setDate(dstBegin.getDate() + (7 - dow)); // Adjust to 2nd sunday if the 7th isn't a sunday
		}

		var dstEnd = new Date(d.getYear(), 10, 1, 6, 0, 0, 0); // 7AM GMT == DST switchover time, Mar 7 == earliest possible DST day
		dow = dstEnd.getDay();
		if (dow > 0) {
			dstEnd.setDate(dstEnd.getDate() + (7 - dow)); // Adjust to 1st sunday if the 1st isn't a sunday
		}
		dst = d >= dstBegin && d < dstEnd;
	}

	var tzOffset = dst ? -4 : -5;

	d = new Date(d.getTime() + tzOffset * 3600000);

	var hour = d.getUTCHours();
	var pm = 0;
	if (hour >= 12) {
		hour -= 12;
		pm = 1;
	}
	if (hour === 0) {
		hour = 12;
	}

	var mins = d.getUTCMinutes();
	if (mins < 10) {
		mins = '0' + mins;
	}
	var secs = d.getUTCSeconds();
	if (secs < 10) {
		secs = '0' + secs;
	}

	var monthAbbr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()];

	var AMorPM = pm ? ' PM ' : ' AM ';
	if (d.getTime() < new Date().getTime() - 16 * 60 * 60 * 1000) {
		//More than 16 hours old, show date
		return monthAbbr + ' ' + d.getDate() + ', ' + d.getFullYear() + ' - ' + hour + ':' + mins + ' ' + AMorPM + ' EST';
	}
	return hour + ':' + mins + ':' + secs + AMorPM + 'EST';
}

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrencyMatrix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flags__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_preact_i18n__ = __webpack_require__(9);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var formatExchangeRate = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["f" /* generatePriceFormatter */])({ SecurityTypeCode: 'CURRENCY' });
var INTL_NS = 'currencies';
var colNames = ['Dollar', 'Euro', 'Canadian', 'Peso'];

var CurrencyMatrix = function (_Component) {
	_inherits(CurrencyMatrix, _Component);

	function CurrencyMatrix() {
		_classCallCheck(this, CurrencyMatrix);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	CurrencyMatrix.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getCurrencyMatrix"])(['USD', 'EUR', 'CAD', 'MXN']).then(function (data) {
			return _this2.setState({ data: data });
		});
	};

	CurrencyMatrix.prototype.render = function render(_ref, _ref2) {
		var _ref$transform = _ref.transform,
		    transform = _ref$transform === undefined ? 'uppercase' : _ref$transform;
		var data = _ref2.data;

		if (!data) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a['currency-matrix'] },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__glyphs__["a" /* FinanceSpinner */], null)
			);
		}
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_6__container__["a" /* default */],
			{ transform: transform, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7_preact_i18n__["d" /* Text */], { id: INTL_NS + '.currency' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a['currency-matrix'] },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'table',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'thead',
						null,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'tr',
							null,
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('th', null),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'th',
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__flags__["a" /* default */], { country: 'usa' })
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'th',
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__flags__["a" /* default */], { country: 'europe' })
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'th',
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__flags__["a" /* default */], { country: 'canada' })
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'th',
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__flags__["a" /* default */], { country: 'mexico' })
							)
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'tr',
							null,
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('th', null),
							data.columns.map(function (col, i) {
								return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'th',
									null,
									col,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'small',
										null,
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7_preact_i18n__["d" /* Text */], { id: INTL_NS + '.currencyLong.' + colNames[i] })
									)
								);
							})
						)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'tbody',
						null,
						data.rows.map(function (row, i) {
							return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'tr',
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'th',
									null,
									'1 ',
									data.columns[i]
								),
								row.map(function (price, j) {
									return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'td',
										{ 'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a.price },
										formatExchangeRate(price)
									);
								})
							);
						})
					)
				)
			)
		);
	};

	return CurrencyMatrix;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(861);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(884);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(911);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(677);
/* unused harmony reexport scaleOrdinal */
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(912);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(913);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(914);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(915);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(692);
/* unused harmony reexport scaleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(916);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(917);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(918);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(919);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(920);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(921);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(922);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(923);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(924);
/* unused harmony reexport scaleSequential */






































/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(666);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(395);


/* harmony default export */ __webpack_exports__["a"] = (function (compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function left(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
      }
      return lo;
    },
    right: function right(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function (d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function (array, f) {
  if (f == null) f = pair;
  var i = 0,
      n = array.length - 1,
      p = array[0],
      pairs = new Array(n < 0 ? 0 : n);
  while (i < n) {
    pairs[i] = f(p, p = array[++i]);
  }return pairs;
});

function pair(a, b) {
  return [a, b];
}

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(669);


/* harmony default export */ __webpack_exports__["a"] = (function (array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(422);


/* harmony default export */ __webpack_exports__["a"] = (function (values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  } else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  } else {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function (start, stop, count) {
    var reverse,
        i = -1,
        n,
        ticks,
        step;

    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [start];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while (++i < n) {
            ticks[i] = (start + i) * step;
        }
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while (++i < n) {
            ticks[i] = (start - i) / step;
        }
    }

    if (reverse) ticks.reverse();

    return ticks;
});

function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count),
        power = Math.floor(Math.log(step) / Math.LN10),
        error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count),
        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
        error = step0 / step1;
    if (error >= e10) step1 *= 10;else if (error >= e5) step1 *= 5;else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  } else {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(675);


/* harmony default export */ __webpack_exports__["a"] = (function (matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(378);



var implicit = { name: "implicit" };

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "",
        i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1,
        n = _.length,
        d,
        key;
    while (++i < n) {
      if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    }return scale;
  };

  scale.range = function (_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return ordinal().domain(domain).range(range).unknown(unknown);
  };

  return scale;
}

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis_js__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed_js__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color_js__ = __webpack_require__(396);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color_js__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function (colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i,
        color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function (t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis_js__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed_js__["a" /* default */]);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(519);


/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  var n = values.length;
  return function (t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis_js__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = genericArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberArray_js__ = __webpack_require__(520);



/* unused harmony default export */ var _unused_webpack_default_export = (function (a, b) {
  return (Object(__WEBPACK_IMPORTED_MODULE_1__numberArray_js__["b" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_1__numberArray_js__["a" /* default */] : genericArray)(a, b);
});

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) {
    x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[i], b[i]);
  }for (; i < nb; ++i) {
    c[i] = b[i];
  }return function (t) {
    for (i = 0; i < na; ++i) {
      c[i] = x[i](t);
    }return c;
  };
}

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var d = new Date();
  return a = +a, b = +b, function (t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(516);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || (typeof a === "undefined" ? "undefined" : _typeof(a)) !== "object") a = {};
  if (b === null || (typeof b === "undefined" ? "undefined" : _typeof(b)) !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function (t) {
    for (k in i) {
      c[k] = i[k](t);
    }return c;
  };
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(460);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function () {
    return b;
  };
}

function one(b) {
  return function (t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
      // scan index for next number in b
  am,
      // current match in a
  bm,
      // current match in b
  bs,
      // string preceding current number in b, if any
  i = -1,
      // index in s
  s = [],
      // string constants and placeholders
  q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({ i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(am, bm) });
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
    for (var i = 0, o; i < b; ++i) {
      s[(o = q[i]).i] = o.x(t);
    }return s.join("");
  });
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return +x;
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(901);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(688);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__ = __webpack_require__(689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__["a"]; });
/* unused harmony reexport FormatSpecifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__ = __webpack_require__(908);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__ = __webpack_require__(909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__ = __webpack_require__(910);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__["a"]; });







/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup_js__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim_js__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity_js__ = __webpack_require__(907);









var map = Array.prototype.map,
    prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

/* harmony default export */ __webpack_exports__["a"] = (function (locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup_js__["a" /* default */])(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__["a" /* default */])(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i,
          n,
          c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = Object(__WEBPACK_IMPORTED_MODULE_4__formatTrim_js__["a" /* default */])(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);break;
        default:
          value = padding + valuePrefix + value + valueSuffix;break;
      }

      return numerals(value);
    }

    format.toString = function () {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function (value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* unused harmony export FormatSpecifier */
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(463);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function (x, p) {
    var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* formatDecimalParts */])(x, p);
    if (!d) return x + "";
    var coefficient = d[0],
        exponent = d[1],
        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
        n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* formatDecimalParts */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(691);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [[second, 1, durationSecond], [second, 5, 5 * durationSecond], [second, 15, 15 * durationSecond], [second, 30, 30 * durationSecond], [minute, 1, durationMinute], [minute, 5, 5 * durationMinute], [minute, 15, 15 * durationMinute], [minute, 30, 30 * durationMinute], [hour, 1, durationHour], [hour, 3, 3 * durationHour], [hour, 6, 6 * durationHour], [hour, 12, 12 * durationHour], [day, 1, durationDay], [day, 2, 2 * durationDay], [week, 1, durationWeek], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisector */])(function (i) {
        return i[2];
      }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function (y) {
    return new Date(invert(y));
  };

  scale.domain = function (_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function (interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function (count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function (interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval)) : scale;
  };

  scale.copy = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});

/***/ }),
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntervalSelector; });
/* unused harmony export Interval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_intervals__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dynamic_stock_chart_constants__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_finance_time_scale__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_preact_i18n__ = __webpack_require__(9);
var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var INTL_NS = 'interval-selector';

/**
 * A radio button list of common time intervals for viewing data on a stock chart
 * @param {Object} props
 * @param {Boolean} scaled [optional, default=true] Whether to use financeScale scaled values (true) or regular Date (false)
 * @param {Function} [props.onSelect]          called when an interval is selected
 * @param {Number[]} [props.customInterval]    a custom time range, an array with the first elemnt being the start time, second element the end time
 * @param {String} [props.class]               class for the container element
 * @param {String|Object} [props.style]        style string or object for the container element
 */
// TODO: Add dynamic interval after static intervals
var IntervalSelector = (_temp2 = _class = function (_Component) {
	_inherits(IntervalSelector, _Component);

	function IntervalSelector() {
		var _temp, _this, _ret;

		_classCallCheck(this, IntervalSelector);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { active: 0 }, _this.formatInterval = function (interval) {
			var start = _this.props.scaled ? Object(__WEBPACK_IMPORTED_MODULE_7__lib_finance_time_scale__["b" /* financeScaleInvert */])(interval[0]) : interval[0];
			var end = _this.props.scaled ? Object(__WEBPACK_IMPORTED_MODULE_7__lib_finance_time_scale__["b" /* financeScaleInvert */])(interval[1]) : interval[1];
			return [Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["l" /* intlDateNode */])(start), ' - ', Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["l" /* intlDateNode */])(end)];
		}, _this.handleSelect = function (interval, index) {
			var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props;

			var label = 'custom';

			if (!Array.isArray(interval)) {
				var to = props.timeLimits && props.timeLimits[1];
				label = interval;
				interval = (props.scaled ? __WEBPACK_IMPORTED_MODULE_3__lib_intervals__["b" /* labelToScaledTimeInterval */] : __WEBPACK_IMPORTED_MODULE_3__lib_intervals__["c" /* labelToTimeInterval */])(interval.value || interval, to);
			}

			_this.setState({ active: index, interval: interval });
			props.onSelect && props.onSelect(interval, label);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	IntervalSelector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (this.props.customInterval !== nextProps.customInterval) {
			if (nextProps.customInterval.length) {
				this.handleSelect(nextProps.customInterval, nextProps.labels.length, nextProps);
			}
		}
		// Default to 1 day view now instead of MAX
		if (this.props.labels.length === 1 && nextProps.labels.length > 1) {
			this.handleSelect(nextProps.labels[0], 0, nextProps);
		}
		// If the 'Max' interval is selected, then set that correctly
		else if (this.state.active === this.props.labels.indexOf('MAX') && Object(__WEBPACK_IMPORTED_MODULE_5__lib_util__["o" /* shallowDiffers */])(this.props.labels, nextProps.labels)) {
				this.handleSelect('MAX', nextProps.labels.length - 1, nextProps);
			}
	};

	IntervalSelector.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var active = _ref2.active,
		    interval = _ref2.interval;

		var customInterval = _ref.customInterval,
		    labels = _ref.labels,
		    select = _ref.select,
		    displayValue = _ref.displayValue,
		    width = _ref.width,
		    buttonClass = _ref.buttonClass,
		    listClass = _ref.listClass,
		    props = _objectWithoutProperties(_ref, ['customInterval', 'labels', 'select', 'displayValue', 'width', 'buttonClass', 'listClass']);

		var intervals = labels.concat(width >= __WEBPACK_IMPORTED_MODULE_4__dynamic_stock_chart_constants__["a" /* SMALL_BREAKPOINT */] && customInterval && customInterval.length ? [customInterval] : []);

		interval = props.interval || interval;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(props.class, __WEBPACK_IMPORTED_MODULE_2__style___default.a['interval-selector'], width <= 375 && __WEBPACK_IMPORTED_MODULE_2__style___default.a.narrow), style: props.style },
			select ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_6__cube_blocks__["q" /* Select */],
				{
					displayValue: displayValue,
					'class': props.class,
					buttonClass: buttonClass,
					listClass: listClass,
					anchor: 'right',
					disabled: props.disabled,
					value: interval,
					onChange: this.handleSelect,
					iconPosition: 'right'
				},
				intervals.map(function (label, index) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__cube_blocks__["m" /* Option */], { title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + label }), value: label });
				})
			) : !select && intervals.map(function (label, index) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Interval, {
					active: active === index,
					label: label,
					labelFormatter: _this2.formatInterval,
					index: index,
					onSelect: _this2.handleSelect
				});
			})
		);
	};

	return IntervalSelector;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	labels: ['1d'],
	scaled: true
}, _temp2);

/**
 * A button labelled with a time interval
 * @param {Object} props
 * @param {Function} [props.onSelect]        called when this button is pressed, with props.interval
 * @param {Boolean} [props.active]           if true, this interval is active
 * @param {String|Number[]} [props.label]    label to put on this interval button. if passed a time interval, it will be converted to a label
 * @param {String} [props.class]             class for the container element
 * @param {String|Object} [props.style]      style string or object for the container element
 */


var Interval = function (_Component2) {
	_inherits(Interval, _Component2);

	function Interval() {
		var _temp3, _this3, _ret2;

		_classCallCheck(this, Interval);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp3 = (_this3 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this3), _this3.handleClick = function () {
			var _this3$props = _this3.props,
			    label = _this3$props.label,
			    index = _this3$props.index,
			    active = _this3$props.active;
			// no need to fire an event if this button is already active

			!active && _this3.props.onSelect && _this3.props.onSelect(label, index);
		}, _temp3), _possibleConstructorReturn(_this3, _ret2);
	}

	Interval.prototype.render = function render(_ref3) {
		var active = _ref3.active,
		    label = _ref3.label,
		    labelFormatter = _ref3.labelFormatter,
		    props = _objectWithoutProperties(_ref3, ['active', 'label', 'labelFormatter']);

		if (Array.isArray(label)) {
			label = labelFormatter(label);
		} else {
			var labelKey = label && label.toUpperCase && label.toUpperCase();
			// eslint-disable-next-line no-alert, new-cap
			label = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + labelKey });
		}
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["b" /* Localizer */],
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'button',
				{
					onClick: this.handleClick,
					'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(props.class, __WEBPACK_IMPORTED_MODULE_2__style___default.a.interval, active && __WEBPACK_IMPORTED_MODULE_2__style___default.a.active),
					style: props.style,
					'data-tracking-link-name': label
				},
				label
			)
		);
	};

	return Interval;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Earnings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__annual_quarterly_selector__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__stock_data_table__ = __webpack_require__(471);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var INTL_NS = 'stock-data-table';
var INTL_NS_IS = 'incomeStatement';

var Earnings = function (_Component) {
	_inherits(Earnings, _Component);

	function Earnings() {
		var _temp, _this, _ret;

		_classCallCheck(this, Earnings);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChangeTimeRange = function (_ref) {
			var _ref$value = _ref.value,
			    timespan = _ref$value === undefined ? '' : _ref$value;

			_this.setState({ timespan: timespan.toLowerCase() });
		}, _this.setDefaultColumnHeadings = function () {
			// If the earnings data is missing/unavailable, display the default column headings as follows:
			// For 2017 quarterly column headings: Q1'17, Q2'17, Q3'17, Q4'17.
			// For 2017 annual column headings: 12/31/2017, 12/31/2016, 12/31/2016.
			// Fill the data.rows array with standard dates; i.e.,
			// data.rows[0]: ["Q1", "Q1", "2017-03-31", "2017-03-31", 2017]
			// ...
			// data.rows[11]: ["Q4", "Q4", "2015-12-31", "2015-12-31", 2015]
			var data = {};
			data.columns = ['Fiscal Quarter', 'Calendar Quarter', 'Reported Date', 'Filing Date', 'Fiscal Year'];
			data.rows = [];

			var currYear = new Date().getFullYear();
			var numYear = void 0,
			    numQtr = void 0,
			    currMonth = void 0,
			    qtrDate = void 0,
			    i = 0;
			var dashStr = '-';
			var q3EndMonth = 9;

			for (numYear = 0; numYear < 3; numYear++) {
				for (numQtr = 1; numQtr <= 4; numQtr++) {
					currMonth = numQtr * 3;
					qtrDate = currYear + dashStr + (currMonth <= q3EndMonth ? '0' : '') + currMonth + dashStr + Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["j" /* getDaysInMonth */])(currMonth, currYear);
					data.rows[i++] = ['Q' + numQtr, 'Q' + numQtr, qtrDate, qtrDate, currYear];
				}
				currYear--;
			}
			return data;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Earnings.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_2__os_cloudquote__["getIncomeStatement"])(this.props.symbol).then(function (data) {
			if (!data.columns || data.columns.length === 0 || !data.rows || data.rows.length === 0) {
				data = _this2.setDefaultColumnHeadings();
			}
			_this2.setState({ data: data });
		});
	};

	Earnings.prototype.render = function render(props, _ref2) {
		var data = _ref2.data,
		    _ref2$timespan = _ref2.timespan,
		    timespan = _ref2$timespan === undefined ? 'quarterly' : _ref2$timespan;

		var rows = data && data.rows;

		if (!rows || !rows.length) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__glyphs__["a" /* FinanceSpinner */], null);
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["g" /* Header */],
				{ 'class': __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style_less___default.a.statisticsHeader, props.class), title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.netIncContOp' }) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__annual_quarterly_selector__["a" /* default */], { value: timespan, onChange: this.handleChangeTimeRange, anchor: 'right' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9__stock_data_table__["a" /* default */], {
				data: data,
				compact: true,
				showDates: true,
				cols: [{
					name: 'Revenue',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.revenue' })
				}, {
					name: 'Net Income From Continuing Operations',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.netIncContOpLong' })
				}],
				timespan: timespan
			})
		);
	};

	return Earnings;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AnnualQuarterlySelector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var INTL_NS = 'annual-quarterly-selector';

function AnnualQuarterlySelector(_ref) {
	var onChange = _ref.onChange,
	    value = _ref.value,
	    props = _objectWithoutProperties(_ref, ['onChange', 'value']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["q" /* Select */],
		_extends({}, props, { onChange: onChange, value: value, iconPosition: 'right' }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["m" /* Option */], { title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ANNUAL */] }), value: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ANNUAL */] }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["m" /* Option */], { title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* QUARTERLY */] }), value: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* QUARTERLY */] })
	);
}

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANNUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QUARTERLY; });
var ANNUAL = 'annual';
var QUARTERLY = 'quarterly';

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncomeStatement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__currency_indicator__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index__ = __webpack_require__(471);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var INTL_NS = 'stock-data-table';
var INTL_NS_IS = 'incomeStatement';



var IncomeStatement = function (_Component) {
	_inherits(IncomeStatement, _Component);

	function IncomeStatement() {
		_classCallCheck(this, IncomeStatement);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	IncomeStatement.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["getIncomeStatement"])(this.props.symbol).then(function (data) {
			return _this2.setState({ data: data });
		});
	};

	IncomeStatement.prototype.render = function render(_ref, _ref2) {
		var data = _ref2.data;

		var timespan = _ref.timespan,
		    props = _objectWithoutProperties(_ref, ['timespan']);

		var rows = data && data.rows;

		if (!rows || !rows.length) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__glyphs__["a" /* FinanceSpinner */], null);
		}

		data.rows.map(function (row) {
			var oi = data.columns.indexOf('Operating Income'),
			    on = data.columns.indexOf('Other Non-Operating Items, Net');
			row.push(row[oi] + row[on]);
		});
		data.columns.push('Earnings Before Taxes');

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */],
				{ 'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a.dataHeader,
					title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.incomeStatement' }),
					secondary: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.numInMs' })
				},
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__currency_indicator__["a" /* CurrencyIndicator */], { symbol: props.symbol })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.revenue' }),
				showDates: true,
				cols: [{
					name: 'Total Revenue',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.totalRev' })
				}, {
					name: 'Cost of Revenue',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.costOfRev' })
				}, {
					name: 'Other Revenue',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.otherRev' })
				}, {
					name: 'Gross Profit',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.grossProfit' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.opExpenses' }),
				cols: [{
					name: 'Research and Development',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.researchDev' })
				}, {
					name: 'SG&A',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.sGA' })
				}, {
					name: 'Depreciation, Depletion, Amortization and Accretion',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.depAmort' })
				}, {
					name: 'Other Operating Expense',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.otherOpExpenses' })
				}, {
					name: 'Operating Expenses',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.opExpenses' })
				}, {
					name: 'Operating Income',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.opIncome' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.incContOp' }),
				cols: [{
					name: 'Other Non-Operating Items, Net',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.otherNonOp' })
				}, {
					name: 'Earnings Before Taxes',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.earningsPreTax' })
				}, {
					name: 'Interest Expense, Non-Operating',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.intExpNonOp' })
				}, {
					name: 'Income Before Taxes',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.incPreTax' })
				}, {
					name: 'Income Taxes',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.incTaxes' })
				}, {
					name: 'Net Income From Continuing Operations',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.netIncContOp' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.nonRecurring' }),
				cols: [{
					name: 'Noncontrolling Interest, Extraordinary Items and Discontinued Operations',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.nonContIntEtc' })
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.netIncome' }),
				cols: [{
					name: 'Net Income',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_IS + '.netIncome' }),
					bold: true
				}]
			})
		);
	};

	return IncomeStatement;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tabs":"finance_financial-details-panel_tabs","tabHeader":"finance_financial-details-panel_tabHeader","floatRight":"finance_financial-details-panel_floatRight"};

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTL_NS */
/* unused harmony export INTERVAL_NS */
/* unused harmony export COMP_NS */
/* unused harmony export StockChartImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockChartBare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StockChartWithIntervals; });
/* unused harmony export StockChartButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_linkstate__ = __webpack_require__(727);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var INTL_NS = 'stock-chart',
    INTERVAL_NS = INTL_NS + '.intervals',
    COMP_NS = INTL_NS + '.comparisons';

var StockChartImage = function (_Component) {
	_inherits(StockChartImage, _Component);

	function StockChartImage(props, context) {
		_classCallCheck(this, StockChartImage);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.isLoaded = function () {
			_this.setState({ loaded: true });
		};

		_this.svg = document.implementation && document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
		return _this;
	}

	StockChartImage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.symbol !== this.props.symbol) {
			this.setState({ loaded: false });
		}
	};

	StockChartImage.prototype.render = function render(props, _ref) {
		var _ref$loaded = _ref.loaded,
		    loaded = _ref$loaded === undefined ? false : _ref$loaded;

		// NOTE: This image contains X-axis values that can't be localized
		var src = this.svg ? Object(__WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getSVGPriceChartURL"])(props) : Object(__WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getPNGPriceChartURL"])(props);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style___default.a['stock-chart'], !loaded && __WEBPACK_IMPORTED_MODULE_4__style___default.a.loading) },
			!loaded && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__glyphs__["a" /* FinanceSpinner */], { 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.spinner }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: src, onload: this.isLoaded })
		);
	};

	return StockChartImage;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var StockChartBare = function StockChartBare(props, state) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a['stock-chart'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockChartImage, props)
	);
};

var StockChartWithIntervals = function (_Component2) {
	_inherits(StockChartWithIntervals, _Component2);

	function StockChartWithIntervals() {
		var _temp, _this2, _ret;

		_classCallCheck(this, StockChartWithIntervals);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.intervals = [{ days: 1, label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTERVAL_NS + '.oneDay' }) }, { days: 7, label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTERVAL_NS + '.oneWeek' }) }, { days: 31, label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTERVAL_NS + '.oneMonth' }) }, { days: 92, label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTERVAL_NS + '.threeMonth' }) }, { days: 366, label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTERVAL_NS + '.oneYear' }) }, { days: 1830, label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTERVAL_NS + '.fiveYear' }) }, { days: 73000, label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTERVAL_NS + '.max' }) // 200 years, defaults to max
		}], _this2.comparisons = [{ label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: COMP_NS + '.none' }), symbol: null }, { label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: COMP_NS + '.dow' }), symbol: '$DJI' }, { label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: COMP_NS + '.nasdaq' }), symbol: '$COMP' }, { label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: COMP_NS + '.sp500' }), symbol: '$SPX' }], _temp), _possibleConstructorReturn(_this2, _ret);
	}

	StockChartWithIntervals.prototype.render = function render(_ref2, _ref3) {
		var _this3 = this;

		var _ref3$curInterval = _ref3.curInterval,
		    curInterval = _ref3$curInterval === undefined ? 0 : _ref3$curInterval,
		    _ref3$curComparison = _ref3.curComparison,
		    curComparison = _ref3$curComparison === undefined ? 0 : _ref3$curComparison;

		var symbol = _ref2.symbol,
		    props = _objectWithoutProperties(_ref2, ['symbol']);

		var interval = this.intervals[curInterval];
		var comparison = this.comparisons[curComparison];
		if (comparison.symbol) {
			symbol += ',' + comparison.symbol;
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': '' + __WEBPACK_IMPORTED_MODULE_4__style___default.a['stock-chart-with-intervals'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockChartImage, _extends({ interval: interval.days, symbol: symbol }, props)),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.intervals + ' ' + __WEBPACK_IMPORTED_MODULE_4__style___default.a['horizontal-nav'] },
				this.intervals.map(function (interval, i) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockChartButton, {
						onClick: Object(__WEBPACK_IMPORTED_MODULE_7_linkstate__["a" /* default */])(_this3, 'curInterval', 'interval'),
						interval: i,
						active: i === curInterval,
						label: interval.label
					});
				})
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.comparisons },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.inner },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.title },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'span',
							null,
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */],
								{ id: INTL_NS + '.compareTo' },
								'Compare to'
							)
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["q" /* Select */],
							{ anchor: 'right', iconPosition: 'right', value: curComparison, onChange: Object(__WEBPACK_IMPORTED_MODULE_7_linkstate__["a" /* default */])(this, 'curComparison', 'value') },
							this.comparisons.map(function (item, i) {
								return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["m" /* Option */], { iconPosition: 'left', title: item.label, value: i });
							})
						)
					)
				)
			)
		);
	};

	return StockChartWithIntervals;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var StockChartButton = function (_Component3) {
	_inherits(StockChartButton, _Component3);

	function StockChartButton() {
		var _temp2, _this4, _ret2;

		_classCallCheck(this, StockChartButton);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, _Component3.call.apply(_Component3, [this].concat(args))), _this4), _this4.handleClick = function () {
			_this4.props.onClick(_this4.props);
		}, _temp2), _possibleConstructorReturn(_this4, _ret2);
	}

	StockChartButton.prototype.render = function render(_ref4) {
		var active = _ref4.active,
		    label = _ref4.label;

		var activeStyle = active ? __WEBPACK_IMPORTED_MODULE_4__style___default.a.active : '';
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			{ onClick: this.handleClick, 'class': activeStyle + ' ' + __WEBPACK_IMPORTED_MODULE_4__style___default.a['interval-selector'] },
			label
		);
	};

	return StockChartButton;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function dlv(obj, key, def, p) {
	p = 0;
	key = key.split ? key.split('.') : key;
	while (obj && p < key.length) {
		obj = obj[key[p++]];
	}
	return obj === undefined ? def : obj;
}

/** Create an Event handler function that sets a given state property.
 *	@param {Component} component	The component whose state should be updated
 *	@param {string} key				A dot-notated key path to update in the component's state
 *	@param {string} eventPath		A dot-notated key path to the value that should be retrieved from the Event or component
 *	@returns {function} linkedStateHandler
 */
function linkState(component, key, eventPath) {
	var path = key.split('.'),
	    cache = component.__lsc || (component.__lsc = {});

	return cache[key + eventPath] || (cache[key + eventPath] = function (e) {
		var t = e && e.target || this,
		    state = {},
		    obj = state,
		    v = typeof eventPath === 'string' ? dlv(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e,
		    i = 0;
		for (; i < path.length - 1; i++) {
			obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
		}
		obj[path[i]] = v;
		component.setState(state);
	});
}

/* harmony default export */ __webpack_exports__["a"] = (linkState);
//# sourceMappingURL=linkstate.es.js.map

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"splitsDividends":"finance_historical-data-panel_splitsDividends","sdCont":"finance_historical-data-panel_sdCont","wide":"finance_historical-data-panel_wide","filter":"finance_historical-data-panel_filter","item":"finance_historical-data-panel_item","label":"finance_historical-data-panel_label","selectButton":"finance_historical-data-panel_selectButton","icon":"finance_historical-data-panel_icon","intervalSelector":"finance_historical-data-panel_intervalSelector"};

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildYears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adjustTimerange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sortData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filterRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloudquote_data_table__ = __webpack_require__(377);


var buildYears = function buildYears(_ref) {
	var columns = _ref.columns,
	    rows = _ref.rows;

	var i = columns.indexOf('Date'),
	    years = {};

	rows.forEach(function (row) {
		var d = new Date(row[i]),
		    year = d.getFullYear(),
		    month = d.getMonth() + 1;

		if (years[year]) {
			if (years[year][month]) {
				years[year][month].push(row);
			} else {
				years[year][month] = [row];
			}
		} else {
			var _years$year;

			years[year] = (_years$year = {}, _years$year[month] = [row], _years$year);
		}
	});
	return years;
};

var adjustTimerange = function adjustTimerange(start, end, interval, data) {
	if (interval === '1D') {
		var day = data.rows[0],
		    dayInMilliseconds = 8.64e+7,
		    t = apiDate({
			start: day[0] - dayInMilliseconds,
			end: day[0]
		});

		start = t.start;
		end = t.end;

		data.rows = [day];
	}

	if (interval === 'MAX') {
		var _day = data.rows.slice(-1)[0],
		    _t = apiDate({ start: _day[0], end: end });

		start = _t.start;
	}

	return { timerange: { start: start, end: end }, cacheData: data };
};

/**
 * Set the start date to a week ago.
 * @param {String} start    the start date "2016-10-14"
 * @returns {String}        returns a date "2016-10-07"
 */
var setStart = function setStart(start) {
	var newDay = void 0,
	    daysInWeek = 7,
	    ten = 10;

	start = start.split('-');
	newDay = start[2] - daysInWeek;
	start[2] = newDay < ten ? '0' + newDay : newDay;

	return start.join('-');
};

var apiDate = function apiDate(timerange) {
	timerange.end = new Date(timerange.end).toISOString().split('T')[0];
	timerange.start = new Date(timerange.start).toISOString().split('T')[0];

	return timerange;
};

var sortData = function sortData(_ref2) {
	var columns = _ref2.columns,
	    rows = _ref2.rows;

	var dateKey = !columns ? 'eventDate' : Object(__WEBPACK_IMPORTED_MODULE_0__cloudquote_data_table__["b" /* indexOrKey */])(columns, 'Date');
	rows = rows || [];
	rows = rows.sort(function (a, b) {
		return b[dateKey] > a[dateKey] ? 1 : -1;
	});
	return { columns: columns, rows: rows };
};

var filterRows = function filterRows() {
	var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var start = arguments[1];
	var end = arguments[2];
	return rows.filter(function (row, i) {
		return row.eventDate >= start && row.eventDate <= end;
	});
};

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuoteHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var QuoteHeader = function QuoteHeader(_ref) {
	var width = _ref.width,
	    _ref$enableHeader = _ref.enableHeader,
	    enableHeader = _ref$enableHeader === undefined ? true : _ref$enableHeader,
	    props = _objectWithoutProperties(_ref, ['width', 'enableHeader']);

	var WIDTH_BREAKPOINT = 500;
	return width >= WIDTH_BREAKPOINT ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.quoteLookup) },
		enableHeader && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["h" /* HeaderV2 */], { 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.header, width >= 768 && __WEBPACK_IMPORTED_MODULE_2__style___default.a.wide), title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */],
				{ id: 'quote-header.quoteLookup' },
				'Quote Lookup'
			) }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'p',
			{ 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.lastUpdated, enableHeader && __WEBPACK_IMPORTED_MODULE_2__style___default.a.padTop) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */],
				{ id: 'QUOTES_DELAYED' },
				'Quotes delayed at least 15min.'
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: '/finance/disclaimer', target: '_blank', rel: 'noopener noreferrer' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */],
					{ id: 'DISCLAIMER' },
					'Disclaimer'
				)
			)
		)
	) : null;
};


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfilePhone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profile__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_phone__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__provide_finance_model__ = __webpack_require__(1051);





//Export the view components after wrapping them with the model providers for the
//finance data

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3__provide_finance_model__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__profile__["a" /* default */]));
var ProfilePhone = Object(__WEBPACK_IMPORTED_MODULE_3__provide_finance_model__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__profile_phone__["a" /* default */]);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CompanyInfo;
/* unused harmony export DataWithLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container__ = __webpack_require__(355);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };









var INTL_NS = 'company-profile';

function CompanyInfo(_ref) {
	var data = _ref.data;

	var rows = data && data.rows && data.rows[0];

	if (!rows) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__glyphs__["a" /* FinanceSpinner */], null);
	}

	var exchangeName = rows.exchangeName,
	    symbol = rows.symbol,
	    ceo = rows.ceo,
	    address = rows.address,
	    city = rows.city,
	    state = rows.state,
	    zipCode = rows.zipCode,
	    phoneNumber = rows.phoneNumber,
	    exchange = rows.exchange,
	    industry = rows.industry;

	var industryId = industry && industry.trim && industry.trim().length ? Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["b" /* camel */])(industry) : 'dataUnavailable';

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_5__container__["a" /* default */],
		{ parent: true, 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.container, title: exchangeName || symbol },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.left },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(DataWithLabel, { label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.ceo' }), value: ceo }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(DataWithLabel, { value: address, unavailableTextId: INTL_NS + '.addressUnavailable' }),
			city && state && zipCode && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				null,
				city.toLowerCase() + ', ' + state + ' ' + zipCode
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(DataWithLabel, {
				value: !!phoneNumber && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'a',
					{ href: 'tel:' + phoneNumber },
					phoneNumber
				),
				unavailableTextId: INTL_NS + '.phoneNumberUnavailable'
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.right },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(DataWithLabel, { label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.exchange' }), value: exchange, lowercase: false }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(DataWithLabel, { label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.industry' }), value: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.industries.' + industryId },
					industry
				) })
		)
	);
}

function DataWithLabel(_ref2) {
	var label = _ref2.label,
	    value = _ref2.value,
	    _ref2$lowercase = _ref2.lowercase,
	    lowercase = _ref2$lowercase === undefined ? true : _ref2$lowercase,
	    _ref2$unavailableText = _ref2.unavailableTextId,
	    unavailableTextId = _ref2$unavailableText === undefined ? INTL_NS + '.dataUnavailable' : _ref2$unavailableText;

	if (typeof value === 'string' && lowercase) value = value.toLowerCase();
	var labelValue = (typeof label === 'undefined' ? 'undefined' : _typeof(label)) === 'object' ? label : label && '' + label;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		null,
		label && labelValue,
		label && ': ',
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			{ 'class': value ? label && __WEBPACK_IMPORTED_MODULE_4__style___default.a.bold : __WEBPACK_IMPORTED_MODULE_4__style___default.a.dataUnavailable },
			value || Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: unavailableTextId })
		)
	);
}

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Description;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container__ = __webpack_require__(355);








var INTL_NS = 'company-profile';

function Description(_ref) {
	var data = _ref.data,
	    _ref$hide = _ref.hide,
	    hide = _ref$hide === undefined ? false : _ref$hide;

	if (hide) return null;

	var rows = data && data.rows && data.rows[0];

	if (!rows) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__glyphs__["a" /* FinanceSpinner */], null);
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.description },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_5__container__["a" /* default */],
			{ parent: true, 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.container, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.description' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2_classnames___default()(!rows.businessSummary && __WEBPACK_IMPORTED_MODULE_4__style___default.a.dataUnavailable) },
				rows.businessSummary || Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dataUnavailable' })
			)
		)
	);
}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = model;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(1047);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**	Creates a higher order component that resolves (async) values from a model to props.
 *	This allows (but importantly abstracts) context access, and manages re-rendering in response to resolved data.
 *	`model()` is simply a formalization of what is typically done as side-effects within `componentDidMount()`.
 *
 *	@name model
 *	@param {String} [namespace]				The context property at which to obtain a model instance. If empty, all of `context` is used.
 *	@param {Object|Function} [mapToProps]	An object containing default configuration values
 *	@returns {Function} modelBinding(Child) -> ModelDataWrapper<Child>
 *
 *	@example
 *	// resolves news.getTopStories(), passing it down as a "stories" prop
 *	let withTopStories = model('news', {
 *		stories: 'getTopStories'
 *	});
 *	export default withTopStories( props =>
 *		<ul>
 *			{ props.stories.map( item =>
 *				<li>{item.title}</li>
 *			) }
 *		</ul>
 *	);
 *
 *	@example
 *	// resolves a news story by ID and passes it down as a "story" prop
 *	let withStory = model('news', props => ({
 *		story: ['getStory', props.id]
 *	}));
 *
 *	// Simple "view" functional component to render a story
 *	const StoryView = ({ story }) => (
 *		<div class="story">
 *			<h2>{story ? story.title : '...'}</h2>
 *			<p>{story && story.content}</p>
 *		</div>
 *	);
 *
 *	// Wrap StoryView in the loader component created by model()
 *	const Story = withStory(StoryView);
 *
 *	// Provide a news model into context so Story can wire up to it
 *	render(
 *		<Provider news={newsModel({ origin: '//news.api' })}>
 *			<div class="demo">
 *				<h1>News Story #1234:</h1>
 *				<Story id="1234" />
 *			</div>
 *		</Provider>
 *	);
 */
function model(ns) {
	var mapToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var mapLibToProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__util__["c" /* noop */];

	// @TODO this could be global. should it be?
	var CACHE = {};

	return function (Child) {
		return function (_Component) {
			_inherits(ModelDataWrapper, _Component);

			function ModelDataWrapper(props, context) {
				_classCallCheck(this, ModelDataWrapper);

				var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

				_this.state = {};
				_this.currentKeys = {};

				// used for creating unique IDs.
				_this.tracking = {};
				_this.counter = 0;

				_this.mapping = mapLibToProps(Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* get */])(context, ns), props);

				_this.refresh = function () {
					_this.invoke(_this.props, false, true);
				};
				return _this;
			}

			ModelDataWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(props, state) {
				return !Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(props, this.props) || !Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(state, this.state);
			};

			ModelDataWrapper.prototype.invoke = function invoke(props, keysOnly, refresh) {
				var _this2 = this;

				var source = Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* get */])(this.context, ns),
				    isFunction = typeof mapToProps === 'function',
				    mapping = isFunction ? mapToProps(props) : mapToProps,
				    keys = [];

				var _loop = function _loop(prop) {
					if (mapping.hasOwnProperty(prop)) {
						var path = mapping[prop],
						    args = [];
						if (Array.isArray(path)) {
							args = path.slice(1);
							path = path[0];
						}
						if (!isFunction) {
							args = args.map(function (p) {
								return typeof p === 'string' && p in props ? props[p] : p;
							});
						}

						// @TODO faster object key / serialization would be nice here
						var key = JSON.stringify([ns, path].concat(args));
						keys.push(key);
						if (keysOnly) return 'continue';

						if (!refresh && _this2.currentKeys[prop] === key) {
							return 'continue';
						}

						_this2.currentKeys[prop] = key;

						var p = void 0;
						if (typeof path === 'function') {
							p = path();
						} else if (typeof path !== 'string') {
							p = path;
						} else {
							var fn = __WEBPACK_IMPORTED_MODULE_1_dlv___default()(source, path);
							if (!fn) throw Error(ns + '.' + path + ' not found.');
							p = fn.apply(undefined, args);
						}

						if (p && p.then !== undefined && p.__modelConnectResolved) {
							p = p.__modelConnectResolved;
						}

						// magically re-render for async values:
						if (p && p.then !== undefined) {

							var newState = {};
							var _state = _this2.state,
							    pending = _state.pending,
							    rejected = _state.rejected;

							// set that this property call is pending if not already set

							if (!pending) {
								var _newState$pending;

								newState.pending = (_newState$pending = {}, _newState$pending[prop] = true, _newState$pending);
							} else if (!pending[prop]) {
								var _extends2;

								newState.pending = _extends({}, pending, (_extends2 = {}, _extends2[prop] = true, _extends2));
							}

							// Since we're starting a new call for prop, remove any old rejected status for it if it exists
							if (rejected && rejected[prop]) {
								newState.rejected = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* removeKeyFromObject */])(prop, rejected);
							}

							var id = ++_this2.counter;
							_this2.tracking[prop] = id;

							// handle the promise results
							p.then(function (data) {
								p.__modelConnectResolved = data;

								// cache the result if the promise resolved successfully
								var newState = {};
								newState[prop] = CACHE[key] = data;
								return newState;
							}).catch(function (err) {
								if (_this2.tracking[prop] !== id) return;

								// If there was an error, use the cached value if available and set the rejected property
								var rejected = _this2.state.rejected && _extends({}, _this2.state.rejected) || {};
								rejected[prop] = err;
								var newState = { rejected: rejected };
								if (CACHE[key]) newState[prop] = CACHE[key];
								return newState;
							}).then(function (newState) {
								if (_this2.tracking[prop] !== id) return;
								delete _this2.tracking[prop];

								// remove the pending key for this prop if necessary
								var pending = _this2.state.pending;
								if (pending && pending[prop]) newState.pending = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* removeKeyFromObject */])(prop, pending);
								_this2.setState(newState);
							});

							// if we got a Promise but there's a cached value, use that until the new value comes in:
							if (typeof CACHE[key] !== 'undefined') {
								newState[prop] = CACHE[key];
							}
							_this2.setState(newState);
						} else {
							var _this2$setState;

							//for non-promises, just set the state with the value
							_this2.setState((_this2$setState = {}, _this2$setState[prop] = p, _this2$setState));
						}
					}
				};

				for (var prop in mapping) {
					var _ret = _loop(prop);

					if (_ret === 'continue') continue;
				}return this.keys = keys;
			};

			ModelDataWrapper.prototype.componentWillMount = function componentWillMount() {
				this.invoke(this.props);
			};

			ModelDataWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
				if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(nextProps, this.props) && Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* join */])(this.keys) !== Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* join */])(this.invoke(nextProps, true))) {
					this.invoke(nextProps);
				}
			};

			ModelDataWrapper.prototype.render = function render(props, state) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, _extends({ refresh: this.refresh }, this.mapping, props, state));
			};

			return ModelDataWrapper;
		}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);
	};
}

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addToRecentlyViewed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stock_recently_viewed__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_storage__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1054);




/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__stock_recently_viewed__["a" /* default */]);

/**
 * Takes a security ticker and ticket type and attempts to add to local storage
 * @param  {String} sym security ticker
 * @example "GOOG"
 * @param  {String} securityType API-provided security classification
 * @example "STOCK"
 */
var addToRecentlyViewed = function addToRecentlyViewed(sym, securityType) {
	var MAX_RECENT = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].maxRecent,
	    allowedInStorage = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].allowedInStorage;

	// Only certain security types have been whitelisted; see component-level config

	if (!allowedInStorage[securityType]) return;

	var symbols = __WEBPACK_IMPORTED_MODULE_1__lib_storage__["a" /* recentStorage */].get('stocks') || [];

	// Securities should be ordered by most recently viewed first
	if (symbols[0] === sym) return;
	symbols = [sym].concat(symbols);

	// Only one instance of each security should be present in the list
	if (symbols.lastIndexOf(sym)) symbols.splice(symbols.lastIndexOf(sym), 1);

	if (symbols.length > MAX_RECENT) symbols.pop();
	__WEBPACK_IMPORTED_MODULE_1__lib_storage__["a" /* recentStorage */].set('stocks', symbols);
};

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return recentStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_dbee__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_dbee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__os_dbee__);


var localStorage = __WEBPACK_IMPORTED_MODULE_0__os_dbee___default()('finance-components');

/* unused harmony default export */ var _unused_webpack_default_export = (localStorage);
var recentStorage = localStorage.ns('stock-recently-viewed');

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VerticalBarGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HorizontalBarGraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var VerticalBarGraph = function VerticalBarGraph(_ref) {
	var width = _ref.width,
	    height = _ref.height,
	    bars = _ref.bars,
	    props = _objectWithoutProperties(_ref, ['width', 'height', 'bars']);

	var barWidth = width / bars.length;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a['bar-graph'] + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a['vertical-bar-graph'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'svg',
			{ width: '100%', viewBox: '0 0 ' + width + ' ' + height },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.bars },
				bars.map(function (row, i) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VerticalBarGraphBar, _extends({}, bars[i], { width: barWidth, height: height, i: i }, props));
				})
			)
		)
	);
};


var VerticalBarGraphBar = function VerticalBarGraphBar(_ref2) {
	var i = _ref2.i,
	    value = _ref2.value,
	    barLabel = _ref2.barLabel,
	    valLabel = _ref2.valLabel,
	    width = _ref2.width,
	    height = _ref2.height,
	    className = _ref2.className,
	    _ref2$padding = _ref2.padding,
	    padding = _ref2$padding === undefined ? 1 : _ref2$padding,
	    _ref2$barStartValue = _ref2.barStartValue,
	    barStartValue = _ref2$barStartValue === undefined ? 0 : _ref2$barStartValue;


	var labelHeight = barLabel ? 25 : 0;
	var barMax = height - labelHeight;

	var barPos = value * barMax;
	var barStart = barStartValue * barMax;

	var valHeight = 25;
	var labelInside = false;
	var labelPos = void 0;
	if (barPos > barStart) {
		//Upward bar
		if (barMax - barPos > valHeight) {
			labelPos = barPos + 5;
		} else if (barPos - barStart > valHeight) {
			labelPos = barPos - 12;
			labelInside = true;
		} else {
			labelPos = barStart - 12;
		}
	} else if (barPos > valHeight) {
		labelPos = barPos - 12;
	} else if (barStart - barPos > valHeight) {
		labelPos = barPos + 5;
		labelInside = true;
	} else {
		labelPos = barStart + 5;
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'g',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.barGroup + ' ' + (className || ''), transform: 'translate(' + width * i + ',0)' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.bg, x: padding, width: width - padding - padding, y: labelHeight, height: barMax }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.bar, x: padding, width: width - padding - padding, y: height - (barStart > barPos ? barStart : barPos), height: Math.abs(barStart - barPos) }),
		valLabel && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'text',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.value + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a[labelInside ? 'inside' : 'outside'], x: width / 2, y: height - labelPos, 'text-anchor': 'middle' },
			valLabel
		),
		barLabel && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'text',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.label, x: width / 2, y: labelHeight / 2, 'dominant-baseline': 'central', 'text-anchor': 'middle' },
			barLabel
		)
	);
};

var HorizontalBarGraph = function HorizontalBarGraph(_ref3) {
	var width = _ref3.width,
	    height = _ref3.height,
	    bars = _ref3.bars,
	    props = _objectWithoutProperties(_ref3, ['width', 'height', 'bars']);

	var barHeight = height / bars.length;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a['bar-graph'] + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a['horizontal-bar-graph'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'svg',
			{ width: '100%', viewBox: '0 0 ' + width + ' ' + height },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.bars },
				bars.map(function (row, i) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(HorizontalBarGraphBar, _extends({}, bars[i], { height: barHeight, width: width, i: i }, props));
				})
			)
		)
	);
};


var HorizontalBarGraphBar = function HorizontalBarGraphBar(_ref4) {
	var i = _ref4.i,
	    value = _ref4.value,
	    barLabel = _ref4.barLabel,
	    valLabel = _ref4.valLabel,
	    width = _ref4.width,
	    height = _ref4.height,
	    className = _ref4.className,
	    _ref4$padding = _ref4.padding,
	    padding = _ref4$padding === undefined ? 3 : _ref4$padding,
	    _ref4$labelHeight = _ref4.labelHeight,
	    labelHeight = _ref4$labelHeight === undefined ? height * .5 : _ref4$labelHeight,
	    _ref4$labelPos = _ref4.labelPos,
	    labelPos = _ref4$labelPos === undefined ? 'top' : _ref4$labelPos,
	    _ref4$labelWidth = _ref4.labelWidth,
	    labelWidth = _ref4$labelWidth === undefined ? width * .2 : _ref4$labelWidth,
	    _ref4$barStartValue = _ref4.barStartValue,
	    barStartValue = _ref4$barStartValue === undefined ? 0.5 : _ref4$barStartValue;

	var barTop = labelPos === 'top' ? labelHeight + padding : 0;
	var barLeft = labelPos === 'left' ? labelWidth + padding : 0;
	var barHeight = height - barTop - padding;

	var barMax = width - barLeft;
	var barPos = value * barMax;
	var barStart = barStartValue * barMax;

	var valWidth = 20;
	var labelInside = false;
	var labelLeft = true;
	var labelX = void 0;
	if (barPos > barStart) {
		//Rightward bar
		if (barMax - barPos > valWidth) {
			labelX = barPos;
		} else if (barPos - barStart > valWidth) {
			labelX = barPos;
			labelInside = true;
			labelLeft = false;
		} else {
			labelX = barStart;
			labelLeft = false;
		}
	} else if (barPos > valWidth) {
		labelX = barPos;
		labelLeft = false;
	} else if (barStart - barPos > valWidth) {
		labelX = barPos;
		labelInside = true;
	} else {
		labelX = barStart;
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'g',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.barGroup + ' ' + (__WEBPACK_IMPORTED_MODULE_1__style___default.a[className] || ''), transform: 'translate(0,' + height * i + ')' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.bg, x: barLeft, y: barTop, width: barMax, height: barHeight }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.bar, x: barLeft + (barStart < barPos ? barStart : barPos), y: barTop, width: Math.abs(barStart - barPos), height: barHeight }),
		valLabel && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'text',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.value + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a[labelInside ? 'inside' : 'outside'], x: barLeft + labelX + (labelLeft ? 2 : -2), y: barTop + barHeight / 2, 'dominant-baseline': 'central', 'text-anchor': labelLeft ? 'start' : 'end' },
			valLabel
		),
		barLabel && {
			top: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'text',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.label, x: 5, y: labelHeight / 2, 'dominant-baseline': 'central', 'text-anchor': 'left' },
				barLabel
			),
			left: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'text',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.label, x: 0, y: height / 2, 'dominant-baseline': 'central', 'text-anchor': 'start' },
				barLabel
			)
		}[labelPos]
	);
};

/***/ }),
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AnalystsPanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_details_page__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__insider_transactions__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__growth_estimates__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__upgrade_downgrade__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__price_targets_chart__ = __webpack_require__(806);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











function AnalystsPanel(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1__stock_details_page__["a" /* default */],
		_extends({ showCurrencyIndicator: true }, props),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__insider_transactions__["a" /* InsiderTransactionsDataTable */], props),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__growth_estimates__["a" /* GrowthEstimatesDataTable */], props),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.twoColumns },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["d" /* ContainerSize */],
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__upgrade_downgrade__["a" /* UpgradeDowngradeDataTable */], props),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__price_targets_chart__["a" /* default */], props)
			)
		)
	);
}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stockPriceBar":"finance_stock-price-bar_stockPriceBar","loading":"finance_stock-price-bar_loading","invalidSymbol":"finance_stock-price-bar_invalidSymbol","stockHeaderCont":"finance_stock-price-bar_stockHeaderCont","lastUpdated":"finance_stock-price-bar_lastUpdated","stockHeader":"finance_stock-price-bar_stockHeader","stock":"finance_stock-price-bar_stock","price":"finance_stock-price-bar_price","search":"finance_stock-price-bar_search","symbolLookup":"finance_stock-price-bar_symbolLookup","positive":"finance_stock-price-bar_positive","negative":"finance_stock-price-bar_negative","changePrice":"finance_stock-price-bar_changePrice","priceCont":"finance_stock-price-bar_priceCont","changePercent":"finance_stock-price-bar_changePercent","searchCont":"finance_stock-price-bar_searchCont","stockSymbol":"finance_stock-price-bar_stockSymbol","symbol-id":"finance_stock-price-bar_symbol-id","medium":"finance_stock-price-bar_medium","liteDisclaimer":"finance_stock-price-bar_liteDisclaimer","searchBar":"finance_stock-price-bar_searchBar","wide":"finance_stock-price-bar_wide","phone":"finance_stock-price-bar_phone","input":"finance_stock-price-bar_input","noIcon":"finance_stock-price-bar_noIcon"};

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export encodeParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = apiCall;
/* harmony export (immutable) */ __webpack_exports__["c"] = getApiUrl;
/* unused harmony export PROTOCOL */
/* unused harmony export MAX_URL_LEN */
/* unused harmony export makeSplitApiCalls */
/* harmony export (immutable) */ __webpack_exports__["b"] = apiCallWithManySymbols;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cachedFetch__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(654);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * Craft and make API calls
 * @module util/apiCall
 */

/**
 * encode parameters into a query string
 * @private
 * @function encodeParams
 * @param {Object} params     the parameters to encode into a query string
 * @returns {String}          a query string with the parameters URI encoded
 * @memberof util/apiCall
 */
function encodeParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.keys(params).map(function (key, index) {
    var delimeter = index === 0 ? '?' : '&';
    var param = params[key];

    return '' + delimeter + encodeURIComponent(key) + '=' + encodeURIComponent(param);
  }).join('');
}

/**
 * Wrapper around cachedGetJSON() that fetches cloudquote URLs.
 * @function apiCall
 * @param {String} api       the endpoint to make a request to
 * @param {Object} params    parameters for the query string of the request
 * @returns {Promise}        a Promise which resolves when the request completes, rejects if response status !== 200
 * @memberof util/apiCall
 */
function apiCall(api, params) {
  if ('symbol' in params && !params.symbol) {
    return Promise.reject(Error('Symbol is required'));
  }
  params.symbol && (params.symbol = params.symbol.toUpperCase());
  return Object(__WEBPACK_IMPORTED_MODULE_0__cachedFetch__["a" /* default */])(getApiUrl(api, params));
}

/**
 * Encode an endpoint and parameters into a CloudQuote API URL
 * @function getApiUrl
 * @param {String} api       the endpoint to make a request to
 * @param {Object} params    parameters for the query string of the request
 * @returns {String}         a URL to the CloudQuote API
 * @memberof util/apiCall
 */
function getApiUrl(api, params) {
  var query = encodeParams(params);
  return '//api.cloudquote.net' + api + query;
}

// Used only for determining whether the api url exceeds the max allowable length
var PROTOCOL = 'https:';
// https://support.microsoft.com/en-us/help/208427/maximum-url-length-is-2-083-characters-in-internet-explorer
var MAX_URL_LEN = 2048;

/**
 * @private
 * Makes one or multiple api calls for a provided set of securities based on the max URL length
 * @function makeSplitApiCalls
 * @param {String} api             the endpoint to make a request to
 * @param {String[]} symbols       array of symbols
 * @param {Object} params          parameters for the query string of the request
 * @param {Number} [maxUrlLength=2048]    a field or array of fields
 * @returns {Promise}              a Promise resolving with JSON or rejecting with error
 */
function makeSplitApiCalls(api, symbols, params) {
  var maxUrlLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MAX_URL_LEN;

  var numParts = 1;
  // each array in symbolParts is an array of symobls that will be included in a GET request
  var symbolParts = [symbols];
  // split the symbols into multiple GET requests until each request meets the max URL length requirement
  while (symbolParts[0].length > 1 && symbolParts.some(function (s) {
    return (PROTOCOL + getApiUrl(api, _extends({ symbols: Object(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* toCsv */])(s) }, params))).length > maxUrlLength;
  })) {
    numParts++;
    symbolParts = [];
    var splitLength = Math.ceil(symbols.length / numParts);
    var symbolsClone = symbols.slice();
    while (symbolsClone.length) {
      symbolParts.push(symbolsClone.splice(0, Math.min(splitLength, symbolsClone.length)));
    }
  }
  return Promise.all(symbolParts.map(function (s) {
    return apiCall(api, _extends({ symbols: Object(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* toCsv */])(s) }, params));
  }));
}

/**
 * Makes one or multiple api calls and aggregates into a single response
 * @function apiCallWithManySymbols
 * @param {String} api             the endpoint to make a request to
 * @param {String[]} symbols       array of symbols
 * @param {Object} params          parameters for the query string of the request
 * @returns {Promise}              a Promise resolving with JSON or rejecting with error
 * @memberof util/apiCall
 */
function apiCallWithManySymbols(api, symbols, params) {
  return makeSplitApiCalls(api, symbols, params).then(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* mergeResponses */]);
}

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cachedGetJSON;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_hash__ = __webpack_require__(35);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/**
 * fetch with caching, and an easy way to fetch JSON
 * @module util/cachedFetch
 */

// Dedupe inflight requests. If you try to request something while a fetch is already in progress,
// it will return the same Promise as the request already in progress.
var IN_FLIGHT = {};

// The duration to keep fetch responses in cache, in seconds
var DEFAULT_CACHE_MAX_AGE = 60;

var isGoodResponse = function isGoodResponse(r) {
	return r.ok ? r : Promise.reject('cloudquote Error ' + r.status);
};
var toJSON = function toJSON(r) {
	return r.json();
};

/**
 * Fetch wrapped with max-age caching, saves to dbee until it expires.
 * <p>See <a href="https://www.sitepoint.com/cache-fetched-ajax-requests/">Cache Fetched AJAX Requests</a></p>
 * If caching every single request becomes a memory problem on the client side,
 * maybe use LRU caching of last 25~ requests instead
 * <p>TODO: Implement a shared cached for stock symbols</p>
 * @param {String} url                 the url to fetch. this is also hashed to create a cacheKey
 * @param {Object|Number} options      options for fetch. if options is a number, it is used as the expiry time for this request in cache
 * @param {Number} [options.expiry]    the expiry time for a fetch to stay active in cache, default 300 seconds
 * @memberof util/cachedFetch
 */
function cachedFetch(url, options) {
	var expiry = DEFAULT_CACHE_MAX_AGE;
	if (typeof options === 'number') {
		expiry = options;
		options = undefined;
	} else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
		expiry = typeof options.expiry === 'number' ? options.expiry : expiry;
	}

	var cacheKey = Object(__WEBPACK_IMPORTED_MODULE_1__os_hash__["default"])(url + JSON.stringify(options));

	var cached = __WEBPACK_IMPORTED_MODULE_0__storage__["a" /* fetchCache */].get(cacheKey) || {};
	var _cached$data = cached.data,
	    data = _cached$data === undefined ? null : _cached$data,
	    _cached$ts = cached.ts,
	    ts = _cached$ts === undefined ? null : _cached$ts;


	if (data !== null && ts !== null) {
		var age = (Date.now() - ts) / 1000;
		if (age < expiry) {
			var response = typeof Blob !== 'undefined' ? new Response(new Blob([data])) : {
				ok: true,
				status: 200,
				text: function text() {
					return data;
				},
				json: function json() {
					return JSON.parse(data);
				}
			};
			return Promise.resolve(response);
		}

		__WEBPACK_IMPORTED_MODULE_0__storage__["a" /* fetchCache */].remove(cacheKey);
	}

	return fetch(url, options).then(function (response) {
		if (response.status === 200) {

			// only store json and text
			var ct = response.headers.get('Content-Type');
			if (ct && (ct.match(/application\/json/i) || ct.match(/text\//i))) {

				// clone response because responses can only be consumed once
				response.clone().text().then(function (data) {

					// store the hashed url with the response data and current timestamp
					__WEBPACK_IMPORTED_MODULE_0__storage__["a" /* fetchCache */].set(cacheKey, {
						data: data,
						ts: Date.now()
					});
				});
			}
		}
		return response;
	});
}

/**
 * Use cachedFetch to get a URL, if the response is OK then resolves with the JSON response
 * @param {String} url           a url to fetch
 * @param {Function} callback    a callback for handling response data
 * @returns {Promise}            a Promise which resolves when the request completes, rejects if the response status !== 200
 * @memberof util/cachedFetch
 */
function cachedGetJSON(url, options) {
	var cacheKey = Object(__WEBPACK_IMPORTED_MODULE_1__os_hash__["default"])(url + JSON.stringify(options));
	if (IN_FLIGHT[cacheKey]) {
		return IN_FLIGHT[cacheKey];
	}

	return IN_FLIGHT[cacheKey] = cachedFetch(url, options).then(function (data) {
		delete IN_FLIGHT[cacheKey];return data;
	}).then(isGoodResponse).then(toJSON).catch(function (err) {
		delete IN_FLIGHT[cacheKey];return Promise.reject(err);
	});
}

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUniqueSymbol;
/**
 * @private
 * getUniqueSymbol - Take a row of data, and return the UniqueSymbol
 *
 * @param  {Object} row    a row of data
 * @return {String} symbol a symbol or array of symbols that have been transformed into EXCHANGE:SYMBOL
 */
function getUniqueSymbol(row) {
	if (!row) return null;

	var exchange = '',
	    symbol = '',
	    delimiter = ':';

	if (row.hasOwnProperty('Symbol')) {
		symbol = row.Symbol.toUpperCase();
	} else {
		return null;
	}

	if (row.hasOwnProperty('ExchangePrefixCode')) {
		exchange = row.ExchangePrefixCode.toUpperCase();
	} else {
		return null;
	}
	// else {
	// 	delimiter = '';
	// }
	// Leaving delimiter as ':' even if ExchangePrefixCode is missing, as
	// discussed in CR. Would be an indication to other modules that
	// it's in EXCHANGE:SYMBOL format if something else is reuqired by Yahoo

	return '' + exchange + delimiter + symbol;
}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = {"finance-blocks":{"currency":"({{currency}}) ","lastUpdated":"Updated {{lastUpdateTime}}. ","quotesDelayed":"Quotes delayed at least 15min. ","poweredBy":"Financial content solutions powered by ","poweredByProvider":"CloudQuote.io ","placeholder":"Search Symbol or Company Name","disclaimer":"Disclaimer ","field-headers":{"price":"Price","symbol":"Symbol","name":"Index","changePrice":"Change","changePercent":"Change %"}}}

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SymbolLookup; });
/* unused harmony export SymbolSuggestionPanel */
/* unused harmony export SymbolSuggestionRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__os_cloudquote__ = __webpack_require__(335);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var UP_ARROW = 38;
var DOWN_ARROW = 40;
var DEFAULT_MAX_SEARCH_RESULTS = 6;
var CARRIAGE_RETURN = 13;

/**
 * An input box for finding symbols and adding them to a list of Comparing symbols.
 * @param {Object} props
 * @param {Function} [props.onSymbolSelect]      called when a symbol is selected by SymbolSuggestionPanel
 * @param {Boolean|String} [props.disabled]      if true, disabled the input. if @type {String}, replace the placeholder text with disabled
 * @param {String} [props.dropdownClass]         a class name for the suggestion box that drops down from the SymbolLookup
 * @param {Boolean|Object} [props.icon=true]     if true, display the default icon. if passed a React element, renders a custom icon (eg icon={<Icon name="ok" />})
 * @param {String} [props.placeholder]           the placeholder text for the <input> element.
 * @param {Number} [props.maxLength]             the maxlength attribute for the input box
 * @param {Number} [props.maxResults]            the max number of results to display in the Suggestions box
 * @param {String} [props.toUpperCase]           if true, the input box will force all input to upper case
 * @param {String} [props.class]                 class for the container element
 * @param {String|Object} [props.style]          style string or object for the container element
 */
var SymbolLookup = (_temp2 = _class = function (_Component) {
	_inherits(SymbolLookup, _Component);

	function SymbolLookup() {
		var _temp, _this, _ret;

		_classCallCheck(this, SymbolLookup);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			value: '',
			showResults: false
		}, _this.handleBlur = function (e) {
			setTimeout(function () {
				return _this.setState({ showResults: false });
			}, 250);
		}, _this.handleFocus = function (e) {
			_this.setState({ showResults: true });
		}, _this.handleOnChange = function (e) {
			var key = e.keyCode || e.charCode;
			var value = e.target.value;


			if (_this.props.toUpperCase) {
				value = value.toUpperCase();
			}
			_this.setState({ value: value });

			if (key === CARRIAGE_RETURN) {
				_this.state.value && _this.suggestions.handleSymbolSelect();
			} else if (key === UP_ARROW) {
				_this.suggestions.bumpCursor(-1);
				e.preventDefault(); // prevent the cursor moving in the input box
			} else if (key === DOWN_ARROW) {
				_this.suggestions.bumpCursor(1);
				e.preventDefault(); // prevent the cursor moving in the input box
			}
		}, _this.handleSymbolSelect = function (quote) {
			if (quote) {
				var trackingSource = _this.props.trackingSource,
				    track = _this.context && _this.context.track;

				if (trackingSource && track && track.api && track.api.track) {
					var trackingType = _this.props.trackingType ? _this.props.trackingType : 'trackgif',
					    trackingZone = _this.props.trackingZone ? _this.props.trackingZone : 'finance-blocks';
					track.api.track({
						type: trackingType,
						id: trackingSource,
						symbol: quote.UniqueSymbol,
						zone: trackingZone
					});
				}

				_this.props.onSymbolSelect && _this.props.onSymbolSelect(quote);
				_this.setState({ value: '' });
			}
		}, _this.handleSubmitButton = function () {
			_this.suggestions.submit();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	SymbolLookup.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var _ref2$value = _ref2.value,
		    value = _ref2$value === undefined ? '' : _ref2$value,
		    showResults = _ref2.showResults;

		var disabled = _ref.disabled,
		    dropdownClass = _ref.dropdownClass,
		    _ref$icon = _ref.icon,
		    icon = _ref$icon === undefined ? true : _ref$icon,
		    maxLength = _ref.maxLength,
		    maxResults = _ref.maxResults,
		    _ref$placeholder = _ref.placeholder,
		    placeholder = _ref$placeholder === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'placeholder' }) : _ref$placeholder,
		    theme = _ref.theme,
		    props = _objectWithoutProperties(_ref, ['disabled', 'dropdownClass', 'icon', 'maxLength', 'maxResults', 'placeholder', 'theme']);

		var children = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["b" /* Localizer */],
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
				type: 'text',
				maxlength: maxLength,
				value: value,
				placeholder: typeof disabled === 'string' ? disabled : placeholder,
				onFocus: this.handleFocus,
				onBlur: this.handleBlur,
				onkeyUp: this.handleOnChange,
				disabled: !!disabled
			})
		);

		icon = (typeof icon === 'undefined' ? 'undefined' : _typeof(icon)) === 'object' ? icon : icon && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__cube_blocks__["i" /* Icon */], { name: 'search-cube' });

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(props.class, __WEBPACK_IMPORTED_MODULE_2__style_less___default.a.symbolLookup, __WEBPACK_IMPORTED_MODULE_2__style_less___default.a[theme]) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_less___default.a.input, !icon && __WEBPACK_IMPORTED_MODULE_2__style_less___default.a.noIcon), style: props.style },
				children,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(SymbolSuggestionPanel, {
					'class': dropdownClass,
					ref: function ref(e) {
						return _this2.suggestions = e;
					} /* a ref to call bumpCursor and get selections from child */,
					onSymbolSelect: this.handleSymbolSelect,
					visible: showResults && value.length > 0,
					maxResults: maxResults,
					searchTerm: value
				})
			),
			icon && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'button',
				{ onClick: this.handleSubmitButton, disabled: !!disabled, 'class': __WEBPACK_IMPORTED_MODULE_2__style_less___default.a.button },
				icon
			)
		);
	};

	return SymbolLookup;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	maxResults: DEFAULT_MAX_SEARCH_RESULTS
}, _temp2);

/**
 * An input box to search for a searchTerm and get a list of suggestion results from the CloudQuote API.
 * @param {Object} props
 * @param {Function} [props.onSymbolSelect]    called when a symbol is selected in the list
 * @param {Boolean} [props.visible]            if false, dont show the container
 * @param {String} [props.searchTerm]          the term to search for in the CloudQuote API
 * @param {String} [props.class]               class for the container element
 * @param {String|Object} [props.style]        style string or object for the container element
 */


var SymbolSuggestionPanel = function (_Component2) {
	_inherits(SymbolSuggestionPanel, _Component2);

	function SymbolSuggestionPanel() {
		var _temp3, _this3, _ret2;

		_classCallCheck(this, SymbolSuggestionPanel);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp3 = (_this3 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this3), _this3.counter = 0, _this3.state = {
			cursor: 0,
			quotes: [],
			isSearching: false
		}, _this3.handleSymbolSelect = function (quote) {
			var value = quote ? quote : _this3.state.quotes.length && _this3.state.quotes[_this3.state.cursor];

			_this3.props.onSymbolSelect && _this3.props.onSymbolSelect(value);
			_this3.setState({ quotes: [] });
		}, _this3.bumpCursor = function () {
			var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

			var cursor = _this3.state.cursor + n;
			cursor = cursor < 0 ? _this3.state.quotes.length - 1 : cursor >= _this3.state.quotes.length ? 0 : cursor;

			_this3.setState({ cursor: cursor });
		}, _this3.handleRowHover = function (index) {
			_this3.setState({ cursor: index });
		}, _this3.doSearch = function (searchTerm) {
			var queryId = ++_this3.counter;
			var query = 'SYMBOL/' + searchTerm + '|SYMBOL/' + searchTerm + '*|NAME/' + searchTerm + '*|WORD/' + searchTerm + '|WORD/' + searchTerm + '*';
			!_this3.state.isSearching && _this3.setState({ isSearching: true });
			Object(__WEBPACK_IMPORTED_MODULE_5__os_cloudquote__["findStock"])(query).then(function (data) {
				// update state if the queryId for this call matches the current counter
				if (queryId === _this3.counter) {
					_this3.setState({ isSearching: false }, function () {
						// wait a tick until setState is done to guarentee re-render so this.props.searchTerm will be current
						data && _this3.setState({
							quotes: (data.rows || []).slice(0, _this3.props.maxResults),
							cursor: 0
						});
					});
				}
			});
		}, _temp3), _possibleConstructorReturn(_this3, _ret2);
	}
	// Keep a simple ID of async calls because we only care about the most recent call.


	SymbolSuggestionPanel.prototype.submit = function submit() {
		var value = this.state.quotes.length && this.state.quotes[this.state.cursor];
		this.props.onSymbolSelect && this.props.onSymbolSelect(value);
		this.setState({ quotes: [] });
	};

	SymbolSuggestionPanel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (this.props.searchTerm !== nextProps.searchTerm) {
			this.doSearch(nextProps.searchTerm);
		}
	};

	SymbolSuggestionPanel.prototype.render = function render(_ref3, _ref4) {
		var _this4 = this;

		var cursor = _ref4.cursor,
		    isSearching = _ref4.isSearching,
		    quotes = _ref4.quotes;

		var visible = _ref3.visible,
		    maxResults = _ref3.maxResults,
		    searchTerm = _ref3.searchTerm,
		    props = _objectWithoutProperties(_ref3, ['visible', 'maxResults', 'searchTerm']);

		props.class = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(props.class, __WEBPACK_IMPORTED_MODULE_2__style_less___default.a['symbol-suggestions'], (!visible || isSearching && !quotes.length) && __WEBPACK_IMPORTED_MODULE_2__style_less___default.a.hidden);

		var renderedResults = quotes.length > 0 ? quotes.map(function (quote, index) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(SymbolSuggestionRow, {
				quote: quote,
				onSymbolSelect: _this4.handleSymbolSelect,
				onMouseEnter: _this4.handleRowHover,
				index: index,
				active: cursor === index
			});
		}) : !isSearching && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */],
					{ id: 'no-results' },
					'No results found, please try again.'
				)
			)
		);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			props,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'table',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tbody',
					null,
					renderedResults
				)
			)
		);
	};

	return SymbolSuggestionPanel;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/**
 * A row with the Name and Symbol of a search result from the CloudQuote API
 * @param {Object} props
 * @param {Function} [props.onMouseEnter]       called when the mouse hovers over this row, called with props.index
 * @param {Function} [props.onSymbolSelect]     called when a row is clicked on, called with props.quote
 * @param {Object} [props.quote]                a stock quote from the CloudQuote API
 * @param {Boolean} [props.active]              true if this row is active, apply hilighting styles
 * @param {Number} [props.index]                the index of the row in a list of results
 * @param {String} [props.class]                class for the container element
 * @param {String|Object} [props.style]         style string or object for the container element
 */
var SymbolSuggestionRow = function (_Component3) {
	_inherits(SymbolSuggestionRow, _Component3);

	function SymbolSuggestionRow() {
		var _temp4, _this5, _ret3;

		_classCallCheck(this, SymbolSuggestionRow);

		for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
			args[_key3] = arguments[_key3];
		}

		return _ret3 = (_temp4 = (_this5 = _possibleConstructorReturn(this, _Component3.call.apply(_Component3, [this].concat(args))), _this5), _this5.handleMouseEnter = function () {
			_this5.props.onMouseEnter && _this5.props.onMouseEnter(_this5.props.index);
		}, _this5.handleClick = function () {
			_this5.props.onSymbolSelect && _this5.props.onSymbolSelect(_this5.props.quote);
		}, _temp4), _possibleConstructorReturn(_this5, _ret3);
	}

	SymbolSuggestionRow.prototype.render = function render(_ref5) {
		var _ref5$quote = _ref5.quote,
		    quote = _ref5$quote === undefined ? {} : _ref5$quote,
		    active = _ref5.active,
		    props = _objectWithoutProperties(_ref5, ['quote', 'active']);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			{
				'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(props.class, __WEBPACK_IMPORTED_MODULE_2__style_less___default.a.result, active && __WEBPACK_IMPORTED_MODULE_2__style_less___default.a.active),
				onClick: this.handleClick,
				onMouseEnter: this.handleMouseEnter,
				style: props.style
			},
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style_less___default.a['result-name'] },
				quote.Name
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style_less___default.a['result-symbol'] },
				quote.Symbol
			)
		);
	};

	return SymbolSuggestionRow;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"symbolLookup":"finance-blocks_symbol-lookup_symbolLookup","input":"finance-blocks_symbol-lookup_input","noIcon":"finance-blocks_symbol-lookup_noIcon","symbol-suggestions":"finance-blocks_symbol-lookup_symbol-suggestions","hidden":"finance-blocks_symbol-lookup_hidden","result":"finance-blocks_symbol-lookup_result","active":"finance-blocks_symbol-lookup_active","result-name":"finance-blocks_symbol-lookup_result-name","result-symbol":"finance-blocks_symbol-lookup_result-symbol","button":"finance-blocks_symbol-lookup_button","dark":"finance-blocks_symbol-lookup_dark"};

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockTableWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_shallow_equal__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_shallow_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__os_shallow_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_utils_lib_inViewport__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_utils_lib_inViewport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cube_utils_lib_inViewport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_utils_lib_isIdle__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_utils_lib_isIdle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cube_utils_lib_isIdle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stock_widget_table__ = __webpack_require__(655);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/*
 * A table of stocks, data is passed in by symbol
 * wraps a StockWidgetTable component and handles subscribing
 * to streaming data;
 *
 * This component is basically the same thing as the stock-symbol-table
 * Component found in the finance-components repo, the only difference
 * is that it wraps stock-widget-table instead of stock-info-table
 */

var StockTableWrapper = function (_Component) {
	_inherits(StockTableWrapper, _Component);

	function StockTableWrapper() {
		var _temp, _this, _ret;

		_classCallCheck(this, StockTableWrapper);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.idleTimeout = 5 * 60 * 1000, _this.onData = function (data) {
			data && _this.setState({ data: data });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	// After 5 minutes, consider the user idle


	StockTableWrapper.prototype.componentDidUnmount = function componentDidUnmount() {
		if (this.streamer) this.streamer.end();
	};

	StockTableWrapper.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		// Setup the streaming data
		var symbols = this.props.symbols,
		    pollingFn = 'getStockPrice',
		    elm = this.base,
		    shouldUpdate = function shouldUpdate() {
			return __WEBPACK_IMPORTED_MODULE_3__cube_utils_lib_inViewport___default()(elm) && !__WEBPACK_IMPORTED_MODULE_4__cube_utils_lib_isIdle___default()(_this2.idleTimeout);
		};


		this.streamer = Object(__WEBPACK_IMPORTED_MODULE_2__os_cloudquote__["newStockAPIStreamer"])({ symbols: symbols, pollingFn: pollingFn, shouldUpdate: shouldUpdate }).on('data', this.onData);
	};

	StockTableWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		// Update the streamer if the symbols changed
		if (!__WEBPACK_IMPORTED_MODULE_1__os_shallow_equal___default()(this.props.symbols, nextProps.symbols)) {
			this.streamer.stream(nextProps.symbols);
		}
	};

	StockTableWrapper.prototype.render = function render(props, _ref) {
		var data = _ref.data;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_widget_table__["a" /* default */], _extends({}, props, { data: data }));
	};

	return StockTableWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = inViewport;
/** Determine if the given element is in the current viewport.
 *	@param {HTMLElement|undefined} elm	The node element to check. Usually elm for a component.
 *	@returns {bool}
 */
function inViewport(elm) {
	if (typeof elm === 'undefined') return false;

	// Bail if detached.
	if (!elm.offsetParent) return false;

	var bbox = elm.getBoundingClientRect();

	// If position and size are both 0, the element (or an ancestor) is hidden.
	if (!bbox.left && !bbox.right && !bbox.top && !bbox.bottom && !(typeof bbox.width === 'number' ? bbox.width : elm.offsetWidth)) {
		return false;
	}

	var viewportHeight = window.innerHeight || document.documentElement.offsetHeight,
	    viewportWidth = window.innerWidth || document.documentElement.offsetWidth;

	if (bbox.top <= viewportHeight && bbox.bottom >= 0 && bbox.left <= viewportWidth && bbox.right >= 0) {
		return true;
	}

	return false;
}
module.exports = exports['default'];

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = isIdle;

/** Determine if the user has been idle for longer than a given threshold.
 *	@param {Number} threshold	A set amount of time after which, if there are no events, we consider the user idle.
 *	@returns {Bool}
 */

var timeOfLastEvent = Date.now(),
    events = ['scroll', 'mousedown', 'mousemove', 'keydown', 'touchstart'],
    initialized = false;

function isIdle() {
	var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60000;

	if (!initialized) {
		for (var i = 0; i < events.length; i++) {
			window.addEventListener(events[i], registerEvent);
		}

		initialized = true;
	}

	var delta = Date.now() - timeOfLastEvent;

	if (delta > threshold) {
		return true;
	}

	return false;
}

function registerEvent(e) {
	timeOfLastEvent = Date.now();
}
module.exports = exports['default'];

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stockWidgetTable":"finance-blocks_stock-widget-table_stockWidgetTable","dataTable":"finance-blocks_stock-widget-table_dataTable","clearfix":"finance-blocks_stock-widget-table_clearfix","positive":"finance-blocks_stock-widget-table_positive","negative":"finance-blocks_stock-widget-table_negative","financeTable":"finance-blocks_stock-widget-table_financeTable","annual":"finance-blocks_stock-widget-table_annual","bold":"finance-blocks_stock-widget-table_bold","loading":"finance-blocks_stock-widget-table_loading","spinner":"finance-blocks_stock-widget-table_spinner","dataHeader":"finance-blocks_stock-widget-table_dataHeader","image":"finance-blocks_stock-widget-table_image","selected":"finance-blocks_stock-widget-table_selected","iconArrow":"finance-blocks_stock-widget-table_iconArrow","price":"finance-blocks_stock-widget-table_price","symbol":"finance-blocks_stock-widget-table_symbol","name":"finance-blocks_stock-widget-table_name","change":"finance-blocks_stock-widget-table_change","chart":"finance-blocks_stock-widget-table_chart"};

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LastUpdated;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util__ = __webpack_require__(656);





function LastUpdated(_ref) {
	var LastTradeTime = _ref.LastTradeTime,
	    currency = _ref.currency;

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.lastUpdated },
		LastTradeTime && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'lastUpdated', fields: { lastUpdateTime: Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["b" /* formatLastTradeTime */])(LastTradeTime) } }),
		currency && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'currency', fields: { currency: currency } }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'quotesDelayed' }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'a',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.disclaimer, href: '/finance/disclaimer', target: '_blank', rel: 'noopener noreferrer' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'disclaimer' })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.poweredBy },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'poweredBy' }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: '//www.cloudquote.net', target: '_blank', rel: 'noopener noreferrer' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'poweredByProvider' })
			)
		)
	);
}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"lastUpdated":"finance-blocks_last-updated_lastUpdated","disclaimer":"finance-blocks_last-updated_disclaimer"};

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__currency_indicator__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl_json__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__intl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










/**
 * A specific implementation of the Tertiary nav for use on the Stock Details Desktop page.
 */
var StockDetailsNav = function StockDetailsNav(_ref) {
	var symbol = _ref.symbol,
	    type = _ref.type,
	    uniqueSymbol = _ref.uniqueSymbol,
	    current = _ref.current,
	    showCurrencyIndicator = _ref.showCurrencyIndicator,
	    menus = _ref.menus,
	    locale = _ref.locale,
	    showProfileInfo = _ref.showProfileInfo,
	    device = _ref.device,
	    _ref$liteMenus = _ref.liteMenus,
	    liteMenus = _ref$liteMenus === undefined ? false : _ref$liteMenus,
	    props = _objectWithoutProperties(_ref, ['symbol', 'type', 'uniqueSymbol', 'current', 'showCurrencyIndicator', 'menus', 'locale', 'showProfileInfo', 'device', 'liteMenus']);

	if (uniqueSymbol) symbol = uniqueSymbol;
	if (type) type = type.toLowerCase();

	var nav = (menus[type] || menus.default).reduce(function (items, item) {
		// Exclude the non-lite options
		if (liteMenus && !item.lite) return items;
		// Exclude the item from the nav if it's restricted for the provided locale
		if (item.limitedLocales && item.limitedLocales.indexOf(locale) >= 0) return items;
		// If this symbol does not have any profile data, do not include the link either
		if (device && item.url.indexOf('/profile/') > -1 && !showProfileInfo) return items;
		// Otherwise add the necessary properties before including in the list of items to send to the blocks component
		items.push(prepItemForInclusionInNav(item));
		return items;
	}, []);

	function prepItemForInclusionInNav(item) {
		item.url = item.url.replace('{symbol}', symbol);
		if (item.label && typeof item.label === 'string') {
			// We force the scope here to stop finance-blocks from trumping our namespace, which is
			// currently happening. I.E., it looks for 'finance-blocks.stock-details-nav.VALUE'
			item.label = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["a" /* IntlProvider */],
				{ scope: 'finance-components.stock-details-nav', definition: __WEBPACK_IMPORTED_MODULE_5__intl_json___default.a },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: '' + Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["b" /* camel */])(item.label) },
					item.label
				)
			);
		}
		return item;
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_6__style_less___default.a.navContainer },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["u" /* TertiaryNav */], _extends({ items: nav, 'class': __WEBPACK_IMPORTED_MODULE_7_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style_less___default.a.stockDetailsNav, __WEBPACK_IMPORTED_MODULE_6__style_less___default.a.overrideBlocks), device: 'desktop', current: current }, props)),
		type !== 'index' && showCurrencyIndicator && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style_less___default.a.navFooter },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__currency_indicator__["a" /* CurrencyIndicator */], { symbol: symbol })
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (StockDetailsNav);

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"currency-indicator":"finance_currency-indicator_x"};

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navContainer":"finance_stock-details-nav_navContainer","navFooter":"finance_stock-details-nav_navFooter","stockDetailsNav":"finance_stock-details-nav_stockDetailsNav","overrideBlocks":"finance_stock-details-nav_overrideBlocks"};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading":"finance_glyphs_loading","spinner":"finance_glyphs_spinner"};

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTL_NS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InsiderTransactionsDataTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloudquote_data_table__ = __webpack_require__(377);






var INTL_NS = 'analysts-panel.insiderTransactions';

function pick(data, key) {
	return String(data.rows[0][data.columns.indexOf(key)]);
}

function priceFormat(value) {
	return Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["e" /* formatNumber */])(value, { Decimals: 2, Default: '-' });
}

var InsiderTransactionsDataTable = Object(__WEBPACK_IMPORTED_MODULE_4__cloudquote_data_table__["a" /* default */])({
	headers: [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.earningsEstimate' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.currentQtr' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.nextQtr' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.currentYear' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.nextYear' })],
	cells: ['Label', 'Current Qtr', 'Next Qtr', 'Current Year', 'Next Year'],
	sort: function normalizeEarningsEstimatesData(data) {
		if (!data || !data.rows || !data.rows.length) {
			return data;
		}
		return {
			columns: ['Label', 'Current Qtr', 'Next Qtr', 'Current Year', 'Next Year'],
			// this table will have 5 rows
			rows: [[Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.numberOfAnalysts' }), pick(data, 'curQuarterEstimateCount'), pick(data, 'nextQuarterEstimateCount'), pick(data, 'curYearEstimateCount'), pick(data, 'nextYearEstimateCount')], [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.averageEstimate' }), priceFormat(pick(data, 'curQuarterMeanEstimate')), priceFormat(pick(data, 'nextQuarterMeanEstimate')), priceFormat(pick(data, 'curYearMeanEstimate')), priceFormat(pick(data, 'nextYearMeanEstimate'))], [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.lowEstimate' }), priceFormat(pick(data, 'curQuarterLowEstimate')), priceFormat(pick(data, 'nextQuarterLowEstimate')), priceFormat(pick(data, 'curYearLowEstimate')), priceFormat(pick(data, 'nextYearLowEstimate'))], [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.highEstimate' }), priceFormat(pick(data, 'curQuarterHighEstimate')), priceFormat(pick(data, 'nextQuarterHighEstimate')), priceFormat(pick(data, 'curYearHighEstimate')), priceFormat(pick(data, 'nextYearHighEstimate'))], [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.priorYearEps' }), priceFormat(pick(data, 'prevPrevPrevQuarterActualEPS')), priceFormat(pick(data, 'prevPrevQuarterActualEPS')), priceFormat(pick(data, 'prevYearActualEPS')), priceFormat(pick(data, 'curYearEstimatedEPS'))]]
		};
	},
	apiMethod: __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getEarningsEstimatesBySecurity"]
});

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"financeTable":"finance_cloudquote-data-table_financeTable","annual":"finance_cloudquote-data-table_annual","noResults":"finance_cloudquote-data-table_noResults","bold":"finance_cloudquote-data-table_bold","dataHeader":"finance_cloudquote-data-table_dataHeader","negative":"finance_cloudquote-data-table_negative"};

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footnoteContainer":"finance_footnotes_footnoteContainer","footnoteChildContainer":"finance_footnotes_footnoteChildContainer","split":"finance_footnotes_split","footnote":"finance_footnotes_footnote"};

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GrowthEstimatesDataTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__ = __webpack_require__(377);





var INTL_NS = 'analysts-panel.growthEstimates';

function pick(data, key) {
	return String(data.rows[0][data.columns.indexOf(key)]);
}

var GrowthEstimatesDataTable = Object(__WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["a" /* default */])({
	headers: [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.growthEstimates' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.percentGrowth' })],
	cells: ['Label', __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["c" /* tableUtils */].formatField('Growth Estimate', function (value) {
		return value && (value !== 'null' || value === 0) ? value + '%' : '-';
	})],
	sort: function normalizeEarningsEstimatesData(data) {
		if (!data || !data.rows || !data.rows.length) {
			return data;
		}
		return {
			columns: ['Label', 'Growth Estimate'],
			// this table will have 5 rows
			rows: [[Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.currentQtr' }), pick(data, 'curQuarterGrowthEstimateVsYearPriorEPS')], [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.nextQtr' }), pick(data, 'nextQuarterGrowthEstimateVsYearPriorEPS')], [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.currentYear' }), pick(data, 'curYearGrowthEstimateVsPrevYearEPS')], [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.nextYear' }), pick(data, 'nextYearGrowthEstimateVsCurYearEstimate')], [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.nextFiveYears' }), pick(data, 'longTermGrowthMeanEstimate')]]
		};
	},
	apiMethod: __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getEarningsEstimatesBySecurity"]
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpgradeDowngradeDataTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cloudquote_data_table__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style__);









var INTL_NS = 'analysts-panel.upgradeDowngrade';

function pick(data, key) {
	return String(data.row[data.columns.indexOf(key)] || '');
}

var ICON_MAP = {
	upgrade: 'arrow-up',
	downgrade: 'arrow-down'
};

var UpDownCell = function UpDownCell(props) {
	var type = pick(props, 'type') || '';
	// Camel-case the id for multi-word results to map to INTL.json keys
	var typeId = Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["b" /* camel */])(type);

	var iconType = ICON_MAP[type.toLowerCase()];
	var icon = iconType && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["i" /* Icon */], { name: iconType });

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style___default.a.upOrDown, __WEBPACK_IMPORTED_MODULE_7__style___default.a[type.toLowerCase()]) },
		icon,
		' ',
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */],
			{ id: INTL_NS + '.' + typeId },
			type
		)
	);
};

var FirmAndRatingCell = function FirmAndRatingCell(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			pick(props, 'firm')
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */],
				{ id: INTL_NS + '.' + Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["b" /* camel */])(pick(props, 'rating')) },
				pick(props, 'rating')
			)
		)
	);
};

var DataTable = Object(__WEBPACK_IMPORTED_MODULE_6__cloudquote_data_table__["a" /* default */])({
	headers: [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.upgradesDowngrades' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.firmName' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.date' })],
	cells: [UpDownCell, FirmAndRatingCell, __WEBPACK_IMPORTED_MODULE_6__cloudquote_data_table__["c" /* tableUtils */].formatField('ratingDate', __WEBPACK_IMPORTED_MODULE_4__lib_util__["l" /* intlDateNode */])],
	sort: __WEBPACK_IMPORTED_MODULE_6__cloudquote_data_table__["c" /* tableUtils */].sort.descending.dateByKey('ratingDate'),
	apiMethod: function apiMethod(_ref) {
		var symbol = _ref.symbol;
		return Object(__WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getRatingsBySecurity"])(symbol);
	},
	maxRows: 5
});

var UpgradeDowngradeDataTable = function UpgradeDowngradeDataTable(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.upgradesDowngrades },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(DataTable, props)
	);
};

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceTargetsChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var INTL_NS = 'analysts-panel.priceTargetsChart';

function getExtents(bars) {
	return [0, bars.reduce(function (acc, value) {
		return Math.max(acc, value);
	}, 0) * __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* Y_WINDOW_MAX_RANGE */]];
}

function sortAndNormalizeData(_ref) {
	var columns = _ref.columns,
	    rows = _ref.rows;

	return rows.sort(function (a, b) {
		return new Date(b[columns.indexOf('ratingDate')]).getTime() - new Date(a[columns.indexOf('ratingDate')]).getTime();
	}).slice(0, 5).map(function (row) {
		return row[columns.indexOf('priceTarget')];
	});
}

var PriceTargetsChart = function (_Component) {
	_inherits(PriceTargetsChart, _Component);

	function PriceTargetsChart() {
		_classCallCheck(this, PriceTargetsChart);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	PriceTargetsChart.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getRatingsBySecurity"])(this.props.symbol).then(sortAndNormalizeData).then(function (bars) {
			return _this2.setState({ bars: bars });
		});
	};

	PriceTargetsChart.prototype.render = function render(_ref2, _ref3) {
		var width = _ref2.width;
		var bars = _ref3.bars;

		var height = 250;
		var halfWidth = width / 2;
		if (!bars) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__glyphs__["a" /* FinanceSpinner */], null);
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.priceTargets },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.header },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.priceTargets' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(BarChart, {
				bars: bars,
				width: halfWidth,
				height: height
			})
		);
	};

	return PriceTargetsChart;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/**
 * Calculate the percentage of `value` within the range of the given extents and return a proportional height for that value.
 * @param {Number} height       the total height of the container
 * @param {Number} value        a value from data. This value is expected to be within the provided extents
 * @param {Number[]} extents    the extents of the data forming a range.
 * @returns {Number}            a height that is proportional to the total height based on `value`.
 * @example <caption>Calculate the height of data point "20" within height=100 and extents=[0, 100]</caption>
 * let height = 100
 * let value = 20;
 * let extents = [0, 100];
 * let scaledHeight = scaleY(height, value, extents);
 * console.log(scaledHeight); // 20
 */



function scaleY(height, value) {
	var extents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [0, 100];
	var min = extents[0],
	    max = extents[1];

	var range = max - min;
	var percent = 1 - (range - value) / range;
	var scaled = height * percent;
	return scaled;
}

var NO_PADDING = { padding: 0 }; // force no padding  on this svg element. padding will mess up svg calculations.

var BarChart = function BarChart(_ref4) {
	var width = _ref4.width,
	    height = _ref4.height,
	    _ref4$bars = _ref4.bars,
	    bars = _ref4$bars === undefined ? [] : _ref4$bars,
	    props = _objectWithoutProperties(_ref4, ['width', 'height', 'bars']);

	if (!height || !width) {
		return;
	}
	var barsContainerWidth = width * __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* BARS_CONTAINER_WIDTH */];
	var padding = barsContainerWidth * .05;
	var containerHeight = height - 3 * __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* LINE_HEIGHT */] - __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* OFFSET_TOP */];
	var barsContainerTransformX = (parseFloat(1 - __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* BARS_CONTAINER_WIDTH */]) * 100).toFixed();
	var averageEstimate = Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["h" /* getAverage */])(bars);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'svg',
		{ style: NO_PADDING, 'class': __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style___default.a.barChart, props.class), width: width, height: height },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(YAxis, {
			bars: bars,
			containerHeight: containerHeight,
			containerWidth: width
		}),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'svg',
			{ x: barsContainerTransformX + '%' },
			bars.length ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VerticalBarGroup, {
				bars: bars,
				padding: padding,
				containerHeight: containerHeight,
				containerWidth: barsContainerWidth
			}) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'text',
				{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.noData, x: barsContainerWidth / 2, y: containerHeight / 2, 'text-anchor': 'middle' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dataUnavailable' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				XAxisLabel,
				{
					containerWidth: barsContainerWidth,
					containerHeight: height
				},
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.analystsPriceTargets' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ReferenceLine, {
				containerHeight: containerHeight,
				containerWidth: barsContainerWidth,
				bars: bars,
				value: averageEstimate
			})
		)
	);
};

var XAxisLabel = function XAxisLabel(_ref5) {
	var children = _ref5.children,
	    containerHeight = _ref5.containerHeight,
	    containerWidth = _ref5.containerWidth;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'text',
		{ 'text-anchor': 'middle', x: containerWidth / 2, y: containerHeight - __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* LINE_HEIGHT */] / 4 },
		children
	);
};

var ReferenceLine = function ReferenceLine(_ref6) {
	var containerHeight = _ref6.containerHeight,
	    containerWidth = _ref6.containerWidth,
	    bars = _ref6.bars,
	    value = _ref6.value;

	var extents = getExtents(bars);
	var lineY = containerHeight - scaleY(containerHeight, value, extents) + __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* LINE_HEIGHT */] / 2;
	if (!value) return null;

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'g',
		{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.dashedLine },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('line', {
			y1: lineY,
			y2: lineY,
			x1: 0,
			x2: containerWidth
		}),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__glyphs__["b" /* Pill */], {
			centerY: true,
			y: lineY,
			x: 0,
			label: value || Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.noData' })
		})
	);
};

var VerticalBarGroup = function VerticalBarGroup(_ref7) {
	var bars = _ref7.bars,
	    padding = _ref7.padding,
	    containerHeight = _ref7.containerHeight,
	    containerWidth = _ref7.containerWidth;

	var numBars = bars.length;
	var extents = getExtents(bars);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'g',
		{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.barGroup },
		bars.map(function (value, index) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VerticalBar, {
				containerHeight: containerHeight,
				barHeight: scaleY(containerHeight, value, extents),
				barWidth: containerWidth / numBars,
				padding: padding,
				index: index,
				value: value
			});
		})
	);
};

// An svg group of lines all equal distance apart
var YAxis = function YAxis(_ref8) {
	var bars = _ref8.bars,
	    containerHeight = _ref8.containerHeight,
	    containerWidth = _ref8.containerWidth,
	    _ref8$numLines = _ref8.numLines,
	    numLines = _ref8$numLines === undefined ? 11 : _ref8$numLines;

	var max = getExtents(bars)[1];
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'g',
		null,
		Array.apply(undefined, Array(numLines)).map(function (_, index, arr) {

			var lineY = scaleY(containerHeight, index, [0, arr.length - 1]) + __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* OFFSET_TOP */];
			var axisLabelContainerWidth = containerWidth * (1 - __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* BARS_CONTAINER_WIDTH */]);
			var rightAlignTextX = axisLabelContainerWidth - 5;
			var customLabelTextX = axisLabelContainerWidth * .7;
			var textY = lineY + __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* LINE_HEIGHT */] / 2;
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('line', {
					x1: containerWidth * (1 - __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* BARS_CONTAINER_WIDTH */]),
					x2: containerWidth,
					y1: lineY,
					y2: lineY
				}),
				index % 2 === 0 && index < arr.length - 1 && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'text',
					{
						'text-anchor': 'end',
						x: rightAlignTextX,
						y: textY
					},
					scaleY(max, arr.length - index, [0, arr.length]).toFixed(1)
				),
				index === arr.length - 1 && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'text',
					{
						'text-anchor': 'middle',
						x: customLabelTextX,
						y: containerHeight + __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* LINE_HEIGHT */] / 2
					},
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'tspan',
						{ x: customLabelTextX, dy: 0 },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */],
							{ id: INTL_NS + '.US' },
							'US'
						)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'tspan',
						{ x: customLabelTextX, dy: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* LINE_HEIGHT */] * 1.23 },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */],
							{ id: INTL_NS + '.currency' },
							'Dollars'
						)
					)
				)
			);
		})
	);
};

var VerticalBar = function VerticalBar(_ref9) {
	var _ref9$padding = _ref9.padding,
	    padding = _ref9$padding === undefined ? 0 : _ref9$padding,
	    containerHeight = _ref9.containerHeight,
	    barHeight = _ref9.barHeight,
	    barWidth = _ref9.barWidth,
	    index = _ref9.index,
	    value = _ref9.value;

	var barX = barWidth * index + padding;
	var barY = containerHeight - barHeight + __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* OFFSET_TOP */];
	barWidth = barWidth - 2 * padding;

	var textY = containerHeight + 1.25 * __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* LINE_HEIGHT */] + __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* OFFSET_TOP */];

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'g',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', {
			'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.verticalBar,
			height: barHeight,
			width: barWidth,
			x: barX,
			y: barY
		}),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'text',
			{ x: barX + barWidth / 2, y: textY, 'text-anchor': 'middle' },
			value
		)
	);
};

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OFFSET_TOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Y_WINDOW_MAX_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BARS_CONTAINER_WIDTH; });
var LINE_HEIGHT = 12; // an approximation of the line height for SVG text.
var OFFSET_TOP = LINE_HEIGHT / 2; // the price-targets-chart needs top padding because drawing at "y=0" will cut-off content at the top.
var Y_WINDOW_MAX_RANGE = 1.2; // the y-range of the price-targets-chart's window is 20% above the highest value
var BARS_CONTAINER_WIDTH = .80; // a percentage size that specifies how much space the lines/bars will occupy within it's container

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MajorCurrencies; });
/* unused harmony export MajorCurrenciesRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flags__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MajorCurrencies = function (_Component) {
	_inherits(MajorCurrencies, _Component);

	function MajorCurrencies() {
		var _temp, _this, _ret;

		_classCallCheck(this, MajorCurrencies);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { data: [] }, _this.handleData = function (data) {
			_this.setState({ data: data.rows });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	MajorCurrencies.prototype.componentWillMount = function componentWillMount() {
		this.streamer = Object(__WEBPACK_IMPORTED_MODULE_2__os_cloudquote__["stockAPIStreamer"])(['EUR-USD', 'USD-JPY', 'GBP-USD', 'USD-CAD'], 'getStockPrice').on('data', this.handleData);
	};

	MajorCurrencies.prototype.componentWillUnmount = function componentWillUnmount() {
		this.streamer && this.streamer.end();
	};

	MajorCurrencies.prototype.render = function render(props, _ref) {
		var data = _ref.data;

		if (!data || !data.length) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['major-currencies'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__glyphs__["a" /* FinanceSpinner */], null)
		);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['major-currencies'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.inner },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(MajorCurrenciesRow, { fromFlag: 'europe', toFlag: 'usa', symbol: data[0].Symbol, desc: 'Euro to Dollar', ratio: '1 EUR = ' + Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["e" /* formatNumber */])(data[0].Price, { Decimals: 2 }) + ' USD' }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(MajorCurrenciesRow, { fromFlag: 'usa', toFlag: 'japan', symbol: data[1].Symbol, desc: 'Dollar to Yen', ratio: '1 USD = ' + Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["e" /* formatNumber */])(data[1].Price, { Decimals: 0 }) + ' YEN' }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(MajorCurrenciesRow, { fromFlag: 'uk', toFlag: 'usa', symbol: data[2].Symbol, desc: 'GBP to Dollar', ratio: '1 GBP = ' + Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["e" /* formatNumber */])(data[2].Price, { Decimals: 2 }) + ' USD' }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(MajorCurrenciesRow, { fromFlag: 'usa', toFlag: 'canada', symbol: data[3].Symbol, desc: 'Dollar to CAD', ratio: '1 USD = ' + Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["e" /* formatNumber */])(data[3].Price, { Decimals: 2 }) + ' CAD' })
			)
		);
	};

	return MajorCurrencies;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);




var MajorCurrenciesRow = function MajorCurrenciesRow(_ref2) {
	var fromFlag = _ref2.fromFlag,
	    toFlag = _ref2.toFlag,
	    symbol = _ref2.symbol,
	    desc = _ref2.desc,
	    ratio = _ref2.ratio;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.row },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.flag },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__flags__["a" /* default */], { country: fromFlag })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.desc },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1_preact_router__["a" /* Link */],
				{ href: '/stockQuote/' + symbol },
				desc
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.ratio },
				ratio
			)
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.flag },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__flags__["a" /* default */], { country: toFlag })
		)
	);
};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flag":"finance_flags_flag"};

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flagsContext;
function flagsContext(key) {
	return flags[key];
}

var flags = {
	'./australia': __webpack_require__(811),
	'./canada': __webpack_require__(812),
	'./europe': __webpack_require__(813),
	'./france': __webpack_require__(814),
	'./germany': __webpack_require__(815),
	'./hongkong': __webpack_require__(816),
	'./japan': __webpack_require__(817),
	'./mexico': __webpack_require__(818),
	'./uk': __webpack_require__(819),
	'./usa': __webpack_require__(820)
};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/australia_VlyR6.svg";

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/canada_1ByLT.svg";

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/europe_23hmy.svg";

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/france_eEicW.svg";

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/germany_3FdzB.svg";

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/hongkong_1ROIP.svg";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/japan_2RbhU.svg";

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/mexico_3lNBg.png";

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/uk_lfVA1.svg";

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/usa_3Ryon.svg";

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"major-currencies":"finance_currencies_major-currencies","clearfix":"finance_currencies_clearfix","row":"finance_currencies_row","flag":"finance_currencies_flag"};

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"currency-matrix":"finance_currency-matrix_x","clearfix":"finance_currency-matrix_clearfix","flag":"finance_currency-matrix_flag","unity":"finance_currency-matrix_unity","price":"finance_currency-matrix_price"};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"parent":"finance_container_parent","wide":"finance_container_wide","shiftedContainer":"finance_container_shiftedContainer","container":"finance_container_x","dark":"finance_container_dark"};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(30).then((function(require) {
		cb(__webpack_require__(825));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(677);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* range */])(n).map(function (i) {
      return start + step * i;
    });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function (_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function (_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function () {
    return bandwidth;
  };

  scale.step = function () {
    return step;
  };

  scale.round = function (_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function (_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function (_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function (_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function (_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function () {
    return band().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function () {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(667);


/* unused harmony default export */ var _unused_webpack_default_export = (function (values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(674);









/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) {
      tz.shift(), --m;
    }while (tz[m - 1] > x1) {
      tz.pop(), --m;
    }var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function (_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function (_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function (_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return x;
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(514);





/* unused harmony default export */ var _unused_webpack_default_export = (function (values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(668);


/* unused harmony default export */ var _unused_webpack_default_export = (function (values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  } else {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(422);


/* unused harmony default export */ var _unused_webpack_default_export = (function (values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;else --m;
    }
  } else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;else --m;
    }
  }

  if (m) return sum / m;
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(514);




/* unused harmony default export */ var _unused_webpack_default_export = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  } else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) {
    j += arrays[i].length;
  }merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (array, indexes) {
  var i = indexes.length,
      permutes = new Array(i);
  while (i--) {
    permutes[i] = array[indexes[i]];
  }return permutes;
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(395);


/* unused harmony default export */ var _unused_webpack_default_export = (function (values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  } else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(676);


/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nest__ = __webpack_require__(879);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set__ = __webpack_require__(880);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys__ = __webpack_require__(881);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values__ = __webpack_require__(882);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__(883);
/* unused harmony reexport entries */







/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(515);


/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var keys = [],
      _sortKeys = [],
      _sortValues,
      _rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (_sortValues != null) array.sort(_sortValues);
      return _rollup != null ? _rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function (values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function _entries(map, depth) {
    if (++depth > keys.length) return map;
    var array,
        sortKey = _sortKeys[depth - 1];
    if (_rollup != null && depth >= keys.length) array = map.entries();else array = [], map.each(function (v, k) {
      array.push({ key: k, values: _entries(v, depth) });
    });
    return sortKey != null ? array.sort(function (a, b) {
      return sortKey(a.key, b.key);
    }) : array;
  }

  return nest = {
    object: function object(array) {
      return apply(array, 0, createObject, setObject);
    },
    map: function map(array) {
      return apply(array, 0, createMap, setMap);
    },
    entries: function entries(array) {
      return _entries(apply(array, 0, createMap, setMap), 0);
    },
    key: function key(d) {
      keys.push(d);return nest;
    },
    sortKeys: function sortKeys(order) {
      _sortKeys[keys.length - 1] = order;return nest;
    },
    sortValues: function sortValues(order) {
      _sortValues = order;return nest;
    },
    rollup: function rollup(f) {
      _rollup = f;return nest;
    }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(515);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function add(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set();

  // Copy constructor.
  if (object instanceof Set) object.each(function (value) {
    set.add(value);
  });

  // Otherwise, assume it’s an array.
  else if (object) {
      var i = -1,
          n = object.length;
      if (f == null) while (++i < n) {
        set.add(object[i]);
      } else while (++i < n) {
        set.add(f(object[i], i, object));
      }
    }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (map) {
  var keys = [];
  for (var key in map) {
    keys.push(key);
  }return keys;
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (map) {
  var values = [];
  for (var key in map) {
    values.push(map[key]);
  }return values;
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (map) {
  var entries = [];
  for (var key in map) {
    entries.push({ key: key, value: map[key] });
  }return entries;
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(686);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function (_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function () {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(678);




// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
      x,
      z;
  if (r === g && g === b) x = z = y;else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function brighter(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function darker(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function rgb() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */](lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* deg2rad */];
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function brighter(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function darker(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function rgb() {
    return hcl2lab(this).rgb();
  }
}));

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(678);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
      // NaN if l=0 or l=1
  h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function brighter(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */](255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
  }
}));

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(396);


/* unused harmony default export */ var _unused_webpack_default_export = (function (a, b) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0__color_js__["c" /* hue */])(+a, +b);
  return function (t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  return a = +a, b = +b, function (t) {
    return Math.round(a * (1 - t) + b * t);
  };
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(891);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({ i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb) }, { i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb) });
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path
      q.push({ i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b) });
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({ i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b) });
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({ i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb) }, { i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb) });
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function (a, b) {
    var s = [],
        // string constants and placeholders
    q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function (t) {
      var i = -1,
          n = q.length,
          o;
      while (++i < n) {
        s[(o = q[i]).i] = o.x(t);
      }return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["b" /* parseSvg */], ", ", ")", ")");

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose_js__ = __webpack_require__(892);


var cssNode, cssRoot, cssView, svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function (a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function (p0, p1) {
  var ux0 = p0[0],
      uy0 = p0[1],
      w0 = p0[2],
      ux1 = p1[0],
      uy1 = p1[1],
      w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function i(t) {
      return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
    };
  }

  // General case.
  else {
      var d1 = Math.sqrt(d2),
          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;
      i = function i(t) {
        var s = t * S,
            coshr0 = cosh(r0),
            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
      };
    }

  i.duration = S * 1000;

  return i;
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(396);



function hsl(hue) {
  return function (start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(396);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
  return function (t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(396);



function hcl(hue) {
  return function (start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(396);



function cubehelix(hue) {
  return function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  }(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function piecewise(interpolate, values) {
  var i = 0,
      n = values.length - 1,
      v = values[0],
      I = new Array(n < 0 ? 0 : n);
  while (i < n) {
    I[i] = interpolate(v, v = values[++i]);
  }return function (t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) {
    samples[i] = interpolator(i / (n - 1));
  }return samples;
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(687);



/* harmony default export */ __webpack_exports__["a"] = (function (domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s":
      {
        var value = Math.max(Math.abs(start), Math.abs(stop));
        if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
        return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
      }
    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      {
        if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
        break;
      }
    case "f":
    case "%":
      {
        if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
        break;
      }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(688);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (grouping, thousands) {
  return function (value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function (s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;break;
      case "0":
        if (i0 === 0) i0 = i;i1 = i;break;
      default:
        if (!+s[i]) break out;if (i0 > 0) i0 = 0;break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto_js__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded_js__ = __webpack_require__(906);




/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function _(x, p) {
    return (x * 100).toFixed(p);
  },
  "b": function b(x) {
    return Math.round(x).toString(2);
  },
  "c": function c(x) {
    return x + "";
  },
  "d": __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* default */],
  "e": function e(x, p) {
    return x.toExponential(p);
  },
  "f": function f(x, p) {
    return x.toFixed(p);
  },
  "g": function g(x, p) {
    return x.toPrecision(p);
  },
  "o": function o(x) {
    return Math.round(x).toString(8);
  },
  "p": function p(x, _p) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded_js__["a" /* default */])(x * 100, _p);
  },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded_js__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto_js__["a" /* default */],
  "X": function X(x) {
    return Math.round(x).toString(16).toUpperCase();
  },
  "x": function x(_x) {
    return Math.round(_x).toString(16);
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(463);


/* harmony default export */ __webpack_exports__["a"] = (function (x, p) {
    var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* formatDecimalParts */])(x, p);
    if (!d) return x + "";
    var coefficient = d[0],
        exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return x;
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(462);


/* harmony default export */ __webpack_exports__["a"] = (function (step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(462);


/* harmony default export */ __webpack_exports__["a"] = (function (step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(462);


/* harmony default export */ __webpack_exports__["a"] = (function (step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(step)) + 1;
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(461);






function deinterpolate(a, b) {
  return (b = Math.log(b / a)) ? function (x) {
    return Math.log(x / a) / b;
  } : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0 ? function (t) {
    return -Math.pow(-b, t) * Math.pow(-a, 1 - t);
  } : function (t) {
    return Math.pow(b, t) * Math.pow(a, 1 - t);
  };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : function (x) {
    return Math.pow(base, x);
  };
}

function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function (x) {
    return Math.log(x) / base;
  });
}

function reflect(f) {
  return function (x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function (_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function (count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function (count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function (d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function () {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function floor(x) {
        return pows(Math.floor(logs(x)));
      },
      ceil: function ceil(x) {
        return pows(Math.ceil(logs(x)));
      }
    }));
  };

  scale.copy = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(461);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent))) ? function (x) {
      return (raise(x, exponent) - a) / b;
    } : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function (t) {
      return raise(a + b * t, 1 / exponent);
    };
  }

  scale.exponent = function (_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(378);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0,
        n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) {
      thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* quantile */])(domain, i / n);
    }return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
  };

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) {
      if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    }domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return rescale();
  };

  scale.range = function (_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function () {
    return thresholds.slice();
  };

  scale.copy = function () {
    return quantile().domain(domain).range(range);
  };

  return scale;
}

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(423);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) {
      domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    }return scale;
  }

  scale.domain = function (_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function (_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
  };

  scale.copy = function () {
    return quantize().domain([x0, x1]).range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(378);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function (_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function () {
    return threshold().domain(domain).range(range);
  };

  return scale;
}

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(84);




/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["c" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(424);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(424);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(424);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(424);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(357);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(357);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function (t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(424);


function ramp(range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(423);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function (_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function () {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = decadelyInterval;
/* harmony export (immutable) */ __webpack_exports__["m"] = yearlyInterval;
/* harmony export (immutable) */ __webpack_exports__["j"] = quarterlyInterval;
/* harmony export (immutable) */ __webpack_exports__["h"] = monthlyInterval;
/* harmony export (immutable) */ __webpack_exports__["l"] = weeklyInterval;
/* harmony export (immutable) */ __webpack_exports__["b"] = dailyInterval;
/* harmony export (immutable) */ __webpack_exports__["a"] = bihourlyInterval;
/* harmony export (immutable) */ __webpack_exports__["f"] = hourlyInterval;
/* harmony export (immutable) */ __webpack_exports__["i"] = quarterHourlyInterval;
/* harmony export (immutable) */ __webpack_exports__["d"] = fiveMinutelyInterval;
/* harmony export (immutable) */ __webpack_exports__["g"] = minutelyInterval;
/* harmony export (immutable) */ __webpack_exports__["e"] = halfMinutelyInterval;
/* harmony export (immutable) */ __webpack_exports__["k"] = secondlyInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__finance_time_scale__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__finance_constants__ = __webpack_require__(421);




/**
 * Return an array of ticks that represent "neat" tick intervals on a decade
 * basis that encompass startTick and stopTick.  The first tick will be the first trading tick of January of the decade
 * following startTick.  The last returned tick will be the first tick of the decade of stopTick.
 *
 * @param {Integer} startTick The financeTimeScale tick representing the beginning of the data series
 * @param {Integer} stopTick The financeTimeScale tick representing the end of the data series
 * @returns {Array} An array of uniformly-ish distributed ticks to use for the axis.
 */
function decadelyInterval(startTick, stopTick) {
	var firstTickDecade = __WEBPACK_IMPORTED_MODULE_2__finance_constants__["F" /* YEARS_PER_DECADE */] * (Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(startTick)).getFullYear() / __WEBPACK_IMPORTED_MODULE_2__finance_constants__["F" /* YEARS_PER_DECADE */] | 0) + __WEBPACK_IMPORTED_MODULE_2__finance_constants__["F" /* YEARS_PER_DECADE */];
	var lastTickDecade = __WEBPACK_IMPORTED_MODULE_2__finance_constants__["F" /* YEARS_PER_DECADE */] * (Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(stopTick)).getFullYear() / __WEBPACK_IMPORTED_MODULE_2__finance_constants__["F" /* YEARS_PER_DECADE */] | 0);
	var decades = [];
	for (var i = firstTickDecade; i <= lastTickDecade; i += __WEBPACK_IMPORTED_MODULE_2__finance_constants__["F" /* YEARS_PER_DECADE */]) {
		//eslint-disable-next-line no-magic-numbers
		decades.push(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["a" /* financeScale */])(new Date(i - 1, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["c" /* DECEMBER */], 31, 23, 59, 59, 999)) + 1);
	}

	return decades;
}

/**
 * Return an array of ticks that represent "neat" tick intervals on a yearly
 * basis that encompass startTick and stopTick.  The first tick will be the first trading tick of January of the year
 * following startTick.  The last returned tick will be the first tick of the year of stopTick.
 *
 * @param {Integer} startTick The financeTimeScale tick representing the beginning of the data series
 * @param {Integer} stopTick The financeTimeScale tick representing the end of the data series
 * @returns {Array} An array of uniformly-ish distributed ticks to use for the axis.
 */
function yearlyInterval(startTick, stopTick) {
	var firstTickYear = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(startTick)).getFullYear() + 1;
	var lastTickYear = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(stopTick)).getFullYear();
	var years = [];
	for (var i = firstTickYear; i <= lastTickYear; i++) {
		//eslint-disable-next-line no-magic-numbers
		years.push(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["a" /* financeScale */])(new Date(i - 1, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["c" /* DECEMBER */], 31, 23, 59, 59)) + 1);
	}

	return years;
}

/**
 * Same as yearlyInterval but with quarterly intervals starting on the tick of the first trading day
 * each quarter: i.e. first tick in January, April, July, and October
 * @see yearlyInterval
 */
function quarterlyInterval(startTick, stopTick) {
	var firstTickDate = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(startTick));
	var lastTickDate = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(stopTick));
	var year = firstTickDate.getFullYear();
	//get the first Jan/Apr/Jul/Oct month following the first month
	var firstMonth = __WEBPACK_IMPORTED_MODULE_2__finance_constants__["l" /* MONTHS_PER_QUARTER */] * (1 + (firstTickDate.getMonth() / __WEBPACK_IMPORTED_MODULE_2__finance_constants__["l" /* MONTHS_PER_QUARTER */] | 0));
	var months = [];
	for (var month = firstMonth; Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(new Date(year, month, 1)) <= lastTickDate; month += __WEBPACK_IMPORTED_MODULE_2__finance_constants__["l" /* MONTHS_PER_QUARTER */]) {
		months.push(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["a" /* financeScale */])(new Date(year, month, 1)) + 1);
	}

	return months;
}

/**
 * Same as yearlyInterval but with monthly intervals starting on the tick of the first trading day of the month
 * @see yearlyInterval
 */
function monthlyInterval(startTick, stopTick) {
	var firstTickDate = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(startTick));
	var lastTickDate = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(stopTick));
	var year = firstTickDate.getFullYear();
	var months = [];
	for (var month = firstTickDate.getMonth() + 1; Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(new Date(year, month, 1)) <= lastTickDate; month++) {
		months.push(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["a" /* financeScale */])(new Date(year, month, 1)) + 1);
	}

	return months;
}

/**
 * Same as yearlyInterval but with weekly intervals starting on Monday
 * @see yearlyInterval
 */
function weeklyInterval(startTick, stopTick) {
	return intervalsWeeklyOrLess(startTick, stopTick, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["q" /* SECONDS_PER_FINANCE_WEEK */]);
}

/**
 * Same as yearlyInterval but with daily intervals starting at the beginning of the day
 * @see yearlyInterval
 */
function dailyInterval(startTick, stopTick) {
	return intervalsWeeklyOrLess(startTick, stopTick, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */]);
}

/**
 * Same as yearlyInterval but with intervals every 2 hours starting at the beginning of the day
 * @see yearlyInterval
 */
function bihourlyInterval(startTick, stopTick) {
	return intervalsWeeklyOrLess(startTick, stopTick, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["n" /* SECONDS_PER_BI_HOUR */]);
}

/**
 * Same as yearlyInterval but with intervals every hour starting at the top of the hour :00
 * @see yearlyInterval
 */
function hourlyInterval(startTick, stopTick) {
	return intervalsWeeklyOrLess(startTick, stopTick, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["u" /* SECONDS_PER_HOUR */]);
}

/**
 * Same as yearlyInterval but with intervals every 15 minutes starting at the closest quarter-hour
 * e.g. :00, :15, :30, :45
 * @see yearlyInterval
 */
function quarterHourlyInterval(startTick, stopTick) {
	//find the first quarter-hour after startTick
	return intervalsWeeklyOrLess(startTick, stopTick, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["w" /* SECONDS_PER_QUARTER_HOUR */]);
}

/**
 * Same as yearlyInterval but with intervals every 15 minutes starting at the closest quarter-hour
 * e.g. :00, :05, :10, :15
 * @see yearlyInterval
 */
function fiveMinutelyInterval(startTick, stopTick) {
	//find the first quarter-hour after startTick
	return intervalsWeeklyOrLess(startTick, stopTick, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["s" /* SECONDS_PER_FIVE_MINUTES */]);
}

/**
 * Same as yearlyInterval but with intervals every minute starting at the top of the minute
 * @see yearlyInterval
 */
function minutelyInterval(startTick, stopTick) {
	return intervalsWeeklyOrLess(startTick, stopTick, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["v" /* SECONDS_PER_MINUTE */]);
}

/**
 * Same as yearlyInterval but with intervals every 30 seconds on :00 and :30 second boundaries
 * @see yearlyInterval
 */
function halfMinutelyInterval(startTick, stopTick) {
	return intervalsWeeklyOrLess(startTick, stopTick, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["t" /* SECONDS_PER_HALF_MINUTE */]);
}

/**
 * Same as yearlyInterval but with intervals every second
 * @see yearlyInterval
 */
function secondlyInterval(startTick, stopTick) {
	return intervalsWeeklyOrLess(startTick, stopTick, 1);
}

/*
 * Common function to calculate intervals that span a week or less where the seconds
 * in an interval are consistent
 */
function intervalsWeeklyOrLess(startTick, stopTick, interval) {
	var d = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["a" /* getEasternTimeFromDate */])(Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["b" /* financeScaleInvert */])(startTick));
	var baseTime = void 0;
	if (interval > __WEBPACK_IMPORTED_MODULE_2__finance_constants__["o" /* SECONDS_PER_FINANCE_DAY */]) {
		//Anything over a day, start at the beginning of the current finance week
		//shift to the Monday on or before the current day represented by the tick
		var dayShift = (d.getDay() + __WEBPACK_IMPORTED_MODULE_2__finance_constants__["A" /* SHIFT_MONDAY_TO_DAY_0 */]) % __WEBPACK_IMPORTED_MODULE_2__finance_constants__["b" /* DAYS_PER_WEEK */];
		baseTime = new Date(d.getFullYear(), d.getMonth(), d.getDate() - dayShift, __WEBPACK_IMPORTED_MODULE_2__finance_constants__["d" /* FIRST_HOUR */], __WEBPACK_IMPORTED_MODULE_2__finance_constants__["e" /* FIRST_MINUTE */], __WEBPACK_IMPORTED_MODULE_2__finance_constants__["f" /* FIRST_SECOND */]);
	} else if (interval > __WEBPACK_IMPORTED_MODULE_2__finance_constants__["u" /* SECONDS_PER_HOUR */]) {
		//Anything over an hour, start at the beginning of the current finance day
		baseTime = new Date(d.getFullYear(), d.getMonth(), d.getDate(), __WEBPACK_IMPORTED_MODULE_2__finance_constants__["d" /* FIRST_HOUR */], __WEBPACK_IMPORTED_MODULE_2__finance_constants__["e" /* FIRST_MINUTE */], __WEBPACK_IMPORTED_MODULE_2__finance_constants__["f" /* FIRST_SECOND */]);
	} else if (interval >= __WEBPACK_IMPORTED_MODULE_2__finance_constants__["v" /* SECONDS_PER_MINUTE */]) {
		//Anything over an hour, start at the beginning of the hour
		baseTime = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours());
	} else if (interval > 1) {
		//Anything over a second, start at the beginning of the minute
		baseTime = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
	} else {
		//For a second or less, start on the second
		baseTime = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
	}

	baseTime = Object(__WEBPACK_IMPORTED_MODULE_1__daylight_savings_time__["b" /* getLocalTimeFromEasternDate */])(baseTime);

	//Get the first tick that is a multiple of the interval after the base time
	var firstTick = Object(__WEBPACK_IMPORTED_MODULE_0__finance_time_scale__["a" /* financeScale */])(baseTime);
	while (firstTick <= startTick) {
		firstTick += interval;
	}
	var intervalTicks = [];
	for (var currentTick = firstTick; currentTick <= stopTick; currentTick += interval) {
		intervalTicks.push(currentTick);
	}

	return intervalTicks;
}

/***/ }),
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"interval-selector":"finance_interval-selector_x","interval":"finance_interval-selector_interval","active":"finance_interval-selector_active","narrow":"finance_interval-selector_narrow"};

/***/ }),
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncomeCashBalancePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_details_page__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__annual_quarterly_selector__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__financial_details_tabs__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__annual_quarterly_selector_constants__ = __webpack_require__(723);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var IncomeCashBalancePanel = function (_Component) {
	_inherits(IncomeCashBalancePanel, _Component);

	function IncomeCashBalancePanel() {
		var _temp, _this, _ret;

		_classCallCheck(this, IncomeCashBalancePanel);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			timespan: __WEBPACK_IMPORTED_MODULE_5__annual_quarterly_selector_constants__["b" /* QUARTERLY */]
		}, _this.handleChangeTimeRange = function (_ref) {
			var _ref$value = _ref.value,
			    timespan = _ref$value === undefined ? '' : _ref$value;

			_this.setState({ timespan: timespan.toLowerCase() });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	IncomeCashBalancePanel.prototype.render = function render(props, _ref2) {
		var timespan = _ref2.timespan;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_1__stock_details_page__["a" /* default */],
			props,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__annual_quarterly_selector__["a" /* default */], { 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.floatRight, value: timespan, onChange: this.handleChangeTimeRange }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__financial_details_tabs__["a" /* default */], _extends({ timespan: timespan }, props))
		);
	};

	return IncomeCashBalancePanel;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FinancialDetailsPanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stock_data_table_income_statement__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stock_data_table_cash_flow__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stock_data_table_balance_sheet__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_i18n__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var INTL_NS = 'financial-details-tabs';

var TAB_ITEMS = [{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.incomeStatement' }), ComponentClass: __WEBPACK_IMPORTED_MODULE_2__stock_data_table_income_statement__["a" /* default */] }, { title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.cashFlow' }), ComponentClass: __WEBPACK_IMPORTED_MODULE_3__stock_data_table_cash_flow__["a" /* default */] }, { title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.balanceSheet' }), ComponentClass: __WEBPACK_IMPORTED_MODULE_4__stock_data_table_balance_sheet__["a" /* default */] }];

function FinancialDetailsPanel(_ref) {
	var timespan = _ref.timespan,
	    props = _objectWithoutProperties(_ref, ['timespan']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["t" /* Tabs */],
		{ 'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a.tabs },
		TAB_ITEMS.map(function (_ref2) {
			var title = _ref2.title,
			    ComponentClass = _ref2.ComponentClass;
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["s" /* Tab */],
				{ title: title },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ComponentClass, _extends({ timespan: timespan }, props))
			);
		})
	);
}

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CashFlow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__currency_indicator__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index__ = __webpack_require__(471);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var INTL_NS = 'stock-data-table';
var INTL_NS_CF = 'cashFlow';



var CashFlow = function (_Component) {
	_inherits(CashFlow, _Component);

	function CashFlow() {
		_classCallCheck(this, CashFlow);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	CashFlow.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["getCashFlow"])(this.props.symbol).then(function (data) {
			return _this2.setState({ data: data });
		});
	};

	CashFlow.prototype.render = function render(_ref, _ref2) {
		var data = _ref2.data;

		var timespan = _ref.timespan,
		    props = _objectWithoutProperties(_ref, ['timespan']);

		var rows = data && data.rows;

		if (!rows || !rows.length) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__glyphs__["a" /* FinanceSpinner */], null);
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */],
				{ 'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a.dataHeader,
					title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.cashFlow' }),
					secondary: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.numInMs' })
				},
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__currency_indicator__["a" /* CurrencyIndicator */], { symbol: props.symbol })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.periodEnding' }),
				showDates: true,
				cols: [{
					name: 'Net Income',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.netIncome' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.opActivities' }),
				cols: [{
					name: 'Depreciation, Amortization, Depletion and Accretion',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.depAmort' })
				}, {
					name: 'Other Non-Cash Activities',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.otherNonCash' })
				}, {
					name: 'Deferred Taxes',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.deferredTax' })
				}, {
					name: 'Change in Working Capital',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.changeWC' })
				}, {
					name: 'Total Cash from Operating Activities',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.totalOperating' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.investActivities' }),
				cols: [{
					name: 'Capital Expenditures',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.capEx' })
				}, {
					name: 'Other Investing Cash Flow',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.otherInvesting' })
				}, {
					name: 'Total Cash from Investing Activities',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.totalInvesting' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.financingActivities' }),
				cols: [{
					name: 'Dividends and Distributions',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.dividends' })
				}, {
					name: 'Purchase or Sale of Stock',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.buySellStock' })
				}, {
					name: 'Other Financing Cash Flow',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.otherFinancing' })
				}, {
					name: 'Purchase and Retirement of Debt',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.payDebt' })
				}, {
					name: 'Total Cash from Financing Activities',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.totalFinancing' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.exRateEffects' }),
				cols: [{
					name: 'Exchange Rate Effects',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.exRate' })
				}, {
					name: 'Net Change in Cash',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_CF + '.changeCash' }),
					bold: true
				}]
			})
		);
	};

	return CashFlow;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BalanceSheet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__currency_indicator__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index__ = __webpack_require__(471);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var INTL_NS = 'stock-data-table';
var INTL_NS_BS = 'balanceSheet';



var BalanceSheet = function (_Component) {
	_inherits(BalanceSheet, _Component);

	function BalanceSheet() {
		_classCallCheck(this, BalanceSheet);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	BalanceSheet.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["getBalanceSheet"])(this.props.symbol).then(function (data) {
			return _this2.setState({ data: data });
		});
	};

	BalanceSheet.prototype.render = function render(_ref, _ref2) {
		var data = _ref2.data;

		var timespan = _ref.timespan,
		    props = _objectWithoutProperties(_ref, ['timespan']);

		var rows = data && data.rows;

		if (!rows || !rows.length) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__glyphs__["a" /* FinanceSpinner */], null);
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */],
				{ 'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a.dataHeader,
					title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.balanceSheet' }),
					secondary: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.numInMs' })
				},
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__currency_indicator__["a" /* CurrencyIndicator */], { symbol: props.symbol })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.periodEnding' }),
				showDates: true,
				cols: []
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.currAssets' }),
				cols: [{
					name: 'Cash and Cash Equivalents',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.cash' })
				}, {
					name: 'Short Term Investments',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.investST' })
				}, {
					name: 'Accounts Receivable',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.aR' })
				}, {
					name: 'Prepaid Expenses',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.prepaidExp' })
				}, {
					name: 'Inventory',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.inventory' })
				}, {
					name: 'Other Current Assets',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.otherCurrAssets' })
				}, {
					name: 'Current Assets',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.currAssets' })
				}, {
					name: 'Long Term Investments',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.investLT' })
				}, {
					name: 'Net Property, Plant and Equipment',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.netPPE' })
				}, {
					name: 'Goodwill and Intangibles',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.goodWill' })
				}, {
					name: 'Other Non-Current Assets',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.otherNonCurrAssets' })
				}, {
					name: 'Long Term Receivables',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.receivablesLT' })
				}, {
					name: 'Total Assets',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.totalAssets' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.currLiab' }),
				cols: [{
					name: 'Accounts Payable',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.aP' })
				}, {
					name: 'Other Current Liabilities',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.otherCurrLiab' })
				}, {
					name: 'Accrued Liabilities and Other Payables',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.accruedLiab' })
				}, {
					name: 'Short Term Debt',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.debtST' })
				}, {
					name: 'Current Portion of Long Term Debt',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.debtCurrentLT' })
				}, {
					name: 'Current Liabilities',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.currLiab' }),
					bold: true
				}, {
					name: 'Long Term Debt',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.debtLT' })
				}, {
					name: 'Other Non-Current Liabilities',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.otherNonCurrLiab' })
				}, {
					name: 'Total Liabilities',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.totalLiab' }),
					bold: true
				}]
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* default */], {
				timespan: timespan,
				data: data,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.shareHoldersEquity' }),
				cols: [{
					name: 'Common Stock',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.commonStock' })
				}, {
					name: 'Preferred Stock',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.preferredStock' })
				}, {
					name: 'Retained Earnings',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.retainedEarnings' })
				}, {
					name: 'Treasury Stock',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.treasuryStock' })
				}, {
					name: 'Additional Paid-In Capital',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.addlPIC' })
				}, {
					name: 'Accumulated Other Comprehensive Income',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.accumIncome' })
				}, {
					name: 'Other Equity',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.otherEquity' })
				}, {
					name: 'Total Equity',
					nameIntl: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_BS + '.totalEquity' }),
					bold: true
				}]
			})
		);
	};

	return BalanceSheet;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FundsPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stock_list__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_blocks__ = __webpack_require__(23);






function FundsPanel(_ref) {
	var width = _ref.width;

	var dollarVolumeColumns = ['symbolWithName', 'price', 'changePrice', 'dollarVolume'];
	var volumeColumns = ['symbolWithName', 'price', 'changePrice', 'changePercent'];

	if (width && width > 500) {
		dollarVolumeColumns.splice(2, 0, 'changePercent');
		volumeColumns.push('volume');
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
		{ parent: true },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'MOST_ACTIVE_FUNDS' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_list__["a" /* default */], {
				showHeaders: true,
				query: {
					type: 'FUND',
					list: '+dollarVolume',
					limit: 5
				},
				columns: dollarVolumeColumns,
				trackingSource: 'funds-panel/most-active-funds'
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'FUND_GAINERS' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_list__["a" /* default */], {
				showHeaders: true,
				query: {
					type: 'FUND',
					list: '+percentChange',
					limit: 5
				},
				columns: volumeColumns,
				trackingSource: 'funds-panel/fund-gainers'
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'POPULAR_FUNDS' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_list__["a" /* default */], {
				showHeaders: true,
				query: {
					type: 'FUND',
					list: '+popularity',
					limit: 5
				},
				columns: volumeColumns,
				trackingSource: 'funds-panel/popular-funds'
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'FUND_LOSERS' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_list__["a" /* default */], {
				showHeaders: true,
				query: {
					type: 'FUND',
					list: '-percentChange',
					limit: 5
				},
				columns: volumeColumns,
				trackingSource: 'funds-panel/fund-losers'
			})
		)
	);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__cube_blocks__["x" /* containerSize */])({ height: false })(FundsPanel));

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stock-chart":"finance_stock-chart_x","loading":"finance_stock-chart_loading","spinner":"finance_stock-chart_spinner","stock-chart-with-intervals":"finance_stock-chart_stock-chart-with-intervals","intervals":"finance_stock-chart_intervals","interval-selector":"finance_stock-chart_interval-selector","active":"finance_stock-chart_active","comparisons":"finance_stock-chart_comparisons","inner":"finance_stock-chart_inner","title":"finance_stock-chart_title"};

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stockInfoTable":"finance_stock-info-table_stockInfoTable","dataTable":"finance_stock-info-table_dataTable","clearfix":"finance_stock-info-table_clearfix","positive":"finance_stock-info-table_positive","negative":"finance_stock-info-table_negative","financeTable":"finance_stock-info-table_financeTable","annual":"finance_stock-info-table_annual","noResults":"finance_stock-info-table_noResults","bold":"finance_stock-info-table_bold","dataHeader":"finance_stock-info-table_dataHeader","change":"finance_stock-info-table_change","changeCompound":"finance_stock-info-table_changeCompound","alternate1":"finance_stock-info-table_alternate1","alternate2":"finance_stock-info-table_alternate2","symbolWithName":"finance_stock-info-table_symbolWithName","image":"finance_stock-info-table_image","selected":"finance_stock-info-table_selected","iconArrow":"finance_stock-info-table_iconArrow","price":"finance_stock-info-table_price","symbol":"finance_stock-info-table_symbol","name":"finance_stock-info-table_name","trash":"finance_stock-info-table_trash","chart":"finance_stock-info-table_chart","dark":"finance_stock-info-table_dark"};

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stock-list":"finance_stock-list_x","box-label":"finance_stock-list_box-label","section-label":"finance_stock-list_section-label"};

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HistoricalDataPanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_details_page__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(1029);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function HistoricalDataPanel(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1__stock_details_page__["a" /* default */],
		_extends({ showCurrencyIndicator: true }, props),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */], props)
	);
}

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTL_NS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filter; });
/* unused harmony export Item */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interval_selector__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_intervals__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_panel__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fetch_data__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__os_save_as__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__os_cloudquote__ = __webpack_require__(335);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var INTL_NS = 'historical-data-panel.filter';

var Filter = function (_Component) {
	_inherits(Filter, _Component);

	function Filter() {
		var _temp, _this, _ret;

		_classCallCheck(this, Filter);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			view: {
				value: 'Historical Prices'
			},
			frequency: 'daily',
			interval: '1M',
			symbolTypeCode: null
		}, _this.cacheData = {}, _this.viewChange = function (view) {
			if (view.value === 'Dividends / Splits') {
				_this.setState({
					view: view,
					data: null,
					interval: 'MAX',
					start: '1900-01-01'
				});
			} else {
				_this.setState({
					view: view,
					data: null
				});
			}
			_this.getData();
		}, _this.changeFrequency = function (v) {
			var _this$cacheData = _this.cacheData,
			    columns = _this$cacheData.columns,
			    rows = _this$cacheData.rows,
			    years = _this$cacheData.years,
			    daysInWeek = 5,
			    value = v && v.value || _this.state.frequency;


			switch (value) {
				case 'weekly':
					rows = rows.filter(function (row, i) {
						return i % daysInWeek === 0;
					});
					break;
				case 'monthly':
					rows = [];
					Object.keys(years).forEach(function (year) {
						Object.keys(years[year]).forEach(function (month) {
							rows.push(years[year][month][0]);
						});
					});
					rows = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["f" /* sortData */])({ columns: columns, rows: rows }).rows;
					break;
			}

			_this.setState({
				data: {
					historical: {
						columns: columns,
						rows: rows
					}
				},
				frequency: value
			});
		}, _this.getStockType = function (symbol) {
			Object(__WEBPACK_IMPORTED_MODULE_12__os_cloudquote__["getStockPrice"])(symbol).then(function (_ref) {
				var rows = _ref.rows;

				if (rows && rows[0]) {
					_this.setState({ symbolTypeCode: rows[0].SecurityTypeCode });
				} else {
					_this.setState({ symbolTypeCode: null });
				}
			});
		}, _this.getData = function (props) {
			var _this$state = _this.state,
			    start = _this$state.start,
			    end = _this$state.end,
			    interval = _this$state.interval,
			    view = _this$state.view,
			    _ref2 = props || _this.props,
			    symbol = _ref2.symbol;

			if (view.value === 'Historical Prices') {
				Object(__WEBPACK_IMPORTED_MODULE_9__fetch_data__["a" /* getHistoricalData */])({ symbol: symbol, start: start, end: end, interval: interval }).then(function (_ref3) {
					var start = _ref3.start,
					    end = _ref3.end,
					    cacheData = _ref3.cacheData;

					_this.cacheData = cacheData;
					_this.setState({ start: start, end: end }, _this.changeFrequency);
				});
			} else {
				Object(__WEBPACK_IMPORTED_MODULE_9__fetch_data__["b" /* getStockData */])({ symbol: symbol, start: start, end: end }).then(function (data) {
					return _this.setState({ data: data });
				});
			}
		}, _this.assembleCsv = function (data) {
			var heading = data.columns.join(',');
			var rows = data.rows.map(function (row) {
				return row.join(',');
			});
			var body = rows.join('\n');
			return [heading, body].join('\n');
		}, _this.downloadLink = function () {
			return Object(__WEBPACK_IMPORTED_MODULE_11__os_save_as__["b" /* supported */])() && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.item },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["i" /* Icon */], { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.icon, name: 'download-cube' }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'a',
					{ href: '#', onclick: _this.downloadData },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_5_preact_i18n__["d" /* Text */],
						{ id: INTL_NS + '.downloadData' },
						'Download Data'
					)
				)
			);
		}, _this.downloadData = function () {
			var data = _this.state.data;
			var symbol = _this.props.symbol;

			Object(__WEBPACK_IMPORTED_MODULE_11__os_save_as__["a" /* saveAs */])(_this.assembleCsv(data.historical), symbol + '.csv', 'text/csv');
		}, _this.handleSelectInterval = function (timerange, interval) {
			var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props;

			// apiDate cannot accept -Infinity so we're passing Jan 1, 1900 as the start
			var apiStart = interval && interval.value === 'MAX' ? -2208970800000 : timerange[0];
			timerange = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* apiDate */])({ start: apiStart, end: timerange[1] });

			_this.setState({
				end: timerange.end,
				start: timerange.start,
				data: null,
				interval: interval && interval.value || _this.state.interval
			});

			_this.getData(props);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	// will assemble all the data into a csv format


	// will hide the download link if the browser is unsupported


	// called when the user clicks the download link, initiates serving the file


	Filter.prototype.componentWillMount = function componentWillMount() {
		var time = Object(__WEBPACK_IMPORTED_MODULE_4__lib_intervals__["c" /* labelToTimeInterval */])(this.state.interval);
		this.handleSelectInterval(time);
		this.getStockType(this.props.symbol);
	};

	Filter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.symbol !== this.props.symbol) {
			var time = Object(__WEBPACK_IMPORTED_MODULE_4__lib_intervals__["c" /* labelToTimeInterval */])(this.state.interval);
			this.handleSelectInterval(time, null, nextProps);
		}
	};

	Filter.prototype.render = function render(_ref4, _ref5) {
		var view = _ref5.view,
		    start = _ref5.start,
		    end = _ref5.end,
		    frequency = _ref5.frequency,
		    data = _ref5.data,
		    interval = _ref5.interval,
		    symbolTypeCode = _ref5.symbolTypeCode;

		var props = _objectWithoutProperties(_ref4, []);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.filter },
				this.downloadLink(),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					Item,
					{ id: INTL_NS + '.timePeriod', label: 'time period' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__interval_selector__["a" /* default */], {
						select: true,
						scaled: false,
						'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.intervalSelector,
						buttonClass: __WEBPACK_IMPORTED_MODULE_2__style___default.a.selectButton,
						disabled: !data,
						interval: interval,
						labels: __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* TIMEPERIODS */],
						displayValue: [Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["l" /* intlDateNode */])(start), ' - ', Object(__WEBPACK_IMPORTED_MODULE_3__lib_util__["l" /* intlDateNode */])(end)],
						customInterval: [],
						onSelect: this.handleSelectInterval
					})
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					Item,
					{ label: INTL_NS + '.view' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["q" /* Select */],
						{
							buttonClass: __WEBPACK_IMPORTED_MODULE_2__style___default.a.selectButton,
							disabled: !data,
							value: view.value,
							onChange: this.viewChange,
							iconPosition: 'right'
						},
						__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* VIEWS */].map(function (v) {
							return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["m" /* Option */], {
								title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5_preact_i18n__["d" /* Text */], { id: INTL_NS + '.views.' + v.substring(0, 3).toLowerCase() }),
								value: v
							});
						})
					)
				),
				view.value === 'Historical Prices' && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					Item,
					{ label: INTL_NS + '.frequency' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["q" /* Select */],
						{
							buttonClass: __WEBPACK_IMPORTED_MODULE_2__style___default.a.selectButton,
							disabled: !data,
							value: frequency,
							onChange: this.changeFrequency,
							iconPosition: 'right'
						},
						__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* FREQUENCY */].map(function (v) {
							return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["m" /* Option */], { title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5_preact_i18n__["d" /* Text */], { id: INTL_NS + '.frequencies.' + v }), value: v });
						})
					)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_7__cube_blocks__["d" /* ContainerSize */],
				{ height: false },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__data_panel__["a" /* default */], _extends({ view: view, data: data, symbolTypeCode: symbolTypeCode }, props))
			)
		);
	};

	return Filter;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);


var Item = function Item(_ref6) {
	var label = _ref6.label,
	    id = _ref6.id,
	    children = _ref6.children,
	    props = _objectWithoutProperties(_ref6, ['label', 'id', 'children']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.item },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.label },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_5_preact_i18n__["d" /* Text */],
				{ id: id || label },
				label
			)
		),
		children
	);
};


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DataPanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__historical__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__splits_dividends__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var INTL_NS = 'historical-data-panel.divSplit';

function DataPanel(_ref) {
	var view = _ref.view,
	    data = _ref.data,
	    symbolTypeCode = _ref.symbolTypeCode,
	    width = _ref.width,
	    props = _objectWithoutProperties(_ref, ['view', 'data', 'symbolTypeCode', 'width']);

	return !data ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__glyphs__["a" /* FinanceSpinner */], null) : view.value === 'Historical Prices' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__historical__["a" /* default */], _extends({ maxRows: '10000000', data: data.historical, symbolTypeCode: symbolTypeCode }, props)) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.splitsDividends },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */],
			{ 'class': __WEBPACK_IMPORTED_MODULE_7_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style___default.a.sdCont, width > 630 && __WEBPACK_IMPORTED_MODULE_4__style___default.a.wide), parent: true },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */],
				{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dividends' }) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__splits_dividends__["a" /* default */], _extends({ header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dividend' }), maxRows: '10000000', data: data.dividends }, props))
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */],
				{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.stockSplits' }) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__splits_dividends__["a" /* default */], _extends({ header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6_preact_i18n__["d" /* Text */], { id: INTL_NS + '.split' }), maxRows: '10000000', data: data.splits }, props))
			)
		)
	);
}

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloudquote_data_table__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_i18n__ = __webpack_require__(9);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var INTL_NS = 'historical-data-panel.headers';

var FOOTNOTES = ['adjustedClose'].map(function (name) {
	return { name: name, text: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: name }) };
});

var HistoricalData = function HistoricalData(_ref) {
	var symbolTypeCode = _ref.symbolTypeCode,
	    props = _objectWithoutProperties(_ref, ['symbolTypeCode']);

	var formatter = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["f" /* generatePriceFormatter */])({ SecurityTypeCode: symbolTypeCode }, { Default: '-' });
	var HistoricalDataTable = Object(__WEBPACK_IMPORTED_MODULE_1__cloudquote_data_table__["a" /* default */])({
		headers: [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.date' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.open' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.high' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.low' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.close' }), {
			name: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.adjustedClose' }),
			footnotes: FOOTNOTES,
			id: 'adjustedClose'
		}, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.volume' })],
		cells: [__WEBPACK_IMPORTED_MODULE_1__cloudquote_data_table__["c" /* tableUtils */].formatField('Date', __WEBPACK_IMPORTED_MODULE_2__lib_util__["l" /* intlDateNode */]), priceFormatField('Open', formatter), priceFormatField('High', formatter), priceFormatField('Low', formatter), priceFormatField('Close', formatter), priceFormatField('Adjusted Close', formatter), __WEBPACK_IMPORTED_MODULE_1__cloudquote_data_table__["c" /* tableUtils */].formatField('Volume', function (value) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(value, { Comma: true });
		})],
		sort: __WEBPACK_IMPORTED_MODULE_1__cloudquote_data_table__["c" /* tableUtils */].sort.descending.dateByKey('Date'),
		maxRows: 25,
		apiMethod: function apiMethod(_ref2) {
			var symbol = _ref2.symbol;
			return Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["getStockPriceHistory"])(symbol);
		},
		footnotes: FOOTNOTES
	});

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(HistoricalDataTable, props);
};

function priceFormatField(field, formatter) {
	return __WEBPACK_IMPORTED_MODULE_1__cloudquote_data_table__["c" /* tableUtils */].formatField(field, function (value) {
		return formatter(value);
	});
}

/* harmony default export */ __webpack_exports__["a"] = (HistoricalData);

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloudquote_data_table__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var INTL_NS = 'historical-data-panel.headers';

var SplitsDividends = function SplitsDividends(_ref) {
	var props = _objectWithoutProperties(_ref, []);

	var SplitOrDividend = Object(__WEBPACK_IMPORTED_MODULE_2__cloudquote_data_table__["a" /* default */])({
		headers: [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.date' }), props.header],
		cells: [__WEBPACK_IMPORTED_MODULE_2__cloudquote_data_table__["c" /* tableUtils */].formatField('eventDate', __WEBPACK_IMPORTED_MODULE_1__lib_util__["c" /* formatDate */]), 'value']
	});

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(SplitOrDividend, props);
};

/* harmony default export */ __webpack_exports__["a"] = (SplitsDividends);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterStockData */
/* unused harmony export corporateActions */
/* harmony export (immutable) */ __webpack_exports__["b"] = getStockData;
/* unused harmony export historicalData */
/* harmony export (immutable) */ __webpack_exports__["a"] = getHistoricalData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(729);



function filterStockData(stock, start, end) {
	stock.rows = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* filterRows */])(stock.rows || [], start, end);
	return stock;
}

function corporateActions(symbol, type, start, end) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__os_cloudquote__["getCorporateActions"])({
		symbols: [symbol],
		eventType: type
	}).then(function (data) {
		return filterStockData(data, start, end);
	});
}

function getStockData(_ref) {
	var symbol = _ref.symbol,
	    start = _ref.start,
	    end = _ref.end;

	return Promise.all([corporateActions(symbol, 'split', start, end), corporateActions(symbol, 'dividend', start, end)]).then(function (data) {
		return { splits: data[0], dividends: data[1] };
	});
}

function historicalData(data, start, end, interval) {
	data = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* sortData */])(data);
	data.years = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* buildYears */])(data);

	var _adjustTimerange = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* adjustTimerange */])(start, end, interval, data),
	    timerange = _adjustTimerange.timerange,
	    cacheData = _adjustTimerange.cacheData;

	return {
		cacheData: cacheData,
		start: timerange.start,
		end: timerange.end
	};
}

function getHistoricalData(_ref2) {
	var symbol = _ref2.symbol,
	    start = _ref2.start,
	    end = _ref2.end,
	    interval = _ref2.interval;

	if (interval === '1D') {
		start = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* setStart */])(start);
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0__os_cloudquote__["getStockPriceHistory"])({
		symbol: symbol,
		to: end,
		from: start
	}).then(function (data) {
		return historicalData(data, start, end, interval);
	});
}

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FREQUENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VIEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIMEPERIODS; });
var FREQUENCY = ['daily', 'weekly', 'monthly'];
var VIEWS = ['Historical Prices', 'Dividends / Splits'];
var TIMEPERIODS = ['1D', '1W', '1M', '3M', '6M', '1Y', '5Y', '10Y', 'MAX'];

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saveAs;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supported; });
/**
* tested on Chrome, Safari (+IOS), Firefox, Edge, IE 10 & 11, Brave
*/

/**
* triggers a client-side file save tailored to user's browser.
* @param {string} data - data to be included in text file.
* @param {string} filename - name of file to be downloaded.
* @param {string} mimetype - mimetype of file to be downloaded.
*/

function saveAs(data, filename, mimetype) {
	var handler = getHandler();
	if (handler) {
		return handler(data, filename, mimetype);
	}
}

// returns boolean if browser file download is compatible.
var supported = function supported() {
	return !!getHandler();
};

/**
* checks for browser compatibility and returns appropriate fn to
* achieve client-side file download.
*/

function getHandler() {
	if (isIE() >= 9) return handleIE;
	if (isBlobCompat()) return handleBlobCompat;
}

/**
* HTML5 Download & Blob compatible browser downloads. Includes most modern
* browsers and is the preferred solution.
*/

var isBlobCompat = function isBlobCompat() {
	return 'download' in document.createElement('a') && !!new Blob();
};

var handleBlobCompat = function handleBlobCompat(data, filename, mimetype) {
	var link = document.createElement('a');
	link.href = 'data:attachment/' + mimetype + ',' + encodeURI(data);
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	setTimeout(function () {
		return document.body.removeChild(link);
	});
};

/**
* Microsoft Edge / Internet Explorer solution. Utilizes iframe, triggers
* download w/ filename but user must manually correct filetype.
*/

var isIE = function isIE() {
	var ua = window.navigator.userAgent;

	// IE 10 or older => return version number
	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	// IE 11 => return version number
	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	// Edge (IE 12+) => return version number
	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	return false;
};

var handleIE = function handleIE(data, filename, mimetype) {
	try {
		var ieData = new Blob([data], { type: mimetype });
		window.navigator.msSaveBlob(ieData, filename);
	} catch (e) {
		var frame = document.createElement('iframe');
		frame.style.cssText = 'position:absolute; left:0; top:-999px;';
		document.body.appendChild(frame);
		var doc = frame.contentWindow.document;
		doc.open("text/html", "replace");
		doc.write(data);
		doc.save = "text";
		doc.execCommand('SaveAs', true, filename);
		doc.close();
		frame.focus();
		setTimeout(function () {
			return document.body.removeChild(frame);
		}, 1000);
	}
};

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HoldingsPanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_details_page__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stock_data_table_holdings__ = __webpack_require__(1038);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var INTL_NS = 'holdings-panel';



function HoldingsPanel(_ref) {
	var props = _objectWithoutProperties(_ref, []);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1__stock_details_page__["a" /* default */],
		props,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["g" /* Header */],
			{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.dataHeader, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.institutional' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: 'currency-indicator', fields: { code: 'USD' /* @TODO: I don't think this is correct... not always USD? */ } })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_data_table_holdings__["a" /* HoldingsDataTable */], _extends({ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.holdingTable }, props)),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["g" /* Header */], { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.dataHeader, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.insider' }) }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_data_table_holdings__["b" /* InsiderTransactionsDataTable */], props)
	);
}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dataHeader":"finance_holdings-panel_dataHeader","holdingTable":"finance_holdings-panel_holdingTable"};

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HoldingsDataTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InsiderTransactionsDataTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_i18n__ = __webpack_require__(9);






var INTL_NS = 'stock-data-table';
var INTL_NS_HOLDINGS = 'holdings';

var HoldingsDataTable = Object(__WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["a" /* default */])({
	headers: [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.holder' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.shares' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.dateReported' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.value' })],

	cells: ['Institution Name', __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["c" /* tableUtils */].formatField('Volume of Security Held', function (value) {
		return Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(value, { Comma: true });
	}), __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["c" /* tableUtils */].formatField('Report Date', __WEBPACK_IMPORTED_MODULE_2__lib_util__["l" /* intlDateNode */]), __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["c" /* tableUtils */].formatField('Value of Security Held', function (value) {
		return Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(value, { Comma: true, Decimals: 2 });
	})],
	sort: __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["c" /* tableUtils */].sort.descending.byKey('Volume of Security Held'),
	maxRows: 10,
	apiMethod: __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getInstitutionalHoldings"]
});

var InsiderTransactionsDataTable = Object(__WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["a" /* default */])({
	headers: [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.insider' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.transaction' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.date' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.value' }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.shares' })],
	cells: ['Insider', formatAcquiredDisposed, __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["c" /* tableUtils */].formatField('Transaction Date', __WEBPACK_IMPORTED_MODULE_2__lib_util__["l" /* intlDateNode */]), formatInsiderValue, __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["c" /* tableUtils */].formatField('Shares', function (value) {
		return Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(value, { Comma: true });
	})],
	sort: __WEBPACK_IMPORTED_MODULE_3__cloudquote_data_table__["c" /* tableUtils */].sort.descending.dateByKey('Transaction Date'),
	maxRows: 50,
	apiMethod: __WEBPACK_IMPORTED_MODULE_1__os_cloudquote__["getInsiderActions"]
});

function formatAcquiredDisposed(_ref) {
	var columns = _ref.columns,
	    row = _ref.row;

	var priceRange = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(row[columns.indexOf('Price Range')], { Prefix: '$', Decimals: 2, Default: 'N/A' });
	var acquiredOrDisposed = acquiredDisposedToString(row[columns.indexOf('Aquired/Disposal')]);
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + INTL_NS_HOLDINGS + '.' + acquiredOrDisposed, fields: { priceRange: priceRange } });
}

function formatInsiderValue(_ref2) {
	var columns = _ref2.columns,
	    row = _ref2.row;

	return Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(row[columns.indexOf('Shares')] * row[columns.indexOf('Price Range')], { Comma: true, Decimals: 2, Default: '-' });
}

function acquiredDisposedToString(aOrD) {
	return aOrD.toLowerCase() === 'a' ? 'acquisition' : aOrD.toLowerCase() === 'd' ? 'disposition' : 'unknown';
}

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_info_table__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);




var MarketIndicators = function MarketIndicators() {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a['market-indicators'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__stock_info_table__["a" /* default */], {
			showChart: true,
			columns: ['symbol', 'price', 'change'],
			symbols: ['$DJI', '$COMP', '$NYA'],
			cursor: 0
		})
	);
};

/* harmony default export */ __webpack_exports__["a"] = (MarketIndicators);

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"market-indicators":"finance_market-indicators_x","clearfix":"finance_market-indicators_clearfix"};

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MarketsPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__currency_matrix__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stock_symbol_table__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__quote_header__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dynamic_stock_chart__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cube_finance_blocks__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stock_price_bar__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















function routeToSymbol(quote) {
	window.location = '/finance/category/stockdetail/symbol/' + quote.UniqueSymbol;
}

var MarketsPanel = (_temp2 = _class = function (_Component) {
	_inherits(MarketsPanel, _Component);

	function MarketsPanel() {
		var _temp, _this, _ret;

		_classCallCheck(this, MarketsPanel);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { market: _this.props.symbol, quote: [] }, _this.onData = function (data) {
			if (data && data.rows && data.rows.length) {
				_this.setState({ quote: data.rows[0] });
			}
		}, _this.pickMarket = function (_ref) {
			var market = _ref.value;

			_this.setState({ market: market });
			_this.streamer = Object(__WEBPACK_IMPORTED_MODULE_11__os_cloudquote__["stockAPIStreamer"])(market, 'getStockPrice').on('data', _this.onData);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	MarketsPanel.prototype.generateSelect = function generateSelect(_ref2) {
		var width = _ref2.width,
		    market = _ref2.market,
		    markets = _ref2.markets;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["q" /* Select */],
			{ iconPosition: 'right', onChange: this.pickMarket, value: market, 'class': __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.marketSelect, width < 600 && __WEBPACK_IMPORTED_MODULE_6__style___default.a.marketSelectNarrow), anchor: 'right' },
			Object.keys(markets).map(function (key) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["m" /* Option */], { title: markets[key], value: key });
			})
		);
	};

	MarketsPanel.prototype.componentWillMount = function componentWillMount() {
		this.streamer = Object(__WEBPACK_IMPORTED_MODULE_11__os_cloudquote__["stockAPIStreamer"])(this.props.symbol, 'getStockPrice').on('data', this.onData);
	};

	MarketsPanel.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {
		var symbol = _ref3.symbol;

		if (this.props.symbol !== symbol) {
			this.setState({ market: symbol });
		}
	};

	MarketsPanel.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.stream) this.streamer.end();
	};

	MarketsPanel.prototype.render = function render(_ref4, _ref5) {
		var market = _ref5.market,
		    quote = _ref5.quote;

		var width = _ref4.width,
		    markets = _ref4.markets,
		    enableHeader = _ref4.enableHeader,
		    props = _objectWithoutProperties(_ref4, ['width', 'markets', 'enableHeader']);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ 'class': __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.markets, width <= 500 && __WEBPACK_IMPORTED_MODULE_6__style___default.a.marketsNarrow, width > 500 && __WEBPACK_IMPORTED_MODULE_6__style___default.a.marketsWide), parent: true },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["f" /* DeviceVariance */],
				{ phone: false },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["d" /* ContainerSize */],
					{ height: false },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__quote_header__["a" /* QuoteHeader */], { enableHeader: enableHeader })
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9__cube_finance_blocks__["b" /* SymbolLookup */], {
				'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.symbolLookup,
				onSymbolSelect: routeToSymbol,
				trackingSource: 'markets-panel/symbol-lookup',
				trackingZone: 'finance-components'
			}),
			markets && [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["f" /* DeviceVariance */], {
				phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["g" /* Header */],
					{ transform: 'uppercase', title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */],
							{ id: 'MARKETS' },
							'Markets'
						) },
					this.generateSelect({ width: width, market: market, markets: markets })
				),
				other: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["g" /* Header */], { transform: 'uppercase', title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */],
							{ id: 'MARKETS' },
							'Markets'
						) }),
					this.generateSelect({ width: width, market: market, markets: markets })
				)
			}), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__dynamic_stock_chart__["a" /* default */], { symbol: market, compare: false }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10__stock_price_bar__["a" /* LastUpdated */], _extends({ 'class': __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.hiddenOrBlock, width >= 600 && __WEBPACK_IMPORTED_MODULE_6__style___default.a.hiddenOrBlockWide), quote: quote }, props))],
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.sectors, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */],
						{ id: 'SECTORS' },
						'Sectors'
					) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_symbol_table__["a" /* default */], {
					showHeaders: ['Sector', 'Price', 'Change %', '1 Month %', '3 Month %', '52 Week %'],
					symbols: ['MSECTOR1', 'MSECTOR2', 'MSECTOR3', 'MSECTOR4', 'MSECTOR5', 'MSECTOR6', 'MSECTOR7', 'MSECTOR8', 'MSECTOR9'],
					columns: ['name', 'price', 'changePercent', 'oneMonthChangePercent', 'threeMonthChangePercent', '52WeekChangePercent']
				}),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_symbol_table__["a" /* default */], {
					showHeaders: ['Sector', 'Price', 'Change %'],
					columns: ['name', 'price', 'changePercent'],
					symbols: ['MSECTOR1', 'MSECTOR2', 'MSECTOR3', 'MSECTOR4', 'MSECTOR5', 'MSECTOR6', 'MSECTOR7', 'MSECTOR8', 'MSECTOR9'],
					cursor: 0,
					trackingSource: 'markets-panel/sectors'
				})
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__currency_matrix__["a" /* default */], { transform: 'capitalize' }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.worldMarkets, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_8_preact_i18n__["d" /* Text */],
						{ id: 'WORLD_MARKETS' },
						'World Markets'
					) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_symbol_table__["a" /* default */], {
					showHeaders: ['Index', '', 'Price', 'Change %'],
					columns: ['flag', 'name', 'price', 'changePercent'],
					symbols: ['$FTSE', '$PARI', '$DAX', '$N225', '$HSI', '$AOI', 'TSX:0000'],
					flags: ['uk', 'france', 'germany', 'japan', 'hongkong', 'australia', 'canada'],
					cursor: 0,
					trackingSource: 'markets-panel/world-markets'
				})
			)
		);
	};

	return MarketsPanel;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	symbol: '$DJI',
	markets: {
		COMP: 'NASDAQ',
		$DJI: 'Dow Jones',
		SPX: 'S&P 500'
	}
}, _temp2);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["x" /* containerSize */])({ height: false })(MarketsPanel));

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"quoteLookup":"finance_quote-header_quoteLookup","header":"finance_quote-header_header","lastUpdated":"finance_quote-header_lastUpdated","padTop":"finance_quote-header_padTop","wide":"finance_quote-header_wide"};

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"markets-panel":"finance_markets-panel_x","clearfix":"finance_markets-panel_clearfix","markets":"finance_markets-panel_markets","marketsWide":"finance_markets-panel_marketsWide","sectors":"finance_markets-panel_sectors","marketsNarrow":"finance_markets-panel_marketsNarrow","symbolLookup":"finance_markets-panel_symbolLookup","worldMarkets":"finance_markets-panel_worldMarkets","marketSelect":"finance_markets-panel_marketSelect","marketSelectNarrow":"finance_markets-panel_marketSelectNarrow","hiddenOrBlock":"finance_markets-panel_hiddenOrBlock","hiddenOrBlockWide":"finance_markets-panel_hiddenOrBlockWide","panel-header":"finance_markets-panel_panel-header","panel-header-label":"finance_markets-panel_panel-header-label","widget-panel":"finance_markets-panel_widget-panel","box-label":"finance_markets-panel_box-label","section-label":"finance_markets-panel_section-label"};

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PressWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/* Loads the widget once only using a singleton pattern */
function getPressWidget(callback) {
	if (window.cqPressWidget) return callback(window.cqPressWidget);
	if (window.cqPressWidgetCallbacks) return window.cqPressWidgetCallbacks.push(callback);

	window.cqPressWidgetCallbacks = [callback];

	var script = document.createElement('script');
	script.addEventListener('load', function () {
		window.cqPressWidget = window.currentWidget;

		for (var _iterator = window.cqPressWidgetCallbacks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;

			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}

			var _callback = _ref;

			_callback(window.currentWidget);
		}

		delete window.cqPressWidgetCallbacks;
	});
	script.src = '//widgets.financialcontent.com/synacor/pressreleases.js';

	document.head.appendChild(script);
}

/*
 * The <PressWidget /> component defined below is a preact component
 * which will detect the path which it is placed under
 * and render the correct content depending on the location the user is navigated to.
 *
 * It needs no parameters passed to it.
 *
 * The component looks at the location.href parameter, and watches for
 * state changes in the global history object,
 * and thus will navigate alongside most types of client-side navigation.
 *
 * Please integrate it as follows, by making the following changes under these route paths:
 *
 * /finance/category/stockdetail/symbol/:symbol
 *   Add <PressWidget /> Below The Chart
 *
 * /finance/category/press
 *   Replace <iframe src="https://synacor.xmware.com/".... /> with <PressWidget />
 *
 * /finance/category/press/......
 *   These wildcard paths should render the same component as /finance/category/press
 *   Probably the only thing needed to make this happen is
 *   to remove the "exact" parameter from the react <Route>
 *   for the /finance/category/press page
 *
 *  WARNING: If you attempt to add the widget to any other path, it will render no content. This is intentional.
 */

var PressWidget = function (_Component) {
	_inherits(PressWidget, _Component);

	function PressWidget() {
		var _temp, _this, _ret;

		_classCallCheck(this, PressWidget);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.setPressWidgetRef = function (el) {
			return _this.setState({ el: el });
		}, _this.renderPressWidget = function (_ref2) {
			var prevEl = _ref2.el;
			var el = _this.state.el;

			if (el && el !== prevEl) {
				getPressWidget(function (pressWidget) {
					if (!_this.pressWidgetInstance) {
						_this.pressWidgetInstance = new pressWidget({ el: el, Authorization: 'publicKey gqp28e0kv2a' });
					}
					_this.pressWidgetInstance.render();
				});
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	PressWidget.prototype.componentDidMount = function componentDidMount() {
		this.renderPressWidget({});
	};

	PressWidget.prototype.componentDidUpdate = function componentDidUpdate(props, state) {
		this.renderPressWidget(state);
	};

	PressWidget.prototype.render = function render() {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { ref: this.setPressWidgetRef });
	};

	return PressWidget;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTL_NS */
/* unused harmony export Profile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__competitors__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__company_info__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__description__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stock_details_page__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__os_model_connect__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cube_store_connect__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__os_finance_model__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_recompose__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cube_blocks__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
















var INTL_NS = 'company-profile';

function Profile(_ref) {
	var symbol = _ref.symbol,
	    profileData = _ref.profileData,
	    competitorStockData = _ref.competitorStockData,
	    locale = _ref.locale,
	    pending = _ref.pending,
	    width = _ref.width,
	    props = _objectWithoutProperties(_ref, ['symbol', 'profileData', 'competitorStockData', 'locale', 'pending', 'width']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_4__stock_details_page__["a" /* default */],
		_extends({ symbol: symbol }, props, { 'class': __WEBPACK_IMPORTED_MODULE_7_classnames___default()(props.class, __WEBPACK_IMPORTED_MODULE_6__style___default.a.profile, width < 490 && __WEBPACK_IMPORTED_MODULE_6__style___default.a.narrow) }),
		pending && pending.profileData ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__glyphs__["a" /* FinanceSpinner */], null) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__company_info__["a" /* default */], { data: profileData, symbol: symbol }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__competitors__["a" /* default */], { data: competitorStockData, pending: pending && pending.competitorStockData, symbol: symbol }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__description__["a" /* default */], {
				data: profileData,
				hide: locale && __WEBPACK_IMPORTED_MODULE_11_dlv___default()(__WEBPACK_IMPORTED_MODULE_10__os_finance_model__["a" /* config */], 'limitedLocales', []).indexOf(locale) >= 0
			})
		)
	);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8__os_model_connect__["a" /* default */])('financeModel', function (_ref2) {
	var symbol = _ref2.symbol;
	return {
		profileData: ['getProfile', symbol],
		competitorStockData: ['getCompetitorStockData', symbol]
	};
}), Object(__WEBPACK_IMPORTED_MODULE_9__cube_store_connect__["a" /* default */])(function (_ref3) {
	var locale = _ref3.locale;
	return { locale: locale };
}), Object(__WEBPACK_IMPORTED_MODULE_13__cube_blocks__["x" /* containerSize */])({ height: false }))(Profile));

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Competitors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_info_table__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function Competitors(_ref) {
	var data = _ref.data,
	    pending = _ref.pending,
	    props = _objectWithoutProperties(_ref, ['data', 'pending']);

	//show a spinner while the data is loading
	if (pending) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__glyphs__["a" /* FinanceSpinner */], null);

	var noData = !pending && !(data && data.rows && data.rows.length);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style___default.a.competitors, noData && __WEBPACK_IMPORTED_MODULE_4__style___default.a.dataUnavailable) },
		noData ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: 'competitorsUnavailable' }) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__stock_info_table__["a" /* default */], _extends({
			dataTable: true,
			showHeaders: true,
			columns: ['competitors', 'price', 'changeCompound', 'marketCap'],
			data: data
		}, props))
	);
}

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = join;
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["e"] = shallowEqual;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeKeyFromObject;
/* harmony export (immutable) */ __webpack_exports__["c"] = noop;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/** Joins an array (using newlines) if it exists, otherwise returns an empty string
 *	@private
 */
function join(arr) {
  return arr ? arr.join('\n') : '';
}

/** Returns an object property if `key` is non-empty, otherwise returns the object itself
 *	@private
 */
function get(obj, key) {
  return key ? obj[key] : obj;
}

/** Check if two objects have the same keys, and that all values are strictly equal.
 *	@private
 */
function shallowEqual(a, b) {
  for (var key in a) {
    if (a[key] !== b[key]) return false;
  }for (var _key in b) {
    if (!(_key in a)) return false;
  }return true;
}

/** Returns a clone of the given object without a certain key.
 *	Returns undefined if resulting object would be empty.
 *	@private
 */
function removeKeyFromObject(key, obj) {
  var newObj = void 0;
  if (Object.keys(obj).length > 1) {
    newObj = _extends({}, obj);
    delete newObj[key];
  }
  return newObj;
}

/** An empty function.
 *	@private
 */
function noop() {}

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_default_config_json__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_default_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_default_config_json__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__config_default_config_json___default.a);

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = {"version":"v1","limitedLocales":["es"]}

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTL_NS */
/* unused harmony export ProfilePhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__company_info__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__description__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__os_model_connect__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cube_store_connect__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__os_finance_model__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_dlv__);













var INTL_NS = 'company-profile';

function ProfilePhone(_ref) {
	var symbol = _ref.symbol,
	    profileData = _ref.profileData,
	    locale = _ref.locale;

	var rows = profileData && profileData.rows && profileData.rows[0];

	if (!rows) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__glyphs__["a" /* FinanceSpinner */], null);
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style___default.a.profile, __WEBPACK_IMPORTED_MODULE_5__style___default.a.phone) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */],
			{
				parent: true,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7_preact_i18n__["d" /* Text */], { id: INTL_NS + '.companyProfile' }),
				'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a.phoneHeader,
				transform: 'uppercase'
			},
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__company_info__["a" /* default */], {
				data: profileData,
				symbol: symbol,
				'class': __WEBPACK_IMPORTED_MODULE_5__style___default.a.phone
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__description__["a" /* default */], {
				data: profileData,
				hide: locale && __WEBPACK_IMPORTED_MODULE_11_dlv___default()(__WEBPACK_IMPORTED_MODULE_10__os_finance_model__["a" /* config */], 'limitedLocales', []).indexOf(locale) >= 0
			})
		)
	);
}

var ConnectedProfilePhone = Object(__WEBPACK_IMPORTED_MODULE_9__cube_store_connect__["a" /* default */])(function (_ref2) {
	var locale = _ref2.locale;
	return { locale: locale };
})(ProfilePhone);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__os_model_connect__["a" /* default */])('financeModel', function (_ref3) {
	var symbol = _ref3.symbol;
	return {
		profileData: ['getProfile', symbol]
	};
})(ConnectedProfilePhone));

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__os_finance_model__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__os_context_provider__ = __webpack_require__(530);




// we'll hand out a single shared instance
var financeModel = Object(__WEBPACK_IMPORTED_MODULE_1__os_finance_model__["b" /* default */])();

/**
 * Wrap any component wtih a Provider (@see @os/context-provider) that supplies the financeModel
 *
 * @param Child {Component} A Component to be wrapped
 * @return {Component} A component that wraps Child in <Provider financeModel={financeModelInstance}>
 *
 * @example
 * import provideFinanceModel from '../provide-finance-model';
 * const MyWidget = (props) => <div {...props />
 * export default provideFinanceModel(MyWidget);
 *
 */
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__os_context_provider__["b" /* provide */])({ financeModel: financeModel }));

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecentlyViewed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_storage__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stock_symbol_table__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var INTL_NS = 'stock-recently-viewed';

var RecentlyViewed = function (_Component) {
	_inherits(RecentlyViewed, _Component);

	function RecentlyViewed() {
		var _temp, _this, _ret;

		_classCallCheck(this, RecentlyViewed);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			symbols: []
		}, _this.getStocksFromStorage = function () {
			var symbols = __WEBPACK_IMPORTED_MODULE_1__lib_storage__["a" /* recentStorage */].get('stocks') || [];
			if (symbols.length) _this.setState({ symbols: symbols });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	RecentlyViewed.prototype.componentWillMount = function componentWillMount() {
		this.getStocksFromStorage();
	};

	RecentlyViewed.prototype.render = function render(_ref, _ref2) {
		var _ref$abbrv = _ref.abbrv,
		    abbrv = _ref$abbrv === undefined ? true : _ref$abbrv;
		var symbols = _ref2.symbols;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.stockRecentlyViewed) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__cube_blocks__["h" /* HeaderV2 */], { 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.header,
				title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.recentlyViewed' },
					'Recently Viewed'
				)
			}),
			symbols.length ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__stock_symbol_table__["a" /* default */], {
				showHeaders: !!symbols.length,
				symbols: symbols,
				abbrv: abbrv,
				columns: ['symbolWithName', 'price', 'changePrice', 'changePercent'],
				trackingSource: 'stock-recently-viewed',
				trackingZone: 'finance-components'
			}) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.noRecentStocks) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.noStockDataAvailable' },
					'No stock data available'
				)
			)
		);
	};

	return RecentlyViewed;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stockRecentlyViewed":"finance_stock-recently-viewed_stockRecentlyViewed","clearfix":"finance_stock-recently-viewed_clearfix","noRecentStocks":"finance_stock-recently-viewed_noRecentStocks"};

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ENABLED = 'Enabled';
var DISABLED = null;

/* harmony default export */ __webpack_exports__["a"] = ({

	//	Maximum number of stocks stored to local storage
	maxRecent: 10,

	/** Whitelist for different securities types to consider for local storage
 *	 Toggle below to allow
 */
	allowedInStorage: {
		COMMODITY: DISABLED,
		CURRENCY: ENABLED,
		FUND: ENABLED,
		FUTURE: DISABLED,
		INDEX: DISABLED,
		INTEREST: DISABLED,
		MISC: DISABLED,
		NOTE: DISABLED,
		OPTION: DISABLED,
		RIGHTS: DISABLED,
		SECTOR: DISABLED,
		STATISTIC: DISABLED,
		STOCK: ENABLED,
		TEST: DISABLED,
		UNKNOWN: DISABLED,
		WARRANT: DISABLED
	}
});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTL_NS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectorPerformance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_graph__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_util_stock_price__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var INTL_NS = 'sector-performance';

var SectorPerformance = function (_Component) {
	_inherits(SectorPerformance, _Component);

	function SectorPerformance() {
		_classCallCheck(this, SectorPerformance);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SectorPerformance.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["getStockPrice"])(['MSECTOR1', 'MSECTOR2', 'MSECTOR3', 'MSECTOR4', 'MSECTOR5', 'MSECTOR6', 'MSECTOR7', 'MSECTOR8', 'MSECTOR9']).then(function (data) {
			return _this2.setState({ data: data });
		});
	};

	SectorPerformance.prototype.render = function render(_ref, _ref2) {
		var data = _ref2.data;

		_objectDestructuringEmpty(_ref);

		if (!data || !data.rows) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['sector-performance'] });

		var bars = [{ barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.materials' }) }, { barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.conglomerates' }) }, { barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.consumer' }) }, { barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.financial' }) }, { barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.healthcare' }) }, { barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.industrial' }) }, { barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.services' }) }, { barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.technology' }) }, { barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: INTL_NS + '.utilities' }) }];
		var min = -1,
		    max = 1;
		for (var i = 0; i < data.rows.length; i++) {
			var row = data.rows[i];
			var goodPrevClose = Object(__WEBPACK_IMPORTED_MODULE_5__lib_util_stock_price__["a" /* getGoodPrevClose */])(row);
			var change = bars[i].change = Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["a" /* calcChange */])(row.Price, goodPrevClose);
			min = change.percent > min ? min : change.percent;
			max = change.percent < max ? max : change.percent;
		}
		var extra = (max - min) * .05;
		min -= extra;
		max += extra;

		for (var _i = 0; _i < bars.length; _i++) {
			var bar = bars[_i];
			bar.value = bar.change ? (bar.change.percent - min) / (max - min) : 'N/A';
			bar.className = bar.change ? bar.change.class : '';
			bar.valLabel = bar.change ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["e" /* formatNumber */])(bar.change.percent, { Decimals: 2, Default: '', Plus: true, Suffix: '%' }) : 'N/A';
		}

		bars.sort(function (a, b) {
			return b.value - a.value;
		});

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['sector-performance'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'vert-graph' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__bar_graph__["b" /* VerticalBarGraph */], { bars: bars, width: 500, height: 150, padding: 5 })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'horiz-graph' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__bar_graph__["a" /* HorizontalBarGraph */], { bars: bars, width: 250, height: 200, labelPos: 'left', labelWidth: 70 })
			)
		);
	};

	return SectorPerformance;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bar-graph":"finance_bar-graph_x","bg":"finance_bar-graph_bg","bars":"finance_bar-graph_bars","barGroup":"finance_bar-graph_barGroup","bar":"finance_bar-graph_bar","value":"finance_bar-graph_value","outside":"finance_bar-graph_outside","inside":"finance_bar-graph_inside","label":"finance_bar-graph_label","positive":"finance_bar-graph_positive","negative":"finance_bar-graph_negative"};

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sector-performance":"finance_sector-performance_x","clearfix":"finance_sector-performance_clearfix","vert-graph":"finance_sector-performance_vert-graph","horiz-graph":"finance_sector-performance_horiz-graph"};

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stock_symbol_table__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);





var SectorsPanel = function SectorsPanel() {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a['sectors-panel'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a['panel-header'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'SECTORS' })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a['widget-panel'] },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_symbol_table__["a" /* default */], {
					showHeaders: ['Sector', 'Price', 'Change %', '1 Month %', '3 Month %', '52 Week %'],
					symbols: ['MSECTOR1', 'MSECTOR2', 'MSECTOR3', 'MSECTOR4', 'MSECTOR5', 'MSECTOR6', 'MSECTOR7', 'MSECTOR8', 'MSECTOR9'],
					columns: ['name', 'price', 'changePercent', 'oneMonthChangePercent', 'threeMonthChangePercent', '52WeekChangePercent']
				})
			)
		)
	);
};
/* harmony default export */ __webpack_exports__["a"] = (SectorsPanel);

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sectors-panel":"finance_sectors-panel_x","clearfix":"finance_sectors-panel_clearfix","panel-header":"finance_sectors-panel_panel-header","panel-header-label":"finance_sectors-panel_panel-header-label","widget-panel":"finance_sectors-panel_widget-panel","box-label":"finance_sectors-panel_box-label","section-label":"finance_sectors-panel_section-label"};

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatisticsPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stock_details_page__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__statistics_phone__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__statistics_desktop__ = __webpack_require__(1063);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var StatisticsPanel = function (_Component) {
	_inherits(StatisticsPanel, _Component);

	function StatisticsPanel() {
		_classCallCheck(this, StatisticsPanel);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	StatisticsPanel.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["getSecurityStats"])(this.props.symbol).then(function (data) {
			if (data && data.rows && data.rows.length) {
				_this2.setState({ quote: data.rows[0] });
			}
		});
	};

	StatisticsPanel.prototype.render = function render(props, _ref) {
		var quote = _ref.quote;


		if (!quote) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__glyphs__["a" /* FinanceSpinner */], null);
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_4__stock_details_page__["a" /* default */],
			_extends({ showCurrencyIndicator: true }, props),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["f" /* DeviceVariance */],
				{ phone: false },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["d" /* ContainerSize */],
					{ height: false },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__statistics_desktop__["a" /* default */], _extends({ quote: quote }, props))
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["f" /* DeviceVariance */], {
				phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["d" /* ContainerSize */],
					{ height: false },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__statistics_phone__["a" /* default */], _extends({ quote: quote }, props))
				)
			})
		);
	};

	return StatisticsPanel;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = KeyStatistics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__earnings__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__company_profile__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footnotes__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stock_details__ = __webpack_require__(475);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }












var INTL_NS = 'statistics-panel';

var FOOTNOTES = ['marketCapSecurityStats', 'trailingPe', 'enterpriseValueRevenue', 'enterpriseValueEbitda', 'returnOnAssets', 'returnOnEquity', 'revenuePerShare', 'quarterlyRevenueGrowth', 'quarterlyEarningsGross', 'payoutRatio'].map(function (name) {
	return {
		name: name,
		text: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + name })
	};
});

function KeyStatistics(_ref) {
	var quote = _ref.quote,
	    width = _ref.width,
	    showProfileInfo = _ref.showProfileInfo,
	    className = _ref.class,
	    props = _objectWithoutProperties(_ref, ['quote', 'width', 'showProfileInfo', 'class']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style___default.a.statistics, __WEBPACK_IMPORTED_MODULE_7__style___default.a.phone, className, width > 600 && __WEBPACK_IMPORTED_MODULE_7__style___default.a.wide) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__earnings__["a" /* default */], props),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */], { 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.statisticsHeader, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.valuationMeasures' }) }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__stock_details__["a" /* default */], {
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['marketCapSecurityStats', 'enterpriseValue', 'trailingPe', 'priceToSale', 'priceToBook', 'enterpriseValueRevenue', 'enterpriseValueEbitda']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */], { 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.statisticsHeader, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.financialHighlights' }) }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.managementEffectiveness' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['returnOnAssets', 'returnOnEquity']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.incomeStatement' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['revenue', 'revenuePerShare', 'quarterlyRevenueGrowth', 'grossProfit', 'ebitda', 'dilutedEps', 'quarterlyEarningsGross']
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style___default.a.statistics) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */], { 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.statisticsHeader, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.tradingInformation' }) }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.stockPriceHistory' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['oneYearChange', 'oneYearHigh', 'oneYearLow', 'oneWeekAvgVolume', 'threeMonthAvgVolume', 'sharesOutstanding']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.oneWeekPerformance' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['vsDowWeek', 'vsSPWeek', 'vsNasdaqWeek']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.oneYearPerformance' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['vsDowYear', 'vsSPYear', 'vsNasdaqYear']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dividendInformation' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['trailingDividendRate', 'trailingDividendYield', 'payoutRatio']
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__footnotes__["b" /* default */], { 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.footnotes, notes: FOOTNOTES }),
		showProfileInfo && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__company_profile__["a" /* ProfilePhone */], props)
	);
}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stock-details":"finance_stock-details_x","stock-details-table":"finance_stock-details_stock-details-table","caps":"finance_stock-details_caps","no-transform":"finance_stock-details_no-transform","positive":"finance_stock-details_positive","negative":"finance_stock-details_negative"};

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = StatisticsDesktop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footnotes__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stock_details__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var INTL_NS = 'statistics-panel';

var FOOTNOTES = ['marketCapSecurityStats', 'trailingPe', 'enterpriseValueRevenue', 'enterpriseValueEbitda', 'fiscalYearEnds', 'mostRecentQuarter', 'revenuePerShare', 'quarterlyRevenueGrowth', 'quarterlyEarningsGross', 'totalCashPerShare', 'totalDebtEquity', 'currentRatio', 'bookValuePerShare', 'payoutRatio'].map(function (name) {
	return {
		name: name,
		text: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.' + name }),
		break: name === 'quarterlyEarningsGross'
	};
});

function StatisticsDesktop(_ref) {
	var quote = _ref.quote,
	    width = _ref.width,
	    props = _objectWithoutProperties(_ref, ['quote', 'width']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.statistics, width > 600 && __WEBPACK_IMPORTED_MODULE_6__style___default.a.wide) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */], { 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.statisticsHeader, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.valuationMeasures' }) }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['marketCapSecurityStats', 'enterpriseValue', 'trailingPe', 'priceToSale', 'priceToBook', 'enterpriseValueRevenue', 'enterpriseValueEbitda']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */], { 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.statisticsHeader, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.financialHighlights' }) }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.fiscalYear' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['fiscalYearEnds', 'mostRecentQuarter']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.profitability' }),
				quote: quote,
				fields: ['profitMargin', 'operatingMargin']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.managementEffectiveness' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['returnOnAssets', 'returnOnEquity']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.incomeStatement' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['revenue', 'revenuePerShare', 'quarterlyRevenueGrowth', 'grossProfit', 'ebitda', 'dilutedEps', 'quarterlyEarningsGross']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.balanceSheet' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['totalCash', 'totalCashPerShare', 'totalDebt', 'totalDebtEquity', 'currentRatio', 'bookValuePerShare']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.cashFlowStatement' }),
				quote: quote,
				fields: ['operatingCashFlow', 'leveredFreeCashFlow']
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.statistics) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["g" /* Header */], { 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.statisticsHeader, title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.tradingInformation' }) }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.stockPriceHistory' }),
				quote: quote,
				fields: ['oneYearChange', 'oneYearHigh', 'oneYearLow', 'oneWeekAvgVolume', 'threeMonthAvgVolume', 'sharesOutstanding']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.oneWeekPerformance' }),
				quote: quote,
				fields: ['vsDowWeek', 'vsSPWeek', 'vsNasdaqWeek']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.oneYearPerformance' }),
				quote: quote,
				fields: ['vsDowYear', 'vsSPYear', 'vsNasdaqYear']
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__stock_details__["a" /* default */], {
				header: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: INTL_NS + '.dividendInformation' }),
				quote: quote,
				footnotes: FOOTNOTES,
				fields: ['trailingDividendRate', 'trailingDividendYield', 'payoutRatio']
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__footnotes__["b" /* default */], { notes: FOOTNOTES })
	);
}

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stock_chart__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util_stock_price__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaults__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var StockChartDetails = function StockChartDetails(_ref) {
	var stockData = _ref.stockData,
	    symbol = _ref.symbol;

	var name = stockData.Name || stockData.Symbol || symbol;
	var goodPrevClose = Object(__WEBPACK_IMPORTED_MODULE_4__lib_util_stock_price__["a" /* getGoodPrevClose */])(stockData);

	var change = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["a" /* calcChange */])(stockData.Open, goodPrevClose);
	var changePrice = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(change.price, { Decimals: 2, Default: '$0.00', Prefix: '$' });
	var prevClose = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(goodPrevClose, { Decimals: 2, Default: '0.00' });
	var open = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(stockData.Open, { Decimals: 2, Default: '0.00' });
	var lastTrade = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["d" /* formatLastTradeTime */])(stockData.LastTradeTime);

	var analysis = void 0;
	if (change.price > 0) {
		if (change.price > 5) {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.gappedUp' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.overnightOpeningAt' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					open
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.offOfAPreviousCloseOf' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					prevClose
				)
			);
		} else if (change.price > 0.5) {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.openedAt' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					open
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.todayAnIncreaseOf' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.fromThePreviousCloseOf' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					prevClose
				)
			);
		} else {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.openedSlightlyUpTodayIncreasing' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.positive },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.fromThePreviousCloseOf' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					prevClose
				)
			);
		}
	} else if (change.price < 0) {
		if (change.price < -5) {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.sharesDroppedOvernightTo' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					open
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.aDeclineOf' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.fromThePreviousCloseOf' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					prevClose
				)
			);
		} else if (change.price < -0.5) {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.movedDownwardBy' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.pointsOpeningAt' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					open
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.todayComparedToAPreviousCloseOf' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					prevClose
				)
			);
		} else {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.openedSlightlyDownTodayDecreasing' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.negative },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.to' }),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
					open
				)
			);
		}
	} else if (stockData.Volume > 0) {
		analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'p',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
				name
			),
			' ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.sharesOpenedFlatTodayAt' }),
			' ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
				open
			)
		);
	} else {
		analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'p',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
				name
			),
			' ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-open-analysis.sharesHaveNotTradedSince' }),
			' ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.highlight },
				lastTrade
			)
		);
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a['stock-chart-details'] + ' ' + __WEBPACK_IMPORTED_MODULE_6__style___default.a['table-when-wide'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': 'chart-col' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'box-label' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: 'stock-details.stockChart' },
					'Stock Chart'
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__stock_chart__["b" /* StockChartWithIntervals */], _extends({ symbol: symbol, width: '500', height: '300' }, __WEBPACK_IMPORTED_MODULE_5__defaults__["a" /* default */].chart))
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': 'details-col' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'box-label' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: 'stock-details.atTheOpen' },
					'At the Open'
				)
			),
			analysis,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.detail },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.row },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.label },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-details.open' })
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.value },
						Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(stockData.Open, { Decimals: 2, Default: '0.00' })
					)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.detail },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.row },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.label },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
							{ id: 'stock-details.previousClose' },
							'Previous Close'
						)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.value },
						Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(stockData.PrevClose, { Decimals: 2, Default: '0.00' })
					)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.detail },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.row },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.label },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'stock-details.volume' })
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.value },
						Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(stockData.Volume, { Decimals: 0, Default: '0', Comma: true })
					)
				)
			)
		)
	);
};
/* harmony default export */ __webpack_exports__["a"] = (StockChartDetails);

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stock-chart-details":"finance_stock-chart-details_x","chart-col":"finance_stock-chart-details_chart-col","stock-chart":"finance_stock-chart-details_stock-chart","details-col":"finance_stock-chart-details_details-col","positive":"finance_stock-chart-details_positive","negative":"finance_stock-chart-details_negative","highlight":"finance_stock-chart-details_highlight","detail":"finance_stock-chart-details_detail","row":"finance_stock-chart-details_row","label":"finance_stock-chart-details_label"};

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTL_NS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util_stock_price__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);






var INTL_NS = 'stock-open-analysis';

var StockOpenAnalysis = function StockOpenAnalysis(_ref) {
	var quote = _ref.quote,
	    symbol = _ref.symbol;

	var name = quote.Name || quote.Symbol || symbol;
	var goodPrevClose = Object(__WEBPACK_IMPORTED_MODULE_3__lib_util_stock_price__["a" /* getGoodPrevClose */])(quote);

	var change = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["a" /* calcChange */])(quote.Open, goodPrevClose);
	var changePrice = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(change.price, { Decimals: 2, Default: '0.00', Plus: true });
	var prevClose = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(goodPrevClose, { Decimals: 2, Default: '0.00' });
	var open = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["e" /* formatNumber */])(quote.Open, { Decimals: 2, Default: '0.00' });
	var lastTrade = Object(__WEBPACK_IMPORTED_MODULE_2__lib_util__["d" /* formatLastTradeTime */])(quote.LastTradeTime);

	var analysis = void 0;
	if (change.price > 0) {
		if (change.price > 5) {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.gappedUp' },
					'gapped up'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.positive },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.overnightOpeningAt' },
					'overnight, opening at'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					open
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.offOfAPreviousCloseOf' },
					'off of a previous close of'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					prevClose
				)
			);
		} else if (change.price > 0.5) {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.openedAt' },
					'opened at'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					open
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.todayAnIncreaseOf' },
					'today, an increase of'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.positive },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.fromThePreviousCloseOf' },
					'from the previous close of'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					prevClose
				)
			);
		} else {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.openedSlightlyUpTodayIncreasing' },
					'opened slightly up today, increasing'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.positive },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.fromThePreviousCloseOf' },
					'from the previous close of'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					prevClose
				)
			);
		}
	} else if (change.price < 0) {
		if (change.price < -5) {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.sharesDroppedOvernightTo' },
					'shares dropped overnight to'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					open
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.aDeclineOf' },
					', a decline of'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.negative },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.fromThePreviousCloseOf' },
					'from the previous close of'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					prevClose
				)
			);
		} else if (change.price < -0.5) {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.movedDownwardBy' },
					'moved downward by'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.negative },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.pointsOpeningAt' },
					'points, opening at'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					open
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.todayComparedToAPreviousCloseOf' },
					'today, compared to a previous close of'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					prevClose
				)
			);
		} else {
			analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					name
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.openedSlightlyDownTodayDecreasing' },
					'opened slightly down today, decreasing'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					changePrice
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
					{ id: INTL_NS + '.to' },
					'to'
				),
				' ',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
					open
				)
			);
		}
	} else if (quote.volume > 0) {
		analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'p',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
				name
			),
			' ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
				{ id: INTL_NS + '.sharesOpenedFlatTodayAt' },
				'shares opened flat today at'
			),
			' ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
				open
			)
		);
	} else {
		analysis = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'p',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
				name
			),
			' ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */],
				{ id: INTL_NS + '.sharesHaveNotTradedSince' },
				'shares have not traded since'
			),
			' ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.highlight },
				lastTrade
			)
		);
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': 'stock-open-analysis' },
		analysis
	);
};
/* harmony default export */ __webpack_exports__["a"] = (StockOpenAnalysis);

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stock-open-analysis":"finance_stock-open-analysis_x","clearfix":"finance_stock-open-analysis_clearfix","positive":"finance_stock-open-analysis_positive","negative":"finance_stock-open-analysis_negative","highlight":"finance_stock-open-analysis_highlight"};

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StockPerformanceByInterval */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StockPerformanceByMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockPerformanceByDay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bar_graph__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__change_box__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MONTH_NS = 'stock-performance.months';
var DAYS_NS = 'stock-performance.daysOfWeek';

var daysOfWeek = [DAYS_NS + '.sunday', DAYS_NS + '.monday', DAYS_NS + '.tuesday', DAYS_NS + '.wednesday', DAYS_NS + '.thursday', DAYS_NS + '.friday', DAYS_NS + '.saturday'];

var months = [MONTH_NS + '.jan', MONTH_NS + '.feb', MONTH_NS + '.mar', MONTH_NS + '.apr', MONTH_NS + '.may', MONTH_NS + '.jun', MONTH_NS + '.jul', MONTH_NS + '.aug', MONTH_NS + '.sep', MONTH_NS + '.oct', MONTH_NS + '.nov', MONTH_NS + '.dec'];

var StockPerformanceByInterval = function StockPerformanceByInterval(_ref) {
	var quote = _ref.quote;

	if (!quote) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a['stock-performance-interval'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__glyphs__["a" /* FinanceSpinner */], null)
	);

	var bars = [{
		barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'stock-performance.ytd' }),
		change: Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(quote.Price, quote.StartingPriceYTD)
	}, {
		barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'stock-performance.oneMonth' }),
		change: Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(quote.Price, quote.StartingPrice1M)
	}, {
		barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'stock-performance.threeMonth' }),
		change: Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(quote.Price, quote.StartingPrice3M)
	}, {
		barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'stock-performance.sixMonth' }),
		change: Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(quote.Price, quote.StartingPrice6M)
	}, {
		barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'stock-performance.oneYear' }),
		change: Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(quote.Price, quote.StartingPrice52)
	}];
	var max = 5;
	for (var i = 0; i < bars.length; i++) {
		var bar = bars[i];
		var abs = Math.abs(bar.change.percent);
		if (abs > max) max = abs;
	}
	max *= 1.1;
	for (var _i = 0; _i < bars.length; _i++) {
		var _bar = bars[_i];
		_bar.valLabel = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(_bar.change.percent, { Decimals: 2, Default: '', Plus: true, Suffix: '%' });
		_bar.value = (max + _bar.change.percent) / (max * 2);
		_bar.className = _bar.change.class;
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a['stock-performance-interval'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a['horiz-graph'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__bar_graph__["a" /* HorizontalBarGraph */], { bars: bars, width: 365, height: 200, labelPos: 'left', barStartValue: 0.5 })
		)
	);
};

var StockPerformanceByMonth = function (_Component) {
	_inherits(StockPerformanceByMonth, _Component);

	function StockPerformanceByMonth() {
		_classCallCheck(this, StockPerformanceByMonth);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	StockPerformanceByMonth.prototype.calcBars = function calcBars(data) {
		if (data) {
			var closingRecords = {};
			if (data.rows) {
				for (var i = 0; i < data.rows.length; i++) {
					var row = data.rows[i];
					var d = new Date(row[0]);
					var ym = d.getYear() * 12 + (d.getMonth() - 1);
					closingRecords[ym] = row;
				}
			}
			var min = -25,
			    max = 25; //At least 25% range
			var bars = [];
			var yms = Object.keys(closingRecords).sort(function (a, b) {
				return b - a;
			});
			for (var _i2 = 1; _i2 < 7 && _i2 < yms.length; _i2++) {
				var newer = closingRecords[yms[_i2 - 1]];
				var older = closingRecords[yms[_i2]];
				var change = Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(newer[4], older[4]);
				min = change.percent > min ? min : change.percent;
				max = change.percent < max ? max : change.percent;

				var _d = new Date(newer[0]);
				bars[_i2 - 1] = {
					change: change,
					className: change.class,
					valLabel: Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(change.percent, { Decimals: 2, Default: '', Plus: true, Suffix: '%' }),
					barLabel: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: months[_d.getMonth()] })
				};
			}
			for (var _i3 = 0; _i3 < bars.length; _i3++) {
				var bar = bars[_i3];
				bar.value = (bar.change.percent - min) / (max - min);
			}

			this.setState({ bars: bars });
		}
	};

	StockPerformanceByMonth.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_2__os_cloudquote__["getStockPriceHistory"])(this.props.symbol).then(function (data) {
			_this2.calcBars(data);
		});
	};

	StockPerformanceByMonth.prototype.render = function render(props, _ref2) {
		var bars = _ref2.bars;

		if (!bars || !bars.length) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a['stock-performance-month'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__glyphs__["a" /* FinanceSpinner */], null)
		);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a['stock-performance-month'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__bar_graph__["a" /* HorizontalBarGraph */], { bars: bars, width: 300, height: 200, labelPos: 'left' }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__bar_graph__["b" /* VerticalBarGraph */], { bars: bars, width: 450, height: 200 })
		);
	};

	return StockPerformanceByMonth;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var StockPerformanceByDay = function (_Component2) {
	_inherits(StockPerformanceByDay, _Component2);

	function StockPerformanceByDay() {
		_classCallCheck(this, StockPerformanceByDay);

		return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	StockPerformanceByDay.prototype.calcLast5 = function calcLast5(data) {
		if (!data) return;

		var last5 = [];

		if (data.rows) {
			var rows = data.rows.slice().reverse();
			for (var i = 1; i < 6 && i < rows.length; i++) {
				last5[i - 1] = {
					date: rows[i - 1][0],
					change: Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* calcChange */])(rows[i - 1][4], rows[i][4])
				};
			}
		}

		this.setState({ last5: last5 });
	};

	StockPerformanceByDay.prototype.calculateChangeBoxes = function calculateChangeBoxes(last5) {
		return last5.map(function (row) {
			var date = new Date(row.date);
			var dayStr = daysOfWeek[date.getUTCDay()];
			var dateStr = months[date.getUTCMonth()] + ' ' + date.getUTCDate();
			return {
				className: row.change.class,
				label: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: dayStr }),
				sub: dateStr,
				value: Object(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* formatNumber */])(row.change.percent, { Decimals: 2, Default: '0.00%', Plus: true, Suffix: '%' })
			};
		});
	};

	StockPerformanceByDay.prototype.componentWillMount = function componentWillMount() {
		var _this4 = this;

		Object(__WEBPACK_IMPORTED_MODULE_2__os_cloudquote__["getStockPriceHistory"])(this.props.symbol).then(function (data) {
			_this4.calcLast5(data);
		});
	};

	StockPerformanceByDay.prototype.render = function render(props, _ref3) {
		var last5 = _ref3.last5;

		if (!last5) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a['stock-performance-day'] },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__glyphs__["a" /* FinanceSpinner */], null)
			);
		}
		var boxes = this.calculateChangeBoxes(last5);
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a['stock-performance-day'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a['section-label'] },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */],
					{ id: 'stock-performance.last5Days' },
					'Last 5 Days'
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__change_box__["a" /* ChangeBoxes */], { boxes: boxes })
		);
	};

	return StockPerformanceByDay;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeBoxes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);



var ChangeBoxes = function ChangeBoxes(_ref) {
	var boxes = _ref.boxes;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a['change-boxes'] },
		boxes.map(function (box) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a['change-box'] + ' ' + box.className },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.label },
					box.label
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.sub },
					box.sub
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.indicator },
					box.value
				)
			);
		})
	);
};

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"change-boxes":"finance_change-box_change-boxes","clearfix":"finance_change-box_clearfix","change-box":"finance_change-box_x","label":"finance_change-box_label","sub":"finance_change-box_sub","indicator":"finance_change-box_indicator","positive":"finance_change-box_positive","negative":"finance_change-box_negative"};

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stock-performance-month":"finance_stock-performance_stock-performance-month","clearfix":"finance_stock-performance_clearfix","stock-performance-day":"finance_stock-performance_stock-performance-day","stock-performance-interval":"finance_stock-performance_stock-performance-interval","vert-graph":"finance_stock-performance_vert-graph","section-label":"finance_stock-performance_section-label"};

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockQuotePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_details_page__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_preact_router__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dynamic_stock_chart__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol_detail_table__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_detail_table__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stock_recently_viewed__ = __webpack_require__(735);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var StockQuotePanel = function (_Component) {
	_inherits(StockQuotePanel, _Component);

	function StockQuotePanel() {
		var _temp, _this, _ret;

		_classCallCheck(this, StockQuotePanel);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { quote: {} }, _this.handleSymbolSelect = function (sym) {
			Object(__WEBPACK_IMPORTED_MODULE_5_preact_router__["c" /* route */])('/stockQuote/' + sym);
		}, _this.onData = function (data) {
			if (data && data.rows && data.rows.length) {

				var currentSym = _this.state.quote.UniqueSymbol;
				var _data$rows$ = data.rows[0],
				    newSym = _data$rows$.UniqueSymbol,
				    securityType = _data$rows$.SecurityTypeCode;
				// Only attempt to add to recently viewed in local storage if a new security

				if (!currentSym || currentSym !== newSym) Object(__WEBPACK_IMPORTED_MODULE_10__stock_recently_viewed__["a" /* addToRecentlyViewed */])(newSym, securityType);

				_this.setState({ quote: data.rows[0] });
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	StockQuotePanel.prototype.componentWillMount = function componentWillMount() {
		this.streamer = Object(__WEBPACK_IMPORTED_MODULE_6__os_cloudquote__["stockAPIStreamer"])(this.props.symbol, 'getStockPrice').on('data', this.onData);
	};

	StockQuotePanel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.symbol !== this.props.symbol) {
			this.streamer.stream(nextProps.symbol);
		}
	};

	StockQuotePanel.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.streamer) this.streamer.end();
	};

	StockQuotePanel.prototype.render = function render(_ref, _ref2) {
		var quote = _ref2.quote;

		var _ref$showInWatchlist = _ref.showInWatchlist,
		    showInWatchlist = _ref$showInWatchlist === undefined ? true : _ref$showInWatchlist,
		    props = _objectWithoutProperties(_ref, ['showInWatchlist']);

		if (!quote) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a['stock-quote-panel'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__glyphs__["a" /* FinanceSpinner */], null)
		);

		var details = quote.SecurityTypeCode === 'INDEX' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9__index_detail_table__["a" /* default */], _extends({ quote: quote }, props)) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__symbol_detail_table__["a" /* default */], _extends({ quote: quote }, props));

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_1__stock_details_page__["a" /* default */],
			_extends({ showInWatchlist: showInWatchlist }, props, { 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(props.class, __WEBPACK_IMPORTED_MODULE_3__style___default.a['stock-quote-panel']) }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__dynamic_stock_chart__["a" /* default */], { symbol: props.symbol, quote: quote }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a['widget-panel'] },
					details
				)
			)
		);
	};

	return StockQuotePanel;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stock-quote-panel":"finance_stock-quote-panel_x"};

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DetailTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_details__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_blocks__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function DetailTable(_ref) {
	var quote = _ref.quote,
	    width = _ref.width,
	    props = _objectWithoutProperties(_ref, ['quote', 'width']);

	var fieldGroup1 = void 0,
	    fieldGroup2 = void 0;
	if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_js__["m" /* isCurrency */])(quote)) {
		fieldGroup1 = ['open', 'prevClose', 'bid'];
		fieldGroup2 = ['ask', 'dayRange', '52WeekRange'];
	} else {
		fieldGroup1 = ['open', 'prevClose', 'bid', 'ask', 'dayRange', '52WeekRange'];
		fieldGroup2 = ['marketCap', 'profitOverEarnings', 'volume', 'averageVolume', 'dividend', 'yield'];
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style___default.a.quotePanel, width > 600 && __WEBPACK_IMPORTED_MODULE_3__style___default.a.wide) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__stock_details__["a" /* default */], _extends({
				fields: fieldGroup1,
				quote: quote
			}, props))
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style___default.a.quotePanel, width > 600 && __WEBPACK_IMPORTED_MODULE_3__style___default.a.wide) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__stock_details__["a" /* default */], _extends({
				fields: fieldGroup2,
				quote: quote
			}, props))
		)
	);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["x" /* containerSize */])({ height: false })(DetailTable));

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"quotePanel":"finance_symbol-detail-table_quotePanel","wide":"finance_symbol-detail-table_wide"};

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DetailTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_details__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__cube_blocks__["x" /* containerSize */])({ height: false })(DetailTable));
function DetailTable(_ref) {
	var width = _ref.width,
	    props = _objectWithoutProperties(_ref, ['width']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.quotePanel, width > 600 && __WEBPACK_IMPORTED_MODULE_2__style___default.a.wide) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__stock_details__["a" /* default */], _extends({
				fields: ['prevClose', 'open', 'volume'],
				quote: props.quote
			}, props))
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.quotePanel, width > 600 && __WEBPACK_IMPORTED_MODULE_2__style___default.a.wide) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__stock_details__["a" /* default */], _extends({
				fields: ['dayRange', '52WeekRange', 'averageVolume'],
				quote: props.quote
			}, props))
		)
	);
}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"quotePanel":"finance_index-detail-table_quotePanel","wide":"finance_index-detail-table_wide"};

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StocksPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stock_list__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_blocks__ = __webpack_require__(23);






function StocksPanel(_ref) {
	var width = _ref.width;

	var dollarVolumeColumns = ['symbolWithName', 'price', 'changePrice', 'dollarVolume'];
	var volumeColumns = ['symbolWithName', 'price', 'changePrice', 'changePercent'];

	// if we have the room, add
	if (width && width > 500) {
		dollarVolumeColumns.splice(2, 0, 'changePercent');
		volumeColumns.push('volume');
	}
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
		{ parent: true },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'MOST_ACTIVE_STOCKS' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_list__["a" /* default */], {
				showHeaders: true,
				query: {
					type: 'STOCK',
					list: '+dollarVolume',
					filter: 'MAJORCOMPANIES',
					limit: 5
				},
				columns: dollarVolumeColumns,
				trackingSource: 'stocks-panel/most-active-stocks'
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'STOCK_GAINERS' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_list__["a" /* default */], {
				showHeaders: true,
				query: {
					type: 'STOCK',
					list: '+percentChange',
					filter: 'MAJORCOMPANIES',
					limit: 5
				},
				columns: volumeColumns,
				trackingSource: 'stocks-panel/stock-gainers'
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'POPULAR_STOCKS' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_list__["a" /* default */], {
				showHeaders: true,
				query: {
					type: 'STOCK',
					list: '+popularity',
					filter: 'MAJORCOMPANIES',
					limit: 5
				},
				columns: volumeColumns,
				trackingSource: 'stocks-panel/popular-stocks'
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_3__container__["a" /* default */],
			{ title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'STOCK_LOSERS' }) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__stock_list__["a" /* default */], {
				showHeaders: true,
				query: {
					type: 'STOCK',
					list: '-percentChange',
					filter: 'MAJORCOMPANIES',
					limit: 5
				},
				columns: volumeColumns,
				trackingSource: 'stocks-panel/stock-losers'
			})
		)
	);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__cube_blocks__["x" /* containerSize */])({ height: false })(StocksPanel));

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StocksWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_finance_blocks__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stock_list__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container__ = __webpack_require__(355);
var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var StocksWidget = (_temp2 = _class = function (_Component) {
	_inherits(StocksWidget, _Component);

	function StocksWidget() {
		var _temp, _this, _ret;

		_classCallCheck(this, StocksWidget);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleSymbolSelect = function (quote) {
			window.location = '/finance/category/stockdetail/symbol/' + quote.UniqueSymbol;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	StocksWidget.prototype.render = function render(_ref) {
		var query = _ref.query,
		    columns = _ref.columns,
		    title = _ref.title,
		    theme = _ref.theme;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_5__container__["a" /* default */],
			{ transform: 'uppercase', title: title, theme: theme },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__stock_list__["a" /* default */], {
				showHeaders: true,
				query: query,
				columns: columns,
				trackingSource: 'stocks-widget',
				theme: theme
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_finance_blocks__["b" /* SymbolLookup */], {
				'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.symbolLookup,
				onSymbolSelect: this.handleSymbolSelect,
				trackingSource: 'stocks-widget/symbol-lookup',
				trackingZone: 'finance-components',
				theme: theme
			}),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_finance_blocks__["a" /* LastUpdated */], { theme: theme })
		);
	};

	return StocksWidget;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	query: {
		type: 'STOCK',
		list: '+dollarVolume',
		filter: 'MAJORCOMPANIES',
		limit: 8
	},
	columns: ['symbol', 'price', 'changeCompound', 'dollarVolume'],
	title: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["d" /* Text */], { id: 'MOST_ACTIVE_STOCKS' })
}, _temp2);


/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"symbolLookup":"finance_stocks-widget_symbolLookup"};

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockTickerBar; });
/* unused harmony export ItemUpperLeft */
/* unused harmony export ItemUpperRight */
/* unused harmony export ItemLowerLeft */
/* unused harmony export ItemLowerRight */
/* unused harmony export StockTickerBarItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_cloudquote__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_util_stock_price__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__glyphs__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaults__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style__);
var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var StockTickerBar = (_temp2 = _class = function (_Component) {
	_inherits(StockTickerBar, _Component);

	function StockTickerBar() {
		var _temp, _this, _ret;

		_classCallCheck(this, StockTickerBar);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onData = function (data) {
			if (data && data.rows) {
				_this.setState({ data: data.rows });
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	StockTickerBar.prototype.setStreamer = function setStreamer() {
		this.streamer = Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["stockAPIStreamer"])(this.props.symbols, 'getStockPrice').on('data', this.onData);
		if (!this.props.isStreaming && this.streamer) {
			this.streamer.end();
		}
	};

	StockTickerBar.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		if (this.props.query) {
			Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["sortedSecurityList"])(this.props.query).then(function (data) {
				if (data && data.rows) {
					_this2.props.symbols = data.rows.map(function (row, i) {
						return row.UniqueSymbol;
					});
				}
				_this2.setStreamer();
			});
		} else {
			this.setStreamer();
		}
	};

	StockTickerBar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var _this3 = this;

		// Next has query which is different than before or did not contain query before
		if (nextProps.query) {
			if (!this.props.query || !Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["p" /* shallowEqual */])(nextProps.query, this.props.query)) {
				Object(__WEBPACK_IMPORTED_MODULE_3__os_cloudquote__["sortedSecurityList"])(nextProps.query).then(function (data) {
					if (data && data.rows) {
						_this3.setState({ data: null });
						nextProps.symbols = data.rows.map(function (row, i) {
							return row.UniqueSymbol;
						});
						_this3.streamer.stream(nextProps.symbols);
					}
					if (!_this3.props.isStreaming) {
						_this3.streamer.end();
					}
				});
			}
		}
		// Next has different symbols
		else if (!Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["p" /* shallowEqual */])(nextProps.symbols, this.props.symbols)) {
				this.setState({ data: null });
				this.streamer.stream(nextProps.symbols);
				if (!this.props.isStreaming) {
					this.streamer.end();
				}
			} else if (nextProps.isStreaming && !this.props.isStreaming) {
				this.streamer.stream(nextProps.symbols);
			}
			// Turn streaming off
			else if (!nextProps.isStreaming && this.props.isStreaming) {
					this.streamer.end();
				}
	};

	StockTickerBar.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.streamer) {
			this.streamer.end();
		}
	};

	StockTickerBar.prototype.render = function render(_ref, _ref2) {
		var symbols = _ref.symbols,
		    isStreaming = _ref.isStreaming;
		var data = _ref2.data;

		if (!data || !data.length) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a['stock-ticker-bar'] },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__glyphs__["a" /* FinanceSpinner */], { 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.spinner })
		);

		var child = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_8__cube_blocks__["b" /* Carousel */],
			{ noItemsMsg: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_2_preact_i18n__["d" /* Text */],
					{ id: 'stock-ticker-bar.noIndexesSelected' },
					'No indexes selected'
				) },
			data.map(function (q) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StockTickerBarItem, { q: q });
			})
		);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a['stock-ticker-bar']) },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.items },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__cube_blocks__["f" /* DeviceVariance */], {
					adaptive: true,
					phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(child, { showScrollButtons: false }),
					other: child
				})
			)
		);
	};

	return StockTickerBar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	symbols: __WEBPACK_IMPORTED_MODULE_7__defaults__["a" /* default */].defaultSymbols
}, _temp2);

/**
 * Place the Symbol name in the upper left of the item
 */


var ItemUpperLeft = function ItemUpperLeft(_ref3) {
	var q = _ref3.q;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.symbol },
		q.ShortName || q.Symbol
	);
};

/**
 * Place the percent change in the upper right of the item for desktop
 */
var ItemUpperRight = function ItemUpperRight(_ref4) {
	var q = _ref4.q,
	    change = _ref4.change;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["n" /* percentFormatter */])(change.percent)
	);
};

/**
 * Place the value (desktop) or percent (mobile) in the lower left
 */
var ItemLowerLeft = function ItemLowerLeft(_ref5) {
	var q = _ref5.q,
	    change = _ref5.change;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.price },
		Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["f" /* generatePriceFormatter */])(q)(q.Price)
	);
};

/**
 * Place the value change in the lower right for desktop
 */
var ItemLowerRight = function ItemLowerRight(_ref6) {
	var q = _ref6.q,
	    change = _ref6.change;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.changePrice },
		Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["f" /* generatePriceFormatter */])(q)(change.price, { Plus: true })
	);
};

var StockTickerBarItem = function StockTickerBarItem(_ref7) {
	var q = _ref7.q;

	//Gracefully handle a bad quote Lookup
	if (!q) return null;

	var goodPrevClose = Object(__WEBPACK_IMPORTED_MODULE_5__lib_util_stock_price__["a" /* getGoodPrevClose */])(q);
	var change = Object(__WEBPACK_IMPORTED_MODULE_4__lib_util__["a" /* calcChange */])(q.Price, goodPrevClose);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.item, __WEBPACK_IMPORTED_MODULE_9__style___default.a[change.class]) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'a',
			{ href: '/finance/category/stockdetail/symbol/' + q.UniqueSymbol,
				'data-tracking-id': 'stock-ticker',
				'data-tracking-type': 'trackgif',
				'data-tracking-zone': 'finance-components',
				'data-tracking-symbol': q.UniqueSymbol
			},
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.view },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.row },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__cube_blocks__["f" /* DeviceVariance */], {
						phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ItemUpperLeft, { q: q }),
						other: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'span',
							null,
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ItemUpperLeft, { q: q }),
							' ',
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ItemUpperRight, { q: q, change: change })
						)
					})
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					{ 'class': __WEBPACK_IMPORTED_MODULE_9__style___default.a.row },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'span',
						{ 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__style___default.a.change, __WEBPACK_IMPORTED_MODULE_9__style___default.a[change.class]) },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__cube_blocks__["f" /* DeviceVariance */], {
							phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ItemUpperRight, { q: q, change: change }),
							other: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'span',
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ItemLowerLeft, { q: q, change: change }),
								' ',
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ItemLowerRight, { q: q, change: change })
							)
						})
					)
				)
			)
		)
	);
};

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stock-ticker-bar":"finance_stock-ticker-bar_x","items":"finance_stock-ticker-bar_items","item":"finance_stock-ticker-bar_item","view":"finance_stock-ticker-bar_view","row":"finance_stock-ticker-bar_row","rowSmall":"finance_stock-ticker-bar_rowSmall","symbol":"finance_stock-ticker-bar_symbol","price":"finance_stock-ticker-bar_price","change":"finance_stock-ticker-bar_change","changePrice":"finance_stock-ticker-bar_changePrice","positive":"finance_stock-ticker-bar_positive","negative":"finance_stock-ticker-bar_negative","spinner":"finance_stock-ticker-bar_spinner"};

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stock_info_table__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);




var WorldMarkets = function WorldMarkets() {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a['world-markets'] },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__stock_info_table__["a" /* default */], {
			columns: ['symbol', 'price', 'change'],
			symbols: ['$FTSE', '$PARI', '$DAX', '$N225', '$HSI', '$AOI', 'TSX:0000'],
			cursor: 0
		})
	);
};

/* harmony default export */ __webpack_exports__["a"] = (WorldMarkets);

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"world-markets":"finance_world-markets_x","clearfix":"finance_world-markets_clearfix"};

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_finance_blocks__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quote_header__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);








function routeToSymbol(quote) {
	window.location = '/finance/category/stockdetail/symbol/' + quote.UniqueSymbol;
}

var SymbolLookupWidget = function SymbolLookupWidget(_ref) {
	var width = _ref.width,
	    theme = _ref.theme;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["f" /* DeviceVariance */], {
		phone: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_finance_blocks__["b" /* SymbolLookup */], {
			'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.symbolLookupWidget,
			onSymbolSelect: routeToSymbol,
			trackingSource: 'symbol-lookup-widget',
			trackingZone: 'finance-components'
		}),
		tablet: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_4__container__["a" /* default */],
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__quote_header__["a" /* QuoteHeader */], null),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_finance_blocks__["b" /* SymbolLookup */], {
				'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.symbolLookupWidget, __WEBPACK_IMPORTED_MODULE_6__style___default.a.tablet, width >= 768 && __WEBPACK_IMPORTED_MODULE_6__style___default.a.wide),
				onSymbolSelect: routeToSymbol,
				trackingSource: 'symbol-lookup-widget',
				trackingZone: 'finance-components'
			})
		),
		desktop: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_4__container__["a" /* default */],
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__quote_header__["a" /* QuoteHeader */], null),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_finance_blocks__["b" /* SymbolLookup */], {
				'class': __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.symbolLookupWidget, __WEBPACK_IMPORTED_MODULE_6__style___default.a.desktop),
				onSymbolSelect: routeToSymbol,
				trackingSource: 'symbol-lookup-widget',
				trackingZone: 'finance-components',
				theme: theme
			})
		)
	});
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["x" /* containerSize */])({ height: false })(SymbolLookupWidget));

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"symbolLookupWidget":"finance_symbol-lookup-widget_symbolLookupWidget","desktop":"finance_symbol-lookup-widget_desktop","tablet":"finance_symbol-lookup-widget_tablet","wide":"finance_symbol-lookup-widget_wide"};

/***/ })
]));


// WEBPACK FOOTER //
// widgets/finance.98b3e2f1.chunk.js